import {
  RawExodusCard,
  ExodusCard,
  toEdition,
  toCardType,
  toFoilOnly,
  toSetName,
  toRarity,
} from '../types/ExodusCard';

export const ExodusCardsJson: ExodusCard[] = ((cards: RawExodusCard[]) =>
  cards
    .map((c) => ({
      ...c,
      edition: toEdition(c.edition),
      set_name: toSetName(c.set_name),
      card_type: c.card_type?.map(toCardType),
      foil_only:
        c.foil_only !== undefined ? toFoilOnly(c.foil_only) : undefined,
      rarity: c.rarity !== undefined ? toRarity(c.rarity) : undefined,
    }))
    .sort((a, b) =>
      a.card_id < b.card_id ? -1 : a.card_id > b.card_id ? 1 : 0
    ))([
  {
    card_id: 'card_452',
    s3_large_image_name:
      'NDUyLS0tMS1hLWRpbWVuc2lvbi1pbi1ydWluLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDUyLS0tMS1hLWRpbWVuc2lvbi1pbi1ydWluLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDUyLS0tMS1hLWRpbWVuc2lvbi1pbi1ydWluLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'A Dimension in Ruin',
    set_name: 'The Dimension That Disappeared',
    set_number: '1',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Thai Vo',
    effect:
      'All creature types except Chrono deal 1 less damage during battle this turn. You may destroy 1 energy in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/A-Dimension-in-Ruin-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_159',
    s3_large_image_name:
      'MTU5LS0tMS1CbG9zc29tLUF2YWlsLUZvaWwtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTU5LS0tMS1CbG9zc29tLUF2YWlsLUZvaWwtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTU5LS0tMS1CbG9zc29tLUF2YWlsLUZvaWwtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Blossom Avail',
    set_name: 'Galaxy Tides',
    set_number: '1',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'COCOs',
    effect:
      "If you have less Life Points than your opponent and don't have any creatures on the field, summon 1 Uncommon creature from your graveyard with 2 energy on it.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Blossom-Avail-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_557',
    s3_large_image_name: 'NTU3LS0tMS1NYW51c2NyaXB0LW9mLXRoZS1BcmNoaXZpc3QucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTU3LS0tMS1NYW51c2NyaXB0LW9mLXRoZS1BcmNoaXZpc3QucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTU3LS0tMS1NYW51c2NyaXB0LW9mLXRoZS1BcmNoaXZpc3QucG5n/t',
    name: 'Manuscript of the Archivist',
    set_name: 'Threshold of Time',
    set_number: '1',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Yosi Saputra',
    effect:
      "Pay 1 Life Point. Your Archive creatures don't lose energy during battle this turn.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Manuscript-of-the-Archivist-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_278',
    s3_large_image_name: 'Mjc4LS0tMS1Sb2FyaW5nLVNhbmN0dWFyeS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc4LS0tMS1Sb2FyaW5nLVNhbmN0dWFyeS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc4LS0tMS1Sb2FyaW5nLVNhbmN0dWFyeS5wbmcEXODUS/t',
    name: 'Roaring Sanctuary',
    set_name: 'Converging Chasms',
    set_number: '1',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      'Pay 1 Life Point. Each player may look through their Main Deck and select 1 card to add to their hand. Then, each player shuffles their Main Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Roaring-Sanctuary-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_221',
    s3_large_image_name:
      'MjIxLS0tMS1WYW5xdWlzaC1SZXZlcnNlci1vZi1UaW1lLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjIxLS0tMS1WYW5xdWlzaC1SZXZlcnNlci1vZi1UaW1lLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjIxLS0tMS1WYW5xdWlzaC1SZXZlcnNlci1vZi1UaW1lLnBuZwEXODUSEXODUS/t',
    name: 'Vanquish, Reverser of Time',
    set_name: 'Crystal Forge',
    set_number: '1',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    effect:
      "When this creature is revealed by a card effect, look through each opponent's Main Deck. Choose 1 card from it and send it to their graveyard. Then, shuffle their Main Deck and draw 1 energy from your Energy Deck.",
    ruling:
      '<p>■&nbsp;If you reveal a&nbsp;<em>Vanquish, Reverser of Time</em>&nbsp;due to&nbsp;<em>Mortarbloom Liege</em>\'s "Clarity Cannon" Ability,&nbsp;<em>Vanquish</em>\'s "Luminescent Chance" Ability allows you to send a card from your opponent\'s Main Deck to their graveyard; you MAY select one of the two cards being revealed from the "Clarity Cannon" Ability as those cards are still considered part of their Main Deck while they are being revealed;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Vanquish--Reverser-of-Time-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_558',
    s3_large_image_name: 'NTU4LS0tMi1DYW55b24tb2YtU2VjcmV0cy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTU4LS0tMi1DYW55b24tb2YtU2VjcmV0cy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTU4LS0tMi1DYW55b24tb2YtU2VjcmV0cy5wbmcEXODUS/t',
    name: 'Canyon of Secrets',
    set_name: 'Threshold of Time',
    set_number: '2',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Thai Vo',
    effect:
      'Target 1 of your Machines in play and rebuild it, even if it and the rebuild target have already been rebuilt this turn. (Send it to the graveyard and replace it with one of your Machines from a zone that is viewable by you.)',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Canyon-of-Secrets-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_453',
    s3_large_image_name: 'NDUzLS0tMi1jaHJvbm9sb2dpY2FsLXJlbGFwc2UtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDUzLS0tMi1jaHJvbm9sb2dpY2FsLXJlbGFwc2UtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDUzLS0tMi1jaHJvbm9sb2dpY2FsLXJlbGFwc2UtNzJkcGkucG5n/t',
    name: 'Chronological Relapse',
    set_name: 'The Dimension That Disappeared',
    set_number: '2',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'A.Gvin',
    effect:
      "If you have 3 Life Points or less, target 1 symmetry card from a player's graveyard and play it immediately (you must still pay any costs).",
    ruling:
      '<p>■ When this card is played, the owner declares which graveyard and card they are targeting with its effect;<br><br>■ Because this card\'s effect says, "immediately", any responses must be played before this card begins resolving; players are unable to respond to the card that this card targets;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;</sup></strong>&nbsp;- If the symmetry targeted by <em>Relapse</em> stays in play after resolution (<em>Chains</em>, <em>Stellarfalls</em>, <em>Fractured Portals</em>, etc.) and that card becomes frozen, <strong>it activates under the owner\'s control</strong> when it unfreezes;<br><br>■ This card\'s effect states that you "play" the target card from a graveyard, which means, if resolved, that the target card comes out of the graveyard and into play during the course of its resolution;<br><br>■ This card cannot play a symmetry card from a graveyard that is freeze-locked by&nbsp;<em>Vanciere the Future Phenomenon</em>&nbsp;since the target card technically cannot leave the frozen graveyard;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chronological-Relapse-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_160',
    s3_large_image_name: 'MTYwLS0tMi1Gb3Jlc3Qtb2YtQ3JhZ3MtRm9pbC00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTYwLS0tMi1Gb3Jlc3Qtb2YtQ3JhZ3MtRm9pbC00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTYwLS0tMi1Gb3Jlc3Qtb2YtQ3JhZ3MtRm9pbC00Q1AucG5n/t',
    name: 'Forest of Crags',
    set_name: 'Galaxy Tides',
    set_number: '2',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'André Martinez',
    effect:
      'Pay 1 energy. Look through your Main Deck and select 1 card. Shuffle your Main Deck and place the selected card on top.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Forest-of-Crags-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_222',
    s3_large_image_name: 'MjIyLS0tMi1IYXJiaW5nZXItTXVzaHJvb20ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjIyLS0tMi1IYXJiaW5nZXItTXVzaHJvb20ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjIyLS0tMi1IYXJiaW5nZXItTXVzaHJvb20ucG5n/t',
    name: 'Harbinger Mushroom',
    set_name: 'Crystal Forge',
    set_number: '2',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk'],
    creature_type_count: 1,
    artist: 'Hoang Tran',
    effect:
      'When this creature is revealed by a card effect, each opponent loses 1 Life Point. Then, draw 1 energy from your Energy Deck.',
    ruling:
      '<p>■&nbsp;This creature\'s Ability deals 2 damage to the opposing team in 2v2 format whenever it\'s revealed, since it specifies "each opponent".</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Harbinger-Mushroom-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_279',
    s3_large_image_name: 'Mjc5LS0tMi1TaGFyZHZlaWxzLU9ucnVzaC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc5LS0tMi1TaGFyZHZlaWxzLU9ucnVzaC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc5LS0tMi1TaGFyZHZlaWxzLU9ucnVzaC5wbmcEXODUS/t',
    name: "Shardveil's Onrush",
    set_name: 'Converging Chasms',
    set_number: '2',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      "Pay 1 energy. Freeze all 1-energy creatures on the field. (Frozen creatures cannot attack and are flipped face-up at the end of the owner's next turn.)",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Shardveil-s-Onrush-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_223',
    s3_large_image_name: 'MjIzLS0tMy1DYXJjZXJ5LXRoZS1DaGVtaWNhbC1PZGRpdHkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjIzLS0tMy1DYXJjZXJ5LXRoZS1DaGVtaWNhbC1PZGRpdHkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjIzLS0tMy1DYXJjZXJ5LXRoZS1DaGVtaWNhbC1PZGRpdHkucG5n/t',
    name: 'Carcery the Chemical Oddity',
    set_name: 'Crystal Forge',
    set_number: '3',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    effect:
      'When this creature is put into play, destroy 1 Common, Uncommon, and Rare Treefolk or Mushfolk on your field along with all energy attached to them (if you cannot, you lose 2 Life Points). Then, your opponent loses Life Points equal to the amount of energy destroyed.',
    ruling:
      "<p>■&nbsp;When this creature enters play (whether by summon, symmetry effect, switch effect, etc.), its Ability triggers&nbsp;immediately, but symmetry cards can be played in response to its Ability before it begins resolving;</p>\n<p>■&nbsp;<strong>You&nbsp;<em>must</em>&nbsp;have at least 1 of all three Rarities</strong>&nbsp;(Common, Uncommon, Rare) on your field in order to blow up their energy and cause direct damage to your opponent's Life Points;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - If you do not meet&nbsp;<em>all</em>&nbsp;of the conditions (i.e. missing only 1 Rarity), you lose 2 Life Points when this creature enters play;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;You cannot use this creature's Ability if you do not meet&nbsp;<em>all</em>&nbsp;of the Ability's requirements;</p>\n<p>■&nbsp;<em>Carcery's&nbsp;</em>\"Energy Heartpulse\"&nbsp;Ability is an all-or-nothing effect: you cannot pick and choose how many energies from each creature to explode for the effect;</p>\n<p>■ If you have more than 1 creature of a certain Rarity in play when this Ability triggers, you may choose which of your creatures to use as part of this Ability's effect;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;Due to the wording,&nbsp;<strong>you cannot choose multiple creatures of the same Rarity for this effect</strong>, it&nbsp;must&nbsp;be exactly one of each Rarity;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<em>Carcery the Chemical Oddity</em><strong>&nbsp;can choose itself to meet the Rare requirement</strong>&nbsp;as part of its Ability since it is a 3-star Rare and it is counted as being 'in play' when it hits the table;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Carcery-the-Chemical-Oddity-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_161',
    s3_large_image_name:
      'MTYxLS0tMy1FdmVyZHJpZnQtSXNsYW5kcy1Gb2lsLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTYxLS0tMy1FdmVyZHJpZnQtSXNsYW5kcy1Gb2lsLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTYxLS0tMy1FdmVyZHJpZnQtSXNsYW5kcy1Gb2lsLTRDUC5wbmcEXODUS/t',
    name: 'Everdrift Islands',
    set_name: 'Galaxy Tides',
    set_number: '3',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'André Martinez',
    effect: 'Each Common creature in play gains 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Everdrift-Islands-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_559',
    s3_large_image_name:
      'NTU5LS0tMy1TYW5kcy1vZi10aGUtQnJva2VuLVRpbWVwaWVjZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTU5LS0tMy1TYW5kcy1vZi10aGUtQnJva2VuLVRpbWVwaWVjZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTU5LS0tMy1TYW5kcy1vZi10aGUtQnJva2VuLVRpbWVwaWVjZS5wbmcEXODUS/t',
    name: 'Sands of the Broken Timepiece',
    set_name: 'Threshold of Time',
    set_number: '3',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Daria Gallyamova',
    effect:
      "Target 1 symmetry in play and return it to the owner's hand. If you have less Life Points than your opponent, that opponent can't play cards of that name for the rest of the turn.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Sands-of-the-Broken-Timepiece-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_454',
    s3_large_image_name:
      'NDU0LS0tMy10aG91Z2h0c3RyZWFtLWVldmVudGlkZXMtc3dvcmQtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDU0LS0tMy10aG91Z2h0c3RyZWFtLWVldmVudGlkZXMtc3dvcmQtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDU0LS0tMy10aG91Z2h0c3RyZWFtLWVldmVudGlkZXMtc3dvcmQtNzJkcGkucG5n/t',
    name: "Thoughtstream, Eeventide's Sword",
    set_name: 'The Dimension That Disappeared',
    set_number: '3',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Yosi Saputra',
    effect:
      "Destroy 1 of your creatures and all energy attached. Then, destroy all cards on the field (except energy) that don't have any energy attached. If any cards left a player's field due to this effect, that player loses 1 Life Point. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Thoughtstream--Eeventide-s-Sword-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_280',
    s3_large_image_name: 'MjgwLS0tMy1UcmVlZm9yZ2UtRW52b3kucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjgwLS0tMy1UcmVlZm9yZ2UtRW52b3kucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjgwLS0tMy1UcmVlZm9yZ2UtRW52b3kucG5n/t',
    name: 'Treeforge Envoy',
    set_name: 'Converging Chasms',
    set_number: '3',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Nivea Toliver',
    effect:
      'Each Common creature in play becomes unaffected by all other symmetry cards until the end of the turn.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Treeforge-Envoy-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_162',
    s3_large_image_name:
      'MTYyLS0tNC1BcHBhcml0aW9uLUZvaWwtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTYyLS0tNC1BcHBhcml0aW9uLUZvaWwtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTYyLS0tNC1BcHBhcml0aW9uLUZvaWwtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Apparition Grove',
    set_name: 'Galaxy Tides',
    set_number: '4',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'COCOs',
    effect:
      "Pay 1 energy. Switch a creature on your field with a creature in your hand. This doesn't count as a summon.",
    ruling:
      '<p>■&nbsp;After you attack with creature A, then play&nbsp;<em>Apparition Grove</em>&nbsp;to switch creature A with creature B in your hand,&nbsp;<strong>creature B may attack since it is a new creature</strong>, even though it is using the same pile of energy;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: If your&nbsp;<em>Princess of Blades</em>&nbsp;attacks, then you use&nbsp;<em>Apparition Grove</em>&nbsp;to switch it with a&nbsp;<em>Legendary Blade Luhzarus</em>&nbsp;in your hand,&nbsp;<em>Luhzarus</em>&nbsp;may attack immediately. Then, you could also Pay 1 energy to trigger its Ability: Blade Barrage and have&nbsp;<em>Luhzarus</em>&nbsp;attack yet again;</p>\n<p>■&nbsp;<em>Apparition Grove</em>&nbsp;can be used on a&nbsp;<em>Legendary Blade Luhzarus</em>&nbsp;on your field to switch it with a second&nbsp;<em>Legendary Blade Luhzarus</em>&nbsp;in your hand to effectively attack 4 times per turn with the same pile of energy OR up to 6 times per turn if you have 2x&nbsp;<em>Apparition Grove</em>;</p>\n<p>■&nbsp;<strong>*</strong><u><strong>Technical Ruling</strong></u><strong>:</strong>&nbsp;The&nbsp;player must declare/show (not reveal because it does not trigger any "reveal" effects) the card that will be replacing the creature targeted by&nbsp;<em>Apparition Grove&nbsp;</em>(creature B). The player should be proactive by lowering creature B from their hand to the table while simultaneously lifting creature A from the table to their hand;&nbsp;<strong>that way, all players can see there are clearly 2 different cards being switched in/out of play</strong>;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Apparition-Grove-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_224',
    s3_large_image_name: 'MjI0LS0tNC1CcmlsbGlhbnQtQnJpZ2h0dmVpbC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjI0LS0tNC1CcmlsbGlhbnQtQnJpZ2h0dmVpbC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjI0LS0tNC1CcmlsbGlhbnQtQnJpZ2h0dmVpbC5wbmcEXODUS/t',
    name: 'Brilliant Brightveil',
    set_name: 'Crystal Forge',
    set_number: '4',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Hoang Tran',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Brilliant-Brightveil-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_455',
    s3_large_image_name:
      'NDU1LS0tNC1lcm9kYXMtYXNjZW5kYW5jZS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDU1LS0tNC1lcm9kYXMtYXNjZW5kYW5jZS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDU1LS0tNC1lcm9kYXMtYXNjZW5kYW5jZS03MmRwaS5wbmcEXODUS/t',
    name: "Eroda's Ascendance",
    set_name: 'The Dimension That Disappeared',
    set_number: '4',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Odysseas Stamoglou',
    effect:
      'Pay half of your Life Points, rounded down. Send all cards in your Main Deck to the graveyard. Then, you may summon "Eroda the Flickering Facade" and/or "Devourer of Dimensions" from your hand or graveyard, if possible. If you do, you may move your Afterthoughts underneath it (Afterthoughts turn into Chronos). Opposing creatures and piles cannot increase in energy for the rest of the turn.',
    ruling:
      '<p>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>"Pay half of your Life Points, rounded down," means that you pay <strong>exactly half</strong> of your current Life total—and if the result is a&nbsp;fractional number, round the result down to the nearest whole number;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - The amount of Life Points you pay is not rounded down, only the result (if needed);<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - "rounded down"&nbsp;is a suffix&nbsp;phrase of the overall cost, affecting the result only and not the cost itself;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Eroda-s-Ascendance-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_560',
    s3_large_image_name:
      'NTYwLS0tNC1IYWlsZmlyZS1hbmQtQnJpbXN0b25lLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTYwLS0tNC1IYWlsZmlyZS1hbmQtQnJpbXN0b25lLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTYwLS0tNC1IYWlsZmlyZS1hbmQtQnJpbXN0b25lLnBuZwEXODUSEXODUS/t',
    name: 'Hailfire and Brimstone',
    set_name: 'Threshold of Time',
    set_number: '4',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      'When this card is played, ignite it; it leaves play when a symmetry is revealed from your Main Deck. When you successfully summon or put into play a Hailfire, ignite it, then reveal the top card of your Main Deck. If it was a Hailfire, draw it.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hailfire-and-Brimstone-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_281',
    s3_large_image_name: 'MjgxLS0tNC1TaGFyZHZlaWwtQ291cmllci5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjgxLS0tNC1TaGFyZHZlaWwtQ291cmllci5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjgxLS0tNC1TaGFyZHZlaWwtQ291cmllci5wbmcEXODUS/t',
    name: 'Shardveil Courier',
    set_name: 'Converging Chasms',
    set_number: '4',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Nivea Toliver',
    effect: 'Each Uncommon creature in play gains 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Shardveil-Courier-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_561',
    s3_large_image_name: 'NTYxLS0tNS1BdGxhcy1BYmxhemUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTYxLS0tNS1BdGxhcy1BYmxhemUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTYxLS0tNS1BdGxhcy1BYmxhemUucG5n/t',
    name: 'Atlas Ablaze',
    set_name: 'Threshold of Time',
    set_number: '5',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Yosi Saputra',
    effect:
      'This card is considered a creature when it is revealed. When this card is played, take 1 energy from your Energy Deck and use it to start a new pile. Target 1 of your creatures in play; for each rarity star it has below 3, that new pile gains 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Atlas-Ablaze-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_456',
    s3_large_image_name: 'NDU2LS0tNS1jb3JydXB0ZWQta2V5c3RvbmUtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDU2LS0tNS1jb3JydXB0ZWQta2V5c3RvbmUtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDU2LS0tNS1jb3JydXB0ZWQta2V5c3RvbmUtNzJkcGkucG5n/t',
    name: 'Corrupted Keystone',
    set_name: 'The Dimension That Disappeared',
    set_number: '5',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Alejandro Arévalo',
    effect:
      "Target 1 of your creatures in play without an Ability; this turn, it doesn't take damage when battling opposing creatures.",
    ruling:
      '<p>■ Inactive or negated Abilities&nbsp;<strong><u>cannot</u></strong>&nbsp;be targeted by&nbsp;<em>Corrupted Keystone</em>. This card specifically targets a creature "without an Ability", and inactive/negated Abilities are not considered removed;</p>\n<p>■ If&nbsp;<em>Verneejus the Molecular Mockery</em>&nbsp;targets and "steals" a creature\'s Ability, the now Ability-less&nbsp;creature can then be targeted by&nbsp;<em>Corrupted Keystone</em>&nbsp;that turn, since Verneejus states "that creature loses its Ability";</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Corrupted-Keystone-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_225',
    s3_large_image_name: 'MjI1LS0tNS1DcmVha2luZy1Sb3R3b29kLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjI1LS0tNS1DcmVha2luZy1Sb3R3b29kLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjI1LS0tNS1DcmVha2luZy1Sb3R3b29kLnBuZwEXODUSEXODUS/t',
    name: 'Creaking Rotwood',
    set_name: 'Crystal Forge',
    set_number: '5',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Elena Shiyanova',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Creaking-Rotwood-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_163',
    s3_large_image_name: 'MTYzLS0tNS1DcnlzdGFsLUJlbGwtRm9pbC00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTYzLS0tNS1DcnlzdGFsLUJlbGwtRm9pbC00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTYzLS0tNS1DcnlzdGFsLUJlbGwtRm9pbC00Q1AucG5n/t',
    name: 'Crystal Bell',
    set_name: 'Galaxy Tides',
    set_number: '5',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Kenny Estrella',
    effect:
      'Each player draws 1 card from their Main Deck for each Shardfolk in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystal-Bell-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_282',
    s3_large_image_name: 'MjgyLS0tNS1Qb3J0YWxzLUNvbGxpZGUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjgyLS0tNS1Qb3J0YWxzLUNvbGxpZGUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjgyLS0tNS1Qb3J0YWxzLUNvbGxpZGUucG5n/t',
    name: 'Portals Collide',
    set_name: 'Converging Chasms',
    set_number: '5',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      "Select one of your Common creatures and one of your opponent's Rare creatures in play; those creatures battle. If both creatures were destroyed by battle, your opponent loses 1 Life Point.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Portals-Collide-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_562',
    s3_large_image_name: 'NTYyLS0tNi1Jc2xhLURlLUxhcy1DYXJ0YXMucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTYyLS0tNi1Jc2xhLURlLUxhcy1DYXJ0YXMucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTYyLS0tNi1Jc2xhLURlLUxhcy1DYXJ0YXMucG5n/t',
    name: 'Isla De Las Cartas',
    set_name: 'Threshold of Time',
    set_number: '6',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Odysseas Stamoglou',
    effect:
      'Put any amount of energy from your hand into play however you like.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Isla-De-Las-Cartas-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_457',
    s3_large_image_name: 'NDU3LS0tNi1tYWRuZXNzLXNldHRsZXMtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDU3LS0tNi1tYWRuZXNzLXNldHRsZXMtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDU3LS0tNi1tYWRuZXNzLXNldHRsZXMtNzJkcGkucG5n/t',
    name: 'Madness Settles',
    set_name: 'The Dimension That Disappeared',
    set_number: '6',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Tommy Suhartono',
    effect:
      "Your Life Points become 3. Your Chronos don't lose energy this turn unless by your own card effects or Abilities. You can't resolve effects or Abilities that switch Life Points with your opponent for the rest of the game.",
    ruling:
      "<p>■ If&nbsp;<em>Tethered to Eeventide</em>&nbsp;is played while&nbsp;<em>Madness Settles</em>&nbsp;is active, the targeted creature will effectively be destroyed, but its energy will remain in play as a blank pile. This is due to the fact that Tethered's effect simultaneously destroys the creature and its energy<em>—</em>but&nbsp;<em>Madness Settles</em>&nbsp;prevents the Chrono's energy from being destroyed, thus, only the creature gets destroyed;</p>\n<p>■&nbsp;Cards such as&nbsp;<em>Unsummon</em>&nbsp;remove the targeted creature&nbsp;<strong><u>before</u></strong>&nbsp;the energy is destroyed, so&nbsp;<em>Madness Settles</em>&nbsp;will no longer effect the energy that was attached to the targeted creature once the creature leaves play;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>If Anathema's creature side Ability is active when this card is played, your Life Points won't become 3, but the rest of its effect still applies as your Life Points becoming 3 isn't a cost;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Madness-Settles-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_283',
    s3_large_image_name: 'MjgzLS0tNi1SZWxlYXNlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjgzLS0tNi1SZWxlYXNlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjgzLS0tNi1SZWxlYXNlLnBuZwEXODUSEXODUS/t',
    name: 'Release',
    set_name: 'Converging Chasms',
    set_number: '6',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Esther Yong',
    effect:
      'You may only play this card if you have less Life Points than your opponent. Cancel the effect of one "Chains" symmetry card and send it to the graveyard.',
    ruling: '',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Release-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_164',
    s3_large_image_name:
      'MTY0LS0tNi1TaG9yZXMtU3RhcnJ5LUJsb2NrYWRlLUZvaWwtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTY0LS0tNi1TaG9yZXMtU3RhcnJ5LUJsb2NrYWRlLUZvaWwtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTY0LS0tNi1TaG9yZXMtU3RhcnJ5LUJsb2NrYWRlLUZvaWwtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Shores of the Starry Blockade',
    set_name: 'Galaxy Tides',
    set_number: '6',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'COCOs',
    effect:
      'Discard 3 Shardfolk creatures from your hand. You and your opponent reveal your hands and discard any creatures revealed.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Shores-of-the-Starry-Blockade-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_226',
    s3_large_image_name: 'MjI2LS0tNi1TcG9yZWhlYXJ0LVNocm9vbS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjI2LS0tNi1TcG9yZWhlYXJ0LVNocm9vbS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjI2LS0tNi1TcG9yZWhlYXJ0LVNocm9vbS5wbmcEXODUS/t',
    name: 'Sporeheart Shroom',
    set_name: 'Crystal Forge',
    set_number: '6',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk'],
    creature_type_count: 1,
    artist: 'Reign',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Sporeheart-Shroom-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_458',
    s3_large_image_name: 'NDU4LS0tNy1sdWNpYS1saWV2ZHJhaHMtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDU4LS0tNy1sdWNpYS1saWV2ZHJhaHMtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDU4LS0tNy1sdWNpYS1saWV2ZHJhaHMtNzJkcGkucG5n/t',
    name: 'Lucia Lievdrahs',
    set_name: 'The Dimension That Disappeared',
    set_number: '7',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Tommy Suhartono',
    effect:
      'Destroy 1 of your frozen cards in play. Then, target up to 2 energy in play and permanently freeze them.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lucia-Lievdrahs-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_165',
    s3_large_image_name: 'MTY1LS0tNy1NYWVsc3Ryb20tRm9pbC00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTY1LS0tNy1NYWVsc3Ryb20tRm9pbC00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTY1LS0tNy1NYWVsc3Ryb20tRm9pbC00Q1AucG5n/t',
    name: 'Maelstrom',
    set_name: 'Galaxy Tides',
    set_number: '7',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Gary McCluskey',
    effect:
      'Switch your Main Deck with your graveyard. (Flip over your Main Deck and it becomes your graveyard. Shuffle your graveyard before it becomes your Main Deck.)',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Maelstrom-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_284',
    s3_large_image_name: 'Mjg0LS0tNy1NeXN0ZXJpb3VzLVNvam91cm5lci5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg0LS0tNy1NeXN0ZXJpb3VzLVNvam91cm5lci5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg0LS0tNy1NeXN0ZXJpb3VzLVNvam91cm5lci5wbmcEXODUS/t',
    name: 'Mysterious Sojourner',
    set_name: 'Converging Chasms',
    set_number: '7',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Hafid Moenir',
    effect: 'Each Rare creature in play loses 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mysterious-Sojourner-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_563',
    s3_large_image_name:
      'NTYzLS0tNy1TYWlscy1vZi10aGUtRmFsbGVuLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTYzLS0tNy1TYWlscy1vZi10aGUtRmFsbGVuLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTYzLS0tNy1TYWlscy1vZi10aGUtRmFsbGVuLnBuZwEXODUSEXODUS/t',
    name: 'Sails of the Fallen',
    set_name: 'Threshold of Time',
    set_number: '7',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'A.Gvin',
    effect:
      'This card remains on the field when it is played, and leaves play when it is targeted. Whenever a Leviathan enters play, add 1 energy beneath this card. When this card leaves play, move the energy beneath it to your Leviathans in play however you like.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Sails-of-the-Fallen-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_227',
    s3_large_image_name: 'MjI3LS0tNy1WZW51cy1UcmVldHJhcC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjI3LS0tNy1WZW51cy1UcmVldHJhcC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjI3LS0tNy1WZW51cy1UcmVldHJhcC5wbmcEXODUS/t',
    name: 'Venus Treetrap',
    set_name: 'Crystal Forge',
    set_number: '7',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Mushfolk'],
    creature_type_count: 2,
    artist: 'Sarayu Ruangvesh',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Venus-Treetrap-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_166',
    s3_large_image_name: 'MTY2LS0tOC1BbGFuYS10aGUtU3Rhci1Gb3JtYXRpb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTY2LS0tOC1BbGFuYS10aGUtU3Rhci1Gb3JtYXRpb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTY2LS0tOC1BbGFuYS10aGUtU3Rhci1Gb3JtYXRpb24ucG5n/t',
    name: 'Alana the Star Formation',
    set_name: 'Galaxy Tides',
    set_number: '8',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'COCOs',
    effect:
      "When this creature is summoned, it gains 1 energy and you may look at your opponent's hand.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Alana-the-Star-Formation-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_459',
    s3_large_image_name: 'NDU5LS0tOC1lbmVyZ3ktNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDU5LS0tOC1lbmVyZ3ktNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDU5LS0tOC1lbmVyZ3ktNzJkcGkucG5n/t',
    name: 'Energy',
    set_name: 'The Dimension That Disappeared',
    set_number: '8',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Energy'],
    artist: 'Brandon McDonald',
    ruling: '',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Energy-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_564',
    s3_large_image_name: 'NTY0LS0tOC1Mb3N0LUNvdmUtVW52ZWlsZWQucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTY0LS0tOC1Mb3N0LUNvdmUtVW52ZWlsZWQucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTY0LS0tOC1Mb3N0LUNvdmUtVW52ZWlsZWQucG5n/t',
    name: 'Lost Cove, Unveiled',
    set_name: 'Threshold of Time',
    set_number: '8',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Dmitry Isakevitch',
    effect:
      'Discard 1 card from your hand or field with "Cove" in its name. Then, negate the effects of all other symmetry cards on the stack and destroy them.',
    ruling:
      '<p>■ This card cannot discard itself from your hand or field to fulfill its cost;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - You can discard another copy of <em>Lost Cove, Unveiled</em> or <em>Crystal Cove</em> to fulfill its requirement;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lost-Cove--Unveiled-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_285',
    s3_large_image_name: 'Mjg1LS0tOC1Ta3lib3JuLUd1aWxkLUNhc3RsZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg1LS0tOC1Ta3lib3JuLUd1aWxkLUNhc3RsZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg1LS0tOC1Ta3lib3JuLUd1aWxkLUNhc3RsZS5wbmcEXODUS/t',
    name: 'Skyborn Guild Castle',
    set_name: 'Converging Chasms',
    set_number: '8',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      'Select one of your Common Angels on the field and add 1 energy to it from your Energy Deck. If you have less creatures in play than your opponent, add another energy to it.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Skyborn-Guild-Castle-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_228',
    s3_large_image_name: 'MjI4LS0tOC1TdHJhbmdsZXItRmlnLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjI4LS0tOC1TdHJhbmdsZXItRmlnLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjI4LS0tOC1TdHJhbmdsZXItRmlnLnBuZwEXODUSEXODUS/t',
    name: 'Strangler Fig',
    set_name: 'Crystal Forge',
    set_number: '8',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Hoang Tran',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Strangler-Fig-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_167',
    s3_large_image_name: 'MTY3LS0tOS1Hb2xkLUVuZXJneS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTY3LS0tOS1Hb2xkLUVuZXJneS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTY3LS0tOS1Hb2xkLUVuZXJneS5wbmcEXODUS/t',
    name: 'Energy',
    set_name: 'Galaxy Tides',
    set_number: '9',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Energy'],
    artist: 'Rebecca Weaver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energy-First-1',
    is_default_edition: true,
  },
  {
    card_id: 'card_286',
    s3_large_image_name: 'Mjg2LS0tOS10ZWFsLWVuZXJneS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg2LS0tOS10ZWFsLWVuZXJneS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg2LS0tOS10ZWFsLWVuZXJneS5wbmcEXODUS/t',
    name: 'Energy',
    set_name: 'Converging Chasms',
    set_number: '9',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Energy'],
    artist: 'André Martinez',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energy-First-3',
    is_default_edition: true,
  },
  {
    card_id: 'card_460',
    s3_large_image_name:
      'NDYwLS0tOS1lcm9kYS10aGUtZmxpY2tlcmluZy1mYWNhZGUtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDYwLS0tOS1lcm9kYS10aGUtZmxpY2tlcmluZy1mYWNhZGUtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDYwLS0tOS1lcm9kYS10aGUtZmxpY2tlcmluZy1mYWNhZGUtNzJkcGkucG5n/t',
    name: 'Eroda the Flickering Facade',
    set_name: 'The Dimension That Disappeared',
    set_number: '9',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Brandon McDonald',
    effect:
      ' Only 1 copy of this card is allowed in your Main Deck. ABILITY: When this card would leave your Main Deck, put it face-up beneath your Main Deck instead & attach 1 energy from your field to it at the end of each turn; when zero cards remain in your Main Deck, summon it along with all energy attached. ',
    ruling:
      '<p>■&nbsp;Similar to energy that\'s "beneath the Main Deck", Eroda is&nbsp;<strong><u>not</u></strong>&nbsp;part of the Main Deck, nor is it considered to be "the bottom of" / "at the bottom of"&nbsp;the Main Deck. Eroda is entirely separate and is considered to be underneath / beneath the deck as if in a separate zone;</p>\n<p>■ Due to Eroda\'s wording "when this card&nbsp;<strong><u>would</u></strong>&nbsp;leave your Main Deck" … "put it face-up beneath your Main Deck&nbsp;<strong><u>instead</u></strong>", it does not fulfill a draw requirement, thus allowing the player to draw the next card after Eroda fully resolves from leaving the Main Deck;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Similarly, cards that search or send cards out of the Main Deck (such as&nbsp;<em>Sign of the Crow</em>,&nbsp;<em>Chains of the Ancient One</em>,&nbsp;<em>Bridge Bastion Dragon</em>, etc.), will trigger Eroda\'s Ability and won\'t count Eroda as a card being searched or sent out of the deck. The player would then search / send out the&nbsp;<strong><u>next</u></strong>&nbsp;card in order to fulfill the original card\'s effect / Ability;</p>\n<p>■&nbsp;When Eroda enters play from beneath the Main Deck, the player chooses to either summon it on an existing blank pile along with any energy attached from beneath the Main Deck, OR using only the energy beneath the Main Deck as a new pile. In the case of having no energy beneath the Main Deck when Eroda is summoned (from beneath the Main Deck), it can simply be summoned on an existing blank pile;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;If there are no valid open blank piles on your field and no energy beneath the Main Deck when Eroda needs to be summoned (from beneath the Main Deck), Eroda then goes straight to the graveyard;</p>\n<p>■&nbsp;During the course of normal gameplay, when zero cards remain in the Main Deck and Eroda\'s Ability triggers in an attempt to summon itself from beneath the Main Deck, players can respond to its Ability as usual. However, if Eroda\'s Ability causes it to be summoned from beneath the Main Deck in the middle of the owner\'s Draw Phase while they still need to Deck Recycle &amp; draw more cards, the Ability&nbsp;<strong><u>cannot</u></strong>&nbsp;be responded to and must resolve before the Deck Recycle<em>—</em>because the act of drawing card(s) during the Draw Phase is uninterruptable by default. For this reason, Eroda\'s Ability is considered "semi-automated";<br><br>■&nbsp;<em>If&nbsp;Eroda the Flickering Facade</em>&nbsp;appears in the Starting Hand (whether in the opening hand or by mulligan), its Ability triggers&nbsp;and will cause<br><em>Eroda&nbsp;</em><em>to immediately go beneath the Main Deck and allow the player to draw a replacement card.<br>The replacement draw is due to the fact that&nbsp;</em><em>Eroda\'s&nbsp;</em><em>Ability triggers whenever it "would" leave the Main Deck. Since it never actually goes from the deck to the hand, it doesn\'t count toward the number of cards drawn;<br></em><br><em>■&nbsp;Eroda&nbsp;</em><em>moves 1 energy to itself while beneath the Main Deck at the end of every single turn, and can move your teammate\'s energy in 2v2;</em></p>\n<p><em>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - If both players on a team each have their own&nbsp;</em><em>Eroda&nbsp;triggering to pull energy beneath the deck at the end of the turn, while there is only 1 energy among their shared field, they may come to a mutual agreement regarding which&nbsp;</em><em>Eroda&nbsp;</em><em>the energy should move to;</em></p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Eroda-the-Flickering-Facade-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_229',
    s3_large_image_name: 'MjI5LS0tOS1TcGFya3Nwb3JlLUNsdXN0ZXIucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjI5LS0tOS1TcGFya3Nwb3JlLUNsdXN0ZXIucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjI5LS0tOS1TcGFya3Nwb3JlLUNsdXN0ZXIucG5n/t',
    name: 'Sparkspore Cluster',
    set_name: 'Crystal Forge',
    set_number: '9',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk', 'Mistform'],
    creature_type_count: 2,
    artist: 'Elena Shiyanova',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Sparkspore-Cluster-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_565',
    s3_large_image_name:
      'NTY1LS0tOS1UbGFoLUJhcnJpY2FkZS1vZi10aGUtTGlicmFyeS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTY1LS0tOS1UbGFoLUJhcnJpY2FkZS1vZi10aGUtTGlicmFyeS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTY1LS0tOS1UbGFoLUJhcnJpY2FkZS1vZi10aGUtTGlicmFyeS5wbmcEXODUS/t',
    name: 'Tlah, Barricade of the Library',
    set_name: 'Threshold of Time',
    set_number: '9',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Drifter', 'Archive'],
    creature_type_count: 2,
    artist: 'Tanatola',
    effect:
      'This creature can only enter play on top of a Drifter. While this creature is in play, non-Archive creatures cannot attack on the turn they are summoned.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Tlah--Barricade-of-the-Library-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_287',
    s3_large_image_name: 'Mjg3LS0tMTAtQWxsdXZpb24tdGhlLUJyaXNrLVRpZGUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg3LS0tMTAtQWxsdXZpb24tdGhlLUJyaXNrLVRpZGUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg3LS0tMTAtQWxsdXZpb24tdGhlLUJyaXNrLVRpZGUucG5n/t',
    name: 'Alluvion the Brisk Tide',
    set_name: 'Converging Chasms',
    set_number: '10',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'B.A. Miller',
    effect:
      'While this creature is on your field, for each creature you cause your opponent to discard from their hand, add 1 energy to a Shardfolk in play. Only 1 "Alluvion the Brisk Tide" Ability can be active on the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Alluvion-the-Brisk-Tide-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_168',
    s3_large_image_name:
      'MTY4LS0tMTAtRW1iZXJpYS1CcmluZ2VyLW9mLUluZmVybm9zLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTY4LS0tMTAtRW1iZXJpYS1CcmluZ2VyLW9mLUluZmVybm9zLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTY4LS0tMTAtRW1iZXJpYS1CcmluZ2VyLW9mLUluZmVybm9zLnBuZwEXODUSEXODUS/t',
    name: 'Emberia, Bringer of Infernos',
    set_name: 'Galaxy Tides',
    set_number: '10',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Victor Corbella',
    effect:
      'When this creature is summoned, your opponent chooses and discards 1 card from their hand to the graveyard.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Emberia--Bringer-of-Infernos-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_566',
    s3_large_image_name:
      'NTY2LS0tMTAtRXZvbS1DaGltZXJpY2FsLVJlc29uYW5jZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTY2LS0tMTAtRXZvbS1DaGltZXJpY2FsLVJlc29uYW5jZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTY2LS0tMTAtRXZvbS1DaGltZXJpY2FsLVJlc29uYW5jZS5wbmcEXODUS/t',
    name: 'Evom, Chimerical Resonance',
    set_name: 'Threshold of Time',
    set_number: '10',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Drifter', 'Archive'],
    creature_type_count: 2,
    artist: 'A.Gvin',
    effect:
      'This creature can only enter play on top of a Drifter. While this creature is in play, once per turn, you may attach an existing blank pile of energy on your field to it.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Evom--Chimerical-Resonance-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_230',
    s3_large_image_name: 'MjMwLS0tMTAtTGlnaHRzdHJ1Y2stTGViYW5vbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjMwLS0tMTAtTGlnaHRzdHJ1Y2stTGViYW5vbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjMwLS0tMTAtTGlnaHRzdHJ1Y2stTGViYW5vbi5wbmcEXODUS/t',
    name: 'Lightstruck Lebanon',
    set_name: 'Crystal Forge',
    set_number: '10',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Storm'],
    creature_type_count: 2,
    artist: 'S. Calvin',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lightstruck-Lebanon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_461',
    s3_large_image_name:
      'NDYxLS0tMTAtc21va2VzdHJlYW0tdGhlLXBlcmZlY3QtbWltaWNyeS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDYxLS0tMTAtc21va2VzdHJlYW0tdGhlLXBlcmZlY3QtbWltaWNyeS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDYxLS0tMTAtc21va2VzdHJlYW0tdGhlLXBlcmZlY3QtbWltaWNyeS03MmRwaS5wbmcEXODUS/t',
    name: 'Smokestream the Perfect Mimicry',
    set_name: 'The Dimension That Disappeared',
    set_number: '10',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Brandon McDonald',
    effect:
      "While this creature is on the field, whenever an opposing creature enters play, you may force it to immediately battle this creature. AFTERTHOUGHT ABILITY: Your opponent can't cause more than one of your Afterthoughts to leave play at a time.",
    ruling:
      "<p>■ While <em>Smokestream's</em> Afterthought Ability is active, the player that is resolving the Afterthought-removal card gets to choose which active Afterthought&nbsp;leaves play;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Smokestream-the-Perfect-Mimicry-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_169',
    s3_large_image_name:
      'MTY5LS0tMTEtQ3J5c3RhbC1Db21tYW5kLUFuZHJvbWVkYS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTY5LS0tMTEtQ3J5c3RhbC1Db21tYW5kLUFuZHJvbWVkYS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTY5LS0tMTEtQ3J5c3RhbC1Db21tYW5kLUFuZHJvbWVkYS5wbmcEXODUS/t',
    name: 'Crystal Command Andromeda',
    set_name: 'Galaxy Tides',
    set_number: '11',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'COCOs',
    effect:
      "When this creature is summoned, if you have an \"Emberia, Bringer of Infernos\" on the field, choose 1 of your opponent's creatures and flip it face-down. It cannot attack while it's face-down. Flip it face-up at the end of your opponent's next turn.",
    ruling:
      "<p>■ This creature's Ability acts the same as Freeze mechanically, but as it doesn't use the keyword \"freeze\",<strong>&nbsp;it doesn't count toward the freeze-count in play</strong>;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystal-Command-Andromeda-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_567',
    s3_large_image_name:
      'NTY3LS0tMTEtRXJvY25lLUNvbnNjcmlwdC1DcnVzYWRlci5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTY3LS0tMTEtRXJvY25lLUNvbnNjcmlwdC1DcnVzYWRlci5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTY3LS0tMTEtRXJvY25lLUNvbnNjcmlwdC1DcnVzYWRlci5wbmcEXODUS/t',
    name: 'Erocne, Conscript Crusader',
    set_name: 'Threshold of Time',
    set_number: '11',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Drifter', 'Archive'],
    creature_type_count: 2,
    artist: 'Yosi Saputra',
    effect:
      'This creature can only enter play on top of a Drifter. This creature can attack opposing creatures up to once each during your Attack Phase.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Erocne--Conscript-Crusader-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_462',
    s3_large_image_name:
      'NDYyLS0tMTEtcm9ycm9oLWJlYXV0aWZ1bC1uaWdodG1hcmUtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDYyLS0tMTEtcm9ycm9oLWJlYXV0aWZ1bC1uaWdodG1hcmUtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDYyLS0tMTEtcm9ycm9oLWJlYXV0aWZ1bC1uaWdodG1hcmUtNzJkcGkucG5n/t',
    name: 'Rorroh, Beautiful Nightmare',
    set_name: 'The Dimension That Disappeared',
    set_number: '11',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono', 'Crow'],
    creature_type_count: 2,
    artist: 'Wes',
    effect:
      "When this creature battles, 1 damage carries over and hits your opponent's Life Points directly for each energy it has left after the battle, up to the number of Afterthoughts you have in play. AFTERTHOUGHT ABILITY: Chronos you control deal 1 additional damage when battling opposing Rare (or higher) creatures.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rorroh--Beautiful-Nightmare-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_231',
    s3_large_image_name:
      'MjMxLS0tMTEtUm9zZXJvb3QtUmVkLUNlZGFyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjMxLS0tMTEtUm9zZXJvb3QtUmVkLUNlZGFyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjMxLS0tMTEtUm9zZXJvb3QtUmVkLUNlZGFyLnBuZwEXODUSEXODUS/t',
    name: 'Roseroot Red Cedar',
    set_name: 'Crystal Forge',
    set_number: '11',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Wes',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Roseroot-Red-Cedar-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_288',
    s3_large_image_name: 'Mjg4LS0tMTEtU2hhdHRlcmdsYXNzLU93bC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg4LS0tMTEtU2hhdHRlcmdsYXNzLU93bC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg4LS0tMTEtU2hhdHRlcmdsYXNzLU93bC5wbmcEXODUS/t',
    name: 'Shatterglass Owl',
    set_name: 'Converging Chasms',
    set_number: '11',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Owl'],
    creature_type_count: 2,
    artist: 'Victor Corbella',
    effect:
      "While this creature is on your field, whenever one of your Common or Uncommon Shardfolk battles and destroys an opponent's creature, freeze an opponent's creature.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Shatterglass-Owl-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_289',
    s3_large_image_name: 'Mjg5LS0tMTItQ3J5c3RhbGxpbmUtU3RhZy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg5LS0tMTItQ3J5c3RhbGxpbmUtU3RhZy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjg5LS0tMTItQ3J5c3RhbGxpbmUtU3RhZy5wbmcEXODUS/t',
    name: 'Crystalline Stag',
    set_name: 'Converging Chasms',
    set_number: '12',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Stag'],
    creature_type_count: 2,
    artist: 'B.A. Miller',
    effect:
      'When this creature is summoned, freeze a blank pile of energy on the field. (The energy is flipped face-down. While face-down, energy cannot be added to it from the hand and a creature cannot be summoned on the pile.)',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystalline-Stag-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_170',
    s3_large_image_name:
      'MTcwLS0tMTItRGltZW5zaW9uYWwtRGVzcGVyYWRvLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTcwLS0tMTItRGltZW5zaW9uYWwtRGVzcGVyYWRvLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTcwLS0tMTItRGltZW5zaW9uYWwtRGVzcGVyYWRvLnBuZwEXODUSEXODUS/t',
    name: 'Dimensional Desperado',
    set_name: 'Galaxy Tides',
    set_number: '12',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'COCOs',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Desperado-First-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_568',
    s3_large_image_name: 'NTY4LS0tMTItRXJ1Yy1BcmNoaXZlJ3MtQWVnaXMucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTY4LS0tMTItRXJ1Yy1BcmNoaXZlJ3MtQWVnaXMucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTY4LS0tMTItRXJ1Yy1BcmNoaXZlJ3MtQWVnaXMucG5n/t',
    name: "Eruc, Archive's Aegis",
    set_name: 'Threshold of Time',
    set_number: '12',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Drifter', 'Archive'],
    creature_type_count: 2,
    artist: 'Mat Gimeno',
    effect:
      'This creature can only enter play on top of a Drifter. While this creature is in play, if you have less Life Points than your opponent during your End Phase, you may gain 1 Life Point.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Eruc--Archive-s-Aegis-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_463',
    s3_large_image_name:
      'NDYzLS0tMTItc2lsZW50LWlycmVndWxhcml0eS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDYzLS0tMTItc2lsZW50LWlycmVndWxhcml0eS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDYzLS0tMTItc2lsZW50LWlycmVndWxhcml0eS03MmRwaS5wbmcEXODUS/t',
    name: 'Silent Irregularity',
    set_name: 'The Dimension That Disappeared',
    set_number: '12',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Ruk Trumata',
    effect:
      'Whenever this creature goes to the graveyard, add 1 energy beneath your Main Deck or to a creature in play. AFTERTHOUGHT ABILITY: Ignore all Life Point requirements (excluding costs) for your card effects and Abilities.',
    ruling:
      "<p>■ If a player chooses to turn this creature into an Afterthought, its normal Ability will&nbsp;<strong><u>not</u></strong>&nbsp;trigger, since it never went to the graveyard;</p>\n<p>■&nbsp;<em>Silent Irregularity's</em>&nbsp;normal Ability will effectively trigger whenever it goes to the graveyard from any other zone, such as hand, Main Deck or field. Additionally, its Ability may also trigger if this creature is sent to the graveyard&nbsp;after being destroyed as an Afterthought. The moment Afterthoughts leave play, they are considered creatures again, so&nbsp;<em>Silent Irregularity's</em>&nbsp;normal Ability once again becomes active as it gets sent to the graveyard;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Silent-Irregularity-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_232',
    s3_large_image_name: 'MjMyLS0tMTItVHJlZWZvcmdlLUNvbXBsZXgucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjMyLS0tMTItVHJlZWZvcmdlLUNvbXBsZXgucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjMyLS0tMTItVHJlZWZvcmdlLUNvbXBsZXgucG5n/t',
    name: 'Treeforge Complex',
    set_name: 'Crystal Forge',
    set_number: '12',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Odysseas Stamoglou',
    effect:
      "Pay 1 energy. Reveal the top card of your opponent's Main Deck. If they revealed a creature, they may add it to their hand. If they revealed a symmetry, they lose 2 Life Points.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Treeforge-Complex-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_171',
    s3_large_image_name: 'MTcxLS0tMTMtQ29zbWljLVNoaWVsZC1BcmNoYW5nZWwucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTcxLS0tMTMtQ29zbWljLVNoaWVsZC1BcmNoYW5nZWwucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTcxLS0tMTMtQ29zbWljLVNoaWVsZC1BcmNoYW5nZWwucG5n/t',
    name: 'Cosmic Shield Archangel',
    set_name: 'Galaxy Tides',
    set_number: '13',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'Rebecca Weaver',
    effect:
      'Pay 1 energy when this creature is summoned. Then you and your opponent each send a Rare creature on your field to the graveyard.',
    ruling:
      '<p>■ When this creature is summoned, its Ability&nbsp;<strong>must</strong>&nbsp;trigger unless it is removed from the field in response to being summoned;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - You do not pay the energy cost for its Ability until it triggers;</p>\n<p>■ Its Ability states that players must only "send&nbsp;<u>a Rare creature</u>" from their field to the graveyard, therefore&nbsp;<strong>all attached energy remains in play</strong>;</p>\n<p><em>■&nbsp;</em>If&nbsp;<em>Archangel&nbsp;</em>is summoned on a pile of 1 energy and you pay the cost from itself, the Ability is in the middle of resolving, so both players must send a Rare on the field to their graveyard. However,&nbsp;<em>Archangel</em>&nbsp;has no energy left and is immediately sent to the graveyard. In this case, it does not count as your Rare and&nbsp;<strong>you must select another Rare creature on your field to send to the graveyard if one is available</strong>;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cosmic-Shield-Archangel-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_569',
    s3_large_image_name:
      'NTY5LS0tMTMtRHJhb2gtVW50b2xkLUxpYmVyYXRvci5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTY5LS0tMTMtRHJhb2gtVW50b2xkLUxpYmVyYXRvci5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTY5LS0tMTMtRHJhb2gtVW50b2xkLUxpYmVyYXRvci5wbmcEXODUS/t',
    name: 'Draoh, Untold Liberator',
    set_name: 'Threshold of Time',
    set_number: '13',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Drifter', 'Archive'],
    creature_type_count: 2,
    artist: 'A.Gvin',
    effect:
      'This creature can only enter play on top of a Drifter. You may add any amount of energy from your hand to this creature during your Energy Phase.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Draoh--Untold-Liberator-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_233',
    s3_large_image_name: 'MjMzLS0tMTMtUm9zZXMtUmVhY2gucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjMzLS0tMTMtUm9zZXMtUmVhY2gucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjMzLS0tMTMtUm9zZXMtUmVhY2gucG5n/t',
    name: "Rose's Reach",
    set_name: 'Crystal Forge',
    set_number: '13',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Hafid Moenir',
    effect:
      'If you have at least 1 Common, Uncommon, and Rare creature on your field, unfreeze all non-Shardfolk creatures in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rose-s-Reach-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_290',
    s3_large_image_name: 'MjkwLS0tMTMtU25vdy1CYXN0aW9uLUFiZXJyYXRpb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjkwLS0tMTMtU25vdy1CYXN0aW9uLUFiZXJyYXRpb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjkwLS0tMTMtU25vdy1CYXN0aW9uLUFiZXJyYXRpb24ucG5n/t',
    name: 'Snow Bastion Aberration',
    set_name: 'Converging Chasms',
    set_number: '13',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Michelle Graves',
    effect:
      "This creature comes into play frozen (face-down). When this card reaches 5 or more energy, unfreeze it and permanently freeze an opponent's creature on the field (flip it face-down; the frozen creature cannot attack).",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Snow-Bastion-Aberration-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_464',
    s3_large_image_name:
      'NDY0LS0tMTMtd2FuZGVyd29sZi10aGUtaW5uZXItZmVhci03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDY0LS0tMTMtd2FuZGVyd29sZi10aGUtaW5uZXItZmVhci03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDY0LS0tMTMtd2FuZGVyd29sZi10aGUtaW5uZXItZmVhci03MmRwaS5wbmcEXODUS/t',
    name: 'Wanderwolf the Inner Fear',
    set_name: 'The Dimension That Disappeared',
    set_number: '13',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono', 'Wolf'],
    creature_type_count: 2,
    artist: 'A.Gvin',
    effect:
      "This creature may attack blank piles of energy. (Blank piles don't deal damage to it.) AFTERTHOUGHT ABILITY: The first time your opponent damages your Life Points each turn, you take 1 less damage.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Wanderwolf-the-Inner-Fear-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_465',
    s3_large_image_name:
      'NDY1LS0tMTQtY2F1c3RpYy1zaWxob3VldHRlLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDY1LS0tMTQtY2F1c3RpYy1zaWxob3VldHRlLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDY1LS0tMTQtY2F1c3RpYy1zaWxob3VldHRlLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Caustic Silhouette',
    set_name: 'The Dimension That Disappeared',
    set_number: '14',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Ruk Trumata',
    effect:
      'When this creature enters play, you may discard 1 card from hand and draw 1 card. AFTERTHOUGHT ABILITY: You may send this Afterthought to the graveyard to draw 1 card.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Caustic-Silhouette-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_172',
    s3_large_image_name: 'MTcyLS0tMTQtQ291bmNpbC1vZi1HYWxheGllcy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTcyLS0tMTQtQ291bmNpbC1vZi1HYWxheGllcy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTcyLS0tMTQtQ291bmNpbC1vZi1HYWxheGllcy5wbmcEXODUS/t',
    name: 'Council of Galaxies',
    set_name: 'Galaxy Tides',
    set_number: '14',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'Kenny Estrella',
    effect:
      'When this creature is summoned, reveal the top card of your Main Deck. Then put it back on the top or bottom.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Council-of-Galaxies-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_234',
    s3_large_image_name: 'MjM0LS0tMTQtSGlkZGVuLUhhdmVuLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjM0LS0tMTQtSGlkZGVuLUhhdmVuLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjM0LS0tMTQtSGlkZGVuLUhhdmVuLnBuZwEXODUSEXODUS/t',
    name: 'Hidden Haven',
    set_name: 'Crystal Forge',
    set_number: '14',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Elena Shiyanova',
    effect:
      'Reveal the top card of your Main Deck. If it is a creature, you may add it to your hand. If it is a symmetry, send it to the graveyard.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hidden-Haven-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_570',
    s3_large_image_name: 'NTcwLS0tMTQtTWFyZ2FuYS1DaGltZXJpYy1MaWJyYXJpYW4ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTcwLS0tMTQtTWFyZ2FuYS1DaGltZXJpYy1MaWJyYXJpYW4ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTcwLS0tMTQtTWFyZ2FuYS1DaGltZXJpYy1MaWJyYXJpYW4ucG5n/t',
    name: 'Margana, Chimeric Librarian',
    set_name: 'Threshold of Time',
    set_number: '14',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Drifter', 'Archive'],
    creature_type_count: 2,
    artist: 'Nivea Toliver',
    effect:
      'This creature can only enter play on top of a Drifter. Once per turn, when this creature transforms into another creature, you may search your Main Deck or graveyard for an Archive creature and add it to your hand. (Shuffle your Main Deck if it was searched.)',
    ruling:
      '<ul>\n<li style="font-weight: 400;"><span style="font-weight: 400;"><em>Margana’s</em> Ability specifically states, “</span><strong>Once per turn</strong><span style="font-weight: 400;">, when </span><strong>this</strong><span style="font-weight: 400;"> creature transforms into another creature…”;&nbsp;</span></li>\n<ul>\n<li style="font-weight: 400;"><span style="font-weight: 400;">Drifter/Archive creatures are considered one in the same creature, meaning this Ability can only be used once per turn, regardless if you have multiple copies of <em>Margana</em> being transformed within the Archive stack;</span></li>\n</ul>\n</ul>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Margana--Chimeric-Librarian-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_291',
    s3_large_image_name:
      'MjkxLS0tMTQtUGxhbmV0YXJ5LUNyYWctb2YtdGhlLUNvc21vcy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjkxLS0tMTQtUGxhbmV0YXJ5LUNyYWctb2YtdGhlLUNvc21vcy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjkxLS0tMTQtUGxhbmV0YXJ5LUNyYWctb2YtdGhlLUNvc21vcy5wbmcEXODUS/t',
    name: 'Planetary Crag of the Cosmos',
    set_name: 'Converging Chasms',
    set_number: '14',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    effect:
      'While this creature is on your field, if one of your Shardfolk is targeted by an effect or Ability, you may change the target to this creature instead. The target cannot be changed afterwards.',
    ruling:
      '<p>■ Your other Shardfolk are considered "targeted" when your opponent uses an effect or Ability that lets them "choose" or "select";&nbsp;</p>\n<p>■&nbsp;<strong>You cannot use this Ability against an effect or Ability that affects all other creatures in play</strong>&nbsp;(i.e.&nbsp;<em>Roxanne the Final Paladin</em>&nbsp;or&nbsp;<em>Chaos Chasm, Eeventide Awoken</em>);</p>\n<p>■ This Ability can be used to interrupt a symmetry because the text specifically says, "effect or Ability" and a symmetry is a type of effect;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - This Ability can be activated and used at any time as long as&nbsp;<em>Planetary Crag of the Cosmos</em>&nbsp;is on your field;</p>\n<p><em>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; •&nbsp;</em>&nbsp;If this Ability was used to redirect a target, it can still be responded to, however, it can continue to interrupt those new responses via Playback;</p>\n<p>■ This Ability prohibits the opponent from choosing a new target by normal means, such as through Playback, because the text specifically states, "The target cannot be changed afterwards";&nbsp;<br><br>■ If&nbsp;<em>Planetary Crag of the Cosmos</em>&nbsp;is already frozen and its Ability is used to redirect a freeze target to itself, the freeze will fizzle out due to&nbsp;<em>Planetary Crag</em>&nbsp;already being frozen;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Planetary-Crag-of-the-Cosmos-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_173',
    s3_large_image_name:
      'MTczLS0tMTUtRW5kZWxtb3JlLUJyaW5nZXItb2YtVmljdG9yeS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTczLS0tMTUtRW5kZWxtb3JlLUJyaW5nZXItb2YtVmljdG9yeS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTczLS0tMTUtRW5kZWxtb3JlLUJyaW5nZXItb2YtVmljdG9yeS5wbmcEXODUS/t',
    name: 'Endelmore, Bringer of Victory',
    set_name: 'Galaxy Tides',
    set_number: '15',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'Kenny Estrella',
    effect:
      'When this creature is summoned, search your Main Deck for 1 "Victory, Keeper of the Order" and add it to your hand. Then, shuffle your Main Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Endelmore--Bringer-of-Victory-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_466',
    s3_large_image_name:
      'NDY2LS0tMTUtZmxhc2hmaXJlLW5lYnVsb3VzLWhhemUtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDY2LS0tMTUtZmxhc2hmaXJlLW5lYnVsb3VzLWhhemUtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDY2LS0tMTUtZmxhc2hmaXJlLW5lYnVsb3VzLWhhemUtNzJkcGkucG5n/t',
    name: 'Flashfire, Nebulous Haze',
    set_name: 'The Dimension That Disappeared',
    set_number: '15',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono', 'Hailfire'],
    creature_type_count: 2,
    artist: 'A.Gvin',
    effect:
      "When this creature is summoned and whenever it attacks, take 1 energy from your Energy Deck and use it to start a new pile. AFTERTHOUGHT ABILITY: You can't lose Life Points due to your opponent's card effects or Abilities. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Flashfire--Nebulous-Haze-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_235',
    s3_large_image_name: 'MjM1LS0tMTUtSGVsdmVyLUZvcm1hdGlvbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjM1LS0tMTUtSGVsdmVyLUZvcm1hdGlvbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjM1LS0tMTUtSGVsdmVyLUZvcm1hdGlvbi5wbmcEXODUS/t',
    name: 'Helver Formation',
    set_name: 'Crystal Forge',
    set_number: '15',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      "Pay 1 Life Point. Select one of your Common or Uncommon creatures in play that is multiple types and one of your opponent's creatures that is a single type and switch their energy levels.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Helver-Formation-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_292',
    s3_large_image_name:
      'MjkyLS0tMTUtS25pZ2h0LW9mLXRoZS1Gcm96ZW4tQ2xheW1vcmUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjkyLS0tMTUtS25pZ2h0LW9mLXRoZS1Gcm96ZW4tQ2xheW1vcmUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjkyLS0tMTUtS25pZ2h0LW9mLXRoZS1Gcm96ZW4tQ2xheW1vcmUucG5n/t',
    name: 'Knight of Frozen Claymore',
    set_name: 'Converging Chasms',
    set_number: '15',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Michelle Graves',
    effect: 'When this creature is summoned, freeze 1 energy in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Knight-of-Frozen-Claymore-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_571',
    s3_large_image_name: 'NTcxLS0tMTUtTGF0aXYtUmVzdG9yYXRpdmUtQ2F0YWx5c3QucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTcxLS0tMTUtTGF0aXYtUmVzdG9yYXRpdmUtQ2F0YWx5c3QucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTcxLS0tMTUtTGF0aXYtUmVzdG9yYXRpdmUtQ2F0YWx5c3QucG5n/t',
    name: 'Lativ, Restorative Catalyst',
    set_name: 'Threshold of Time',
    set_number: '15',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Drifter', 'Archive'],
    creature_type_count: 2,
    artist: 'A.Gvin',
    effect:
      'This creature can only enter play on top of a Drifter. If you have no Archive creatures in play, you may summon this creature from your hand or graveyard and it gains 1 energy; the turn immediately ends. "Vital DNA" can only be used once per game.',
    ruling: '<p><em>Official Ruling Coming Soon!</em></p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lativ--Restorative-Catalyst-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_467',
    s3_large_image_name:
      'NDY3LS0tMTYtY29udm9sdXRlZC1jb2FsZXNjZW5jZS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDY3LS0tMTYtY29udm9sdXRlZC1jb2FsZXNjZW5jZS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDY3LS0tMTYtY29udm9sdXRlZC1jb2FsZXNjZW5jZS03MmRwaS5wbmcEXODUS/t',
    name: 'Convoluted Coalescence',
    set_name: 'The Dimension That Disappeared',
    set_number: '16',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono', 'Hailfire'],
    creature_type_count: 2,
    artist: 'Brandon McDonald',
    effect:
      "When this creature is summoned, you may target 1 card with an Afterthought Ability from your graveyard and put it into play as an Afterthought. AFTERTHOUGHT ABILITY: You can't put more Afterthoughts into play. You may draw 1 extra card during your Draw Phase.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Convoluted-Coalescence-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_236',
    s3_large_image_name: 'MjM2LS0tMTYtU3RhcmxpdC1FeHBhbnNlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjM2LS0tMTYtU3RhcmxpdC1FeHBhbnNlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjM2LS0tMTYtU3RhcmxpdC1FeHBhbnNlLnBuZwEXODUSEXODUS/t',
    name: 'Starlit Expanse',
    set_name: 'Crystal Forge',
    set_number: '16',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'J.L.Lockwood',
    effect:
      'Put a card from your hand on top of your Main Deck. Then, draw 1 energy.',
    ruling:
      "<p>■&nbsp;<strong>Energy</strong><strong>&nbsp;cannot be placed on top of the Main Deck</strong>&nbsp;with this effect;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Energy cards can't enter the Main Deck, so only a creature or symmetry card can be chosen by this card's effect;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Starlit-Expanse-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_572',
    s3_large_image_name:
      'NTcyLS0tMTYtVGFjaHlvbi1Ub3VyYmlsbG9uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTcyLS0tMTYtVGFjaHlvbi1Ub3VyYmlsbG9uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTcyLS0tMTYtVGFjaHlvbi1Ub3VyYmlsbG9uLnBuZwEXODUSEXODUS/t',
    name: 'Tachyon Tourbillon',
    set_name: 'Threshold of Time',
    set_number: '16',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect:
      "When this creature is rebuilt, send 1 energy in play to the owner's hand and draw 1 energy. If any Phase was skipped or done out of order this turn, activate this Ability from a viewable zone to target 1 of your Machines in play and rebuild it (even if it and the rebuild target have already been rebuilt this turn).",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Tachyon-Tourbillon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_293',
    s3_large_image_name:
      'MjkzLS0tMTYtVmFzdGlvbi10aGUtV29ybGRzLUhvbGxvdy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjkzLS0tMTYtVmFzdGlvbi10aGUtV29ybGRzLUhvbGxvdy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjkzLS0tMTYtVmFzdGlvbi10aGUtV29ybGRzLUhvbGxvdy5wbmcEXODUS/t',
    name: "Vastion the World's Hollow",
    set_name: 'Converging Chasms',
    set_number: '16',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'André Martinez',
    effect:
      'When this creature is summoned, each player reveals their hand. When this creature attacks, it gains 1 energy just before the attack hits.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Vastion-the-World-s-Hollow-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_174',
    s3_large_image_name:
      'MTc0LS0tMTYtVmljdG9yeS1LZWVwZXItb2YtdGhlLU9yZGVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTc0LS0tMTYtVmljdG9yeS1LZWVwZXItb2YtdGhlLU9yZGVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTc0LS0tMTYtVmljdG9yeS1LZWVwZXItb2YtdGhlLU9yZGVyLnBuZwEXODUSEXODUS/t',
    name: 'Victory, Keeper of the Order',
    set_name: 'Galaxy Tides',
    set_number: '16',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'Didi Esmeralda',
    effect:
      'While this creature is on your field, your opponent cannot attack your other Order creatures.',
    ruling:
      '<p>■&nbsp;<em>Victory\'s&nbsp;</em>Ability "Royal Decree" makes all of your other Order creatures (besides herself) unable to be attacked by your opponent while she is on the field;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - If you have 2&nbsp;<em>Victory, Keeper of the Order&nbsp;</em>on the field, your opponent cannot attack either one&nbsp;because of each affecting the other;</p>\n<p><em>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; •&nbsp;</em>&nbsp;If you have 2&nbsp;<em>Victory, Keeper of the Order&nbsp;</em>on the field, your opponent&nbsp;<u>must</u>&nbsp;destroy or remove a&nbsp;<em>Victory, Keeper of the Order</em>&nbsp;by other means (symmetry or creature Abilities) before they can attack your Order creatures;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Victory--Keeper-of-the-Order-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_468',
    s3_large_image_name:
      'NDY4LS0tMTctaGFpbHN0b25lLWR1c3Rtb3RoLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDY4LS0tMTctaGFpbHN0b25lLWR1c3Rtb3RoLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDY4LS0tMTctaGFpbHN0b25lLWR1c3Rtb3RoLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Hailstone Dustmoth',
    set_name: 'The Dimension That Disappeared',
    set_number: '17',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Behemoth'],
    creature_type_count: 2,
    artist: 'Mat Gimeno',
    effect:
      'While this creature is on the field, once per turn, you may activate this Ability to target 1 creature in play and change it to any rarity for the rest of the turn.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hailstone-Dustmoth-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_573',
    s3_large_image_name: 'NTczLS0tMTctSW5zYXRpYWJsZS1BYnlzbS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTczLS0tMTctSW5zYXRpYWJsZS1BYnlzbS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTczLS0tMTctSW5zYXRpYWJsZS1BYnlzbS5wbmcEXODUS/t',
    name: 'Insatiable Abysm',
    set_name: 'Threshold of Time',
    set_number: '17',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'Thai Vo',
    effect:
      'When this creature battles and survives, you may rebuild it. If you do, it regains the energy it lost during that battle.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Insatiable-Abysm-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_175',
    s3_large_image_name:
      'MTc1LS0tMTctTGVnZW5kYXJ5LUJsYWRlLUx1aHphcnVzLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTc1LS0tMTctTGVnZW5kYXJ5LUJsYWRlLUx1aHphcnVzLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTc1LS0tMTctTGVnZW5kYXJ5LUJsYWRlLUx1aHphcnVzLnBuZwEXODUSEXODUS/t',
    name: 'Legendary Blade Luhzarus',
    set_name: 'Galaxy Tides',
    set_number: '17',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'Victor Corbella',
    effect:
      'You may pay 1 energy from this creature. If you do, it may conduct a second attack during your turn.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Legendary-Blade-Luhzarus-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_294',
    s3_large_image_name:
      'Mjk0LS0tMTctT3Zlcmdyb3duLVRyZW5jaC1WYWxjaGFzbS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk0LS0tMTctT3Zlcmdyb3duLVRyZW5jaC1WYWxjaGFzbS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk0LS0tMTctT3Zlcmdyb3duLVRyZW5jaC1WYWxjaGFzbS5wbmcEXODUS/t',
    name: 'Overgrown Trench Valchasm',
    set_name: 'Converging Chasms',
    set_number: '17',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Mushfolk'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    effect:
      "When this creature is revealed by an effect, you may send 1 energy on the field back to the owner's hand and draw 1 energy.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Overgrown-Trench-Valchasm-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_237',
    s3_large_image_name: 'MjM3LS0tMTctVHJlZWxpZ2h0LUNvbnZveS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjM3LS0tMTctVHJlZWxpZ2h0LUNvbnZveS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjM3LS0tMTctVHJlZWxpZ2h0LUNvbnZveS5wbmcEXODUS/t',
    name: 'Treelight Convoy',
    set_name: 'Crystal Forge',
    set_number: '17',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Elena Shiyanova',
    effect:
      "Pay 1 Life Point. Select one of your Common or Uncommon Treefolk or Mushfolk in play. This turn, it doesn't lose energy during battle.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Treelight-Convoy-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_176',
    s3_large_image_name: 'MTc2LS0tMTgtRHJlYW0tQmxvc3NvbS1EcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTc2LS0tMTgtRHJlYW0tQmxvc3NvbS1EcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTc2LS0tMTgtRHJlYW0tQmxvc3NvbS1EcmFnb24ucG5n/t',
    name: 'Dream Blossom Dragon',
    set_name: 'Galaxy Tides',
    set_number: '18',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'COCOs',
    effect:
      "When this creature is summoned, discard 1 card from your hand if possible. If you do, discard 1 energy from your opponent's side of the field.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dream-Blossom-Dragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_574',
    s3_large_image_name: 'NTc0LS0tMTgtRmxhcmV0cmFwLU1hbnRpcy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTc0LS0tMTgtRmxhcmV0cmFwLU1hbnRpcy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTc0LS0tMTgtRmxhcmV0cmFwLU1hbnRpcy5wbmcEXODUS/t',
    name: 'Flaretrap Mantis',
    set_name: 'Threshold of Time',
    set_number: '18',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'Albert Zhou',
    effect:
      'When one of your Machines attacks or is attacked, you may rebuild it with this creature. If you do, damage it takes is halved (rounded up) for the rest of the turn; the original attack must also carry through if possible, regardless of Playback.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Flaretrap-Mantis-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_295',
    s3_large_image_name: 'Mjk1LS0tMTgtTWlzdHJhaS1EcmlmdHdvb2QucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk1LS0tMTgtTWlzdHJhaS1EcmlmdHdvb2QucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk1LS0tMTgtTWlzdHJhaS1EcmlmdHdvb2QucG5n/t',
    name: 'Mistrai Driftwood',
    set_name: 'Converging Chasms',
    set_number: '18',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Mistform'],
    creature_type_count: 2,
    artist: 'B.A. Miller',
    effect:
      "When this creature is attacked, you may have the attack pass through and hit your Life Points directly instead. When this creature attacks, you may have it hit your opponent's Life Points directly. If it does, destroy this creature and all energy attached after the attack hits.",
    ruling:
      '<p>■ If&nbsp;<em>Roxanne the Final Paladin&nbsp;</em>attacks while the opponent has a&nbsp;<em>Mistrai Driftwood</em>&nbsp;on the field, and the player controlling&nbsp;<em>Mistrai Driftwood</em>&nbsp;activates its "Evanescent Hollow" Ability to let the attack pass through,&nbsp;<em>Roxanne&nbsp;</em>hits the opponent\'s Life Points directly and all other creatures in play, and takes damage from those other creatures (except&nbsp;<em>Mistrai Driftwood</em>, which survives);</p>\n<p>■ If&nbsp;<em>Drangel&nbsp;</em>is on the field when a Common Dragon or Angel attacks&nbsp;<em>Mistrai Driftwood</em>, the Common Dragon or Angel still gains 1 energy from&nbsp;<em>Drangel</em><em>\'s</em>&nbsp;Ability, even if&nbsp;<em>Mistrai Driftwood\'s</em>&nbsp;controller lets the attack pass through due to the original target being a Rare creature;</p>\n<p>■&nbsp;When you declare a direct attack using&nbsp;<em>Mistrai Driftwood\'s</em>&nbsp;Ability while you have&nbsp;<em>Howling Synthesis</em>&nbsp;active on the field, resulting in you revealing a creature, and you switch Mistrai Driftwood with the revealed creature, the revealed creature comes into play &amp; replaces Mistrai Driftwood "just before the attack hits". Any "enter play", "put into play" or "summon" Abilities on the new creature will trigger and resolve, and then that creature will continue on the same attack path originally declared by&nbsp;<em>Mistrai Driftwood</em>. The new creature will be destroyed along with all energy attached after the attack, since the entirety of Driftwood\'s Ability is implied (and Driftwood is no longer in play);</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mistrai-Driftwood-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_238',
    s3_large_image_name: 'MjM4LS0tMTgtTmVidWxhLUdleXNlci1NZWFkb3cucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjM4LS0tMTgtTmVidWxhLUdleXNlci1NZWFkb3cucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjM4LS0tMTgtTmVidWxhLUdleXNlci1NZWFkb3cucG5n/t',
    name: 'Nebula Geyser Meadow',
    set_name: 'Crystal Forge',
    set_number: '18',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'S. Calvin',
    effect:
      'Select one Common or Uncommon creature in your graveyard and put it into play on an existing blank pile of energy on your side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Nebula-Geyser-Meadow-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_469',
    s3_large_image_name:
      'NDY5LS0tMTgtc2hhcmRzY2FsZS1wdGVyb2hlZHJvbi03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDY5LS0tMTgtc2hhcmRzY2FsZS1wdGVyb2hlZHJvbi03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDY5LS0tMTgtc2hhcmRzY2FsZS1wdGVyb2hlZHJvbi03MmRwaS5wbmcEXODUS/t',
    name: 'Shardscale Pterohedron',
    set_name: 'The Dimension That Disappeared',
    set_number: '18',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect:
      "You may activate this Ability from your hand and pay 1 energy to put this creature into play on an existing blank pile on your field. If it enters play on your opponent's turn, pay 1 additional energy. When it enters play by this Ability, opposing Abilities become inactive for the rest of the turn. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Shardscale-Pterohedron-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_296',
    s3_large_image_name: 'Mjk2LS0tMTktQW1ldGh5c3QtVm9pZGNhcC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk2LS0tMTktQW1ldGh5c3QtVm9pZGNhcC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk2LS0tMTktQW1ldGh5c3QtVm9pZGNhcC5wbmcEXODUS/t',
    name: 'Amethyst Voidcap',
    set_name: 'Converging Chasms',
    set_number: '19',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk'],
    creature_type_count: 1,
    artist: 'B.A. Miller',
    effect:
      'If you have less Life Points than your opponent, you may activate this Ability while this creature is in your graveyard. Summon this creature from your graveyard with 1 energy on it. This Ability cannot be used again until after your next Deck Recycle.',
    ruling:
      "<p>■&nbsp;<strong>This creature's Ability will fail to resolve if it is activated in response to a Symmetry that causes a Deck Recycle</strong>&nbsp;(i.e.&nbsp;<em>Starborn Outbreak</em>). This is due to the fact that Symmetry speed is faster than speed of Creature Abilities;&nbsp;</p>\n<p>■ You can activate this Ability&nbsp;<strong>before&nbsp;</strong>or&nbsp;<strong>after&nbsp;</strong>card drawing occurs, but not during; (<strong>Example</strong>: if you need to draw 3 cards from&nbsp;<em>Vortex&nbsp;</em>or your Draw Phase, you can't draw 1 card, trigger&nbsp;<em>Voidcap's&nbsp;</em>Ability, and then draw the other 2);</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Amethyst-Voidcap-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_177',
    s3_large_image_name: 'MTc3LS0tMTktRHJhbmdlbC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTc3LS0tMTktRHJhbmdlbC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTc3LS0tMTktRHJhbmdlbC5wbmcEXODUS/t',
    name: 'Drangel',
    set_name: 'Galaxy Tides',
    set_number: '19',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Angel'],
    creature_type_count: 2,
    artist: 'COCOs',
    effect:
      'While this creature is on the field, each Common Dragon or Angel that attacks a Rare creature gains 1 energy just before the attack hits. Only 1 "Drangel" ability can be active on the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Drangel-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_575',
    s3_large_image_name:
      'NTc1LS0tMTktTGlyZXAtdGhlLUNvbnNvcnRpdW0tSGllYXJjaC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTc1LS0tMTktTGlyZXAtdGhlLUNvbnNvcnRpdW0tSGllYXJjaC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTc1LS0tMTktTGlyZXAtdGhlLUNvbnNvcnRpdW0tSGllYXJjaC5wbmcEXODUS/t',
    name: 'Lirep the Consortium Hierarch',
    set_name: 'Threshold of Time',
    set_number: '19',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine', 'Angel'],
    creature_type_count: 2,
    artist: 'Tommy Suhartono',
    effect:
      'When this creature is rebuilt, you may activate this Ability to make it unaffected by either opposing symmetries or opposing Abilities for the rest of the turn.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lirep-the-Consortium-Hierarch-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_470',
    s3_large_image_name:
      'NDcwLS0tMTktcXVhZHJpdmlhbC13YW5kZXJlci03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDcwLS0tMTktcXVhZHJpdmlhbC13YW5kZXJlci03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDcwLS0tMTktcXVhZHJpdmlhbC13YW5kZXJlci03MmRwaS5wbmcEXODUS/t',
    name: 'Quadrivial Wanderer',
    set_name: 'The Dimension That Disappeared',
    set_number: '19',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Ruk Trumata',
    effect:
      'When this creature enters play, it gains 1 permanently frozen energy for each creature your opponent has in play more than you.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Quadrivial-Wanderer-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_239',
    s3_large_image_name:
      'MjM5LS0tMTktU2lwaG9uaW5nLUVuZXJneS1Sb290cy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjM5LS0tMTktU2lwaG9uaW5nLUVuZXJneS1Sb290cy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjM5LS0tMTktU2lwaG9uaW5nLUVuZXJneS1Sb290cy5wbmcEXODUS/t',
    name: 'Siphoning Energy Roots',
    set_name: 'Crystal Forge',
    set_number: '19',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Elena Shiyanova',
    effect: 'Select and destroy 1 energy from a blank pile on the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Siphoning-Energy-Roots-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_297',
    s3_large_image_name:
      'Mjk3LS0tMjAtQ2Fua2Vyb3VzLU5lZWRsZXNwaXJlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk3LS0tMjAtQ2Fua2Vyb3VzLU5lZWRsZXNwaXJlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk3LS0tMjAtQ2Fua2Vyb3VzLU5lZWRsZXNwaXJlLnBuZwEXODUSEXODUS/t',
    name: 'Cankerous Needlespire',
    set_name: 'Converging Chasms',
    set_number: '20',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    effect:
      "Whenever this creature battles an opposing creature while you have less Life Points than your opponent, destroy both creatures and return all energy attached back to the owners' hands.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cankerous-Needlespire-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_240',
    s3_large_image_name: 'MjQwLS0tMjAtRW5lcmd5LURpc3BlcnNhbC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQwLS0tMjAtRW5lcmd5LURpc3BlcnNhbC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQwLS0tMjAtRW5lcmd5LURpc3BlcnNhbC5wbmcEXODUS/t',
    name: 'Energy Dispersal',
    set_name: 'Crystal Forge',
    set_number: '20',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Nivea Toliver',
    effect:
      "Each player selects one blank pile of energy on their opponent's side of the field and returns it to the owner's hand.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energy-Dispersal-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_178',
    s3_large_image_name: 'MTc4LS0tMjAtRXRoZXJlYWwtQXVyb3JpYWxpcy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTc4LS0tMjAtRXRoZXJlYWwtQXVyb3JpYWxpcy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTc4LS0tMjAtRXRoZXJlYWwtQXVyb3JpYWxpcy5wbmcEXODUS/t',
    name: 'Ethereal Aurorialis',
    set_name: 'Galaxy Tides',
    set_number: '20',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'COCOs',
    effect:
      "When this creature attacks, reveal the top card of your Main Deck. If it is a creature, it attacks your opponent's Life Points directly. If it is a symmetry, it attacks your Life Points directly.",
    ruling:
      '<p>■ When this creature attacks, it&nbsp;<u>must always</u>&nbsp;use its Ability "Transcendent Force" (the Ability is not optional);</p>\n<p>■ When declaring an attack using&nbsp;<em>Ethereal Aurorialis</em>,&nbsp;<strong>your opponent must choose to play or not play any cards in response</strong>&nbsp;<u>before</u>&nbsp;the top card of your Main Deck is revealed;</p>\n<p><em>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;</em>By the time its Ability has triggered, it is too late for you or your opponent to activate any symmetry cards in response until after damage has been dealt;<br><br>■&nbsp;&nbsp;When attacking with <em>Ethereal Aurorialis</em>, the team that controls&nbsp;it may choose to reveal the top card of the&nbsp;Main Deck belonging to any player on their team in&nbsp;Multiplayer format;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>When attacking with&nbsp;<em>Ethereal Aurorialis</em> and<em> Anathema</em> is revealed by its Ability, <em>Ethereal Aurorialis</em> attacks both yours and your opponent\'s Life Points at once due to <em>Anathema</em> being both a creature and a symmetry;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Ethereal-Aurorialis-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_471',
    s3_large_image_name: 'NDcxLS0tMjAtZnJpZ2lkLWxpZ2h0bmluZ3dlbGwtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDcxLS0tMjAtZnJpZ2lkLWxpZ2h0bmluZ3dlbGwtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDcxLS0tMjAtZnJpZ2lkLWxpZ2h0bmluZ3dlbGwtNzJkcGkucG5n/t',
    name: 'Frigid Lightningwell',
    set_name: 'The Dimension That Disappeared',
    set_number: '20',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Storm'],
    creature_type_count: 2,
    artist: 'Tanatola',
    effect:
      "This creature may bypass entirely frozen blank piles of energy and attack your opponent's Life Points directly (even if they have creatures in play).",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Frigid-Lightningwell-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_576',
    s3_large_image_name:
      'NTc2LS0tMjAtU2Npc3NvcnNsYWctU2NvcmlhLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTc2LS0tMjAtU2Npc3NvcnNsYWctU2NvcmlhLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTc2LS0tMjAtU2Npc3NvcnNsYWctU2NvcmlhLnBuZwEXODUSEXODUS/t',
    name: 'Scissorslag Scoria',
    set_name: 'Threshold of Time',
    set_number: '20',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine', 'Hailfire'],
    creature_type_count: 2,
    artist: 'J.L.Lockwood',
    effect:
      'Once per turn, per copy, you may put this creature into play from your hand on an existing blank pile on your field. When it enters play, you may destroy 1 energy in play. If you do, rebuild it. *Ignite *Burst',
    ruling:
      '<ul>\n<li style="font-weight: 400;"><em><span style="font-weight: 400;">Scissorslag Scoria’s</span></em><span style="font-weight: 400;"> “Violent Cinder Falls” Ability is a 2-part Ability where up to 3 things can happen: </span><span style="font-weight: 400;"><br></span><span style="font-weight: 400;">&nbsp;</span></li>\n<ul>\n<li style="font-weight: 400;"><span style="font-weight: 400;">1. You may put it from your hand into play on an existing blank pile on your field (this doesn’t count as a summon),</span></li>\n<li style="font-weight: 400;"><span style="font-weight: 400;">2. When it enters play (regardless if it entered play through its Ability or not) you may destroy 1 energy in play, only if,</span></li>\n<li style="font-weight: 400;"><span style="font-weight: 400;">3) you rebuild it into a valid rebuild target (Machine) afterward;</span><span style="font-weight: 400;"><br><br></span></li>\n<ul>\n<li style="font-weight: 400;"><span style="font-weight: 400;">In order to destroy 1 energy when this creature enters play, you must be able to rebuild it;</span></li>\n</ul>\n</ul>\n</ul>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Scissorslag-Scoria-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_179',
    s3_large_image_name:
      'MTc5LS0tMjEtQnJpZGdlLUJhc3Rpb24tRHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTc5LS0tMjEtQnJpZGdlLUJhc3Rpb24tRHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTc5LS0tMjEtQnJpZGdlLUJhc3Rpb24tRHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Bridge Bastion Dragon',
    set_name: 'Galaxy Tides',
    set_number: '21',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'COCOs',
    effect:
      "When this creature attacks, send the top card of your opponent's Main Deck to the graveyard.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Bridge-Bastion-Dragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_241',
    s3_large_image_name: 'MjQxLS0tMjEtSG93bGluZy1TeW50aGVzaXMucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQxLS0tMjEtSG93bGluZy1TeW50aGVzaXMucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQxLS0tMjEtSG93bGluZy1TeW50aGVzaXMucG5n/t',
    name: 'Howling Synthesis',
    set_name: 'Crystal Forge',
    set_number: '21',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      'This card remains on the field until the end of the turn. When one of your Treefolk or Mushfolk attacks, you may reveal the top card of your Main Deck. If it is a creature, you may switch it with the attacking creature just before the attack hits. If a symmetry is revealed, send it to the graveyard.',
    ruling:
      '<p>■ When a creature is switched due to this card effect, the new creature that is put into play is considered "summoned"&nbsp;(therefore, any on-summon Abilities will trigger);</p>\n<p>■<strong>&nbsp;</strong>Attack Abilities won\'t trigger when those creatures switch into play from&nbsp;<em>Howling Synthesis</em>&nbsp;because the original creature was the one that already declared the attack;&nbsp;</p>\n<p><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;Any "When this creature attacks..." Ability cannot be triggered if it is swapped into play via Synthesis because of missed timing, however, summon/put into play/enter play Abilities will still trigger &amp; resolve;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - You can still resolve effects/Abilities in any order, including attack Abilities of the creature being swapped out, however, players cannot resolve attack Abilities of the creature being swapped in so as to prevent the abuse of certain attack Abilities;&nbsp;</p>\n<p>■<strong>&nbsp;</strong><strong>When attacking with a creature while there are 2&nbsp;</strong><em>Howling Synthesis</em><strong>&nbsp;active in play, simultaneously reveal the top 2 cards of the Main Deck as potential switch targets;<br><br></strong>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - If the switch target is the 2nd topmost card, for example, the attacking creature replaces the target as the 2nd topmost card of the Main Deck;</p>\n<p>■<strong>&nbsp;</strong><strong>While this card is in play and active during a team battle, the owner of the attacking creature reveals the top card of his or her Main Deck (even if a teammate declared an attack with your creature), so that any potential switch does not cause a creature to end up in another player\'s deck;</strong></p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Howling-Synthesis-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_577',
    s3_large_image_name:
      'NTc3LS0tMjEtUGFsaXNhZGVzLXRoZS1FdGVybmFsLUVtYmVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTc3LS0tMjEtUGFsaXNhZGVzLXRoZS1FdGVybmFsLUVtYmVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTc3LS0tMjEtUGFsaXNhZGVzLXRoZS1FdGVybmFsLUVtYmVyLnBuZwEXODUSEXODUS/t',
    name: 'Palisades the Eternal Ember',
    set_name: 'Threshold of Time',
    set_number: '21',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire'],
    creature_type_count: 1,
    artist: 'Ben Cgant',
    effect:
      'While this creature is in play, once per turn, you are not required to destroy ignited card(s) when bursting. *Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Palisades-the-Eternal-Ember-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_472',
    s3_large_image_name:
      'NDcyLS0tMjEtc2hhcmR3b29kLWFtYWxnYW1hdGlvbi03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDcyLS0tMjEtc2hhcmR3b29kLWFtYWxnYW1hdGlvbi03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDcyLS0tMjEtc2hhcmR3b29kLWFtYWxnYW1hdGlvbi03MmRwaS5wbmcEXODUS/t',
    name: 'Shardwood Amalgamation',
    set_name: 'The Dimension That Disappeared',
    set_number: '21',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Treefolk'],
    creature_type_count: 2,
    artist: 'Brandon McDonald',
    effect:
      'When this creature attacks, is attacked or revealed, you may reveal 1 card in your hand. Then, you may target 1 frozen card in play; its frozen condition becomes permanent. ',
    ruling:
      '<p>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>This creature\'s Ability states "your hand"; if triggered while on the field (a shared zone between you and your teammate in 2v2 format) such as by attacking or being attacked, the team may choose which player\'s hand to reveal from;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Shardwood-Amalgamation-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_298',
    s3_large_image_name: 'Mjk4LS0tMjEtVGFuZ2xld29vZC1TbmFnLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk4LS0tMjEtVGFuZ2xld29vZC1TbmFnLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk4LS0tMjEtVGFuZ2xld29vZC1TbmFnLnBuZwEXODUSEXODUS/t',
    name: 'Tanglewood Snag',
    set_name: 'Converging Chasms',
    set_number: '21',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Treefolk'],
    creature_type_count: 2,
    artist: 'COCOs',
    effect:
      "Once per turn, during your turn, you may pay 1 Life Point to reveal 1 card in your hand. If it is a symmetry, destroy 1 energy on your opponent's side of the field.",
    ruling:
      "<p>■ This creature's Ability can be activated at any time during your turn. But,&nbsp;<strong>if activated in response to a Symmetry, the Symmetry will still resolve first</strong>.&nbsp;This is due to the fact that Symmetry speed is faster than speed of Creature Abilities;</p>\n<p>■ If this creature's Ability is on the stack, and it leaves play, the Ability will fizzle when it comes time to resolve, since&nbsp;<em>Tanglewood&nbsp;</em>is no longer in play;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Tanglewood-Snag-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_242',
    s3_large_image_name:
      'MjQyLS0tMjItQ2llcmljZS10aGUtTGlxdWVzY2VudC1JY2ljbGUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQyLS0tMjItQ2llcmljZS10aGUtTGlxdWVzY2VudC1JY2ljbGUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQyLS0tMjItQ2llcmljZS10aGUtTGlxdWVzY2VudC1JY2ljbGUucG5n/t',
    name: 'Cierice the Liquescent Icicle',
    set_name: 'Crystal Forge',
    set_number: '22',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Lexi Medina',
    effect:
      "While this creature is on the field, if all of your opponent's creatures in play are frozen, your Shardfolk may attack their Life Points directly.",
    ruling: '',
    foil_only: 'Yes',
    card_database_link:
      'https://exodus-players.com/cards/search/Cierice-the-Liquescent-Icicle-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_180',
    s3_large_image_name:
      'MTgwLS0tMjItRGltZW5zaW9uYWwtRHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTgwLS0tMjItRGltZW5zaW9uYWwtRHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTgwLS0tMjItRGltZW5zaW9uYWwtRHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Dimensional Dragon',
    set_name: 'Galaxy Tides',
    set_number: '22',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'COCOs',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Dragon-First-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_299',
    s3_large_image_name: 'Mjk5LS0tMjItRW1iZXJzaGFyZC1TaXJlbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk5LS0tMjItRW1iZXJzaGFyZC1TaXJlbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjk5LS0tMjItRW1iZXJzaGFyZC1TaXJlbi5wbmcEXODUS/t',
    name: 'Embershard Siren',
    set_name: 'Converging Chasms',
    set_number: '22',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Victor Corbella',
    effect:
      'When this creature would be discarded from your hand, you may put it into play onto an existing blank pile of energy instead. If you do, destroy 1 energy in play.',
    ruling:
      "<p>■&nbsp;This creature's Ability states, \"When this creature&nbsp;<u>WOULD</u>&nbsp;be&nbsp;discarded from your hand, you may put it into play onto an existing blank pile of energy&nbsp;<u>INSTEAD</u>\". Any discard effect such as&nbsp;<em>Vortex</em>,&nbsp;<em>Cloudburst Spiral</em>,&nbsp;<em>Thoughts of Progress</em>,&nbsp;<em>Dimensional Destruction</em>,&nbsp;<em>Reevaluate</em>, etc., will easily trigger its Ability and let you put it into play and destroy an energy. But since it is never actually discarded, it doesn't count as a discarded card. You wouldn't count it in the case of&nbsp;<em>Reevaluate</em>, and you would need to choose and discard a different card after its Ability resolves in the case of&nbsp;<em>Dimensional Destruction</em>&nbsp;or&nbsp;<em>Thoughts of Progress;</em></p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Embershard-Siren-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_578',
    s3_large_image_name: 'NTc4LS0tMjItTWFnbWEtTW91bnRhaW4tTGF2YXNzdXMucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTc4LS0tMjItTWFnbWEtTW91bnRhaW4tTGF2YXNzdXMucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTc4LS0tMjItTWFnbWEtTW91bnRhaW4tTGF2YXNzdXMucG5n/t',
    name: 'Magma Mountain Lavassus',
    set_name: 'Threshold of Time',
    set_number: '22',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire', 'Mountain'],
    creature_type_count: 2,
    artist: 'Tanatola',
    effect:
      'When this creature enters play, you may add 1 Hailfire from your graveyard to your hand for each rarity you have in play. *Ignite *Burst',
    ruling:
      "<p>■&nbsp;Because this creature's Ability does not specify card type,&nbsp;rarity is checked among all types of cards you have in play;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Magma-Mountain-Lavassus-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_473',
    s3_large_image_name:
      'NDczLS0tMjItcm9hbWluZy1za3lzY3JhcGVyLWxhbmdpcy03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDczLS0tMjItcm9hbWluZy1za3lzY3JhcGVyLWxhbmdpcy03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDczLS0tMjItcm9hbWluZy1za3lzY3JhcGVyLWxhbmdpcy03MmRwaS5wbmcEXODUS/t',
    name: 'Roaming Skyscraper, Langis',
    set_name: 'The Dimension That Disappeared',
    set_number: '22',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Brandon McDonald',
    effect:
      'When this creature enters play or whenever it attacks, you may reveal the top and bottom card of your Main Deck and draw 1 energy.',
    ruling:
      "<p>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>You may reveal the top and bottom card of the Main Deck belonging to any player on your team when using this creature's Ability in Multiplayer or 2v2 format;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<strong><sup>[NEW]&nbsp;</sup></strong>&nbsp;- The player on your team who draws 1 energy from this Ability does not have to be the same player who revealed the top and bottom card of the Main Deck;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Roaming-Skyscraper--Langis-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_243',
    s3_large_image_name:
      'MjQzLS0tMjMtQXdha2VuZWQtU3Rhci1HbGFjaWVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQzLS0tMjMtQXdha2VuZWQtU3Rhci1HbGFjaWVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQzLS0tMjMtQXdha2VuZWQtU3Rhci1HbGFjaWVyLnBuZwEXODUSEXODUS/t',
    name: 'Awakened Star Glacier',
    set_name: 'Crystal Forge',
    set_number: '23',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Kenny Estrella',
    effect:
      'When this creature is summoned, for each additional creature your opponent has in play more than you, freeze 1 creature in play.',
    ruling: '',
    foil_only: 'Yes',
    card_database_link:
      'https://exodus-players.com/cards/search/Awakened-Star-Glacier-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_474',
    s3_large_image_name:
      'NDc0LS0tMjMtY2FyY2VyeS10aGUtbWFuaWFjYWwtbWFkbmVzcy03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDc0LS0tMjMtY2FyY2VyeS10aGUtbWFuaWFjYWwtbWFkbmVzcy03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDc0LS0tMjMtY2FyY2VyeS10aGUtbWFuaWFjYWwtbWFkbmVzcy03MmRwaS5wbmcEXODUS/t',
    name: 'Carcery the Maniacal Madness',
    set_name: 'The Dimension That Disappeared',
    set_number: '23',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Chrono'],
    creature_type_count: 2,
    artist: 'Brandon McDonald',
    effect: 'This creature deals double damage when battling creatures.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Carcery-the-Maniacal-Madness-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_300',
    s3_large_image_name:
      'MzAwLS0tMjMtQ2xvY2t3b3JrLUF1dG9tYXRhLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzAwLS0tMjMtQ2xvY2t3b3JrLUF1dG9tYXRhLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzAwLS0tMjMtQ2xvY2t3b3JrLUF1dG9tYXRhLnBuZwEXODUSEXODUS/t',
    name: 'Clockwork Automata',
    set_name: 'Converging Chasms',
    set_number: '23',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Machine'],
    creature_type_count: 2,
    artist: 'COCOs',
    effect:
      'Once per turn, when a card is sent from the top of your Main Deck to the graveyard, if it is not a Dragon or Slithe-type creature, you may put it on the bottom of your Main Deck and send the next top card to the graveyard instead.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Clockwork-Automata-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_181',
    s3_large_image_name: 'MTgxLS0tMjMtU3RhcmJvdW5kLUdsYWNpZXIucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTgxLS0tMjMtU3RhcmJvdW5kLUdsYWNpZXIucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTgxLS0tMjMtU3RhcmJvdW5kLUdsYWNpZXIucG5n/t',
    name: 'Starbound Glacier',
    set_name: 'Galaxy Tides',
    set_number: '23',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Kenny Estrella',
    effect:
      'At the start of each of your turns, this creature gains 1 energy. It cannot attack.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Starbound-Glacier-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_579',
    s3_large_image_name:
      'NTc5LS0tMjMtVmVuZ2VhbmNlLUJlaGVtb3RoLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTc5LS0tMjMtVmVuZ2VhbmNlLUJlaGVtb3RoLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTc5LS0tMjMtVmVuZ2VhbmNlLUJlaGVtb3RoLnBuZwEXODUSEXODUS/t',
    name: 'Vengeance Behemoth',
    set_name: 'Threshold of Time',
    set_number: '23',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire', 'Behemoth'],
    creature_type_count: 2,
    artist: 'Tommy Suhartono',
    effect:
      'If you burst this turn, you may discard this card from hand to destroy 1 symmetry in play. *Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Vengeance-Behemoth-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_475',
    s3_large_image_name:
      'NDc1LS0tMjQtYnJpc3RsZWNvbmUtcGhhbnRvbS1waW5lLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDc1LS0tMjQtYnJpc3RsZWNvbmUtcGhhbnRvbS1waW5lLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDc1LS0tMjQtYnJpc3RsZWNvbmUtcGhhbnRvbS1waW5lLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Bristlecone Phantom Pine',
    set_name: 'The Dimension That Disappeared',
    set_number: '24',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Brandon McDonald',
    effect:
      'When this creature attacks, target 1 card in your graveyard and put it back in your Main Deck wherever you like. Then, draw 1 energy for each rarity among your creatures in play.',
    ruling:
      "<p>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>\"put it back in your Main Deck wherever you like\" means that you take the target card from the graveyard (looking), flip it face-down, and put it in your Main Deck (without searching through your Main Deck or flipping the cards face-up)<em>—</em>slotting the target card into the Main Deck&nbsp;wherever you like;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>When this creature attacks and its Ability resolves, you may choose 1 card from any player's graveyard on your team and put it back in the owner's Main Deck wherever you like (it does not have to be your own card from your own graveyard, but the target card cannot go from one player's graveyard into&nbsp;a different player's Main Deck);<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<strong><sup>[NEW]&nbsp;</sup></strong>&nbsp;- The player on your team who draws energy from the second part of this creature's Ability can be a different player than the one who put a card from their graveyard into their Main Deck;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Bristlecone-Phantom-Pine-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_244',
    s3_large_image_name: 'MjQ0LS0tMjQtQ2hpZWYtQmFuZGl0LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ0LS0tMjQtQ2hpZWYtQmFuZGl0LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ0LS0tMjQtQ2hpZWYtQmFuZGl0LnBuZwEXODUSEXODUS/t',
    name: 'Chief Bandit',
    set_name: 'Crystal Forge',
    set_number: '24',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Sarayu Ruangvesh',
    effect:
      'When this creature is summoned, it gains 1 energy for each frozen card in play.',
    ruling: '',
    foil_only: 'Yes',
    card_database_link:
      'https://exodus-players.com/cards/search/Chief-Bandit-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_580',
    s3_large_image_name: 'NTgwLS0tMjQtRm9yZXZlci1GaXJlLVNuYXBkcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTgwLS0tMjQtRm9yZXZlci1GaXJlLVNuYXBkcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTgwLS0tMjQtRm9yZXZlci1GaXJlLVNuYXBkcmFnb24ucG5n/t',
    name: 'Forever Fire Snapdragon',
    set_name: 'Threshold of Time',
    set_number: '24',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire', 'Dragon'],
    creature_type_count: 2,
    artist: 'Tommy Suhartono',
    effect:
      'When this creature enters play or attacks, you may ignite 1 of your cards in play. While this creature is in play, whenever a card is sent from the top of the Main Deck to the graveyard, you may also send the next top card to the graveyard. *Ignite *Burst',
    ruling:
      '<p>■ You may automatically ignite any type of card you have in play with this creature\'s "Versicolor Flare" Ability;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Forever-Fire-Snapdragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_301',
    s3_large_image_name:
      'MzAxLS0tMjQtSG9ybmNyZXN0LUNsb3VkZ29yZ2VyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzAxLS0tMjQtSG9ybmNyZXN0LUNsb3VkZ29yZ2VyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzAxLS0tMjQtSG9ybmNyZXN0LUNsb3VkZ29yZ2VyLnBuZwEXODUSEXODUS/t',
    name: 'Horncrest Cloudgorger',
    set_name: 'Converging Chasms',
    set_number: '24',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'B.A. Miller',
    effect:
      "Whenever this creature attacks, send the top card of your Main Deck to the graveyard. If that card is a Dragon or Slithe-type creature, destroy 1 energy on your opponent's side of the field.",
    ruling:
      '<p>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>When this creature attacks and its Ability resolves, you or any player on your team may send the top card of the Main Deck to the graveyard to fulfill its requirement during Multiplayer or 2v2 format;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Horncrest-Cloudgorger-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_182',
    s3_large_image_name: 'MTgyLS0tMjQtTGFudGVybi1MZWFmbG9yZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTgyLS0tMjQtTGFudGVybi1MZWFmbG9yZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTgyLS0tMjQtTGFudGVybi1MZWFmbG9yZS5wbmcEXODUS/t',
    name: 'Lantern Leaflore',
    set_name: 'Galaxy Tides',
    set_number: '24',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'COCOs',
    effect:
      'While this creature is on the field, it is unaffected by Symmetry cards.',
    ruling:
      "<p><em>■&nbsp;</em><strong>This creature's Ability is immediately active from the moment it hits the field / is put into play;</strong></p>\n<p>■ While this creature is on the field, it is unaffected by&nbsp;all&nbsp;symmetry cards (<u>both yours and your opponent's</u>);</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;NOTE: Energy attached to it cannot be affected by symmetry effects;<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;Costs on symmetry cards are considered part of the effect, so you also are not able to pay energy from&nbsp;<em>Lantern Leaflore</em>&nbsp;to fulfill the cost of one of your symmetries;<br><br>■ Symmetries that select or target creatures do not affect&nbsp;<em>Lantern Leaflore;</em></p>\n<p>■ Symmetries&nbsp;that affect all creatures in play without specifying targets do not affect&nbsp;<em>Lantern Leaflore</em>;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lantern-Leaflore-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_302',
    s3_large_image_name: 'MzAyLS0tMjUtQW5nZWxpY2EtdGhlLVZhc3QucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzAyLS0tMjUtQW5nZWxpY2EtdGhlLVZhc3QucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzAyLS0tMjUtQW5nZWxpY2EtdGhlLVZhc3QucG5n/t',
    name: 'Angelica the Vast',
    set_name: 'Converging Chasms',
    set_number: '25',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Victor Corbella & Kenshjn Park',
    effect: 'When this creature attacks, it loses 1 less energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Angelica-the-Vast-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_183',
    s3_large_image_name: 'MTgzLS0tMjUtQmF0dGxlc2hpcC1QaGlsaXN0aWEucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTgzLS0tMjUtQmF0dGxlc2hpcC1QaGlsaXN0aWEucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTgzLS0tMjUtQmF0dGxlc2hpcC1QaGlsaXN0aWEucG5n/t',
    name: 'Battleship Philistia',
    set_name: 'Galaxy Tides',
    set_number: '25',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Leviathan', 'Machine'],
    creature_type_count: 2,
    artist: 'COCOs',
    effect:
      'As long as this creature is on the field, whenever one of your Common Dragons or Angels destroys an opponent\'s creature, send 1 energy on their field back to their hand. This ability can only be used once per turn, regardless if you control another "Battleship Philistia".',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Battleship-Philistia-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_581',
    s3_large_image_name: 'NTgxLS0tMjUtQnVybmluZy1GbGVldC1WYWx2ZXNzZWwucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTgxLS0tMjUtQnVybmluZy1GbGVldC1WYWx2ZXNzZWwucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTgxLS0tMjUtQnVybmluZy1GbGVldC1WYWx2ZXNzZWwucG5n/t',
    name: 'Burning Fleet Valvessel',
    set_name: 'Threshold of Time',
    set_number: '25',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire', 'Leviathan'],
    creature_type_count: 2,
    artist: 'Brandon McDonald',
    effect:
      "While this creature is in play, whenever a player attacks with a Common or Uncommon creature, they may send 1 energy in play to the owner's hand just before the attack hits. If they attacked with a Hailfire, destroy the energy instead. *Ignite *Burst",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Burning-Fleet-Valvessel-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_245',
    s3_large_image_name: 'MjQ1LS0tMjUtQ2FsY2l0ZS1DYXZhbGllci5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ1LS0tMjUtQ2FsY2l0ZS1DYXZhbGllci5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ1LS0tMjUtQ2FsY2l0ZS1DYXZhbGllci5wbmcEXODUS/t',
    name: 'Calcite Cavalier',
    set_name: 'Crystal Forge',
    set_number: '25',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Calcite-Cavalier-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_476',
    s3_large_image_name:
      'NDc2LS0tMjUtaGlzc2luZy1zcG9yZS12YWxzaHJvb20tNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDc2LS0tMjUtaGlzc2luZy1zcG9yZS12YWxzaHJvb20tNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDc2LS0tMjUtaGlzc2luZy1zcG9yZS12YWxzaHJvb20tNzJkcGkucG5n/t',
    name: 'Hissing Spore Valshroom',
    set_name: 'The Dimension That Disappeared',
    set_number: '25',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    effect:
      'When this creature is revealed or attacks, each player reveals the top card of their Main Deck. If a player on your team revealed a symmetry, they may add it to their hand. If they revealed a creature, they may draw 1 energy. ',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hissing-Spore-Valshroom-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_184',
    s3_large_image_name:
      'MTg0LS0tMjYtQmVhY29uLW9mLVdvcmxkcy1OT05Gb2lsLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTg0LS0tMjYtQmVhY29uLW9mLVdvcmxkcy1OT05Gb2lsLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTg0LS0tMjYtQmVhY29uLW9mLVdvcmxkcy1OT05Gb2lsLTRDUC5qcGcEXODUS/t',
    name: 'Beacon of Worlds',
    set_name: 'Galaxy Tides',
    set_number: '26',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Dallin Bifano',
    effect:
      'Move 1 energy from a creature or pile on the field to another creature or pile on the same side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Beacon-of-Worlds-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_303',
    s3_large_image_name:
      'MzAzLS0tMjYtQ2FzY2lsLXRoZS1VbnZhbmlzaGluZy1QYWxhZGluLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzAzLS0tMjYtQ2FzY2lsLXRoZS1VbnZhbmlzaGluZy1QYWxhZGluLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzAzLS0tMjYtQ2FzY2lsLXRoZS1VbnZhbmlzaGluZy1QYWxhZGluLnBuZwEXODUSEXODUS/t',
    name: 'Cascil the Unvanishing Paladin',
    set_name: 'Converging Chasms',
    set_number: '26',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel', 'Mistform'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    effect:
      'This creature cannot be destroyed by battle. (If it would lose its last energy by battle, it stays on the field with 1 energy instead.)',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cascil-the-Unvanishing-Paladin-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_582',
    s3_large_image_name:
      'NTgyLS0tMjYtR2hvc3QtU2hpcC1HYWxsZW9uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTgyLS0tMjYtR2hvc3QtU2hpcC1HYWxsZW9uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTgyLS0tMjYtR2hvc3QtU2hpcC1HYWxsZW9uLnBuZwEXODUSEXODUS/t',
    name: 'Ghost Ship Galleon',
    set_name: 'Threshold of Time',
    set_number: '26',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Leviathan', 'Mistform'],
    creature_type_count: 2,
    artist: 'Brandon McDonald',
    effect:
      'While this creature is in play, once per turn, your opponent loses 1 Life Point whenever energy is moved on the field or sent from their field to their hand.',
    ruling:
      "<p>■&nbsp;Each&nbsp;<em>Ghost Ship Galleon's&nbsp;</em>Ability operates independently of one another;&nbsp;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;If you have 2 copies of this creature in play, you can cause your opponent to lose 2 Life Points per turn (once per copy) whenever energy is moved or sent back to a player's hand due to an effect or Ability;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Ghost-Ship-Galleon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_477',
    s3_large_image_name:
      'NDc3LS0tMjYtbWVjaGFuaWNhbC1oYWxsdWNpbmF0aW9uLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDc3LS0tMjYtbWVjaGFuaWNhbC1oYWxsdWNpbmF0aW9uLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDc3LS0tMjYtbWVjaGFuaWNhbC1oYWxsdWNpbmF0aW9uLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Mechanical Hallucination',
    set_name: 'The Dimension That Disappeared',
    set_number: '26',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine', 'Chrono'],
    creature_type_count: 2,
    artist: 'B.A. Miller',
    effect:
      "While this creature is in play, your opponent can't draw cards due to their own card effects or Abilities. AFTERTHOUGHT ABILITY: You may send this Afterthought to the graveyard to add 1 energy to a creature or pile in play.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mechanical-Hallucination-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_246',
    s3_large_image_name: 'MjQ2LS0tMjYtVG91cm1hbGluZS1EcmFnb24uanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ2LS0tMjYtVG91cm1hbGluZS1EcmFnb24uanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ2LS0tMjYtVG91cm1hbGluZS1EcmFnb24uanBn/t',
    name: 'Tourmaline Dragon',
    set_name: 'Crystal Forge',
    set_number: '26',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Dragon'],
    creature_type_count: 2,
    artist: 'Jackie Felix',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Tourmaline-Dragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_247',
    s3_large_image_name: 'MjQ3LS0tMjctQ3J5c3RhbGZpcmUtV29sZi5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ3LS0tMjctQ3J5c3RhbGZpcmUtV29sZi5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ3LS0tMjctQ3J5c3RhbGZpcmUtV29sZi5qcGcEXODUS/t',
    name: 'Crystalfire Wolf',
    set_name: 'Crystal Forge',
    set_number: '27',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Wolf'],
    creature_type_count: 2,
    artist: 'Mat Gimeno',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystalfire-Wolf-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_185',
    s3_large_image_name:
      'MTg1LS0tMjctRGltZW5zaW9uYWwtRHVzdC1OT05Gb2lsLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTg1LS0tMjctRGltZW5zaW9uYWwtRHVzdC1OT05Gb2lsLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTg1LS0tMjctRGltZW5zaW9uYWwtRHVzdC1OT05Gb2lsLTRDUC5qcGcEXODUS/t',
    name: 'Dimensional Dust',
    set_name: 'Galaxy Tides',
    set_number: '27',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'COCOs',
    effect:
      'Search your graveyard for 1 card with "Dimensional" or "Dust" in its name and add it to your hand.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Dust-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_304',
    s3_large_image_name: 'MzA0LS0tMjctRXBoZW1yYS10aGUtU3Rhci1TaGllbGQucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzA0LS0tMjctRXBoZW1yYS10aGUtU3Rhci1TaGllbGQucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzA0LS0tMjctRXBoZW1yYS10aGUtU3Rhci1TaGllbGQucG5n/t',
    name: 'Ephemra the Star Shield',
    set_name: 'Converging Chasms',
    set_number: '27',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Hafid Moenir',
    effect:
      'At the start of the game, you may reveal this card from your starting hand. If you do, draw 2 extra cards from both your Main Deck and Energy Deck.',
    ruling:
      "<p>■&nbsp;If a 2nd&nbsp;<em>Ephemra&nbsp;</em>is drawn from this creature's \"Guard Glare\" Ability, it is still part of the starting hand during the start of the game, so&nbsp;<strong>the 2nd&nbsp;</strong><strong><em>Ephemra's</em></strong><strong>&nbsp;Ability will trigger</strong>, allowing you to draw an additional 2 cards from each deck;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong><em>Ephemra's&nbsp;</em>Ability doesn't activate until <strong>after mulligans are completed</strong> in 2v2 format;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Ephemra-the-Star-Shield-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_478',
    s3_large_image_name: 'NDc4LS0tMjctaGF6YXJkb3VzLWJyaWdhbnRpbmUtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDc4LS0tMjctaGF6YXJkb3VzLWJyaWdhbnRpbmUtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDc4LS0tMjctaGF6YXJkb3VzLWJyaWdhbnRpbmUtNzJkcGkucG5n/t',
    name: 'Hazardous Brigantine',
    set_name: 'The Dimension That Disappeared',
    set_number: '27',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Leviathan', 'Chrono'],
    creature_type_count: 2,
    artist: 'Albert Zhou',
    effect:
      'Activate this Ability from your hand, field or graveyard; move this creature from its current zone to one of those other zones. "Eerie Presence" can only be used once per turn, per player. AFTERTHOUGHT ABILITY: You may send this Afterthought to the graveyard to destroy 1 energy in play.',
    ruling:
      '<p>&nbsp;■ The activation of this creature\'s Ability must be announced, including from hand;<em> Hazardous Brigantine\'s </em>Ability goes on the stack which allows all players a chance to respond to its Ability before it begins resolving;<br><br>■&nbsp;"Moving" <em>Hazardous Brigantine</em> with its Ability does <span style="text-decoration: underline;"><strong>not</strong></span> count as a summon; however, if you\'re moving it to your field, then it is considered to be "put into play";<br><br>■&nbsp;You may <span style="text-decoration: underline;"><strong>only</strong></span> move <em>Hazardous Brigantine</em> to your field if there is an open blank pile to put it into play on. This is due to the game\'s base rule that creatures <span style="text-decoration: underline;"><strong>must</strong></span> enter play on a pile of 1 or more energy; creatures cannot exist on the field without energy unless otherwise stated;<br><br>■&nbsp;The Afterthought Ability doesn\'t state "target" or "select", however, it does allow the owner to target and choose which energy they want to destroy;<br><br>■&nbsp;This creature can be put into play on your teammate\'s energy pile(s) through its own Ability in 2v2 format;<br><br>■&nbsp;Due to this creature\'s Ability stating, "Activate this Ability from YOUR hand, field or graveyard," your teammate can activate your <em>Brigantine\'s</em> Ability from the field, since that is the only shared zone in 2v2 format; however, if they opt not to make it an Afterthought and let it move zones, it will move to the owner\'s specified zone;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hazardous-Brigantine-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_583',
    s3_large_image_name:
      'NTgzLS0tMjctTm9lbGxhZy10aGUtQ3J1Y2libGUtb2YtVGltZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTgzLS0tMjctTm9lbGxhZy10aGUtQ3J1Y2libGUtb2YtVGltZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTgzLS0tMjctTm9lbGxhZy10aGUtQ3J1Y2libGUtb2YtVGltZS5wbmcEXODUS/t',
    name: 'Noellag the Crucible of Time',
    set_name: 'Threshold of Time',
    set_number: '27',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Leviathan'],
    creature_type_count: 1,
    artist: 'Monztre Ink Studio',
    effect:
      'While this creature is in play, if you have at least 3 different rarities among your creatures in play, you may attack regardless of any effects or Abilities that prevent you or your creature(s) from attacking. When this creature leaves play, move 2 energy in play somewhere else on the same side of the field.',
    ruling:
      '<p>■ Secret Rare and Harmony Rare are counted as a different rarity from Rare in regards to this creature\'s "Time Fracture" Ability;&nbsp;<br><br>■ You are not required to make the 2 energy move to the same target for this creature\'s Ability—they may even be moved off a target to start a new pile;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Noellag-the-Crucible-of-Time-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_248',
    s3_large_image_name: 'MjQ4LS0tMjgtR2FybmV0LU1hcmF1ZGVyLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ4LS0tMjgtR2FybmV0LU1hcmF1ZGVyLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ4LS0tMjgtR2FybmV0LU1hcmF1ZGVyLmpwZwEXODUSEXODUS/t',
    name: 'Garnet Marauder',
    set_name: 'Crystal Forge',
    set_number: '28',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'S. Calvin',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Garnet-Marauder-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_584',
    s3_large_image_name: 'NTg0LS0tMjgtU2hpdmVydmF1bHQtR2xhY2llci5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTg0LS0tMjgtU2hpdmVydmF1bHQtR2xhY2llci5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTg0LS0tMjgtU2hpdmVydmF1bHQtR2xhY2llci5wbmcEXODUS/t',
    name: 'Shivervault Glacier',
    set_name: 'Threshold of Time',
    set_number: '28',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Ruk Trumata',
    effect:
      "You may activate this Ability from your hand or field to discard this creature. If you do, target a player; that player targets up to 2 cards from hand and puts them on the side of the field frozen. Those card(s) unfreeze and return to the owner's hand at the end of the turn.",
    ruling:
      "<p>■ For this creature's Ability, you target a player—that player targets and chooses up to 2 cards (valid numerals: 0, 1, or 2) from their own hand to freeze until the end of the turn;&nbsp;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Frozen cards placed on the side of the field facedown can be viewed by any player as they are considered to be in a viewable zone;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Shivervault-Glacier-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_479',
    s3_large_image_name:
      'NDc5LS0tMjgtc2lnbi1vZi10aGUtY3Jvdy03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDc5LS0tMjgtc2lnbi1vZi10aGUtY3Jvdy03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDc5LS0tMjgtc2lnbi1vZi10aGUtY3Jvdy03MmRwaS5wbmcEXODUS/t',
    name: 'Sign of the Crow',
    set_name: 'The Dimension That Disappeared',
    set_number: '28',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Dmitry Isakevitch',
    effect:
      'Discard 1 card from your hand. Search your Main Deck for 1 Chrono and add it to your hand. Then, shuffle your Main Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Sign-of-the-Crow-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_186',
    s3_large_image_name:
      'MTg2LS0tMjgtU3Rhci1TdHJ1Z2dsZS1OT05Gb2lsLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTg2LS0tMjgtU3Rhci1TdHJ1Z2dsZS1OT05Gb2lsLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTg2LS0tMjgtU3Rhci1TdHJ1Z2dsZS1OT05Gb2lsLTRDUC5qcGcEXODUS/t',
    name: 'Star Struggle',
    set_name: 'Galaxy Tides',
    set_number: '28',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Rennyl Montuya',
    effect: 'Each player loses 1 Life Point.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Star-Struggle-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_305',
    s3_large_image_name: 'MzA1LS0tMjgtU3RhcmJyaW5nZXIucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzA1LS0tMjgtU3RhcmJyaW5nZXIucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzA1LS0tMjgtU3RhcmJyaW5nZXIucG5n/t',
    name: 'Starbringer',
    set_name: 'Converging Chasms',
    set_number: '28',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Nivea Toliver',
    effect:
      "When this creature is summoned, you may send a Rare creature on your field to the graveyard. If you do, send 1 energy in play back to the owner's hand for each Uncommon Angel on your field.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Starbringer-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_585',
    s3_large_image_name:
      'NTg1LS0tMjktQ2FyY2VyeS10aGUtVHdpc3RlZC1UcmVlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTg1LS0tMjktQ2FyY2VyeS10aGUtVHdpc3RlZC1UcmVlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTg1LS0tMjktQ2FyY2VyeS10aGUtVHdpc3RlZC1UcmVlLnBuZwEXODUSEXODUS/t',
    name: 'Carcery the Twisted Tree',
    set_name: 'Threshold of Time',
    set_number: '29',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect:
      'While this creature is in play, all of your energy in play is twisted. (When twisted energy would leave play, you may pay 1 Life Point to keep it in play instead.)',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Carcery-the-Twisted-Tree-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_480',
    s3_large_image_name:
      'NDgwLS0tMjktY2hhaW5zLW9mLXRoZS1hbmNpZW50LW9uZS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDgwLS0tMjktY2hhaW5zLW9mLXRoZS1hbmNpZW50LW9uZS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDgwLS0tMjktY2hhaW5zLW9mLXRoZS1hbmNpZW50LW9uZS03MmRwaS5wbmcEXODUS/t',
    name: 'Chains of the Ancient One',
    set_name: 'The Dimension That Disappeared',
    set_number: '29',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'A.Gvin',
    effect:
      'Send the top 3 cards of your Main Deck to the graveyard. You may add 1 energy beneath your Main Deck or to a creature in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chains-of-the-Ancient-One-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_249',
    s3_large_image_name:
      'MjQ5LS0tMjktSGFpbHN0b3JtLUh5c3RlcmlhLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ5LS0tMjktSGFpbHN0b3JtLUh5c3RlcmlhLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQ5LS0tMjktSGFpbHN0b3JtLUh5c3RlcmlhLmpwZwEXODUSEXODUS/t',
    name: 'Hailstorm Hysteria',
    set_name: 'Crystal Forge',
    set_number: '29',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Elena Shiyanova',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hailstorm-Hysteria-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_187',
    s3_large_image_name:
      'MTg3LS0tMjktU3RhcmJsdWZmLVN1bW1pdC1OT05Gb2lsLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTg3LS0tMjktU3RhcmJsdWZmLVN1bW1pdC1OT05Gb2lsLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTg3LS0tMjktU3RhcmJsdWZmLVN1bW1pdC1OT05Gb2lsLTRDUC5qcGcEXODUS/t',
    name: 'Starbluff Summit',
    set_name: 'Galaxy Tides',
    set_number: '29',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Kenny Estrella',
    effect:
      'Draw 1 card from your Energy Deck. Your opponent draws 1 card from their Main Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Starbluff-Summit-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_306',
    s3_large_image_name: 'MzA2LS0tMjktVHVyYmluZS1BcHBhcmF0dXMucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzA2LS0tMjktVHVyYmluZS1BcHBhcmF0dXMucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzA2LS0tMjktVHVyYmluZS1BcHBhcmF0dXMucG5n/t',
    name: 'Turbine Apparatus',
    set_name: 'Converging Chasms',
    set_number: '29',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'Michelle Graves',
    effect:
      'When this creature is summoned, shuffle all Machine-type creatures from your graveyard into your Main Deck. Then, draw 1 card.',
    ruling:
      "<p>■&nbsp;<strong><em>Turbine Apparatus'&nbsp;</em>\"Reforge Parts\" Ability&nbsp;&nbsp;</strong><strong>is an all-or-nothing type of effect</strong>;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Because its effect is broken up into 2 sentences,&nbsp;<strong>the first effect can't happen unless the second is possible</strong>&nbsp;and vice-versa;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>You must have at least 1 Machine-type creature</strong>&nbsp;in your graveyard to use this creature's Ability, otherwise, nothing happens when it is summoned;</p>\n<p>■ You may draw the 1 card from&nbsp;<strong>either the Main Deck or Energy Deck</strong>;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Turbine-Apparatus-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_250',
    s3_large_image_name: 'MjUwLS0tMzAtQ3J5c3RhbC1MZXZpYXRoYW4uanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjUwLS0tMzAtQ3J5c3RhbC1MZXZpYXRoYW4uanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjUwLS0tMzAtQ3J5c3RhbC1MZXZpYXRoYW4uanBn/t',
    name: 'Crystal Leviathan',
    set_name: 'Crystal Forge',
    set_number: '30',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Leviathan'],
    creature_type_count: 2,
    artist: 'S. Calvin',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystal-Leviathan-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_586',
    s3_large_image_name:
      'NTg2LS0tMzAtRHVzdGlhLXRoZS1BdXJvcmFsLVdoYWxlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTg2LS0tMzAtRHVzdGlhLXRoZS1BdXJvcmFsLVdoYWxlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTg2LS0tMzAtRHVzdGlhLXRoZS1BdXJvcmFsLVdoYWxlLnBuZwEXODUSEXODUS/t',
    name: 'Dustia the Auroral Whale',
    set_name: 'Threshold of Time',
    set_number: '30',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Whale'],
    creature_type_count: 1,
    artist: 'Alejandro Arévalo',
    effect:
      'While this creature is in play, you may switch a creature on your field with a creature that has "Dimensional" or "Dust" in its name from your hand. "Dimensional Rhythm" can only be used once per turn, per copy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dustia-the-Auroral-Whale-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_307',
    s3_large_image_name:
      'MzA3LS0tMzAtR3JhbmRpb3NlLUluZmVjdG9yLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzA3LS0tMzAtR3JhbmRpb3NlLUluZmVjdG9yLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzA3LS0tMzAtR3JhbmRpb3NlLUluZmVjdG9yLnBuZwEXODUSEXODUS/t',
    name: 'Grandiose Infector',
    set_name: 'Converging Chasms',
    set_number: '30',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'J.L.Lockwood',
    effect:
      'When this creature attacks, you may move a blank pile of energy from your side of the field to this creature just before the attack hits.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Grandiose-Infector-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_188',
    s3_large_image_name:
      'MTg4LS0tMzAtSXNsZXMtb2YtdGhlLU1vcm5pbmctU3Rhci1OT05Gb2lsLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTg4LS0tMzAtSXNsZXMtb2YtdGhlLU1vcm5pbmctU3Rhci1OT05Gb2lsLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTg4LS0tMzAtSXNsZXMtb2YtdGhlLU1vcm5pbmctU3Rhci1OT05Gb2lsLTRDUC5qcGcEXODUS/t',
    name: 'Isles of the Morning Star',
    set_name: 'Galaxy Tides',
    set_number: '30',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Kenny Estrella',
    effect:
      'Draw 1 card from your Main Deck. Your opponent draws 1 card from their Energy Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Isles-of-the-Morning-Star-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_481',
    s3_large_image_name: 'NDgxLS0tMzAtcm9zZWJvdW5kLWRldGVycmVuY2UtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDgxLS0tMzAtcm9zZWJvdW5kLWRldGVycmVuY2UtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDgxLS0tMzAtcm9zZWJvdW5kLWRldGVycmVuY2UtNzJkcGkucG5n/t',
    name: 'Rosebound Deterrence',
    set_name: 'The Dimension That Disappeared',
    set_number: '30',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Tanatola',
    effect:
      'Pay 1 Life Point. This card leaves play at the start of your next Energy Phase unless you pay 1 energy to keep it in play instead. If all of your creatures in play share a type, your creatures deal 1 additional damage during battle. ',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rosebound-Deterrence-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_482',
    s3_large_image_name:
      'NDgyLS0tMzEtYXNoZW4tYWZ0ZXJtYXRoLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDgyLS0tMzEtYXNoZW4tYWZ0ZXJtYXRoLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDgyLS0tMzEtYXNoZW4tYWZ0ZXJtYXRoLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Ashen Aftermath',
    set_name: 'The Dimension That Disappeared',
    set_number: '31',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'A.Gvin',
    effect:
      "Pay 1 energy. Target a blank pile of energy in play and send it to the owner's hand. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Ashen-Aftermath-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_251',
    s3_large_image_name:
      'MjUxLS0tMzEtQ3J5c3RhbC1IYW1tZXJoZWFkLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjUxLS0tMzEtQ3J5c3RhbC1IYW1tZXJoZWFkLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjUxLS0tMzEtQ3J5c3RhbC1IYW1tZXJoZWFkLmpwZwEXODUSEXODUS/t',
    name: 'Crystal Hammerhead',
    set_name: 'Crystal Forge',
    set_number: '31',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Shark'],
    creature_type_count: 2,
    artist: 'Sarayu Ruangvesh',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystal-Hammerhead-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_308',
    s3_large_image_name: 'MzA4LS0tMzEtRGltZW5zaW9uYWwtUGhvZW5peC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzA4LS0tMzEtRGltZW5zaW9uYWwtUGhvZW5peC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzA4LS0tMzEtRGltZW5zaW9uYWwtUGhvZW5peC5wbmcEXODUS/t',
    name: 'Dimensional Phoenix',
    set_name: 'Converging Chasms',
    set_number: '31',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Phoenix'],
    creature_type_count: 1,
    artist: 'B.A. Miller',
    effect:
      'While this creature is on your field, whenever you put into play a creature with "Dimensional" or "Dust" in its name, you may move 1 energy to another creature or pile on the same side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Phoenix-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_587',
    s3_large_image_name: 'NTg3LS0tMzEtZWV2ZW50aWRlJ3MtYXJjaGl2ZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTg3LS0tMzEtZWV2ZW50aWRlJ3MtYXJjaGl2ZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTg3LS0tMzEtZWV2ZW50aWRlJ3MtYXJjaGl2ZS5wbmcEXODUS/t',
    name: "Eeventide's Archive",
    set_name: 'Threshold of Time',
    set_number: '31',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Odysseas Stamoglou',
    effect:
      'Only 1 copy of this card is allowed in your Main Deck. \nSearch your Main Deck or graveyard for 1 Archive creature and add it to your hand. Then, shuffle your Main Deck if it was searched. After this card is played, it stays on the field until another card causes it to leave play. \n• LINK: When “Eeventide’s Archive”, “The Great Archive” and “Archive, the Hub of Knowledge” …\n• LINK: Your Archive creatures ...',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Eeventide-s-Archive-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_189',
    s3_large_image_name:
      'MTg5LS0tMzEtSW50ZXJzdGVsbGFyLVRpZGVzLU5PTkZvaWwtNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTg5LS0tMzEtSW50ZXJzdGVsbGFyLVRpZGVzLU5PTkZvaWwtNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTg5LS0tMzEtSW50ZXJzdGVsbGFyLVRpZGVzLU5PTkZvaWwtNENQLmpwZwEXODUSEXODUS/t',
    name: 'Interstellar Tides',
    set_name: 'Galaxy Tides',
    set_number: '31',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Gary McCluskey',
    effect:
      'Search your Main Deck for an Uncommon creature and send it to the graveyard. Then, shuffle your Main Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Interstellar-Tides-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_252',
    s3_large_image_name: 'MjUyLS0tMzItRnJvc3RkZXctUGhvZW5peC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjUyLS0tMzItRnJvc3RkZXctUGhvZW5peC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjUyLS0tMzItRnJvc3RkZXctUGhvZW5peC5qcGcEXODUS/t',
    name: 'Frostdew Phoenix',
    set_name: 'Crystal Forge',
    set_number: '32',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Phoenix'],
    creature_type_count: 2,
    artist: 'Hoang Tran',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Frostdew-Phoenix-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_309',
    s3_large_image_name:
      'MzA5LS0tMzItSGVhcnQtb2YtVHJlZWZvcmdlLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzA5LS0tMzItSGVhcnQtb2YtVHJlZWZvcmdlLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzA5LS0tMzItSGVhcnQtb2YtVHJlZWZvcmdlLmpwZwEXODUSEXODUS/t',
    name: 'Heart of Treeforge',
    set_name: 'Converging Chasms',
    set_number: '32',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      'You may activate this card only if you control Treefolk-type creature(s) on your field. Look at the top 5 cards of your Main Deck and put them back on top in any order.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heart-of-Treeforge-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_588',
    s3_large_image_name: 'NTg4LS0tMzItdGhlLWdyZWF0LWFyY2hpdmUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTg4LS0tMzItdGhlLWdyZWF0LWFyY2hpdmUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTg4LS0tMzItdGhlLWdyZWF0LWFyY2hpdmUucG5n/t',
    name: 'The Great Archive',
    set_name: 'Threshold of Time',
    set_number: '32',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Odysseas Stamoglou',
    effect:
      'Only 1 copy of this card is allowed in your Main Deck. \nSearch your Main Deck or graveyard for 1 Archive creature and add it to your hand. Then, shuffle your Main Deck if it was searched. After this card is played, it stays on the field until another card causes it to leave play.\n• LINK: … become linked, you may put all Archive creatures ...\n• LINK: … may conduct an additional attack … ',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/The-Great-Archive-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_483',
    s3_large_image_name:
      'NDgzLS0tMzItdHJlZWZvcmdlLWJvYXJkcm9vbS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDgzLS0tMzItdHJlZWZvcmdlLWJvYXJkcm9vbS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDgzLS0tMzItdHJlZWZvcmdlLWJvYXJkcm9vbS03MmRwaS5wbmcEXODUS/t',
    name: 'Treeforge Boardroom',
    set_name: 'The Dimension That Disappeared',
    set_number: '32',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Nivea Toliver',
    effect:
      'Pay 1 Life Point. Each player on your team may reveal the top and bottom card of their own Main Deck or 1 card in their hand. Then, draw 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Treeforge-Boardroom-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_190',
    s3_large_image_name:
      'MTkwLS0tMzItVmVuZGV0dGEtUGxhdGVhdS1OT05Gb2lsLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTkwLS0tMzItVmVuZGV0dGEtUGxhdGVhdS1OT05Gb2lsLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTkwLS0tMzItVmVuZGV0dGEtUGxhdGVhdS1OT05Gb2lsLTRDUC5qcGcEXODUS/t',
    name: 'Vendetta Plateau',
    set_name: 'Galaxy Tides',
    set_number: '32',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'COCOs',
    effect:
      'Discard 1 creature or symmetry card from your hand and draw 1 energy card.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Vendetta-Plateau-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_589',
    s3_large_image_name:
      'NTg5LS0tMzMtYXJjaGl2ZS10aGUtaHViLW9mLWtub3dsZWRnZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTg5LS0tMzMtYXJjaGl2ZS10aGUtaHViLW9mLWtub3dsZWRnZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTg5LS0tMzMtYXJjaGl2ZS10aGUtaHViLW9mLWtub3dsZWRnZS5wbmcEXODUS/t',
    name: 'Archive, the Hub of Knowledge',
    set_name: 'Threshold of Time',
    set_number: '33',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Odysseas Stamoglou',
    effect:
      'Only 1 copy of this card is allowed in your Main Deck.\nSearch your Main Deck or graveyard for 1 Archive creature and add it to your hand. Then, shuffle your Main Deck if it was searched. After this card is played, it stays on the field until another card causes it to leave play.\n• LINK: … from your graveyard into your hand.\n• LINK: … during your Attack Phase.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Archive--the-Hub-of-Knowledge-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_484',
    s3_large_image_name:
      'NDg0LS0tMzMtY3J5b2dlbmljLWNyaXRlcmlvbi03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDg0LS0tMzMtY3J5b2dlbmljLWNyaXRlcmlvbi03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDg0LS0tMzMtY3J5b2dlbmljLWNyaXRlcmlvbi03MmRwaS5wbmcEXODUS/t',
    name: 'Cryogenic Criterion',
    set_name: 'The Dimension That Disappeared',
    set_number: '33',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Michelle Graves',
    effect:
      'Target 1 energy on each side of the field and freeze them. Then, all opposing Afterthought Abilities become inactive for the rest of the turn. ',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cryogenic-Criterion-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_253',
    s3_large_image_name: 'MjUzLS0tMzMtQ3J5c3RhbC1Db3ZlLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjUzLS0tMzMtQ3J5c3RhbC1Db3ZlLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjUzLS0tMzMtQ3J5c3RhbC1Db3ZlLmpwZwEXODUSEXODUS/t',
    name: 'Crystal Cove',
    set_name: 'Crystal Forge',
    set_number: '33',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Jackie Felix',
    effect:
      "Pay 1 energy. Select one symmetry in play other than this card and freeze it. (The frozen card is flipped facedown. It flips face-up and activates at the end of the owner's next turn.)",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystal-Cove-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_191',
    s3_large_image_name:
      'MTkxLS0tMzMtUm95YWwtUGF0cmlhcmNoLU5PTkZvaWwtNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTkxLS0tMzMtUm95YWwtUGF0cmlhcmNoLU5PTkZvaWwtNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTkxLS0tMzMtUm95YWwtUGF0cmlhcmNoLU5PTkZvaWwtNENQLmpwZwEXODUSEXODUS/t',
    name: 'Royal Patriarch',
    set_name: 'Galaxy Tides',
    set_number: '33',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'Rebecca Weaver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Royal-Patriarch-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_310',
    s3_large_image_name: 'MzEwLS0tMzMtU2NlbmljLVN1Y2Nlc3Npb24uanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzEwLS0tMzMtU2NlbmljLVN1Y2Nlc3Npb24uanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzEwLS0tMzMtU2NlbmljLVN1Y2Nlc3Npb24uanBn/t',
    name: 'Scenic Succession',
    set_name: 'Converging Chasms',
    set_number: '33',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      'When this card is played, select one of the following rarities: Common or Uncommon. If you have more creatures of the chosen rarity in play than your opponent, select 2 creatures on your field and switch their energy levels.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Scenic-Succession-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_254',
    s3_large_image_name: 'MjU0LS0tMzQtQ3J5c3RhbGxpemUuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjU0LS0tMzQtQ3J5c3RhbGxpemUuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjU0LS0tMzQtQ3J5c3RhbGxpemUuanBn/t',
    name: 'Crystallize',
    set_name: 'Crystal Forge',
    set_number: '34',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Nivea Toliver',
    effect:
      'Pay 1 energy. Select one creature in play with an Ability and cancel its effect for the rest of the turn.',
    ruling:
      '<p>■&nbsp;<em>Crystallize&nbsp;</em>cannot target or affect<em>&nbsp;Lantern Leaflore</em>;</p>\n<p>■&nbsp;On-summon creature Abilities (i.e. "When this creature is summoned...") can be negated by this card (<strong>if played in response</strong>&nbsp;to the creature being summoned). After the end of the turn, the creature will already have been summoned and its on-summon Ability will&nbsp;<strong>not</strong>&nbsp;trigger;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystallize-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_485',
    s3_large_image_name:
      'NDg1LS0tMzQtZW5jYXNlZC1ydW5lcm9jay03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDg1LS0tMzQtZW5jYXNlZC1ydW5lcm9jay03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDg1LS0tMzQtZW5jYXNlZC1ydW5lcm9jay03MmRwaS5wbmcEXODUS/t',
    name: 'Encased Runerock',
    set_name: 'The Dimension That Disappeared',
    set_number: '34',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Daria Gallyamova',
    effect:
      'Pay 1 energy. Target 1 creature or energy in play and freeze it. You may pay another energy. If you do, additionally target 1 creature or energy in play and permanently freeze it.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Encased-Runerock-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_192',
    s3_large_image_name:
      'MTkyLS0tMzQtSGVhdmVubHktSGVyYS1OT05Gb2lsLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTkyLS0tMzQtSGVhdmVubHktSGVyYS1OT05Gb2lsLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTkyLS0tMzQtSGVhdmVubHktSGVyYS1OT05Gb2lsLTRDUC5qcGcEXODUS/t',
    name: 'Heavenly Blade Hera',
    set_name: 'Galaxy Tides',
    set_number: '34',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'Rebecca Weaver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenly-Blade-Hera-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_590',
    s3_large_image_name:
      'NTkwLS0tMzQtbGVhZGVybGVzcy1mYWN0aW9uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTkwLS0tMzQtbGVhZGVybGVzcy1mYWN0aW9uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTkwLS0tMzQtbGVhZGVybGVzcy1mYWN0aW9uLnBuZwEXODUSEXODUS/t',
    name: 'Leaderless Faction',
    set_name: 'Threshold of Time',
    set_number: '34',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Alejandro Arévalo',
    effect:
      "When this card is played, it remains on the field until you perform a Deck Recycle. Whenever a player's Life Points become less than their opponent's, rebuild a Machine on your field (even if it and the rebuild target have already been rebuilt this turn) or draw 1 card.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Leaderless-Faction-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_311',
    s3_large_image_name: 'MzExLS0tMzQtTWFpbi1EZWNrLVN0cmlrZS5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzExLS0tMzQtTWFpbi1EZWNrLVN0cmlrZS5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzExLS0tMzQtTWFpbi1EZWNrLVN0cmlrZS5qcGcEXODUS/t',
    name: 'Main Deck Strike',
    set_name: 'Converging Chasms',
    set_number: '34',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Nivea Toliver',
    effect:
      "Send the top card of your opponent's Main Deck to their graveyard.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Main-Deck-Strike-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_486',
    s3_large_image_name:
      'NDg2LS0tMzUtY2hpdmFscnktb2YtdGhlLXdpbGRzLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDg2LS0tMzUtY2hpdmFscnktb2YtdGhlLXdpbGRzLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDg2LS0tMzUtY2hpdmFscnktb2YtdGhlLXdpbGRzLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Chivalry of the Wilds',
    set_name: 'The Dimension That Disappeared',
    set_number: '35',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Mat Gimeno',
    effect:
      "Pay 1 frozen energy. This turn, your Common and Uncommon Shardfolk and their energy can't leave play due to opposing effects and Abilities. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chivalry-of-the-Wilds-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_591',
    s3_large_image_name: 'NTkxLS0tMzUtY3Jvc3NmaXJlLWZvcm11bGEucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTkxLS0tMzUtY3Jvc3NmaXJlLWZvcm11bGEucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTkxLS0tMzUtY3Jvc3NmaXJlLWZvcm11bGEucG5n/t',
    name: 'Crossfire Formula',
    set_name: 'Threshold of Time',
    set_number: '35',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Daria Gallyamova',
    effect:
      'When this card is played, ignite it; it remains on the field until the end of the turn. When you ignite a card, you may summon a Hailfire from your hand or graveyard on an existing blank pile on your field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crossfire-Formula-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_312',
    s3_large_image_name: 'MzEyLS0tMzUtUmV0dXJuLWZyb20tU3RhcmR1c3QuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzEyLS0tMzUtUmV0dXJuLWZyb20tU3RhcmR1c3QuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzEyLS0tMzUtUmV0dXJuLWZyb20tU3RhcmR1c3QuanBn/t',
    name: 'Return from Stardust',
    set_name: 'Converging Chasms',
    set_number: '35',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Select 1 card in your opponent's graveyard. Your opponent selects 1 card in your graveyard. Add the selected cards to their owners' hands.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Return-from-Stardust-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_255',
    s3_large_image_name: 'MjU1LS0tMzUtU2hhcmQtTGlnaHRob3VzZS5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjU1LS0tMzUtU2hhcmQtTGlnaHRob3VzZS5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjU1LS0tMzUtU2hhcmQtTGlnaHRob3VzZS5qcGcEXODUS/t',
    name: 'Shard Lighthouse',
    set_name: 'Crystal Forge',
    set_number: '35',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Elena Shiyanova',
    effect:
      "Freeze one of your creatures. Then, select one Rare creature on your opponent's side of the field and freeze it. (They unfreeze at the end of the owner's next turn.)",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Shard-Lighthouse-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_193',
    s3_large_image_name: 'MTkzLS0tMzUtU3ltcGhvbnktTk9ORm9pbC00Q1AuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTkzLS0tMzUtU3ltcGhvbnktTk9ORm9pbC00Q1AuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTkzLS0tMzUtU3ltcGhvbnktTk9ORm9pbC00Q1AuanBn/t',
    name: 'Symphony Songsmith',
    set_name: 'Galaxy Tides',
    set_number: '35',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'Kenny Estrella',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Symphony-Songsmith-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_194',
    s3_large_image_name: 'MTk0LS0tMzYtQ29uY2VydG8tTk9ORm9pbC00Q1AuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTk0LS0tMzYtQ29uY2VydG8tTk9ORm9pbC00Q1AuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTk0LS0tMzYtQ29uY2VydG8tTk9ORm9pbC00Q1AuanBn/t',
    name: 'Concerto Virtuoso',
    set_name: 'Galaxy Tides',
    set_number: '36',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'COCOs',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Concerto-Virtuoso-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_256',
    s3_large_image_name:
      'MjU2LS0tMzYtQ3J5c3RhbGx1cy1Db21tYW5kLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjU2LS0tMzYtQ3J5c3RhbGx1cy1Db21tYW5kLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjU2LS0tMzYtQ3J5c3RhbGx1cy1Db21tYW5kLmpwZwEXODUSEXODUS/t',
    name: "Crystallus' Command",
    set_name: 'Crystal Forge',
    set_number: '36',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Hafid Moenir',
    effect:
      'Freeze one of your Common creatures in play. Then, add 1 energy to it from your Energy Deck. (It unfreezes at the end of your next turn.)',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystallus--Command-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_313',
    s3_large_image_name: 'MzEzLS0tMzYtRmlyZWZseS1Hcm90dG8uanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzEzLS0tMzYtRmlyZWZseS1Hcm90dG8uanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzEzLS0tMzYtRmlyZWZseS1Hcm90dG8uanBn/t',
    name: 'Firefly Grotto',
    set_name: 'Converging Chasms',
    set_number: '36',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      'Select a blank pile of energy on your side of the field and attach it to one of your Uncommon creatures in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Firefly-Grotto-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_592',
    s3_large_image_name:
      'NTkyLS0tMzYtdHJlYXN1cnktb2YtdHJlZWZvcmdlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTkyLS0tMzYtdHJlYXN1cnktb2YtdHJlZWZvcmdlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTkyLS0tMzYtdHJlYXN1cnktb2YtdHJlZWZvcmdlLnBuZwEXODUSEXODUS/t',
    name: 'Treasury of Treeforge',
    set_name: 'Threshold of Time',
    set_number: '36',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Amelia Połtoracka',
    effect:
      " Look at your opponent's graveyard, hand and the top card of their Main Deck; target up to 1 viewable card from each and move them to one of those other zones.",
    ruling:
      '<p>■ Because this card\'s effect states "up to 1...", you may opt to choose 0 cards to move from some zone(s);<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - You may move targeted card(s) to any of the three viewable zones, even if a card was not chosen to move out of that particular zone;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Treasury-of-Treeforge-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_487',
    s3_large_image_name:
      'NDg3LS0tMzYtdW5zb3VuZC1hYnN0cmFjdGlvbi03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDg3LS0tMzYtdW5zb3VuZC1hYnN0cmFjdGlvbi03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDg3LS0tMzYtdW5zb3VuZC1hYnN0cmFjdGlvbi03MmRwaS5wbmcEXODUS/t',
    name: 'Unsound Abstraction',
    set_name: 'The Dimension That Disappeared',
    set_number: '36',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Alejandro Arévalo',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Unsound-Abstraction-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_195',
    s3_large_image_name: 'MTk1LS0tMzctQXJpYS1OT05Gb2lsLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTk1LS0tMzctQXJpYS1OT05Gb2lsLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTk1LS0tMzctQXJpYS1OT05Gb2lsLTRDUC5qcGcEXODUS/t',
    name: 'Aria, Wielder of Shards',
    set_name: 'Galaxy Tides',
    set_number: '37',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Didi Esmeralda',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Aria--Wielder-of-Shards-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_257',
    s3_large_image_name: 'MjU3LS0tMzctR2xhY2lhbC1DaGFzbS5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjU3LS0tMzctR2xhY2lhbC1DaGFzbS5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjU3LS0tMzctR2xhY2lhbC1DaGFzbS5qcGcEXODUS/t',
    name: 'Glacial Chasm',
    set_name: 'Crystal Forge',
    set_number: '37',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Sarayu Ruangvesh',
    effect:
      'Freeze one of your Uncommon Shardfolk in play (it unfreezes at the end of your next turn). Then, add 1 energy to it from your Energy Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Glacial-Chasm-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_593',
    s3_large_image_name: 'NTkzLS0tMzctcmVwZWwtdGhlLXRob3VnaHRzdHJlYW0ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTkzLS0tMzctcmVwZWwtdGhlLXRob3VnaHRzdHJlYW0ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTkzLS0tMzctcmVwZWwtdGhlLXRob3VnaHRzdHJlYW0ucG5n/t',
    name: 'Repel the Thoughtstream',
    set_name: 'Threshold of Time',
    set_number: '37',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'A.Gvin',
    effect:
      'When this card is played, it remains on the field until the end of the turn. When your opponent draws a card due to an effect or Ability, you may draw a card from the opposite Deck.',
    ruling: '<p><em>Official Ruling Coming Soon!</em></p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Repel-the-Thoughtstream-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_488',
    s3_large_image_name: 'NDg4LS0tMzctc3Rvcm1zaGlmdC1vYnNjdXJpdHktNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDg4LS0tMzctc3Rvcm1zaGlmdC1vYnNjdXJpdHktNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDg4LS0tMzctc3Rvcm1zaGlmdC1vYnNjdXJpdHktNzJkcGkucG5n/t',
    name: 'Stormshift Obscurity',
    set_name: 'The Dimension That Disappeared',
    set_number: '37',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono', 'Storm'],
    creature_type_count: 2,
    artist: 'Michelle Graves',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Stormshift-Obscurity-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_314',
    s3_large_image_name: 'MzE0LS0tMzctVHdpbGlnaHQtR29yZ2UuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzE0LS0tMzctVHdpbGlnaHQtR29yZ2UuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzE0LS0tMzctVHdpbGlnaHQtR29yZ2UuanBn/t',
    name: 'Twilight Gorge',
    set_name: 'Converging Chasms',
    set_number: '37',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'J.L.Lockwood',
    effect:
      'For each frozen card in play, put a card from your graveyard on the bottom of your Main Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Twilight-Gorge-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_258',
    s3_large_image_name:
      'MjU4LS0tMzgtRnJvc3Rmcm9udC1DcnlzYWRlLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjU4LS0tMzgtRnJvc3Rmcm9udC1DcnlzYWRlLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjU4LS0tMzgtRnJvc3Rmcm9udC1DcnlzYWRlLmpwZwEXODUSEXODUS/t',
    name: 'Frostfront Crysade',
    set_name: 'Crystal Forge',
    set_number: '38',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'S. Calvin',
    effect:
      'Choose one of your Common or Uncommon creatures in play that is frozen and unfreeze it. Then, draw 1 card.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Frostfront-Crysade-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_489',
    s3_large_image_name:
      'NDg5LS0tMzgtcm95YWwtcmVzdXJnZW5jZS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDg5LS0tMzgtcm95YWwtcmVzdXJnZW5jZS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDg5LS0tMzgtcm95YWwtcmVzdXJnZW5jZS03MmRwaS5wbmcEXODUS/t',
    name: 'Royal Resurgence',
    set_name: 'The Dimension That Disappeared',
    set_number: '38',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Phoenix'],
    creature_type_count: 2,
    artist: 'Pradipta Candra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Royal-Resurgence-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_315',
    s3_large_image_name: 'MzE1LS0tMzgtU3RhcmJvcm4tT3V0YnJlYWsuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzE1LS0tMzgtU3RhcmJvcm4tT3V0YnJlYWsuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzE1LS0tMzgtU3RhcmJvcm4tT3V0YnJlYWsuanBn/t',
    name: 'Starborn Outbreak',
    set_name: 'Converging Chasms',
    set_number: '38',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      'Each player performs an immediate Deck Recycle. (Shuffle the graveyard into the Main Deck.)',
    ruling:
      '<p>■ Due to the wording, "Each player performs an immediate Deck Recycle", both players (or all in a Multiplayer game)&nbsp;<strong><em>MUST</em>&nbsp;shuffle their Main Deck</strong>&nbsp;regardless of whether or not that player has any cards in their graveyard;</p>\n<p>&nbsp; &nbsp;&nbsp; -&nbsp;This effect does not say "may" or "if possible", it simply instructs each player to do so. As such, this card should be treated as a "do as much as possible" type of effect;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Starborn-Outbreak-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_594',
    s3_large_image_name: 'NTk0LS0tMzgtdHJpZnJvc3QtZmxvcmV0LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTk0LS0tMzgtdHJpZnJvc3QtZmxvcmV0LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTk0LS0tMzgtdHJpZnJvc3QtZmxvcmV0LnBuZwEXODUSEXODUS/t',
    name: 'Trifrost Floret',
    set_name: 'Threshold of Time',
    set_number: '38',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Alejandro Arévalo',
    effect:
      "If any cards were revealed or frozen this turn, look at the top 5 cards of your opponent's Main Deck and put them back in any order.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Trifrost-Floret-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_196',
    s3_large_image_name:
      'MTk2LS0tMzgtV2lzaHdha2VyLU5PTkZvaWwtNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTk2LS0tMzgtV2lzaHdha2VyLU5PTkZvaWwtNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTk2LS0tMzgtV2lzaHdha2VyLU5PTkZvaWwtNENQLmpwZwEXODUSEXODUS/t',
    name: 'Wishwaker Willow',
    set_name: 'Galaxy Tides',
    set_number: '38',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Kenny Estrella',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Wishwaker-Willow-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_316',
    s3_large_image_name: 'MzE2LS0tMzktQmFubmVyLW9mLVZhbG9yLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzE2LS0tMzktQmFubmVyLW9mLVZhbG9yLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzE2LS0tMzktQmFubmVyLW9mLVZhbG9yLmpwZwEXODUSEXODUS/t',
    name: 'Banner of Valor',
    set_name: 'Converging Chasms',
    set_number: '39',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'S. Calvin',
    effect:
      'If you control "Roxanne the Final Paladin" on your field, add 2 energy to an Angel in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Banner-of-Valor-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_490',
    s3_large_image_name: 'NDkwLS0tMzktY3JvY29pdGUtY3JlYXRpb24tNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDkwLS0tMzktY3JvY29pdGUtY3JlYXRpb24tNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDkwLS0tMzktY3JvY29pdGUtY3JlYXRpb24tNzJkcGkucG5n/t',
    name: 'Crocoite Creation',
    set_name: 'The Dimension That Disappeared',
    set_number: '39',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Machine'],
    creature_type_count: 2,
    artist: 'Nivea Toliver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crocoite-Creation-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_259',
    s3_large_image_name: 'MjU5LS0tMzktRHJpZnRlcnMtRHVlbGluZy5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjU5LS0tMzktRHJpZnRlcnMtRHVlbGluZy5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjU5LS0tMzktRHJpZnRlcnMtRHVlbGluZy5qcGcEXODUS/t',
    name: 'Drifters Dueling',
    set_name: 'Crystal Forge',
    set_number: '39',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Jackie Felix',
    effect:
      "Look at your opponent's hand. Select 1 card from it and put it on top of their Deck.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Drifters-Dueling-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_595',
    s3_large_image_name: 'NTk1LS0tMzktbHVjaWEncy10aHJvbmUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTk1LS0tMzktbHVjaWEncy10aHJvbmUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTk1LS0tMzktbHVjaWEncy10aHJvbmUucG5n/t',
    name: "Lucia's Throne",
    set_name: 'Threshold of Time',
    set_number: '39',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Thai Vo',
    effect:
      'Unfreeze 1 energy on your field for each rarity among your creatures in play. Then, move those energy card(s) to one of your creatures in play. For each rarity star that creature has below 3, it gains 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lucia-s-Throne-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_197',
    s3_large_image_name: 'MTk3LS0tMzktU3RlbGxhci1EcmFnb24tTk9ORm9pbC00Q1AuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTk3LS0tMzktU3RlbGxhci1EcmFnb24tTk9ORm9pbC00Q1AuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTk3LS0tMzktU3RlbGxhci1EcmFnb24tTk9ORm9pbC00Q1AuanBn/t',
    name: 'Stellar Elliptical Dragon',
    set_name: 'Galaxy Tides',
    set_number: '39',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'COCOs',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Stellar-Elliptical-Dragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_260',
    s3_large_image_name: 'MjYwLS0tNDAtQ3J5b2NyZXN0LUNyYWdzLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjYwLS0tNDAtQ3J5b2NyZXN0LUNyYWdzLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjYwLS0tNDAtQ3J5b2NyZXN0LUNyYWdzLmpwZwEXODUSEXODUS/t',
    name: 'Cryocrest Crags',
    set_name: 'Crystal Forge',
    set_number: '40',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Hoang Tran',
    effect:
      'Choose a player. That player selects a card from their hand and puts it onto the side of the field frozen. (It unfreezes at the end of their next turn and returns to their hand.)',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cryocrest-Crags-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_198',
    s3_large_image_name:
      'MTk4LS0tNDAtSGVhdmVubHktSG9zdC1OT05Gb2lsLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTk4LS0tNDAtSGVhdmVubHktSG9zdC1OT05Gb2lsLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTk4LS0tNDAtSGVhdmVubHktSG9zdC1OT05Gb2lsLTRDUC5qcGcEXODUS/t',
    name: 'Heavenly Host',
    set_name: 'Galaxy Tides',
    set_number: '40',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Charlo Nocete',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenly-Host-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_596',
    s3_large_image_name: 'NTk2LS0tNDAtbG9vbWluZy1hdXRvZHJvc3MucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTk2LS0tNDAtbG9vbWluZy1hdXRvZHJvc3MucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTk2LS0tNDAtbG9vbWluZy1hdXRvZHJvc3MucG5n/t',
    name: 'Looming Autodross',
    set_name: 'Threshold of Time',
    set_number: '40',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    effect:
      "During the turn this creature is rebuilt, your Machines can't be attacked by creatures that are higher rarity than them.",
    ruling:
      '<p>■ Harmony Rare creatures are considered higher rarity than Secret Rare creatures, which are considered higher rarity than Rare creatures;&nbsp;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Looming-Autodross-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_317',
    s3_large_image_name:
      'MzE3LS0tNDAtU3RhcnNsZWV0LURvd25wb3VyLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzE3LS0tNDAtU3RhcnNsZWV0LURvd25wb3VyLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzE3LS0tNDAtU3RhcnNsZWV0LURvd25wb3VyLmpwZwEXODUSEXODUS/t',
    name: 'Starsleet Downpour',
    set_name: 'Converging Chasms',
    set_number: '40',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      'This card remains in play until one of your Rare creatures leaves play. Once per turn, you may peek at the top card of your Main Deck.',
    ruling:
      '<p>■&nbsp;Once played,&nbsp;this card may&nbsp;<strong>only</strong>&nbsp;leave the field once the condition of "until one of your Rare creatures leaves play" is met.&nbsp;<strong>You may not discard it if there are no Rare creatures on your field that leave play</strong>;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Starsleet-Downpour-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_491',
    s3_large_image_name:
      'NDkxLS0tNDAtdmlvbGV0LXZpdmlkaWN0YS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDkxLS0tNDAtdmlvbGV0LXZpdmlkaWN0YS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDkxLS0tNDAtdmlvbGV0LXZpdmlkaWN0YS03MmRwaS5wbmcEXODUS/t',
    name: 'Violet Vividicta',
    set_name: 'The Dimension That Disappeared',
    set_number: '40',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Peacock'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Violet-Vividicta-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_199',
    s3_large_image_name:
      'MTk5LS0tNDEtQmVsbGZsb3dlci1EcmFnb24tNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTk5LS0tNDEtQmVsbGZsb3dlci1EcmFnb24tNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTk5LS0tNDEtQmVsbGZsb3dlci1EcmFnb24tNENQLmpwZwEXODUSEXODUS/t',
    name: 'Bellflower Dragon',
    set_name: 'Galaxy Tides',
    set_number: '41',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Dallin Bifano',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Bellflower-Dragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_261',
    s3_large_image_name: 'MjYxLS0tNDEtQ3J5c3RhbC1Db3JyaWRvci5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjYxLS0tNDEtQ3J5c3RhbC1Db3JyaWRvci5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjYxLS0tNDEtQ3J5c3RhbC1Db3JyaWRvci5qcGcEXODUS/t',
    name: 'Crystal Corridor',
    set_name: 'Crystal Forge',
    set_number: '41',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect: 'Add 1 energy from your Energy Deck to a blank pile on the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystal-Corridor-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_318',
    s3_large_image_name:
      'MzE4LS0tNDEtUG9ydGFsLUZhbGwtVmFsbGV5LmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzE4LS0tNDEtUG9ydGFsLUZhbGwtVmFsbGV5LmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzE4LS0tNDEtUG9ydGFsLUZhbGwtVmFsbGV5LmpwZwEXODUSEXODUS/t',
    name: 'Portal Fall Valley',
    set_name: 'Converging Chasms',
    set_number: '41',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Kenny Estrella',
    effect:
      'Select a player. That player reveals the top card of their Main Deck. Then, you may have them put it back on the top or bottom.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Portal-Fall-Valley-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_492',
    s3_large_image_name:
      'NDkyLS0tNDEtcmVsdWN0YW50LWNyb3duLWpld2VsLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDkyLS0tNDEtcmVsdWN0YW50LWNyb3duLWpld2VsLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDkyLS0tNDEtcmVsdWN0YW50LWNyb3duLWpld2VsLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Reluctant Crown Jewel',
    set_name: 'The Dimension That Disappeared',
    set_number: '41',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Reluctant-Crown-Jewel-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_597',
    s3_large_image_name: 'NTk3LS0tNDEtc3RlYW1mb3JnZS1uYXZpZ2F0b3IucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTk3LS0tNDEtc3RlYW1mb3JnZS1uYXZpZ2F0b3IucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTk3LS0tNDEtc3RlYW1mb3JnZS1uYXZpZ2F0b3IucG5n/t',
    name: 'Steamforge Navigator',
    set_name: 'Threshold of Time',
    set_number: '41',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    effect:
      'While this creature is in play, whenever Machine(s) leave your graveyard, search your Main Deck for up to 2 Machines, and add them to your hand. Then, shuffle your Main Deck and rebuild one of your Machines in play.',
    ruling:
      "<p>■ This creature's Ability allows you to force-rebuild one of your Machines in play, even if it and/or the rebuild target have already been rebuilt this turn;&nbsp;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Steamforge-Navigator-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_200',
    s3_large_image_name: 'MjAwLS0tNDItQ2FsbGlncmFwaHktSW5rdmVpbC00Q1AuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjAwLS0tNDItQ2FsbGlncmFwaHktSW5rdmVpbC00Q1AuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjAwLS0tNDItQ2FsbGlncmFwaHktSW5rdmVpbC00Q1AuanBn/t',
    name: 'Calligraphy Inkveil',
    set_name: 'Galaxy Tides',
    set_number: '42',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Mistform'],
    creature_type_count: 2,
    artist: 'Wes',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Calligraphy-Inkveil-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_262',
    s3_large_image_name:
      'MjYyLS0tNDItZnJvc3RiaXR0ZW4tcG9ydGFsLWNhdmVybi1zYW1wbGUtY2FyZC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjYyLS0tNDItZnJvc3RiaXR0ZW4tcG9ydGFsLWNhdmVybi1zYW1wbGUtY2FyZC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjYyLS0tNDItZnJvc3RiaXR0ZW4tcG9ydGFsLWNhdmVybi1zYW1wbGUtY2FyZC5qcGcEXODUS/t',
    name: 'Frostbitten Portal Cavern',
    set_name: 'Crystal Forge',
    set_number: '42',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Mat Gimeno',
    effect:
      'If you have less Life Points than your opponent, choose one creature in play and freeze it.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Frostbitten-Portal-Cavern-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_319',
    s3_large_image_name: 'MzE5LS0tNDItTG9zdGVwLXRoZS1HbGFjaWFsLVBoYW50b20uanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzE5LS0tNDItTG9zdGVwLXRoZS1HbGFjaWFsLVBoYW50b20uanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzE5LS0tNDItTG9zdGVwLXRoZS1HbGFjaWFsLVBoYW50b20uanBn/t',
    name: 'Lostep the Glacial Phantom',
    set_name: 'Converging Chasms',
    set_number: '42',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Mistform'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lostep-the-Glacial-Phantom-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_598',
    s3_large_image_name:
      'NTk4LS0tNDItb2JzdHJ1Y3RpY2EtZHJlZGdlLWVuZ2luZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTk4LS0tNDItb2JzdHJ1Y3RpY2EtZHJlZGdlLWVuZ2luZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTk4LS0tNDItb2JzdHJ1Y3RpY2EtZHJlZGdlLWVuZ2luZS5wbmcEXODUS/t',
    name: 'Obstructica, Dredge Engine',
    set_name: 'Threshold of Time',
    set_number: '42',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect:
      'This creature can attack two creatures at once during the turn it is rebuilt.',
    ruling:
      "<p>■ This creature's Ability allows it to attack two creatures at once during the turn it is rebuilt;&nbsp;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - It deals damage equal to its energy level to both opposing creatures at once (the damage is not divided up) and receives total damage equal to both opposing creatures' energy levels;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Obstructica--Dredge-Engine-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_493',
    s3_large_image_name:
      'NDkzLS0tNDItc3RhcnBsdW1lLXNocm9vbS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDkzLS0tNDItc3RhcnBsdW1lLXNocm9vbS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDkzLS0tNDItc3RhcnBsdW1lLXNocm9vbS03MmRwaS5wbmcEXODUS/t',
    name: 'Starplume Shroom',
    set_name: 'The Dimension That Disappeared',
    set_number: '42',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk', 'Chrono'],
    creature_type_count: 2,
    artist: 'Yosi Saputra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Starplume-Shroom-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_320',
    s3_large_image_name:
      'MzIwLS0tNDMtQ3J5c3RhbHZlaWwtU25pcGVyLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzIwLS0tNDMtQ3J5c3RhbHZlaWwtU25pcGVyLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzIwLS0tNDMtQ3J5c3RhbHZlaWwtU25pcGVyLmpwZwEXODUSEXODUS/t',
    name: 'Crystalveil Sniper',
    set_name: 'Converging Chasms',
    set_number: '43',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystalveil-Sniper-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_494',
    s3_large_image_name: 'NDk0LS0tNDMtZHJlYW1kYXplLXJldmVyaWUtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDk0LS0tNDMtZHJlYW1kYXplLXJldmVyaWUtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDk0LS0tNDMtZHJlYW1kYXplLXJldmVyaWUtNzJkcGkucG5n/t',
    name: 'Dreamdaze Reverie',
    set_name: 'The Dimension That Disappeared',
    set_number: '43',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Stag'],
    creature_type_count: 2,
    artist: 'Michelle Graves',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dreamdaze-Reverie-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_263',
    s3_large_image_name: 'MjYzLS0tNDMtRW5lcmd5LmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjYzLS0tNDMtRW5lcmd5LmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjYzLS0tNDMtRW5lcmd5LmpwZwEXODUSEXODUS/t',
    name: 'Energy',
    set_name: 'Crystal Forge',
    set_number: '43',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Energy'],
    artist: 'Pradipta Candra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energy-First-2',
    is_default_edition: true,
  },
  {
    card_id: 'card_201',
    s3_large_image_name:
      'MjAxLS0tNDMtTW9sdGVuY3JhZy1TbGl0aGUtNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjAxLS0tNDMtTW9sdGVuY3JhZy1TbGl0aGUtNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjAxLS0tNDMtTW9sdGVuY3JhZy1TbGl0aGUtNENQLmpwZwEXODUSEXODUS/t',
    name: 'Moltencrag Slithe',
    set_name: 'Galaxy Tides',
    set_number: '43',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire', 'Slithe'],
    creature_type_count: 2,
    artist: 'Rebecca Weaver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Moltencrag-Slithe-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_599',
    s3_large_image_name: 'NTk5LS0tNDMtcmV2ZXJzZS1yYWluLW9ic2lkaWF2YWwucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTk5LS0tNDMtcmV2ZXJzZS1yYWluLW9ic2lkaWF2YWwucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTk5LS0tNDMtcmV2ZXJzZS1yYWluLW9ic2lkaWF2YWwucG5n/t',
    name: 'Reverse Rain Obsidiaval',
    set_name: 'Threshold of Time',
    set_number: '43',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    effect: '*Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Reverse-Rain-Obsidiaval-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_495',
    s3_large_image_name:
      'NDk1LS0tNDQtY2F2ZXJub3VzLXNjcmFwaG9sbG93LTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDk1LS0tNDQtY2F2ZXJub3VzLXNjcmFwaG9sbG93LTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDk1LS0tNDQtY2F2ZXJub3VzLXNjcmFwaG9sbG93LTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Cavernous Scraphollow',
    set_name: 'The Dimension That Disappeared',
    set_number: '44',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine', 'Chrono'],
    creature_type_count: 2,
    artist: 'Thai Vo',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cavernous-Scraphollow-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_321',
    s3_large_image_name: 'MzIxLS0tNDQtQ2hhb3MtQnVsbC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzIxLS0tNDQtQ2hhb3MtQnVsbC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzIxLS0tNDQtQ2hhb3MtQnVsbC5qcGcEXODUS/t',
    name: 'Chaos Bull',
    set_name: 'Converging Chasms',
    set_number: '44',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Bull'],
    creature_type_count: 2,
    artist: 'Pradipta Candra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chaos-Bull-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_600',
    s3_large_image_name: 'NjAwLS0tNDQtaGFpbGNvcmUtbWV0ZW9yLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjAwLS0tNDQtaGFpbGNvcmUtbWV0ZW9yLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjAwLS0tNDQtaGFpbGNvcmUtbWV0ZW9yLnBuZwEXODUSEXODUS/t',
    name: 'Hailcore Meteor',
    set_name: 'Threshold of Time',
    set_number: '44',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect: '*Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hailcore-Meteor-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_202',
    s3_large_image_name:
      'MjAyLS0tNDQtVGh1bmRlcmNvaWwtRHJhZ29uLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjAyLS0tNDQtVGh1bmRlcmNvaWwtRHJhZ29uLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjAyLS0tNDQtVGh1bmRlcmNvaWwtRHJhZ29uLTRDUC5qcGcEXODUS/t',
    name: 'Thundercoil Dragon',
    set_name: 'Galaxy Tides',
    set_number: '44',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Rebecca Weaver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Thundercoil-Dragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_601',
    s3_large_image_name: 'NjAxLS0tNDUta2luZGxlZmlyZS1ob3VuZC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjAxLS0tNDUta2luZGxlZmlyZS1ob3VuZC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjAxLS0tNDUta2luZGxlZmlyZS1ob3VuZC5wbmcEXODUS/t',
    name: 'Kindlefire Hound',
    set_name: 'Threshold of Time',
    set_number: '45',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire'],
    creature_type_count: 1,
    artist: 'B.A. Miller',
    effect: '*Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Kindlefire-Hound-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_203',
    s3_large_image_name:
      'MjAzLS0tNDUtUG9ydGFsYmFjay1EcmFnb24tNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjAzLS0tNDUtUG9ydGFsYmFjay1EcmFnb24tNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjAzLS0tNDUtUG9ydGFsYmFjay1EcmFnb24tNENQLmpwZwEXODUSEXODUS/t',
    name: 'Portalback Dragon',
    set_name: 'Galaxy Tides',
    set_number: '45',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Charlo Nocete',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Portalback-Dragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_322',
    s3_large_image_name: 'MzIyLS0tNDUtU2VhcmluZy1TY29yY2hncm92ZS5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzIyLS0tNDUtU2VhcmluZy1TY29yY2hncm92ZS5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzIyLS0tNDUtU2VhcmluZy1TY29yY2hncm92ZS5qcGcEXODUS/t',
    name: 'Searing Scorchgrove',
    set_name: 'Converging Chasms',
    set_number: '45',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Hailfire'],
    creature_type_count: 2,
    artist: 'Pradipta Candra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Searing-Scorchgrove-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_496',
    s3_large_image_name:
      'NDk2LS0tNDUtd2VhcndlYXRoZXItc3BlY3Rlci03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDk2LS0tNDUtd2VhcndlYXRoZXItc3BlY3Rlci03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDk2LS0tNDUtd2VhcndlYXRoZXItc3BlY3Rlci03MmRwaS5wbmcEXODUS/t',
    name: 'Wearweather Specter',
    set_name: 'The Dimension That Disappeared',
    set_number: '45',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Leviathan', 'Chrono'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Wearweather-Specter-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_323',
    s3_large_image_name: 'MzIzLS0tNDYtQmxvc3NvbWJhcmstR2FwZXIuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzIzLS0tNDYtQmxvc3NvbWJhcmstR2FwZXIuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzIzLS0tNDYtQmxvc3NvbWJhcmstR2FwZXIuanBn/t',
    name: 'Blossombark Gaper',
    set_name: 'Converging Chasms',
    set_number: '46',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Nivea Toliver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Blossombark-Gaper-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_204',
    s3_large_image_name: 'MjA0LS0tNDYtRHJhZ29uLUtuaWdodC1QYXJ0aXNhbi00Q1AuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjA0LS0tNDYtRHJhZ29uLUtuaWdodC1QYXJ0aXNhbi00Q1AuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjA0LS0tNDYtRHJhZ29uLUtuaWdodC1QYXJ0aXNhbi00Q1AuanBn/t',
    name: 'Dragon Knight Partisan',
    set_name: 'Galaxy Tides',
    set_number: '46',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Rennyl Montuya',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dragon-Knight-Partisan-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_602',
    s3_large_image_name:
      'NjAyLS0tNDYtZWV2ZW50aWRlJ3MtYXJtYWRhLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjAyLS0tNDYtZWV2ZW50aWRlJ3MtYXJtYWRhLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjAyLS0tNDYtZWV2ZW50aWRlJ3MtYXJtYWRhLnBuZwEXODUSEXODUS/t',
    name: "Eeventide's Armada",
    set_name: 'Threshold of Time',
    set_number: '46',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Leviathan'],
    creature_type_count: 1,
    artist: 'Yosi Saputra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Eeventide-s-Armada-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_497',
    s3_large_image_name: 'NDk3LS0tNDYtZnJhY3R1cmVkLXBvcnRhbHMtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDk3LS0tNDYtZnJhY3R1cmVkLXBvcnRhbHMtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDk3LS0tNDYtZnJhY3R1cmVkLXBvcnRhbHMtNzJkcGkucG5n/t',
    name: 'Fractured Portals',
    set_name: 'The Dimension That Disappeared',
    set_number: '46',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'This card stays in play until another card causes it to leave play. During your Energy Phase, you may add any number of energy from your hand to your energy piles.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Fractured-Portals-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_498',
    s3_large_image_name: 'NDk4LS0tNDctY2Vhc2UtdG8tZXhpc3QtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDk4LS0tNDctY2Vhc2UtdG8tZXhpc3QtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDk4LS0tNDctY2Vhc2UtdG8tZXhpc3QtNzJkcGkucG5n/t',
    name: 'Cease to Exist',
    set_name: 'The Dimension That Disappeared',
    set_number: '47',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Tanatola',
    effect:
      'When this card is played, it remains on the field for the rest of the turn. When opposing energy or creatures leave play and would go anywhere other than the graveyard, destroy them instead, if possible. ',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cease-to-Exist-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_324',
    s3_large_image_name: 'MzI0LS0tNDctQ3JhbmtzaGFmdC1PYWsuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzI0LS0tNDctQ3JhbmtzaGFmdC1PYWsuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzI0LS0tNDctQ3JhbmtzaGFmdC1PYWsuanBn/t',
    name: 'Crankshaft Oak',
    set_name: 'Converging Chasms',
    set_number: '47',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Machine'],
    creature_type_count: 2,
    artist: 'B.A. Miller',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crankshaft-Oak-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_603',
    s3_large_image_name:
      'NjAzLS0tNDctc25vd2NhcHBlZC1zZXF1b2lhLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjAzLS0tNDctc25vd2NhcHBlZC1zZXF1b2lhLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjAzLS0tNDctc25vd2NhcHBlZC1zZXF1b2lhLnBuZwEXODUSEXODUS/t',
    name: 'Snowcapped Sequoia',
    set_name: 'Threshold of Time',
    set_number: '47',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Brandon McDonald',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Snowcapped-Sequoia-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_205',
    s3_large_image_name: 'MjA1LS0tNDctU3RhcnNtb2tlLURyYWdvbi00Q1AuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjA1LS0tNDctU3RhcnNtb2tlLURyYWdvbi00Q1AuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjA1LS0tNDctU3RhcnNtb2tlLURyYWdvbi00Q1AuanBn/t',
    name: 'Starsmoke Dragon',
    set_name: 'Galaxy Tides',
    set_number: '47',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Wes',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Starsmoke-Dragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_499',
    s3_large_image_name:
      'NDk5LS0tNDgtYW50aGVtLW9mLWh1bWFuaXR5LTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDk5LS0tNDgtYW50aGVtLW9mLWh1bWFuaXR5LTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDk5LS0tNDgtYW50aGVtLW9mLWh1bWFuaXR5LTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Anthem of Humanity',
    set_name: 'The Dimension That Disappeared',
    set_number: '48',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Thai Vo',
    effect:
      'Search your graveyard for 1 Common creature and add it to your hand. If you have less Life Points than your opponent, you may also search your graveyard for 1 Uncommon creature and add it to your hand.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Anthem-of-Humanity-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_325',
    s3_large_image_name: 'MzI1LS0tNDgtRXZlcmJsb29tLUNlbGVzdGlhbC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzI1LS0tNDgtRXZlcmJsb29tLUNlbGVzdGlhbC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzI1LS0tNDgtRXZlcmJsb29tLUNlbGVzdGlhbC5qcGcEXODUS/t',
    name: 'Everbloom Celestial',
    set_name: 'Converging Chasms',
    set_number: '48',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Rebecca Weaver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Everbloom-Celestial-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_206',
    s3_large_image_name: 'MjA2LS0tNDgtTmVidWxhLU1lY2gtNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjA2LS0tNDgtTmVidWxhLU1lY2gtNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjA2LS0tNDgtTmVidWxhLU1lY2gtNENQLmpwZwEXODUSEXODUS/t',
    name: 'Nebula Mech Starvoid',
    set_name: 'Galaxy Tides',
    set_number: '48',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Gary McCluskey',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Nebula-Mech-Starvoid-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_604',
    s3_large_image_name:
      'NjA0LS0tNDgtdmVub21zcGlyZS1tb25hcmNoLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjA0LS0tNDgtdmVub21zcGlyZS1tb25hcmNoLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjA0LS0tNDgtdmVub21zcGlyZS1tb25hcmNoLnBuZwEXODUSEXODUS/t',
    name: 'Venomspire Monarch',
    set_name: 'Threshold of Time',
    set_number: '48',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Alejandro Arévalo',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Venomspire-Monarch-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_605',
    s3_large_image_name: 'NjA1LS0tNDktYXJjaGl2aXN0LWNoYW5jZWxsb3IucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjA1LS0tNDktYXJjaGl2aXN0LWNoYW5jZWxsb3IucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjA1LS0tNDktYXJjaGl2aXN0LWNoYW5jZWxsb3IucG5n/t',
    name: 'Archivist Chancellor',
    set_name: 'Threshold of Time',
    set_number: '49',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Drifter'],
    artist: 'S. Calvin',
    effect:
      'Once per turn, you may pay 1 Life Point to target an Ability and negate it for the rest of the turn.',
    ruling:
      '<p>■ <span style="font-weight: 400;">This Drifter’s Ability can target itself. However, negating it does not undo the Life Point cost paid during resolution</span>;&nbsp;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Archivist-Chancellor-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_500',
    s3_large_image_name:
      'NTAwLS0tNDktZGltZW5zaW9uYWwtcnVwdHVyZS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTAwLS0tNDktZGltZW5zaW9uYWwtcnVwdHVyZS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTAwLS0tNDktZGltZW5zaW9uYWwtcnVwdHVyZS03MmRwaS5wbmcEXODUS/t',
    name: 'Dimensional Rupture',
    set_name: 'The Dimension That Disappeared',
    set_number: '49',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Tanatola',
    effect:
      'Each player on your team sends the top card of their Main Deck to the graveyard. Each opponent sends the top 2 cards of their Main Deck to the graveyard. ',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Rupture-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_207',
    s3_large_image_name:
      'MjA3LS0tNDktUGxhbmV0c2lkZS1SZW1uYW50LTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjA3LS0tNDktUGxhbmV0c2lkZS1SZW1uYW50LTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjA3LS0tNDktUGxhbmV0c2lkZS1SZW1uYW50LTRDUC5qcGcEXODUS/t',
    name: 'Planetside Remnant',
    set_name: 'Galaxy Tides',
    set_number: '49',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Wes',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Planetside-Remnant-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_326',
    s3_large_image_name:
      'MzI2LS0tNDktUm9pbGluZy1TdG9ybS1UaHVuZGVyaHltbi5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzI2LS0tNDktUm9pbGluZy1TdG9ybS1UaHVuZGVyaHltbi5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzI2LS0tNDktUm9pbGluZy1TdG9ybS1UaHVuZGVyaHltbi5qcGcEXODUS/t',
    name: 'Roiling Storm Thunderhymn',
    set_name: 'Converging Chasms',
    set_number: '49',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Storm'],
    creature_type_count: 2,
    artist: 'Michelle Graves',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Roiling-Storm-Thunderhymn-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_606',
    s3_large_image_name: 'NjA2LS0tNTAtYXJjaGl2aXN0LW1hdmVuLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjA2LS0tNTAtYXJjaGl2aXN0LW1hdmVuLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjA2LS0tNTAtYXJjaGl2aXN0LW1hdmVuLnBuZwEXODUSEXODUS/t',
    name: 'Archivist Maven',
    set_name: 'Threshold of Time',
    set_number: '50',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Drifter'],
    artist: 'J.L.Lockwood',
    effect:
      'Once per turn, you may move 1 energy in play somewhere else on the same side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Archivist-Maven-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_208',
    s3_large_image_name: 'MjA4LS0tNTAtR2FsYXh5LUdhemVyLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjA4LS0tNTAtR2FsYXh5LUdhemVyLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjA4LS0tNTAtR2FsYXh5LUdhemVyLTRDUC5qcGcEXODUS/t',
    name: 'Galaxy Gazer',
    set_name: 'Galaxy Tides',
    set_number: '50',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Kenny Estrella',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Galaxy-Gazer-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_501',
    s3_large_image_name:
      'NTAxLS0tNTAtc2FuZGJsYXN0ZWQtc291cmNlLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTAxLS0tNTAtc2FuZGJsYXN0ZWQtc291cmNlLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTAxLS0tNTAtc2FuZGJsYXN0ZWQtc291cmNlLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Sandblasted Source',
    set_name: 'The Dimension That Disappeared',
    set_number: '50',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Yosi Saputra',
    effect:
      "Target 1 energy in play and send it to the owner's hand. Add 1 energy beneath the Main Deck or to a creature in play. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Sandblasted-Source-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_327',
    s3_large_image_name: 'MzI3LS0tNTAtVmlyaWRpYW4tUGVhay5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzI3LS0tNTAtVmlyaWRpYW4tUGVhay5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzI3LS0tNTAtVmlyaWRpYW4tUGVhay5qcGcEXODUS/t',
    name: 'Viridian Peak',
    set_name: 'Converging Chasms',
    set_number: '50',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mountain'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Viridian-Peak-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_607',
    s3_large_image_name: 'NjA3LS0tNTEtYXJjaGl2aXN0LWN1cmF0b3IucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjA3LS0tNTEtYXJjaGl2aXN0LWN1cmF0b3IucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjA3LS0tNTEtYXJjaGl2aXN0LWN1cmF0b3IucG5n/t',
    name: 'Archivist Curator',
    set_name: 'Threshold of Time',
    set_number: '51',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Drifter'],
    artist: 'Albert Zhou',
    effect:
      'Whenever another player draws card(s) outside of their Draw Phase, you may draw 1 energy.',
    ruling:
      '<p><span style="font-weight: 400;">■ This Drifter’s Ability allows you to draw 1 energy for each instance another player draws card(s) outside of their Draw Phase; </span><span style="font-weight: 400;"><br></span><span style="font-weight: 400;">&nbsp;</span></p>\n<ul>\n<ul>\n<li style="font-weight: 400;"><span style="font-weight: 400;">i.e. If you are playing as the <em>Archivist Curator</em> when <em>Vortex</em> causes your opponent to draw 3 cards at once outside of their Draw Phase, you draw 1 energy total for that instance;</span><span style="font-weight: 400;"><br><br></span></li>\n<ul>\n<li style="font-weight: 400;"><span style="font-weight: 400;">If your opponent is continually re-triggering an effect or Ability that allows them to draw a card, each of those occurrences count as separate instances that trigger this Drifter’s “Curate” Ability;</span></li>\n</ul>\n</ul>\n</ul>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Archivist-Curator-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_502',
    s3_large_image_name: 'NTAyLS0tNTEtY2hyb25pYy1jb2xsaXNpb24tNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTAyLS0tNTEtY2hyb25pYy1jb2xsaXNpb24tNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTAyLS0tNTEtY2hyb25pYy1jb2xsaXNpb24tNzJkcGkucG5n/t',
    name: 'Chronic Collision',
    set_name: 'The Dimension That Disappeared',
    set_number: '51',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Mat Gimeno',
    effect:
      'Target 1 Common or Uncommon creature on your side of the field. Each player on your team may target 1 opposing Common or Uncommon creature in play; your targeted creature battles all opposing targets.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chronic-Collision-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_328',
    s3_large_image_name: 'MzI4LS0tNTEtRGltZW5zaW9uYWwtT2N0b3B1cy5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzI4LS0tNTEtRGltZW5zaW9uYWwtT2N0b3B1cy5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzI4LS0tNTEtRGltZW5zaW9uYWwtT2N0b3B1cy5qcGcEXODUS/t',
    name: 'Dimensional Octopus',
    set_name: 'Converging Chasms',
    set_number: '51',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Octopus'],
    creature_type_count: 1,
    artist: 'S. Calvin',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Octopus-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_209',
    s3_large_image_name:
      'MjA5LS0tNTEtR3JhbmNpZWwtRW1pc3Nhcnktb2YtU3RhcnMtNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjA5LS0tNTEtR3JhbmNpZWwtRW1pc3Nhcnktb2YtU3RhcnMtNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjA5LS0tNTEtR3JhbmNpZWwtRW1pc3Nhcnktb2YtU3RhcnMtNENQLmpwZwEXODUSEXODUS/t',
    name: 'Granciel, Emissary of Stars',
    set_name: 'Galaxy Tides',
    set_number: '51',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Rennyl Montuya',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Granciel--Emissary-of-Stars-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_608',
    s3_large_image_name: 'NjA4LS0tNTItYXJjaGl2aXN0LWNhcmRzbWl0aC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjA4LS0tNTItYXJjaGl2aXN0LWNhcmRzbWl0aC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjA4LS0tNTItYXJjaGl2aXN0LWNhcmRzbWl0aC5wbmcEXODUS/t',
    name: 'Archivist Cardsmith',
    set_name: 'Threshold of Time',
    set_number: '52',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Drifter'],
    artist: 'Tommy Suhartono',
    effect:
      'Once per turn, when your creature(s) or symmetry card(s) become the target of opposing card effect(s) or Abilities, you may target 1 symmetry in your graveyard and play that card immediately (you must still pay any costs).',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Archivist-Cardsmith-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_503',
    s3_large_image_name: 'NTAzLS0tNTItZGVhZC1vZi1uaWdodC03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTAzLS0tNTItZGVhZC1vZi1uaWdodC03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTAzLS0tNTItZGVhZC1vZi1uaWdodC03MmRwaS5wbmcEXODUS/t',
    name: 'Dead of Night',
    set_name: 'The Dimension That Disappeared',
    set_number: '52',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Tommy Suhartono',
    effect:
      "You may move 1 energy from a creature or pile on the field and use it to start a new pile on the same side of the field. You may target 1 Afterthought in play and send it to the owner's graveyard.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dead-of-Night-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_210',
    s3_large_image_name: 'MjEwLS0tNTItR3VhcmRpYW4tQW5nZWwtR2FsYXhpYS00Q1AuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjEwLS0tNTItR3VhcmRpYW4tQW5nZWwtR2FsYXhpYS00Q1AuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjEwLS0tNTItR3VhcmRpYW4tQW5nZWwtR2FsYXhpYS00Q1AuanBn/t',
    name: 'Guardian Angel Galaxia',
    set_name: 'Galaxy Tides',
    set_number: '52',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Rennyl Montuya',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Guardian-Angel-Galaxia-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_329',
    s3_large_image_name: 'MzI5LS0tNTItVGltZWxlc3MtTWFjaGluYXRpb24uanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzI5LS0tNTItVGltZWxlc3MtTWFjaGluYXRpb24uanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzI5LS0tNTItVGltZWxlc3MtTWFjaGluYXRpb24uanBn/t',
    name: 'Timeless Machination',
    set_name: 'Converging Chasms',
    set_number: '52',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Timeless-Machination-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_211',
    s3_large_image_name:
      'MjExLS0tNTMtUHJpbmNlc3Mtb2YtQmxhZGVzLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjExLS0tNTMtUHJpbmNlc3Mtb2YtQmxhZGVzLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjExLS0tNTMtUHJpbmNlc3Mtb2YtQmxhZGVzLTRDUC5qcGcEXODUS/t',
    name: 'Princess of Blades',
    set_name: 'Galaxy Tides',
    set_number: '53',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Didi Esmeralda',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Princess-of-Blades-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_504',
    s3_large_image_name:
      'NTA0LS0tNTMtcHJvamVjdC1vYmxpdmlvbi03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTA0LS0tNTMtcHJvamVjdC1vYmxpdmlvbi03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTA0LS0tNTMtcHJvamVjdC1vYmxpdmlvbi03MmRwaS5wbmcEXODUS/t',
    name: 'Project Oblivion',
    set_name: 'The Dimension That Disappeared',
    set_number: '53',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Michelle Graves',
    effect: 'Each player draws 2 energy cards from their Energy Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Project-Oblivion-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_609',
    s3_large_image_name:
      'NjA5LS0tNTMtdHJhbnNtb2dyaWZpY2F0aW9uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjA5LS0tNTMtdHJhbnNtb2dyaWZpY2F0aW9uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjA5LS0tNTMtdHJhbnNtb2dyaWZpY2F0aW9uLnBuZwEXODUSEXODUS/t',
    name: 'Transmogrification',
    set_name: 'Threshold of Time',
    set_number: '53',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Tanatola',
    effect: 'Summon an Archive creature from your graveyard to your field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Transmogrification-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_330',
    s3_large_image_name: 'MzMwLS0tNTMtVHJlYWNoZXJvdXMtRm9yZXRob3VnaHQuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzMwLS0tNTMtVHJlYWNoZXJvdXMtRm9yZXRob3VnaHQuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzMwLS0tNTMtVHJlYWNoZXJvdXMtRm9yZXRob3VnaHQuanBn/t',
    name: 'Treacherous Forethought',
    set_name: 'Converging Chasms',
    set_number: '53',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Treacherous-Forethought-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_212',
    s3_large_image_name: 'MjEyLS0tNTQtRGF3bmR1c3QtUGFsYWRpbi00Q1AuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjEyLS0tNTQtRGF3bmR1c3QtUGFsYWRpbi00Q1AuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjEyLS0tNTQtRGF3bmR1c3QtUGFsYWRpbi00Q1AuanBn/t',
    name: 'Dawndust Paladin',
    set_name: 'Galaxy Tides',
    set_number: '54',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Dallin Bifano',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dawndust-Paladin-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_610',
    s3_large_image_name:
      'NjEwLS0tNTQtbGlicmFyeS1saXRpZ2F0aW9uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjEwLS0tNTQtbGlicmFyeS1saXRpZ2F0aW9uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjEwLS0tNTQtbGlicmFyeS1saXRpZ2F0aW9uLnBuZwEXODUSEXODUS/t',
    name: 'Library Litigation',
    set_name: 'Threshold of Time',
    set_number: '54',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      'When this card is played, it remains on the field until the end of your next turn. Your opponent plays with their hand and the top card of their Main Deck revealed. When this card leaves play, move 1 energy somewhere else on the same side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Library-Litigation-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_505',
    s3_large_image_name: 'NTA1LS0tNTQtcmVkLWV5ZS1mbGlnaHQtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTA1LS0tNTQtcmVkLWV5ZS1mbGlnaHQtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTA1LS0tNTQtcmVkLWV5ZS1mbGlnaHQtNzJkcGkucG5n/t',
    name: 'Red Eye Flight',
    set_name: 'The Dimension That Disappeared',
    set_number: '54',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      "You may move 1 energy from a creature or pile on the field to another creature or pile on the same side of the field. You may target 1 Afterthought in play and shuffle it into the owner's Main Deck. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Red-Eye-Flight-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_331',
    s3_large_image_name:
      'MzMxLS0tNTQtVHJhdmVyc2UtdGhlLVRyZWV0b3BzLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzMxLS0tNTQtVHJhdmVyc2UtdGhlLVRyZWV0b3BzLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzMxLS0tNTQtVHJhdmVyc2UtdGhlLVRyZWV0b3BzLmpwZwEXODUSEXODUS/t',
    name: 'Traverse the Treetops',
    set_name: 'Converging Chasms',
    set_number: '54',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Jackie Felix',
    effect:
      'Each player may select one of their creatures in play that is multiple types and have it gain 1 energy. If a player has no creatures, they may draw 1 card instead.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Traverse-the-Treetops-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_506',
    s3_large_image_name:
      'NTA2LS0tNTUtZnJvemVuLWZvcnRpdHVkZS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTA2LS0tNTUtZnJvemVuLWZvcnRpdHVkZS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTA2LS0tNTUtZnJvemVuLWZvcnRpdHVkZS03MmRwaS5wbmcEXODUS/t',
    name: 'Frozen Fortitude',
    set_name: 'The Dimension That Disappeared',
    set_number: '55',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Thai Vo',
    effect:
      "Each player on your team may target 1 energy in play and freeze it. (It flips face-down and doesn't count as damage dealt while frozen. It is destroyed last during battle damage. It flips face-up and unfreezes at the end of the owner's next turn.)",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Frozen-Fortitude-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_332',
    s3_large_image_name:
      'MzMyLS0tNTUtR3VpbGRzLUFkdmFuY2VtZW50LmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzMyLS0tNTUtR3VpbGRzLUFkdmFuY2VtZW50LmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzMyLS0tNTUtR3VpbGRzLUFkdmFuY2VtZW50LmpwZwEXODUSEXODUS/t',
    name: "Guild's Advancement",
    set_name: 'Converging Chasms',
    set_number: '55',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Kenny Estrella',
    effect:
      'Move 1 energy from a creature or pile on the field and use it to start a new pile on the same side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Guild-s-Advancement-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_611',
    s3_large_image_name: 'NjExLS0tNTUtbGlicmFyaWFuLWxpY2Vuc2UucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjExLS0tNTUtbGlicmFyaWFuLWxpY2Vuc2UucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjExLS0tNTUtbGlicmFyaWFuLWxpY2Vuc2UucG5n/t',
    name: 'Librarian License',
    set_name: 'Threshold of Time',
    set_number: '55',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Ruk Trumata',
    effect:
      'Pay 1 energy. Target an Ability that is active or activating and waiting to resolve; negate it for the rest of the turn.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Librarian-License-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_213',
    s3_large_image_name:
      'MjEzLS0tNTUtVmluZWJyYW5jaC1TZXJhcGgtNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjEzLS0tNTUtVmluZWJyYW5jaC1TZXJhcGgtNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjEzLS0tNTUtVmluZWJyYW5jaC1TZXJhcGgtNENQLmpwZwEXODUSEXODUS/t',
    name: 'Vinebranch Seraph',
    set_name: 'Galaxy Tides',
    set_number: '55',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Didi Esmeralda',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Vinebranch-Seraph-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_333',
    s3_large_image_name: 'MzMzLS0tNTYtRHVzZ3JvdmUtU3RhaXJ3YXkuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzMzLS0tNTYtRHVzZ3JvdmUtU3RhaXJ3YXkuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzMzLS0tNTYtRHVzZ3JvdmUtU3RhaXJ3YXkuanBn/t',
    name: 'Dusgrove Stairway',
    set_name: 'Converging Chasms',
    set_number: '56',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Jackie Felix',
    effect: 'Send the top card of your Main Deck to the graveyard.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dusgrove-Stairway-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_507',
    s3_large_image_name:
      'NTA3LS0tNTYtZ3VpbGQtbGVhZGVyLXN5bXBvc2l1bS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTA3LS0tNTYtZ3VpbGQtbGVhZGVyLXN5bXBvc2l1bS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTA3LS0tNTYtZ3VpbGQtbGVhZGVyLXN5bXBvc2l1bS03MmRwaS5wbmcEXODUS/t',
    name: 'Guild Leader Symposium',
    set_name: 'The Dimension That Disappeared',
    set_number: '56',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Yosi Saputra',
    effect:
      'Each player may add 1 energy beneath the Main Deck or to a creature in play. If a player added it to a creature that was multiple types, that player may draw 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Guild-Leader-Symposium-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_214',
    s3_large_image_name:
      'MjE0LS0tNTYtQ29uc3RlbGxhdGlvbi1DaGFzZXItNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjE0LS0tNTYtQ29uc3RlbGxhdGlvbi1DaGFzZXItNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjE0LS0tNTYtQ29uc3RlbGxhdGlvbi1DaGFzZXItNENQLmpwZwEXODUSEXODUS/t',
    name: 'Lystari, Constellation Chaser',
    set_name: 'Galaxy Tides',
    set_number: '56',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Gary McCluskey',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lystari--Constellation-Chaser-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_612',
    s3_large_image_name: 'NjEyLS0tNTYtbmV3LXJhZ2UtY3ljbGVzLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjEyLS0tNTYtbmV3LXJhZ2UtY3ljbGVzLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjEyLS0tNTYtbmV3LXJhZ2UtY3ljbGVzLnBuZwEXODUSEXODUS/t',
    name: 'New Rage Cycles',
    set_name: 'Threshold of Time',
    set_number: '56',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Mat Gimeno',
    effect:
      'Draw 1 energy. If you rebuilt a Machine this turn, you may also draw 1 card.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/New-Rage-Cycles-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_613',
    s3_large_image_name: 'NjEzLS0tNTctY29tcGxleGl0eS1nZWFyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjEzLS0tNTctY29tcGxleGl0eS1nZWFyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjEzLS0tNTctY29tcGxleGl0eS1nZWFyLnBuZwEXODUSEXODUS/t',
    name: 'Complexity Gear',
    set_name: 'Threshold of Time',
    set_number: '57',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Ben Cgant',
    effect:
      'If you have at least 3 different rarities among your creatures in play, target 2 opposing creatures in play and switch their energy levels.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Complexity-Gear-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_508',
    s3_large_image_name: 'NTA4LS0tNTctbWFsZXZvbGVudC1taXJhZ2UtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTA4LS0tNTctbWFsZXZvbGVudC1taXJhZ2UtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTA4LS0tNTctbWFsZXZvbGVudC1taXJhZ2UtNzJkcGkucG5n/t',
    name: 'Malevolent Mirage',
    set_name: 'The Dimension That Disappeared',
    set_number: '57',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Yosi Saputra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Malevolent-Mirage-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_334',
    s3_large_image_name: 'MzM0LS0tNTctU2VjbHVkZWQtU2hvcnRjdXQuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzM0LS0tNTctU2VjbHVkZWQtU2hvcnRjdXQuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzM0LS0tNTctU2VjbHVkZWQtU2hvcnRjdXQuanBn/t',
    name: 'Secluded Shortcut',
    set_name: 'Converging Chasms',
    set_number: '57',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect: 'Draw 1 card from your Energy Deck. You lose 1 Life Point.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Secluded-Shortcut-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_215',
    s3_large_image_name: 'MjE1LS0tNTctU3RhcnNwZWFyLU9hay00Q1AuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjE1LS0tNTctU3RhcnNwZWFyLU9hay00Q1AuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjE1LS0tNTctU3RhcnNwZWFyLU9hay00Q1AuanBn/t',
    name: 'Starspear Oak',
    set_name: 'Galaxy Tides',
    set_number: '57',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Cristian Giraldes',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Starspear-Oak-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_614',
    s3_large_image_name:
      'NjE0LS0tNTgtY29tYnVzdGlvbi1jaGFtYmVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjE0LS0tNTgtY29tYnVzdGlvbi1jaGFtYmVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjE0LS0tNTgtY29tYnVzdGlvbi1jaGFtYmVyLnBuZwEXODUSEXODUS/t',
    name: 'Combustion Chamber',
    set_name: 'Threshold of Time',
    set_number: '58',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Ben Cgant',
    effect:
      'Each player discards 1 card from their hand. Then, they may draw 1 card. If a player discarded a Hailfire, they may destroy 1 energy in play. If a player rebuilt a Machine this turn, they may draw another card.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Combustion-Chamber-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_335',
    s3_large_image_name:
      'MzM1LS0tNTgtRHJhZ29uaXMtR3VpbGQtQ2l0YWRlbC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzM1LS0tNTgtRHJhZ29uaXMtR3VpbGQtQ2l0YWRlbC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzM1LS0tNTgtRHJhZ29uaXMtR3VpbGQtQ2l0YWRlbC5qcGcEXODUS/t',
    name: 'Dragonis Guild Citadel',
    set_name: 'Converging Chasms',
    set_number: '58',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      "Send one of your Common Dragons on the field to the graveyard. If you do, destroy 1 energy on your opponent's side of the field. If that Dragon was multiple types, destroy another energy on their field.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dragonis-Guild-Citadel-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_216',
    s3_large_image_name: 'MjE2LS0tNTgtZXVwaG9yaWFzcmVhY2guanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjE2LS0tNTgtZXVwaG9yaWFzcmVhY2guanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjE2LS0tNTgtZXVwaG9yaWFzcmVhY2guanBn/t',
    name: "Euphoria's Reach",
    set_name: 'Galaxy Tides',
    set_number: '58',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Mountain'],
    creature_type_count: 2,
    artist: 'Kenny Estrella',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Euphoria-s-Reach-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_509',
    s3_large_image_name: 'NTA5LS0tNTgtdmFsY3Jvdy1hbGxlZ2lhbnQtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTA5LS0tNTgtdmFsY3Jvdy1hbGxlZ2lhbnQtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTA5LS0tNTgtdmFsY3Jvdy1hbGxlZ2lhbnQtNzJkcGkucG5n/t',
    name: 'Valcrow Allegiant',
    set_name: 'The Dimension That Disappeared',
    set_number: '58',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono', 'Crow'],
    creature_type_count: 2,
    artist: 'Alejandro Arévalo',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Valcrow-Allegiant-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_217',
    s3_large_image_name: 'MjE3LS0tNTktQ3J5c3RhbGRyaWZ0LVNsaXRoZS00Q1AuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjE3LS0tNTktQ3J5c3RhbGRyaWZ0LVNsaXRoZS00Q1AuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjE3LS0tNTktQ3J5c3RhbGRyaWZ0LVNsaXRoZS00Q1AuanBn/t',
    name: 'Crystaldrift Slithe',
    set_name: 'Galaxy Tides',
    set_number: '59',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Slithe'],
    creature_type_count: 2,
    artist: 'Wes',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystaldrift-Slithe-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_510',
    s3_large_image_name: 'NTEwLS0tNTktZGVjYXlpbmctZGVzZXJ0LXJvc2UtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTEwLS0tNTktZGVjYXlpbmctZGVzZXJ0LXJvc2UtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTEwLS0tNTktZGVjYXlpbmctZGVzZXJ0LXJvc2UtNzJkcGkucG5n/t',
    name: 'Decaying Desert Rose',
    set_name: 'The Dimension That Disappeared',
    set_number: '59',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Nivea Toliver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Decaying-Desert-Rose-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_336',
    s3_large_image_name: 'MzM2LS0tNTktSGFybW9uaXplZC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzM2LS0tNTktSGFybW9uaXplZC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzM2LS0tNTktSGFybW9uaXplZC5qcGcEXODUS/t',
    name: 'Harmonized',
    set_name: 'Converging Chasms',
    set_number: '59',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Hafid Moenir',
    effect:
      'If you control two or more creatures on your field and all of those creatures share the same type, you may draw 1 card from either deck or have your opponent discard 1 card from their hand.',
    ruling:
      '<p>■&nbsp;<strong>ALL of your creatures in play&nbsp;</strong><strong><u>must</u></strong><strong>&nbsp;share a type</strong>&nbsp;(even if they are multiple types) to use its effect;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: If you have a&nbsp;<em>Drangel</em>&nbsp;(Dragon/Angel) and a&nbsp;<em>Portalback Dragon</em>&nbsp;(Dragon) in play, you MAY use&nbsp;<em>Guild Warfare</em>. However, if you have a&nbsp;<em>Drangel</em>&nbsp;(Dragon/Angel), a&nbsp;<em>Portalback Dragon</em>&nbsp;(Dragon) and a&nbsp;<em>Concerto Virtuoso</em>&nbsp;(Order) in play, you CANNOT use&nbsp;<em>Guild Warfare</em>;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Harmonized-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_615',
    s3_large_image_name: 'NjE1LS0tNTktc2NhcmxldGRyaWZ0LWhlaWdodHMucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjE1LS0tNTktc2NhcmxldGRyaWZ0LWhlaWdodHMucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjE1LS0tNTktc2NhcmxldGRyaWZ0LWhlaWdodHMucG5n/t',
    name: 'Scarletdrift Heights',
    set_name: 'Threshold of Time',
    set_number: '59',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Tanatola',
    effect:
      'When this card is played, ignite it; it stays in play until the end of the turn. Draw 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Scarletdrift-Heights-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_616',
    s3_large_image_name: 'NjE2LS0tNjAtYnJlYWtpbmctaGVsdmVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjE2LS0tNjAtYnJlYWtpbmctaGVsdmVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjE2LS0tNjAtYnJlYWtpbmctaGVsdmVyLnBuZwEXODUSEXODUS/t',
    name: 'Breaking Helver',
    set_name: 'Threshold of Time',
    set_number: '60',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Ruk Trumata',
    effect:
      'You may target a Drifter and negate its Ability for the rest of the turn. Draw 1 card (or 2 if you burst any cards this turn).',
    ruling:
      '<p>■ This card can target only one singular Ability regarding Drifter/Archive(s) where multiple Abilities are active within the Archive stack;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Breaking-Helver-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_218',
    s3_large_image_name:
      'MjE4LS0tNjAtTmlkYWxhcC1Gcm96ZW4tU3BlYXItNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjE4LS0tNjAtTmlkYWxhcC1Gcm96ZW4tU3BlYXItNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjE4LS0tNjAtTmlkYWxhcC1Gcm96ZW4tU3BlYXItNENQLmpwZwEXODUSEXODUS/t',
    name: 'Nidalap, Frozen Spear',
    set_name: 'Galaxy Tides',
    set_number: '60',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Charlo Nocete',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Nidalap--Frozen-Spear-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_511',
    s3_large_image_name:
      'NTExLS0tNjAtc2xpdGhlcmluZy1hbHRlcnNoYWRlLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTExLS0tNjAtc2xpdGhlcmluZy1hbHRlcnNoYWRlLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTExLS0tNjAtc2xpdGhlcmluZy1hbHRlcnNoYWRlLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Slithering Altershade',
    set_name: 'The Dimension That Disappeared',
    set_number: '60',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono', 'Slithe'],
    creature_type_count: 2,
    artist: 'Yosi Saputra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Slithering-Altershade-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_337',
    s3_large_image_name:
      'MzM3LS0tNjAtVm9sY2FuaWMtVmVoZW1lbmNlLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzM3LS0tNjAtVm9sY2FuaWMtVmVoZW1lbmNlLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzM3LS0tNjAtVm9sY2FuaWMtVmVoZW1lbmNlLmpwZwEXODUSEXODUS/t',
    name: 'Volcanic Vehemence',
    set_name: 'Converging Chasms',
    set_number: '60',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      "This card remains on the field during the turn on which it was played and is discarded at the end of the turn. When a Dragon is sent from the top of your Main Deck to the graveyard, destroy 1 energy on your opponent's side of the field.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Volcanic-Vehemence-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_219',
    s3_large_image_name:
      'MjE5LS0tNjEtRWZpbC10aGUtRXZlcmxhc3RpbmctRW1wcmVzcy1GaXhlZC1Cb3gtVG9wcGVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjE5LS0tNjEtRWZpbC10aGUtRXZlcmxhc3RpbmctRW1wcmVzcy1GaXhlZC1Cb3gtVG9wcGVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjE5LS0tNjEtRWZpbC10aGUtRXZlcmxhc3RpbmctRW1wcmVzcy1GaXhlZC1Cb3gtVG9wcGVyLnBuZwEXODUSEXODUS/t',
    name: 'Efil the Everlasting Empress',
    set_name: 'Galaxy Tides',
    set_number: '61',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Yujin Jung',
    effect:
      "When this creature is summoned, your Life Points become the same as your opponent's Life Points.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Efil-the-Everlasting-Empress-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_512',
    s3_large_image_name:
      'NTEyLS0tNjEtaW5mZWN0ZWQtdmFuYWRpbml0ZS1sYW5jZXItNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTEyLS0tNjEtaW5mZWN0ZWQtdmFuYWRpbml0ZS1sYW5jZXItNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTEyLS0tNjEtaW5mZWN0ZWQtdmFuYWRpbml0ZS1sYW5jZXItNzJkcGkucG5n/t',
    name: 'Infected Vanadinite Lancer',
    set_name: 'The Dimension That Disappeared',
    set_number: '61',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Chrono'],
    creature_type_count: 2,
    artist: 'Yosi Saputra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Infected-Vanadinite-Lancer-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_617',
    s3_large_image_name: 'NjE3LS0tNjEtbG9zdC1hdC1zZWEucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjE3LS0tNjEtbG9zdC1hdC1zZWEucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjE3LS0tNjEtbG9zdC1hdC1zZWEucG5n/t',
    name: 'Lost at Sea',
    set_name: 'Threshold of Time',
    set_number: '61',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Odysseas Stamoglou',
    effect:
      "Target 1 energy in play and send it to the owner's hand. You may draw 1 energy.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lost-at-Sea-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_338',
    s3_large_image_name: 'MzM4LS0tNjEtUGxhdGVhdXMtRWRnZS5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzM4LS0tNjEtUGxhdGVhdXMtRWRnZS5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzM4LS0tNjEtUGxhdGVhdXMtRWRnZS5qcGcEXODUS/t',
    name: "Plateau's Edge",
    set_name: 'Converging Chasms',
    set_number: '61',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'COCOs',
    effect:
      'When this card is played, it remains on the field until the end of the turn. When one of your Common creatures attacks and successfully hits an opposing Rare creature, draw 1 energy card.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Plateau-s-Edge-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_220',
    s3_large_image_name:
      'MjIwLS0tNjItU0VDUkVULVJBUkUtQWxhbmEtdGhlLVN0YXItRm9ybWF0aW9uLTYyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjIwLS0tNjItU0VDUkVULVJBUkUtQWxhbmEtdGhlLVN0YXItRm9ybWF0aW9uLTYyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjIwLS0tNjItU0VDUkVULVJBUkUtQWxhbmEtdGhlLVN0YXItRm9ybWF0aW9uLTYyLnBuZwEXODUSEXODUS/t',
    name: 'Alana the Star Formation',
    set_name: 'Galaxy Tides',
    set_number: '62',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'COCOs',
    effect:
      "When this creature is summoned, it gains 1 energy and you may look at your opponent's hand.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Alana-the-Star-Formation-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_339',
    s3_large_image_name: 'MzM5LS0tNjItQ29sbGF0ZXJhbC1EYW1hZ2UuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzM5LS0tNjItQ29sbGF0ZXJhbC1EYW1hZ2UuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzM5LS0tNjItQ29sbGF0ZXJhbC1EYW1hZ2UuanBn/t',
    name: 'Collateral Damage',
    set_name: 'Converging Chasms',
    set_number: '62',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Hoang Tran',
    effect:
      "This card can only be played on your turn before your Attack Phase. For each Dragon on your field that is multiple types, destroy 1 energy on your opponent's side of the field. You must skip your Attack Phase this turn.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Collateral-Damage-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_618',
    s3_large_image_name:
      'NjE4LS0tNjItc2Vhc29uLW9mLXRvcnJlbnRzLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjE4LS0tNjItc2Vhc29uLW9mLXRvcnJlbnRzLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjE4LS0tNjItc2Vhc29uLW9mLXRvcnJlbnRzLnBuZwEXODUSEXODUS/t',
    name: 'Season of Torrents',
    set_name: 'Threshold of Time',
    set_number: '62',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Thai Vo',
    effect:
      "Send 1 energy in play to the owner's hand. If you have 2 or more Leviathans in play, send 1 energy from each opposing creature and pile in play to the owner's hand instead.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Season-of-Torrents-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_513',
    s3_large_image_name:
      'NTEzLS0tNjItc3RhbGFjdGl0ZS1oYXNwLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTEzLS0tNjItc3RhbGFjdGl0ZS1oYXNwLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTEzLS0tNjItc3RhbGFjdGl0ZS1oYXNwLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Stalactite Hasp',
    set_name: 'The Dimension That Disappeared',
    set_number: '62',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Stalactite-Hasp-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_340',
    s3_large_image_name: 'MzQwLS0tNjMtQnVyaWVkLVBsYWlucy5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQwLS0tNjMtQnVyaWVkLVBsYWlucy5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQwLS0tNjMtQnVyaWVkLVBsYWlucy5qcGcEXODUS/t',
    name: 'Buried Plains',
    set_name: 'Converging Chasms',
    set_number: '63',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect: 'Pay 5 energy. Gain 1 Life Point.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Buried-Plains-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_619',
    s3_large_image_name: 'NjE5LS0tNjMtZGltZW5zaW9uYWwtY2hhc20ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjE5LS0tNjMtZGltZW5zaW9uYWwtY2hhc20ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjE5LS0tNjMtZGltZW5zaW9uYWwtY2hhc20ucG5n/t',
    name: 'Dimensional Chasm',
    set_name: 'Threshold of Time',
    set_number: '63',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Wes',
    effect:
      "Target 1 creature on your side of the field; for each rarity star it has below 3, target 1 card from a graveyard and shuffle it into the owner's Main Deck.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Chasm-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_514',
    s3_large_image_name: 'NTE0LS0tNjMtd2F0ZXJ2YWwtaHlkcmEtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTE0LS0tNjMtd2F0ZXJ2YWwtaHlkcmEtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTE0LS0tNjMtd2F0ZXJ2YWwtaHlkcmEtNzJkcGkucG5n/t',
    name: 'Waterval Hydra',
    set_name: 'The Dimension That Disappeared',
    set_number: '63',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Waterval-Hydra-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_341',
    s3_large_image_name:
      'MzQxLS0tNjQtU3RlbGxhcmZhbGxzLXRoZS1DYXJkc21pdGhzLUhhdmVuLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQxLS0tNjQtU3RlbGxhcmZhbGxzLXRoZS1DYXJkc21pdGhzLUhhdmVuLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQxLS0tNjQtU3RlbGxhcmZhbGxzLXRoZS1DYXJkc21pdGhzLUhhdmVuLmpwZwEXODUSEXODUS/t',
    name: "Stellarfalls, the Cardsmiths' Haven",
    set_name: 'Converging Chasms',
    set_number: '64',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Esther Yong',
    effect:
      "When this card is played, it remains on the field until its effect has occurred. When one of your Uncommon creatures is destroyed by battle, you may destroy 1 energy on your opponent's side of the field.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Stellarfalls--the-Cardsmiths--Haven-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_515',
    s3_large_image_name:
      'NTE1LS0tNjQtdGFybmlzaHdvb2QtY3lwcmVzcy03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTE1LS0tNjQtdGFybmlzaHdvb2QtY3lwcmVzcy03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTE1LS0tNjQtdGFybmlzaHdvb2QtY3lwcmVzcy03MmRwaS5wbmcEXODUS/t',
    name: 'Tarnishwood Cypress',
    set_name: 'The Dimension That Disappeared',
    set_number: '64',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Chrono'],
    creature_type_count: 2,
    artist: 'Thai Vo',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Tarnishwood-Cypress-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_620',
    s3_large_image_name: 'NjIwLS0tNjQtdG9tb3Jyb3cncy10b2RheS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjIwLS0tNjQtdG9tb3Jyb3cncy10b2RheS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjIwLS0tNjQtdG9tb3Jyb3cncy10b2RheS5wbmcEXODUS/t',
    name: "Tomorrow's Today",
    set_name: 'Threshold of Time',
    set_number: '64',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Yosi Saputra',
    effect:
      'If you froze 2 or more cards this turn, your Common creatures receive 1 less damage and your Uncommon creatures deal 1 more damage during battle this turn.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Tomorrow-s-Today-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_342',
    s3_large_image_name: 'MzQyLS0tNjUtRGVwYXJ0dXJlLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQyLS0tNjUtRGVwYXJ0dXJlLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQyLS0tNjUtRGVwYXJ0dXJlLmpwZwEXODUSEXODUS/t',
    name: 'Departure',
    set_name: 'Converging Chasms',
    set_number: '65',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Hoang Tran',
    effect:
      'Move 1 energy from a creature or pile on the field to another creature or pile on the same side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Departure-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_621',
    s3_large_image_name: 'NjIxLS0tNjUtd2FydGltZS1kZXZlbG9wbWVudHMucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjIxLS0tNjUtd2FydGltZS1kZXZlbG9wbWVudHMucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjIxLS0tNjUtd2FydGltZS1kZXZlbG9wbWVudHMucG5n/t',
    name: 'Wartime Developments',
    set_name: 'Threshold of Time',
    set_number: '65',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Tanatola',
    effect: 'If your opponent has more cards in play than you, draw 1 card.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Wartime-Developments-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_516',
    s3_large_image_name:
      'NTE2LS0tNjUtd2F0ZXJmYWxsLWV2b3JnbmFtLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTE2LS0tNjUtd2F0ZXJmYWxsLWV2b3JnbmFtLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTE2LS0tNjUtd2F0ZXJmYWxsLWV2b3JnbmFtLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Waterfall Evorgnam',
    set_name: 'The Dimension That Disappeared',
    set_number: '65',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Yosi Saputra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Waterfall-Evorgnam-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_517',
    s3_large_image_name:
      'NTE3LS0tNjYtZGFuZ2Vyb3VzLWNhbm5vbmVlci1wYWxpc2hyb29taXMtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTE3LS0tNjYtZGFuZ2Vyb3VzLWNhbm5vbmVlci1wYWxpc2hyb29taXMtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTE3LS0tNjYtZGFuZ2Vyb3VzLWNhbm5vbmVlci1wYWxpc2hyb29taXMtNzJkcGkucG5n/t',
    name: 'Dangerous Cannoneer Palishroomis',
    set_name: 'The Dimension That Disappeared',
    set_number: '66',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk'],
    creature_type_count: 1,
    artist: 'Nivea Toliver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dangerous-Cannoneer-Palishroomis-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_343',
    s3_large_image_name: 'MzQzLS0tNjYtRGltZW5zaW9uYWwtRGVzdHJ1Y3Rpb24uanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQzLS0tNjYtRGltZW5zaW9uYWwtRGVzdHJ1Y3Rpb24uanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQzLS0tNjYtRGltZW5zaW9uYWwtRGVzdHJ1Y3Rpb24uanBn/t',
    name: 'Dimensional Destruction',
    set_name: 'Converging Chasms',
    set_number: '66',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      'Discard 2 cards from your hand. Then, draw 1 card from your Main Deck and 1 card from your Energy Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Destruction-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_622',
    s3_large_image_name: 'NjIyLS0tNjYtdmlzY2VyYWwtdmFsdmVuZ2luZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjIyLS0tNjYtdmlzY2VyYWwtdmFsdmVuZ2luZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjIyLS0tNjYtdmlzY2VyYWwtdmFsdmVuZ2luZS5wbmcEXODUS/t',
    name: 'Visceral Valvengine',
    set_name: 'Threshold of Time',
    set_number: '66',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'Tanatola',
    effect:
      'When this creature enters play, you may rebuild it. If you do, draw 1 card.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Visceral-Valvengine-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_344',
    s3_large_image_name: 'MzQ0LS0tNjctRW1lcmFsZC1TbGl0aGVyY3Jlc3QuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ0LS0tNjctRW1lcmFsZC1TbGl0aGVyY3Jlc3QuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ0LS0tNjctRW1lcmFsZC1TbGl0aGVyY3Jlc3QuanBn/t',
    name: 'Emerald Slithercrest',
    set_name: 'Converging Chasms',
    set_number: '67',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Slithe'],
    creature_type_count: 2,
    artist: 'Jackie Felix',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Emerald-Slithercrest-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_623',
    s3_large_image_name:
      'NjIzLS0tNjctaGVkZ2UtZnVuZGVyLW9mLWRyZWFtcy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjIzLS0tNjctaGVkZ2UtZnVuZGVyLW9mLWRyZWFtcy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjIzLS0tNjctaGVkZ2UtZnVuZGVyLW9mLWRyZWFtcy5wbmcEXODUS/t',
    name: 'Hedge, Funder of Dreams',
    set_name: 'Threshold of Time',
    set_number: '67',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    effect:
      'When this creature enters play, you may rebuild it. If you do, it gains 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hedge--Funder-of-Dreams-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_518',
    s3_large_image_name:
      'NTE4LS0tNjctc3RlYW1zaGFmdC1laWRvbG9uLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTE4LS0tNjctc3RlYW1zaGFmdC1laWRvbG9uLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTE4LS0tNjctc3RlYW1zaGFmdC1laWRvbG9uLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Steamshaft Eidolon',
    set_name: 'The Dimension That Disappeared',
    set_number: '67',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine', 'Chrono'],
    creature_type_count: 2,
    artist: 'Tanatola',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Steamshaft-Eidolon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_345',
    s3_large_image_name:
      'MzQ1LS0tNjgtRnJvc3RnZWFyLUJlaGVtb3RoLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ1LS0tNjgtRnJvc3RnZWFyLUJlaGVtb3RoLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ1LS0tNjgtRnJvc3RnZWFyLUJlaGVtb3RoLmpwZwEXODUSEXODUS/t',
    name: 'Frostgear Behemoth',
    set_name: 'Converging Chasms',
    set_number: '68',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Machine'],
    creature_type_count: 2,
    artist: 'Mat Gimeno',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Frostgear-Behemoth-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_624',
    s3_large_image_name:
      'NjI0LS0tNjgtdW5zdGFibGUtY2hyb25pa2VyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjI0LS0tNjgtdW5zdGFibGUtY2hyb25pa2VyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjI0LS0tNjgtdW5zdGFibGUtY2hyb25pa2VyLnBuZwEXODUSEXODUS/t',
    name: 'Unstable Chroniker',
    set_name: 'Threshold of Time',
    set_number: '68',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    effect:
      'When this creature enters play, you may rebuild it. If you do, move 1 energy in play to another creature or pile on the same side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Unstable-Chroniker-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_519',
    s3_large_image_name: 'NTE5LS0tNjgtdmFsY2hyb24tNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTE5LS0tNjgtdmFsY2hyb24tNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTE5LS0tNjgtdmFsY2hyb24tNzJkcGkucG5n/t',
    name: 'Valchron',
    set_name: 'The Dimension That Disappeared',
    set_number: '68',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Leviathan', 'Chrono'],
    creature_type_count: 2,
    artist: 'Alejandro Arévalo',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Valchron-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_625',
    s3_large_image_name: 'NjI1LS0tNjktY3Jhbmt3b3JrLWNvbmZsYWdyYXRpb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjI1LS0tNjktY3Jhbmt3b3JrLWNvbmZsYWdyYXRpb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjI1LS0tNjktY3Jhbmt3b3JrLWNvbmZsYWdyYXRpb24ucG5n/t',
    name: 'Crankwork Conflagration',
    set_name: 'Threshold of Time',
    set_number: '69',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine', 'Hailfire'],
    creature_type_count: 2,
    artist: 'Thai Vo',
    effect:
      'When this creature enters play, you may rebuild it. If you do, destroy 1 energy in play. *Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crankwork-Conflagration-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_520',
    s3_large_image_name:
      'NTIwLS0tNjktaGFycm93aW5nLWhhdW50LTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTIwLS0tNjktaGFycm93aW5nLWhhdW50LTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTIwLS0tNjktaGFycm93aW5nLWhhdW50LTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Harrowing Haunt',
    set_name: 'The Dimension That Disappeared',
    set_number: '69',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Amelia Połtoracka',
    effect:
      'Discard 1 card from your hand. Then, each of your blank piles on the field gain 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Harrowing-Haunt-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_346',
    s3_large_image_name: 'MzQ2LS0tNjktVmFsY3JhdGVyLUJhbmRpdHMuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ2LS0tNjktVmFsY3JhdGVyLUJhbmRpdHMuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ2LS0tNjktVmFsY3JhdGVyLUJhbmRpdHMuanBn/t',
    name: 'Valcrater Bandits',
    set_name: 'Converging Chasms',
    set_number: '69',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Valcrater-Bandits-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_626',
    s3_large_image_name: 'NjI2LS0tNzAtY29tYXRvc2UtY29tZXQucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjI2LS0tNzAtY29tYXRvc2UtY29tZXQucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjI2LS0tNzAtY29tYXRvc2UtY29tZXQucG5n/t',
    name: 'Comatose Comet',
    set_name: 'Threshold of Time',
    set_number: '70',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    effect: '*Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Comatose-Comet-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_521',
    s3_large_image_name: 'NTIxLS0tNzAtZGVzZWNyYXRlZC1zaGlwd3JlY2stNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTIxLS0tNzAtZGVzZWNyYXRlZC1zaGlwd3JlY2stNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTIxLS0tNzAtZGVzZWNyYXRlZC1zaGlwd3JlY2stNzJkcGkucG5n/t',
    name: 'Desecrated Shipwreck',
    set_name: 'The Dimension That Disappeared',
    set_number: '70',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Amelia Połtoracka',
    effect:
      'Discard 1 card from your hand. Then, each opposing blank pile on the field loses 1 energy.',
    ruling:
      '<p>■ Despite this card not specifically stating "target", you may choose which energy is destroyed due to it being an effect;<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - The owner of the energy does not choose which of their energy is destroyed by this effect;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Desecrated-Shipwreck-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_347',
    s3_large_image_name: 'MzQ3LS0tNzAtRHVzdHdvb2QtQWxkZXIuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ3LS0tNzAtRHVzdHdvb2QtQWxkZXIuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ3LS0tNzAtRHVzdHdvb2QtQWxkZXIuanBn/t',
    name: 'Dustwood Alder',
    set_name: 'Converging Chasms',
    set_number: '70',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Hafid Moenir',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dustwood-Alder-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_522',
    s3_large_image_name: 'anathema-front',
    s3_backside_large_image_name: 'anathema-back',
    large_image_url:
      'http://cloud-3.steamusercontent.com/ugc/768365276448626344/FF634DF3949878BE68531AFC7C3A3B1D9FE5F075/',
    small_image_url:
      'http://cloud-3.steamusercontent.com/ugc/768365276448626344/FF634DF3949878BE68531AFC7C3A3B1D9FE5F075/',
    backside_large_image_url:
      'http://cloud-3.steamusercontent.com/ugc/768365276448626905/127521EFED276E7963944ECD97C4D928F99A8CAD/',
    name: 'Anathema',
    set_name: 'The Dimension That Disappeared',
    set_number: '71',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Symmetry', 'Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Thiago Almeida',
    effect:
      'Send the top card of your Main Deck to the graveyard and add 2 energy beneath the Main Deck or to a creature in play. All non-Chronos in play lose 1 energy. You may destroy 1 of your Afterthoughts in play. If you do, flip this card and summon it on an existing blank pile on your field. /  This creature can only enter play through the symmetry effect on the flip side. ABILITY: When this creature is summoned, look at all cards in your Main Deck, then put them back in any order. Life Points cannot change except by creatures attacking directly as long as this card is visible to all players. ',
    ruling:
      '<p>■&nbsp;Since this card is double-sided and both the symmetry and creature side have the same card name, having 1 of this card in your Main Deck automatically counts as 2 copies and fills the 2-card maximum;<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - The card physically counts as 1 card in the deck and on the deck list, but the name printed twice on the card fulfills the 2-count maximum copies by name in deck-building;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>The first part of the effect on the symmetry side is not a cost⁠—do as much as possible;<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;</sup></strong>&nbsp;- You don\'t have to have any cards in the Main Deck to resolve the effect;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>If this card becomes frozen while on the symmetry side, it will still be on the symmetry side when it unfreezes;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong><em>Anathema</em>&nbsp;can be targeted and frozen by&nbsp;<em>Crystal Cove</em>&nbsp;even while it is in play on the creature side, since it is treated as both a symmetry and a creature;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>If this card becomes frozen while on the creature side, it will still be on the creature side when it unfreezes;<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;</sup></strong>&nbsp;- The creature side Ability preventing Life Points from changing except by creature attacks is still active while this card is frozen, regardless of which side it is frozen on, since frozen cards are still visible to all players;<br><br>■&nbsp;<em>Anathema</em>&nbsp;flips back to the symmetry side as soon as the creature leaves play. As long as the card (regardless of which side it\'s on) is in a zone viewable by all players, the continuous Life Point effect from the creature side is active;<br>(i.e. when you look at the cards in a player\'s graveyard, you\'re free to look at the front and back of all cards; since that is considered "visible", it doesn\'t matter which side&nbsp;<em>Anathema&nbsp;</em>is currently on for the continuous effect to be active);</p>\n<p>■&nbsp;Since&nbsp;<em>Anathema\'s</em>&nbsp;creature Ability states "Life Points cannot change except by creatures attacking directly", then players simply cannot trigger cards with a Life Point cost while&nbsp;<em>Anathema</em>&nbsp;is visible to all players. (I.e. this is different from&nbsp;<em>Madness Settles</em>, which says "don\'t lose energy", rather than "cannot".);</p>\n<p>■ If&nbsp;<em>Anathema&nbsp;</em>is triggered&nbsp;<u>in response</u>&nbsp;to a Life Point cost, once&nbsp;<em>Anathema</em>&nbsp;resolves and becomes visible to all players, the original card with the Life Point cost can no longer activate and would fizzle, since&nbsp;<em>Anathema</em>&nbsp;successfully prevented Life Points from changing outside of direct creature attacks;<br><br>■&nbsp;<em>Anathema&nbsp;</em>is considered both a creature and a symmetry, so it can be searched out by cards like&nbsp;<em>Sign of the Crow&nbsp;</em><em>or targeted by&nbsp;</em><em>Chronological Relapse;<br><br>■&nbsp;</em>&nbsp;<strong><sup>[NEW]</sup></strong>&nbsp;When attacking with&nbsp;<em>Ethereal Aurorialis&nbsp;</em>and&nbsp;<em>Anathema</em>&nbsp;is revealed by its Ability,&nbsp;<em>Ethereal Aurorialis</em>&nbsp;attacks both yours and your opponent\'s Life Points at once due to&nbsp;<em>Anathema</em>&nbsp;being both a creature and a symmetry;<em><br></em></p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Anathema-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_627',
    s3_large_image_name: 'NjI3LS0tNzEtYmx1ZWJsYXplLWFuZ2VsLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjI3LS0tNzEtYmx1ZWJsYXplLWFuZ2VsLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjI3LS0tNzEtYmx1ZWJsYXplLWFuZ2VsLnBuZwEXODUSEXODUS/t',
    name: 'Blueblaze Angel',
    set_name: 'Threshold of Time',
    set_number: '71',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire', 'Angel'],
    creature_type_count: 2,
    artist: 'Ben Cgant',
    effect: '*Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Blueblaze-Angel-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_348',
    s3_large_image_name: 'MzQ4LS0tNzEtV2lsZGZpcmUtV2lsbG93LmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ4LS0tNzEtV2lsZGZpcmUtV2lsbG93LmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ4LS0tNzEtV2lsZGZpcmUtV2lsbG93LmpwZwEXODUSEXODUS/t',
    name: 'Wildfire Willow',
    set_name: 'Converging Chasms',
    set_number: '71',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Hailfire'],
    creature_type_count: 2,
    artist: 'Hafid Moenir',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Wildfire-Willow-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_523',
    s3_large_image_name:
      'NTIzLS0tNzItZGV2b3VyZXItb2YtZGltZW5zaW9ucy03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTIzLS0tNzItZGV2b3VyZXItb2YtZGltZW5zaW9ucy03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTIzLS0tNzItZGV2b3VyZXItb2YtZGltZW5zaW9ucy03MmRwaS5wbmcEXODUS/t',
    name: 'Devourer of Dimensions',
    set_name: 'The Dimension That Disappeared',
    set_number: '72',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Brandon McDonald',
    effect:
      ' Only 1 copy of this card is allowed in your Main Deck.  This creature can only enter play on top of "Eroda the Flickering Facade".  When this creature enters play, move all of your other Chronos in play underneath it. ABILITY: You may at any time send a Chrono underneath this creature to the graveyard to negate a card effect or Ability and destroy that card.',
    ruling:
      "<p>■ (As stated on the text of&nbsp;<em>Eroda's Ascendance</em>), any Afterthoughts&nbsp;that get moved underneath this creature when it's summoned turn back into Chronos and are considered creatures while they are beneath&nbsp;<em>Devourer</em>;&nbsp;</p>\n<p>■&nbsp;When&nbsp;<em>Devourer of Dimensions</em>&nbsp;leaves play:</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;If&nbsp;<em>Devourer</em>&nbsp;is bounced to hand, the Chronos beneath it (except&nbsp;<em>Eroda</em>) go to the graveyard.&nbsp;<em>Eroda</em>&nbsp;will remain on the pile of energy (unless the energy is also being destroyed, such as by&nbsp;<em>Unsummon,&nbsp;</em>in which case&nbsp;<em>Eroda</em>&nbsp;will be sent to the graveyard&nbsp;with any other Chronos beneath&nbsp;<em>Devourer</em>);</p>\n<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp; •&nbsp;<u><em>TL;DR&nbsp;</em></u>If there is still energy under&nbsp;<em>Eroda/Devourer</em>&nbsp;when&nbsp;<em>Devourer</em>&nbsp;is bounced or removed from play,&nbsp;<em>Eroda</em>&nbsp;will remain in play on the attached energy. However, if the creature and all energy attached is destroyed, then&nbsp;<em>Eroda</em>&nbsp;is destroyed, too;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp;&nbsp; - If&nbsp;<em>Devourer</em>&nbsp;gets destroyed (such as by battle or&nbsp;<em>Tethered to Eeventide</em>), then all Chronos including&nbsp;<em>Eroda</em>&nbsp;get destroyed with it;</p>\n<p>■ Chronos with an Afterthought Ability that leave play from beneath&nbsp;<em>Devourer of Dimensions</em>&nbsp;can turn into Afterthoughts, instead of being sent to the graveyard;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - When&nbsp;<em>Devourer's</em>&nbsp;Ability is used to send a Chrono beneath itself to the graveyard, and the owner chooses to turn that Chrono into an Afterthought instead of sending it to the graveyard, the condition for&nbsp;<em>Devourer's</em>&nbsp;Ability is considered fulfilled (as if the Chrono went to the graveyard). This is due to the fact that the Afterthought rule does not state \"instead\"; Chronos don't become an Afterthought instead of leaving play, they can simply become an Afterthought due to leaving play;</p>\n<p>■&nbsp;The Chronos that move beneath&nbsp;<em>Devourer of Dimensions</em>&nbsp;from the field will leave their energy piles behind (the energy does&nbsp;<strong><u>not</u></strong>&nbsp;go with them to&nbsp;<em>Devourer</em><em>—</em>they will remain where they are as blank piles);</p>\n<p>■ If a Chrono beneath&nbsp;<em>Devourer of Dimensions</em>&nbsp;becomes frozen, nothing of significance happens aside from the overall freeze-count going up;</p>\n<p>■&nbsp;<em>Devourer of Dimensions</em>&nbsp;does move all of your teammate's Chronos beneath itself in addition to your own, when it enters play, in 2v2 format;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Devourer-of-Dimensions-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_349',
    s3_large_image_name:
      'MzQ5LS0tNzItRWxpc2hyb29tLXRoZS1Qb3Rpb24tUnVubmVyLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ5LS0tNzItRWxpc2hyb29tLXRoZS1Qb3Rpb24tUnVubmVyLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQ5LS0tNzItRWxpc2hyb29tLXRoZS1Qb3Rpb24tUnVubmVyLmpwZwEXODUSEXODUS/t',
    name: 'Elishroom the Potion Runner',
    set_name: 'Converging Chasms',
    set_number: '72',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Elishroom-the-Potion-Runner-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_628',
    s3_large_image_name: 'NjI4LS0tNzItZmlyZW5haWwtaW5mZXJuaWEucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjI4LS0tNzItZmlyZW5haWwtaW5mZXJuaWEucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjI4LS0tNzItZmlyZW5haWwtaW5mZXJuaWEucG5n/t',
    name: 'Firenail Infernia',
    set_name: 'Threshold of Time',
    set_number: '72',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire', 'Dragon'],
    creature_type_count: 2,
    artist: 'Ruk Trumata',
    effect: '*Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Firenail-Infernia-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_350',
    s3_large_image_name: 'MzUwLS0tNzMtRHVuZXdlYXZlci1TbGl0aGUuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzUwLS0tNzMtRHVuZXdlYXZlci1TbGl0aGUuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzUwLS0tNzMtRHVuZXdlYXZlci1TbGl0aGUuanBn/t',
    name: 'Duneweaver Slithe',
    set_name: 'Converging Chasms',
    set_number: '73',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Duneweaver-Slithe-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_629',
    s3_large_image_name: 'NjI5LS0tNzMtc2VhYm91bmQtaW5xdWlzaXRpb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjI5LS0tNzMtc2VhYm91bmQtaW5xdWlzaXRpb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjI5LS0tNzMtc2VhYm91bmQtaW5xdWlzaXRpb24ucG5n/t',
    name: 'Seabound Inquisition',
    set_name: 'Threshold of Time',
    set_number: '73',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Leviathan'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Seabound-Inquisition-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_524',
    s3_large_image_name:
      'NTI0LS0tNzMtdmVybmVlanVzLXRoZS1tb2xlY3VsYXItbW9ja2VyeS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTI0LS0tNzMtdmVybmVlanVzLXRoZS1tb2xlY3VsYXItbW9ja2VyeS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTI0LS0tNzMtdmVybmVlanVzLXRoZS1tb2xlY3VsYXItbW9ja2VyeS03MmRwaS5wbmcEXODUS/t',
    name: 'Verneejus the Molecular Mockery',
    set_name: 'The Dimension That Disappeared',
    set_number: '73',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect:
      'This creature is every creature type. While this creature is in play, once per turn, you may discard 1 card from hand to target 1 creature on the field; that creature loses its Ability and this creature gains it for the rest of the turn. AFTERTHOUGHT ABILITY: Creatures on your side of the field are Chrono in addition to their other type(s).',
    ruling:
      '<p>■&nbsp;Verneejus cannot target Afterthoughts since Afterthoughts are not creatures;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - However, Verneejus&nbsp;<em>can&nbsp;</em>target a Chrono with an (inactive) Afterthought Ability to gain the Afterthought Ability instead of the regular Ability;<br><br>■&nbsp;If target creature has multiple Abilities, Verneejus chooses 1 Ability;</p>\n<p>■&nbsp;Verneejus&nbsp;<em>is</em>&nbsp;able to trigger its own Ability to gain a "when this creature is summoned" Ability in response to its own summon;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Due to the wording "while this creature is in play", like&nbsp;<em>Lantern Leaflore</em>, the Ability can be used the moment it hits the field, before its summon fully resolves;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Verneejus-the-Molecular-Mockery-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_630',
    s3_large_image_name: 'NjMwLS0tNzQtY29tbWFuZGVlcmVkLWNhcmF2ZWwucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjMwLS0tNzQtY29tbWFuZGVlcmVkLWNhcmF2ZWwucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjMwLS0tNzQtY29tbWFuZGVlcmVkLWNhcmF2ZWwucG5n/t',
    name: 'Commandeered Caravel',
    set_name: 'Threshold of Time',
    set_number: '74',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Leviathan'],
    creature_type_count: 1,
    artist: 'Tanatola',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Commandeered-Caravel-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_351',
    s3_large_image_name: 'MzUxLS0tNzQtT3JkYWluZWQtRHJhZ29uLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzUxLS0tNzQtT3JkYWluZWQtRHJhZ29uLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzUxLS0tNzQtT3JkYWluZWQtRHJhZ29uLmpwZwEXODUSEXODUS/t',
    name: 'Ordained Dragon',
    set_name: 'Converging Chasms',
    set_number: '74',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Order'],
    creature_type_count: 2,
    artist: 'Esther Yong',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Ordained-Dragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_525',
    s3_large_image_name:
      'NTI1LS0tNzQtdmFuY2llcmUtdGhlLWZ1dHVyZS1waGVub21lbm9uLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTI1LS0tNzQtdmFuY2llcmUtdGhlLWZ1dHVyZS1waGVub21lbm9uLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTI1LS0tNzQtdmFuY2llcmUtdGhlLWZ1dHVyZS1waGVub21lbm9uLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Vanciere the Future Phenomenon',
    set_name: 'The Dimension That Disappeared',
    set_number: '74',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Treefolk'],
    creature_type_count: 2,
    artist: 'Lexi Medina',
    effect:
      "When this creature is revealed or enters play, freeze-lock your opponent's graveyard. (Cards can't leave a freeze-locked zone until the zone unfreezes.) When this creature attacks, reveal 1 card from your hand or Main Deck.",
    ruling:
      '<p>■&nbsp;If a player needs to perform a Deck Recycle, but their graveyard is freeze-locked, they will be unable to shuffle or draw any cards until their graveyard unfreezes;<br><br>■&nbsp;If a player activates&nbsp;<em>Maelstrom&nbsp;</em>while their graveyard is freeze-locked,&nbsp;<em>Maelstrom’s</em>&nbsp;effect becomes a “do as much as possible”. So their Main Deck would enter the graveyard, but since "cards can’t&nbsp;<u><strong>leave</strong></u>&nbsp;a freeze-locked zone", nothing would shuffle back into the Main Deck;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>This creature\'s Ability states "your hand"; if triggered while on the field (a shared zone between you and your teammate in 2v2 format) by attacking, the team may choose which player\'s hand or Main Deck to reveal from;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Vanciere-the-Future-Phenomenon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_526',
    s3_large_image_name:
      'NTI2LS0tNzUtY29sZGNydXgtcm9vdC1vZi10aGUtd29ybGQtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTI2LS0tNzUtY29sZGNydXgtcm9vdC1vZi10aGUtd29ybGQtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTI2LS0tNzUtY29sZGNydXgtcm9vdC1vZi10aGUtd29ybGQtNzJkcGkucG5n/t',
    name: 'Coldcrux, Root of the World',
    set_name: 'The Dimension That Disappeared',
    set_number: '75',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Treefolk'],
    creature_type_count: 2,
    artist: 'Albert Zhou',
    effect:
      'When this creature is summoned or revealed, unfreeze or permanently freeze 1 card in play.',
    ruling:
      "<p>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>If this creature's Ability targets and freezes a card with an effect that is in the middle of resolving, the rest of that target's effect fizzles out as it disappears from the stack (i.e. the target wouldn't finish resolving due to being frozen);</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Coldcrux--Root-of-the-World-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_352',
    s3_large_image_name:
      'MzUyLS0tNzUtRHJhbmdlbGljLU91dGNyb3NzLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzUyLS0tNzUtRHJhbmdlbGljLU91dGNyb3NzLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzUyLS0tNzUtRHJhbmdlbGljLU91dGNyb3NzLmpwZwEXODUSEXODUS/t',
    name: 'Drangelic Outcross',
    set_name: 'Converging Chasms',
    set_number: '75',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Angel'],
    creature_type_count: 2,
    artist: 'Nivea Toliver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Drangelic-Outcross-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_631',
    s3_large_image_name: 'NjMxLS0tNzUtZXBpc29kaWMtZXhlY3V0aW9uZXIucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjMxLS0tNzUtZXBpc29kaWMtZXhlY3V0aW9uZXIucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjMxLS0tNzUtZXBpc29kaWMtZXhlY3V0aW9uZXIucG5n/t',
    name: 'Episodic Executioner',
    set_name: 'Threshold of Time',
    set_number: '75',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Thai Vo',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Episodic-Executioner-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_632',
    s3_large_image_name:
      'NjMyLS0tNzYtbHVjaWQtbGlxdWlkaXR5LW1vbm9saXRoLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjMyLS0tNzYtbHVjaWQtbGlxdWlkaXR5LW1vbm9saXRoLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjMyLS0tNzYtbHVjaWQtbGlxdWlkaXR5LW1vbm9saXRoLnBuZwEXODUSEXODUS/t',
    name: 'Lucid Liquidity Monolith',
    set_name: 'Threshold of Time',
    set_number: '76',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Thai Vo',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lucid-Liquidity-Monolith-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_527',
    s3_large_image_name:
      'NTI3LS0tNzYtdGltZWdseXBoYS1lZXZlbnRpZGVzLXNlY29uZC1rZXktNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTI3LS0tNzYtdGltZWdseXBoYS1lZXZlbnRpZGVzLXNlY29uZC1rZXktNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTI3LS0tNzYtdGltZWdseXBoYS1lZXZlbnRpZGVzLXNlY29uZC1rZXktNzJkcGkucG5n/t',
    name: "Timeglypha, Eeventide's Second Key",
    set_name: 'The Dimension That Disappeared',
    set_number: '76',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Brandon McDonald',
    effect:
      "This creature may be summoned from your hand during any Phase on any player's turn. While this creature is on the field, you may conduct your Phases of a Turn in any order (each Phase can still only be entered once).",
    ruling:
      "<p>■ A player's turn&nbsp;ends ONLY after&nbsp;<em>all</em>&nbsp;5 phases of a turn have been entered AND left, even if nothing happened that phase. The End Phase itself does not end the turn;</p>\n<p>■&nbsp;<em>Timeglypha</em>&nbsp;causes cards to flip and unfreeze when the End Phase is entered (so long as the freeze timer is due to unfreeze those cards during that End Phase), even when the End Phase is performed at the start of the turn;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Timeglypha--Eeventide-s-Second-Key-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_353',
    s3_large_image_name: 'MzUzLS0tNzYtV2llbGRlci1vZi10aGUtQ3Jvc3MtQmxhZGUuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzUzLS0tNzYtV2llbGRlci1vZi10aGUtQ3Jvc3MtQmxhZGUuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzUzLS0tNzYtV2llbGRlci1vZi10aGUtQ3Jvc3MtQmxhZGUuanBn/t',
    name: 'Wielder of the Cross Blade',
    set_name: 'Converging Chasms',
    set_number: '76',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Didi Esmeralda',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Wielder-of-the-Cross-Blade-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_354',
    s3_large_image_name:
      'MzU0LS0tNzctUG9ydGFsc3RlcC1QYXJhZ29uLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzU0LS0tNzctUG9ydGFsc3RlcC1QYXJhZ29uLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzU0LS0tNzctUG9ydGFsc3RlcC1QYXJhZ29uLmpwZwEXODUSEXODUS/t',
    name: 'Portalstep Paragon',
    set_name: 'Converging Chasms',
    set_number: '77',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Esther Yong',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Portalstep-Paragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_633',
    s3_large_image_name:
      'NjMzLS0tNzctcmFpbmZvcmVzdC1yaWJib25yb290LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjMzLS0tNzctcmFpbmZvcmVzdC1yaWJib25yb290LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjMzLS0tNzctcmFpbmZvcmVzdC1yaWJib25yb290LnBuZwEXODUSEXODUS/t',
    name: 'Rainforest Ribbonroot',
    set_name: 'Threshold of Time',
    set_number: '77',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Alejandro Arévalo',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rainforest-Ribbonroot-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_355',
    s3_large_image_name: 'MzU1LS0tNzgtRGltZW5zaW9uYWwtRG9lLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzU1LS0tNzgtRGltZW5zaW9uYWwtRG9lLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzU1LS0tNzgtRGltZW5zaW9uYWwtRG9lLmpwZwEXODUSEXODUS/t',
    name: 'Dimensional Doe',
    set_name: 'Converging Chasms',
    set_number: '78',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Stag'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Doe-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_634',
    s3_large_image_name: 'NjM0LS0tNzgtcmV2b2x2ZXItbXVzaHJvb20ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjM0LS0tNzgtcmV2b2x2ZXItbXVzaHJvb20ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjM0LS0tNzgtcmV2b2x2ZXItbXVzaHJvb20ucG5n/t',
    name: 'Revolver Mushroom',
    set_name: 'Threshold of Time',
    set_number: '78',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Revolver-Mushroom-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_356',
    s3_large_image_name:
      'MzU2LS0tNzktSHlwZXJleGhhdXN0LUF1dG9tYXRvbi5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzU2LS0tNzktSHlwZXJleGhhdXN0LUF1dG9tYXRvbi5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzU2LS0tNzktSHlwZXJleGhhdXN0LUF1dG9tYXRvbi5qcGcEXODUS/t',
    name: 'Hyperexhaust Automaton',
    set_name: 'Converging Chasms',
    set_number: '79',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hyperexhaust-Automaton-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_635',
    s3_large_image_name: 'NjM1LS0tNzktdmFsZHVzdC1waG9lbml4aXMucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjM1LS0tNzktdmFsZHVzdC1waG9lbml4aXMucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjM1LS0tNzktdmFsZHVzdC1waG9lbml4aXMucG5n/t',
    name: 'Valdust Phoenixis',
    set_name: 'Threshold of Time',
    set_number: '79',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Phoenix'],
    creature_type_count: 1,
    artist: 'Tanatola',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Valdust-Phoenixis-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_636',
    s3_large_image_name: 'NjM2LS0tODAtZW5lcmd5LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjM2LS0tODAtZW5lcmd5LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjM2LS0tODAtZW5lcmd5LnBuZwEXODUSEXODUS/t',
    name: 'Energy',
    set_name: 'Threshold of Time',
    set_number: '80',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Energy'],
    artist: 'Thiago Almeida',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energy-First-5',
    is_default_edition: true,
  },
  {
    card_id: 'card_357',
    s3_large_image_name: 'MzU3LS0tODAtU2VudGllbnQtQW5vbWFseS5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzU3LS0tODAtU2VudGllbnQtQW5vbWFseS5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzU3LS0tODAtU2VudGllbnQtQW5vbWFseS5qcGcEXODUS/t',
    name: 'Sentient Anomaly',
    set_name: 'Converging Chasms',
    set_number: '80',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'S. Calvin',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Sentient-Anomaly-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_637',
    s3_large_image_name:
      'NjM3LS0tODEtb2xpdmVyJ3MtcHN5bGVycmFuLXBvd2VyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjM3LS0tODEtb2xpdmVyJ3MtcHN5bGVycmFuLXBvd2VyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjM3LS0tODEtb2xpdmVyJ3MtcHN5bGVycmFuLXBvd2VyLnBuZwEXODUSEXODUS/t',
    name: "Oliver's Psylerran Power",
    set_name: 'Threshold of Time',
    set_number: '81',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Albert Zhou',
    effect:
      'If your opponent has energy in play greater than your Life Points, draw energy equal to the difference.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Oliver-s-Psylerran-Power-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_358',
    s3_large_image_name: 'MzU4LS0tODEtUGFsYWRpbnMtUGFyYWJsZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzU4LS0tODEtUGFsYWRpbnMtUGFyYWJsZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzU4LS0tODEtUGFsYWRpbnMtUGFyYWJsZS5wbmcEXODUS/t',
    name: "Paladin's Parable",
    set_name: 'Converging Chasms',
    set_number: '81',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Lexi Medina',
    effect:
      'When this creature battles another creature, switch their energy levels just before the attack hits.',
    ruling:
      "<p>■ When&nbsp;<em>Paladin's Parable</em>&nbsp;attacks another&nbsp;<em>Paladin's Parable</em>, the turn player / attacking player chooses which&nbsp;<em>Parable</em>'s Ability resolves first;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Due to the timing of both Abilities attempting to switch energy at the same time, the turn player decides the order of resolution—similar to how the turn player may choose the order of resolution of symmetry cards that unfreeze at the end of their turn.</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Paladin-s-Parable-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_638',
    s3_large_image_name:
      'NjM4LS0tODItb2ZuaS10aGUtYXJjaGl2ZS1hbGl2ZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjM4LS0tODItb2ZuaS10aGUtYXJjaGl2ZS1hbGl2ZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjM4LS0tODItb2ZuaS10aGUtYXJjaGl2ZS1hbGl2ZS5wbmcEXODUS/t',
    name: 'Ofni, the Archive Alive',
    set_name: 'Threshold of Time',
    set_number: '82',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Drifter', 'Archive'],
    creature_type_count: 2,
    artist: 'Alejandro Arévalo',
    effect:
      "This creature can only enter play on top of a stack of 7 or more Archive creatures. Other creatures cannot enter play on top of this creature. While this creature is on the field, it can't be affected by your opponent's card effects or Abilities.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Ofni--the-Archive-Alive-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_359',
    s3_large_image_name:
      'MzU5LS0tODItUm94YW5uZS10aGUtRmluYWwtUGFsYWRpbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzU5LS0tODItUm94YW5uZS10aGUtRmluYWwtUGFsYWRpbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzU5LS0tODItUm94YW5uZS10aGUtRmluYWwtUGFsYWRpbi5wbmcEXODUS/t',
    name: 'Roxanne the Final Paladin',
    set_name: 'Converging Chasms',
    set_number: '82',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Kenshjn Park',
    effect:
      "When this creature attacks, it attacks every other creature on the field at once (both yours and your opponent's). It battles them all at once and receives damage at the same time.",
    ruling:
      "<p>■ When&nbsp;<em>Roxanne</em>&nbsp;attacks, she deals damage equal to her energy to EVERY other creature on the field at once (<u>both yours and your opponent's</u>);&nbsp;<strong>her damage is NOT split up</strong>;&nbsp;</p>\n<p>■ When&nbsp;<em>Roxanne&nbsp;</em>attacks your opponent directly,&nbsp;<strong>she still deals and receives damage from your own creatures</strong>&nbsp;(if any are in play).&nbsp;<strong>The amount of energy she has when she declares the attack is the amount</strong><strong>&nbsp;she deals to your opponent's Life Points</strong>;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<strong><sup>[NEW]&nbsp;</sup></strong>&nbsp;- In Multiplayer free-for-all format, <em>Roxanne</em> can attack an opponent directly that is wide open&nbsp;as her attack target, but she will still&nbsp;battle all other creatures in play (both yours and any opponent's);</p>\n<p>■&nbsp;In a Multiplayer duel,&nbsp;<em>Roxanne</em>&nbsp;will attack and receive damage from every opponent's creature on the field, as well as your own;</p>\n<p>■ If&nbsp;<em>Roxanne the Final Paladin&nbsp;</em>attacks while the opponent has a&nbsp;<em>Mistrai Driftwood</em>&nbsp;on the field, and the player controlling&nbsp;<em>Mistrai Driftwood</em>&nbsp;activates its \"Evanescent Hollow\" Ability to let the attack pass through,&nbsp;<em>Roxanne&nbsp;</em>hits the opponent's Life Points directly and all other creatures in play, and takes damage from those other creatures (except&nbsp;<em>Mistrai Driftwood</em>, which survives);</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - If multiple opponents have&nbsp;<em>Mistrai Driftwood</em>&nbsp;in play and they are all attacked by&nbsp;<em>Roxanne</em>, she deals damage to each opponent that chooses to let the attack pass through, while also battling any other creatures in play;</p>\n<p>■ When&nbsp;<em>Roxanne&nbsp;</em>attacks while a&nbsp;<em>Victory, Keeper of the Order</em>&nbsp;is on the field,&nbsp;<em>Roxanne&nbsp;</em><strong>will hit&nbsp;<em>Victory</em>, and all non-Order type creatures, including your own creatures</strong>.&nbsp;<u>Due to&nbsp;</u><u><em>Victory's&nbsp;</em>Ability,&nbsp;<em>Roxanne&nbsp;</em></u><u>cannot hit other Order type creatures</u>;</p>\n<p>&nbsp;&nbsp;&nbsp; &nbsp;■ If the opponent has 2&nbsp;<em>Victory, Keeper of the Order&nbsp;</em>when&nbsp;<em>Roxanne&nbsp;</em>attacks,<em>&nbsp;</em><u><em>Roxanne&nbsp;</em></u><u>will only hit non-Order type creatures</u>, as well as your own creatures;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Roxanne-the-Final-Paladin-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_639',
    s3_large_image_name: 'NjM5LS0tODMtY29sb3NzYWwtY29udHJpdmFuY2UucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjM5LS0tODMtY29sb3NzYWwtY29udHJpdmFuY2UucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjM5LS0tODMtY29sb3NzYWwtY29udHJpdmFuY2UucG5n/t',
    name: 'Colossal Contrivance',
    set_name: 'Threshold of Time',
    set_number: '83',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Machine', 'Behemoth'],
    creature_type_count: 2,
    artist: 'Albert Zhou',
    effect:
      'When this creature enters play, it gains 1 energy for each rarity among Machines either on your field or in your graveyard.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Colossal-Contrivance-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_360',
    s3_large_image_name:
      'MzYwLS0tODMtSG9sbG93ZmlyZS1IYWxvLURyYWdvbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzYwLS0tODMtSG9sbG93ZmlyZS1IYWxvLURyYWdvbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzYwLS0tODMtSG9sbG93ZmlyZS1IYWxvLURyYWdvbi5wbmcEXODUS/t',
    name: 'Hollowfire Halo Dragon',
    set_name: 'Converging Chasms',
    set_number: '83',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'B.A. Miller',
    effect:
      'When this creature is summoned, you may discard 1 Dragon or Slithe-type creature from your hand. If you do, select 1 creature in play that is lower in rarity than the discarded card and send it to the graveyard (all energy attached remains in play).',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hollowfire-Halo-Dragon-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_640',
    s3_large_image_name:
      'NjQwLS0tODQtYnVybmluZy1oZWFydGJlYXQtZHJhemFoLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjQwLS0tODQtYnVybmluZy1oZWFydGJlYXQtZHJhemFoLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjQwLS0tODQtYnVybmluZy1oZWFydGJlYXQtZHJhemFoLnBuZwEXODUSEXODUS/t',
    name: 'Burning Heartbeat Drazah',
    set_name: 'Threshold of Time',
    set_number: '84',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Hailfire'],
    creature_type_count: 1,
    artist: 'Albert Zhou',
    effect:
      'This creature enters play ignited. While this creature is in play, ignore rarity requirements for igniting. *Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Burning-Heartbeat-Drazah-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_361',
    s3_large_image_name:
      'MzYxLS0tODQtUnVuZWdseXBoaXMtRWV2ZW50aWRlcy1GaXJzdC1LZXkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzYxLS0tODQtUnVuZWdseXBoaXMtRWV2ZW50aWRlcy1GaXJzdC1LZXkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzYxLS0tODQtUnVuZWdseXBoaXMtRWV2ZW50aWRlcy1GaXJzdC1LZXkucG5n/t',
    name: "Runeglyphis, Eeventide's First Key",
    set_name: 'Converging Chasms',
    set_number: '84',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    effect:
      'When this creature is summoned, discard your hand. Then, destroy 1 energy on the field for each Common or Uncommon Dragon or Slithe-type creature in your graveyard.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Runeglyphis--Eeventide-s-First-Key-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_641',
    s3_large_image_name:
      'NjQxLS0tODUtYWxjYXphci1tYW5vci1haWN1bG9mdC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjQxLS0tODUtYWxjYXphci1tYW5vci1haWN1bG9mdC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjQxLS0tODUtYWxjYXphci1tYW5vci1haWN1bG9mdC5wbmcEXODUS/t',
    name: 'Alcázar Manor, Aiculoft',
    set_name: 'Threshold of Time',
    set_number: '85',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    effect:
      'While this creature is in play, once per turn, you may pay 1 frozen energy. If you do, creatures on your field become Shardfolk in addition to their other type(s) for the rest of the turn.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Alc--zar-Manor--Aiculoft-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_362',
    s3_large_image_name:
      'MzYyLS0tODUtR3JhbmRhcmlhLUZvcmdlci1vZi1Tb25ncy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzYyLS0tODUtR3JhbmRhcmlhLUZvcmdlci1vZi1Tb25ncy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzYyLS0tODUtR3JhbmRhcmlhLUZvcmdlci1vZi1Tb25ncy5wbmcEXODUS/t',
    name: 'Grandaria, Forger of Songs',
    set_name: 'Converging Chasms',
    set_number: '85',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'Sangrde',
    effect:
      'While this creature is on your field, whenever one of your Uncommon Order creatures attacks and destroys an opposing creature, look at the top 2 cards of your Main Deck. Add 1 card to your hand and send the other to the graveyard. Only 1 "Grandaria, Forger of Songs" Ability can be active on the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Grandaria--Forger-of-Songs-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_363',
    s3_large_image_name:
      'MzYzLS0tODYtQ2FyY2VyeS1WYWxlLXRoZS1NaXNjcmVhdGlvbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzYzLS0tODYtQ2FyY2VyeS1WYWxlLXRoZS1NaXNjcmVhdGlvbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzYzLS0tODYtQ2FyY2VyeS1WYWxlLXRoZS1NaXNjcmVhdGlvbi5wbmcEXODUS/t',
    name: 'Carcery Vale the Miscreation',
    set_name: 'Converging Chasms',
    set_number: '86',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Thiago Almeida',
    effect:
      'Once per turn, this creature may move energy from your other creature(s) to itself. For each energy moved this way, you lose 1 Life Point.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Carcery-Vale-the-Miscreation-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_642',
    s3_large_image_name:
      'NjQyLS0tODYtY2xvdWRzY3JhcGUtc292ZXJlaWduLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjQyLS0tODYtY2xvdWRzY3JhcGUtc292ZXJlaWduLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjQyLS0tODYtY2xvdWRzY3JhcGUtc292ZXJlaWduLnBuZwEXODUSEXODUS/t',
    name: 'Cloudscrape Sovereign',
    set_name: 'Threshold of Time',
    set_number: '86',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Mushfolk'],
    creature_type_count: 1,
    artist: 'Lexi Medina',
    effect:
      'When this creature enters play, you may discard your hand. If you do, summon any number of Common and Uncommon Mushfolk from your graveyard with 1 energy each.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cloudscrape-Sovereign-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_364',
    s3_large_image_name:
      'MzY0LS0tODctSGFycG9vbi1IYWxiZXJkaWVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzY0LS0tODctSGFycG9vbi1IYWxiZXJkaWVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzY0LS0tODctSGFycG9vbi1IYWxiZXJkaWVyLnBuZwEXODUSEXODUS/t',
    name: 'Harpoon Halberdier',
    set_name: 'Converging Chasms',
    set_number: '87',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Thiago Almeida',
    effect:
      "When this creature is summoned, look at each opponent's hand. Select 1 card from each hand and freeze it by putting it onto the field face-down. (The card(s) unfreeze and return to the owner's hand at the end of their next turn.)",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Harpoon-Halberdier-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_643',
    s3_large_image_name:
      'NjQzLS0tODctaG91cmdseXBoaWEtZWV2ZW50aWRlJ3MtdGhpcmQta2V5LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjQzLS0tODctaG91cmdseXBoaWEtZWV2ZW50aWRlJ3MtdGhpcmQta2V5LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjQzLS0tODctaG91cmdseXBoaWEtZWV2ZW50aWRlJ3MtdGhpcmQta2V5LnBuZwEXODUSEXODUS/t',
    name: "Hourglyphia, Eeventide's Third Key",
    set_name: 'Threshold of Time',
    set_number: '87',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Ruk Trumata',
    effect:
      'If you have at least 3 different rarities among your creatures in play, you may send this creature from your hand or field to the graveyard to skip the next Phase this turn.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Hourglyphia--Eeventide-s-Third-Key-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_365',
    s3_large_image_name: 'MzY1LS0tODgtTGVnZW5kYXJ5LVRob3VnaHRnbGFpdmUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzY1LS0tODgtTGVnZW5kYXJ5LVRob3VnaHRnbGFpdmUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzY1LS0tODgtTGVnZW5kYXJ5LVRob3VnaHRnbGFpdmUucG5n/t',
    name: 'Legendary Thoughtglaive',
    set_name: 'Converging Chasms',
    set_number: '88',
    rarity: 'Secret Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Kenshjn Park',
    effect:
      'If you have less Life Points than your opponent, each of your creatures lose 1 less energy during battle this turn.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Legendary-Thoughtglaive-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_645',
    s3_large_image_name:
      'NjQ1LS0tcDEtZWV2ZW50aWRlJ3MtZW5jbGF2ZS1wcm9tby5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjQ1LS0tcDEtZWV2ZW50aWRlJ3MtZW5jbGF2ZS1wcm9tby5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjQ1LS0tcDEtZWV2ZW50aWRlJ3MtZW5jbGF2ZS1wcm9tby5wbmcEXODUS/t',
    name: "Eeventide's Enclave",
    set_name: 'Threshold of Time',
    set_number: 'P1',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Amelia Połtoracka',
    effect:
      "Target 1 of your creatures in play that doesn't have an Ability; this turn, it may conduct an additional attack for each rarity star it has below 3.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Eeventide-s-Enclave-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_538',
    s3_large_image_name:
      'NTM4LS0tcDEtcmViZWNjYS1lZXZlbnRpZGVzLWZpcnN0LWNoYW1waW9uLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTM4LS0tcDEtcmViZWNjYS1lZXZlbnRpZGVzLWZpcnN0LWNoYW1waW9uLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTM4LS0tcDEtcmViZWNjYS1lZXZlbnRpZGVzLWZpcnN0LWNoYW1waW9uLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: "Rebecca, Eeventide's First Champion",
    set_name: 'The Dimension That Disappeared',
    set_number: 'P1',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Tommy Suhartono',
    effect:
      "Pay 1 Life Point. Each player draws energy equal to the difference between your opponent's Life Points and yours.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rebecca--Eeventide-s-First-Champion-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_529',
    s3_large_image_name:
      'NTI5LS0tcDItc2lwaG9uLWZyb20tdGhvdWdodHMtcHJvbW8tNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTI5LS0tcDItc2lwaG9uLWZyb20tdGhvdWdodHMtcHJvbW8tNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTI5LS0tcDItc2lwaG9uLWZyb20tdGhvdWdodHMtcHJvbW8tNzJkcGkucG5n/t',
    name: 'Siphon from Thoughts',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P2',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Thai Vo / Designed by Nyx',
    effect:
      'Add this card to one of your creatures in play. While in play, treat it as an energy, and it gains the effect: when the creature this card is attached to attacks, it gains 1 energy just before the attack hits. When the creature this card is attached to is attacked, it loses 1 energy just before the attack hits.',
    ruling:
      "<p>■&nbsp;<em>Siphon from Thoughts</em>&nbsp;is, by default, a symmetry. If it resolves and is added to a creature, it is treated as an energy but also retains its symmetry card type;<br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -&nbsp;<em>Crystal Cove</em>&nbsp;can freeze&nbsp;<em>Siphon from Thoughts</em>&nbsp;because this card is treated as both a symmetry and an energy while in play;<br><br><strong>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </strong>- While Siphon is being treated as a symmetry/energy attached to a creature and becomes frozen, the symmetry side of the effect is no longer active--causing the card to no longer be treated as an energy and therefore losing all effects (it detaches from the creature/pile and is now considered a frozen symmetry in play that can get added to a new target when it unfreezes);</p>\n<p>■&nbsp;If the creature this card was attached to is removed from play but the attached energy remains, this card stays attached to that pile as an energy/symmetry;<br><br>■&nbsp;When it is played, it is not directly added to a creature right away, but instead goes face-up on the Stack so that players have a chance to respond to it before it begins resolving;<br><br>■&nbsp;<em>Thoughtstream, Eeventide's Sword</em>&nbsp;can only destroy this card before it becomes an energy;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Siphon-from-Thoughts-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_544',
    s3_large_image_name:
      'NTQ0LS0tcDMtZWV2ZW50aWRlcy1vcmRpbmFuY2UtcHJvbW8tNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ0LS0tcDMtZWV2ZW50aWRlcy1vcmRpbmFuY2UtcHJvbW8tNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ0LS0tcDMtZWV2ZW50aWRlcy1vcmRpbmFuY2UtcHJvbW8tNzJkcGkucG5n/t',
    name: "Eeventide's Ordinance",
    set_name: 'The Dimension That Disappeared',
    set_number: 'P3',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Amelia Połtoracka',
    effect:
      'Pay 2 Life Points. Target 1 creature in play with "Val" in its card name. This turn, when it attacks, it deals damage equal to the total energy between all creatures in play with "Val" in their name.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Eeventide-s-Ordinance-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_542',
    s3_large_image_name:
      'NTQyLS0tcDQtZ2xpc3RlbmluZy11bmRlcmdyb3ZlLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQyLS0tcDQtZ2xpc3RlbmluZy11bmRlcmdyb3ZlLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQyLS0tcDQtZ2xpc3RlbmluZy11bmRlcmdyb3ZlLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Glistening Undergrove',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P4',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Amelia Połtoracka',
    effect:
      'Reveal the top or bottom card of your Main Deck. If it was a symmetry, you may send it to the graveyard to destroy 1 energy in play. Otherwise, you may add it to your hand.',
    ruling:
      '<p><span style="font-family: georgia, serif; background-color: initial;">■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>This card\'s effect states "Otherwise, you may add it to your hand", meaning regardless of revealing a creature or symmetry card (as long as you didn\'t send it to the graveyard to destroy 1 energy), you may add that card to your hand;&nbsp;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>If this card reveals <em>Coldcrux, Root of the World</em> from the top or bottom of your Main Deck and <em>Coldcrux</em> targets &amp; freezes this card, <em>Coldcrux</em> cannot be added to hand since <em>Undergrove</em> became frozen--causing the rest of this symmetry card\'s effect to fizzle and disappear from the stack;<br></span></p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Glistening-Undergrove-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_541',
    s3_large_image_name:
      'NTQxLS0tcDUtbXlzdGVyaW91cy1ib3NrLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQxLS0tcDUtbXlzdGVyaW91cy1ib3NrLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQxLS0tcDUtbXlzdGVyaW91cy1ib3NrLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Mysterious Bosk',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P5',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'COCOs',
    effect:
      "Target 1 energy from one of your opponent's Rare creatures in play and destroy it. Then, add 2 energy to one of your Common or Uncommon creatures in play.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mysterious-Bosk-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_551',
    s3_large_image_name:
      'NTUxLS0tcDctY2hyb25vZ3JhcGgtdmFsZWdpb24tcHJvbW8tNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTUxLS0tcDctY2hyb25vZ3JhcGgtdmFsZWdpb24tcHJvbW8tNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTUxLS0tcDctY2hyb25vZ3JhcGgtdmFsZWdpb24tcHJvbW8tNzJkcGkucG5n/t',
    name: 'Chronograph Valegion',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P7',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Nivea Toliver',
    effect:
      "This creature may attack Afterthoughts. (Afterthoughts don't deal damage to it unless otherwise specified.) AFTERTHOUGHT ABILITY: Your Afterthoughts may attack as if they were creatures (they deal damage equal to the number of Afterthoughts in play). If they do, your creature(s) can't attack this turn and vice-versa.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chronograph-Valegion-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_543',
    s3_large_image_name:
      'NTQzLS0tcDgtZHVuZWR1c3QtcmF2YWdlci1wcm9tby03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQzLS0tcDgtZHVuZWR1c3QtcmF2YWdlci1wcm9tby03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQzLS0tcDgtZHVuZWR1c3QtcmF2YWdlci1wcm9tby03MmRwaS5wbmcEXODUS/t',
    name: 'Dunedust Ravager',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P8',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Nivea Toliver',
    effect:
      'When this creature enters play, move up to 1 energy on each side of the field somewhere else on the same side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dunedust-Ravager-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_539',
    s3_large_image_name:
      'NTM5LS0tcDktZm9yZXJ1bm5lci1vZi1lY2xpcHNlcy1wcm9tby03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTM5LS0tcDktZm9yZXJ1bm5lci1vZi1lY2xpcHNlcy1wcm9tby03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTM5LS0tcDktZm9yZXJ1bm5lci1vZi1lY2xpcHNlcy1wcm9tby03MmRwaS5wbmcEXODUS/t',
    name: 'Forerunner of Eclipses',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P9',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Mushfolk'],
    creature_type_count: 2,
    artist: 'Daria Gallyamova',
    effect:
      'Once per turn, per copy, you may activate this Ability to summon this creature from your hand to your field. If you do, you may target 1 effect or Ability on the stack and that effect becomes "each player draws 1 card".',
    ruling:
      '<p><span style="background-color: transparent; font-family: georgia, serif;">■&nbsp;</span><span style="font-family: georgia, serif; background-color: initial;">This creature\'s Ability can target ANY Ability or effect on the stack (creature or symmetry);&nbsp;</span></p>\n<p><span style="font-family: georgia, serif; background-color: initial;"><span style="background-color: transparent;">■&nbsp;</span><span style="background-color: initial;">If <em>Forerunner\'s</em> Ability resolves and changes a symmetry effect into "each player draws 1 card", that symmetry will go to the graveyard after it resolves;</span></span></p>\n<p><span style="font-family: georgia, serif; background-color: initial;"><span style="background-color: initial;"><span style="background-color: transparent;">■ If <em>Forerunner\'s</em> Ability resolves and changes an active creature Ability into "each player draws 1 card", that creature\'s Ability reverts back to its original printed text after resolution;<br><br></span></span></span><span style="font-family: georgia, serif;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - If the affected creature Ability was one that could only be triggered once per turn, it won\'t be able to activate again on the same turn after its text reverts back;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>If <em>Forerunner of Eclipses</em> is activating from hand and the target card effect or Ability disappears from the stack, <em>Forerunner</em> can choose a new target if possible—otherwise, it will just be summoned to the field;<br><br><span style="font-family: georgia, serif; background-color: initial;"><span style="background-color: initial;"><span style="background-color: transparent;"><em>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>Forerunner\'s</em>&nbsp;Ability can only target effects or Abilities that are still on the stack;<br><br></span></span></span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - If&nbsp;<em>Chains</em> has been in play and&nbsp;<em>Forerunner&nbsp;</em>wasn\'t&nbsp;a response to&nbsp;its initial activation, then <em>Chains</em> can\'t be targeted by <em>Forerunner</em> (unless <em>Chains</em> is unfreezing as that counts as a new activation and puts&nbsp;it back on the stack);<br></span></p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Forerunner-of-Eclipses-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_556',
    s3_large_image_name: 'NTU2LS0tQUExLWNoYWlucy1wcm9tby03MmRwaS5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTU2LS0tQUExLWNoYWlucy1wcm9tby03MmRwaS5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTU2LS0tQUExLWNoYWlucy1wcm9tby03MmRwaS5qcGcEXODUS/t',
    name: 'Chains',
    set_name: 'Birth of Creation',
    set_number: 'AA1',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      "When this card is played, it remains on the field until its effect has occurred. If this card is played on your turn, your opponent cannot attack during their next turn. If this card is played on your opponent's turn, they cannot attack during that turn. ",
    ruling:
      "<p>■&nbsp;<em>Chains</em><strong>&nbsp;affects the player</strong>&nbsp;and&nbsp;<strong>does not target the creatures themselves</strong>;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: Even if a player is 'chained', he or she still cannot attack with a&nbsp;<em>Lantern Leaflore</em>&nbsp;(even though&nbsp;<em>Leaflore</em>&nbsp;is unaffected by symmetry cards) because the player is unable to command the creature to execute the attack;</p>\n<p>■&nbsp;<em>Chains&nbsp;</em>only stops a player from attacking for&nbsp;<u>that</u>&nbsp;turn;</p>\n<p>&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;-&nbsp;Due to the wording \"...it remains on the field until its effect has occurred\",<strong>&nbsp;this card is considered to be resolved and goes to the graveyard</strong>&nbsp;<strong>after the chained player is done with their Attack Phase</strong>&nbsp;(upon entering End Phase);</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: If&nbsp;<em>Chains&nbsp;</em>is played in response to your opponent's&nbsp;<em>Vortex</em>&nbsp;that's currently unfreezing at the end of their turn,&nbsp;<em>Chains&nbsp;</em>will be considered already resolved (since your opponent has already finished their Attack Phase for that turn), and will go the graveyard;</p>\n<p>&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;■&nbsp;Due to the wording \"If this card is played on your opponent's turn, they cannot attack during that turn\", the effect is considered resolved upon the End Phase regardless of whether or not the player attacked that turn;&nbsp;</p>",
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Chains-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_555',
    s3_large_image_name:
      'NTU1LS0tQUEyLWxlZWNoLXByb21vLTcyZHBpLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTU1LS0tQUEyLWxlZWNoLXByb21vLTcyZHBpLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTU1LS0tQUEyLWxlZWNoLXByb21vLTcyZHBpLmpwZwEXODUSEXODUS/t',
    name: 'Leech',
    set_name: 'Birth of Creation',
    set_number: 'AA2',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      "Target 1 energy on your opponent's side of the field and destroy it. Then, add 1 energy to a creature or pile on your side of the field. ",
    ruling:
      '<p>■&nbsp;<strong><em>Leech&nbsp;</em></strong><strong>is an all-or-nothing type of card</strong>;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Because its effect is broken up into 2 sentences,&nbsp;<strong>the first effect can\'t happen unless the second is possible</strong>&nbsp;and vice-versa;</p>\n<p><em>■ Leech&nbsp;</em>cannot be used to start a new pile of energy<em>;</em>&nbsp;it must be added to an existing one;</p>\n<p>■&nbsp;<em>Leech&nbsp;</em>can be played in response to a "When this creature is summoned..." Ability and will stop the Ability if it destroys the creature\'s last energy;</p>',
    foil_only: 'Yes',
    card_database_link: 'https://exodus-players.com/cards/search/Leech-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_554',
    s3_large_image_name:
      'NTU0LS0tQUEzLXVuc3VtbW9uLXByb21vLTcyZHBpLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTU0LS0tQUEzLXVuc3VtbW9uLXByb21vLTcyZHBpLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTU0LS0tQUEzLXVuc3VtbW9uLXByb21vLTcyZHBpLmpwZwEXODUSEXODUS/t',
    name: 'Unsummon',
    set_name: 'Birth of Creation',
    set_number: 'AA3',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      "Pay 1 energy. Target 1 creature in play and send it to the owner's hand. All energy attached to that creature is destroyed.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Unsummon-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_553',
    s3_large_image_name: 'NTUzLS0tQUE0LXZvcnRleC1wcm9tby03MmRwaS5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTUzLS0tQUE0LXZvcnRleC1wcm9tby03MmRwaS5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTUzLS0tQUE0LXZvcnRleC1wcm9tby03MmRwaS5qcGcEXODUS/t',
    name: 'Vortex',
    set_name: 'Birth of Creation',
    set_number: 'AA4',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      'Pay 1 energy. Both you and your opponent discard your entire hand and draw 3 new cards each from the Main Deck.',
    ruling:
      '<p>■ When this card is played, both players can still stack symmetry cards in response before discarding their hand;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Cards played in response to&nbsp;<em>Vortex</em>&nbsp;happen first;</p>\n<p><em>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;</em>If a&nbsp;<em>Vortex&nbsp;</em>is played in response to a&nbsp;<em>Vortex</em>, players can continue playing symmetries or activating Abilities by "adding to the stack" after the first&nbsp;<em>Vortex&nbsp;</em>has resolved, due to symmetries and Abilities being instant-speed<em>;</em>&nbsp;</p>\n<p><em>■</em>&nbsp;<em>Vortex&nbsp;</em>can be played&nbsp;at the start or end of a player\'s Draw Phase, but&nbsp;<strong>NOT&nbsp;</strong>in the middle while they are still drawing;</p>\n<p><em>■</em>&nbsp;Card effects or Abilities cannot be played or trigger in the middle of&nbsp;<em>Vortex&nbsp;</em>resolving. (<strong>Example</strong>:&nbsp;You cannot play&nbsp;<em>Forest of Crags</em>&nbsp;between the cards drawn from&nbsp;<em>Vortex)</em>; (<strong>Example</strong>: Your opponent cannot play&nbsp;<em>Drifter\'s Dueling</em>&nbsp;between the cards drawn from&nbsp;<em>Vortex</em>);</p>',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Vortex-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_550',
    s3_large_image_name: 'NTUwLS0tQUE1LVNpbGVudC1JcnJlZ3VsYXJpdHktNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTUwLS0tQUE1LVNpbGVudC1JcnJlZ3VsYXJpdHktNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTUwLS0tQUE1LVNpbGVudC1JcnJlZ3VsYXJpdHktNzJkcGkucG5n/t',
    name: 'Silent Irregularity',
    set_name: 'The Dimension That Disappeared',
    set_number: 'AA5',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Ruk Trumata',
    effect:
      'Whenever this creature goes to the graveyard, add 1 energy beneath your Main Deck or to a creature in play. AFTERTHOUGHT ABILITY: Ignore all Life Point requirements (excluding costs) for your card effects and Abilities.',
    ruling:
      "<p>■ If a player chooses to turn this creature into an Afterthought, its normal Ability will&nbsp;<strong><u>not</u></strong>&nbsp;trigger, since it never went to the graveyard;</p>\n<p>■&nbsp;<em>Silent Irregularity's</em>&nbsp;normal Ability will effectively trigger whenever it goes to the graveyard from any other zone, such as hand, Main Deck or field. Additionally, its Ability may also trigger if this creature is sent to the graveyard&nbsp;after being destroyed as an Afterthought. The moment Afterthoughts leave play, they are considered creatures again, so&nbsp;<em>Silent Irregularity's</em>&nbsp;normal Ability once again becomes active as it gets sent to the graveyard;</p>",
    foil_only: 'Yes',
    card_database_link:
      'https://exodus-players.com/cards/search/Silent-Irregularity-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_548',
    s3_large_image_name:
      'NTQ4LS0tQUE2LVdhbmRlcndvbGYtdGhlLUlubmVyLUZlYXItNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ4LS0tQUE2LVdhbmRlcndvbGYtdGhlLUlubmVyLUZlYXItNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ4LS0tQUE2LVdhbmRlcndvbGYtdGhlLUlubmVyLUZlYXItNzJkcGkucG5n/t',
    name: 'Wanderwolf the Inner Fear',
    set_name: 'The Dimension That Disappeared',
    set_number: 'AA6',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Chrono', 'Wolf'],
    creature_type_count: 2,
    artist: 'A.Gvin',
    effect:
      "This creature may attack blank piles of energy. (Blank piles don't deal damage to it.) AFTERTHOUGHT ABILITY: The first time your opponent damages your Life Points each turn, you take 1 less damage.",
    ruling: '',
    foil_only: 'Yes',
    card_database_link:
      'https://exodus-players.com/cards/search/Wanderwolf-the-Inner-Fear-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_549',
    s3_large_image_name:
      'NTQ5LS0tQUE3LVNoYXJkc2NhbGUtUHRlcm9oZWRyb24tNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ5LS0tQUE3LVNoYXJkc2NhbGUtUHRlcm9oZWRyb24tNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ5LS0tQUE3LVNoYXJkc2NhbGUtUHRlcm9oZWRyb24tNzJkcGkucG5n/t',
    name: 'Shardscale Pterohedron',
    set_name: 'The Dimension That Disappeared',
    set_number: 'AA7',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect:
      "You may activate this Ability from your hand and pay 1 energy to put this creature into play on an existing blank pile on your field. If it enters play on your opponent's turn, pay 1 additional energy. When it enters play by this Ability, opposing Abilities become inactive for the rest of the turn.",
    ruling: '',
    foil_only: 'Yes',
    card_database_link:
      'https://exodus-players.com/cards/search/Shardscale-Pterohedron-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_547',
    s3_large_image_name:
      'NTQ3LS0tQUE4LUJyaXN0bGVjb25lLVBoYW50b20tUGluZS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ3LS0tQUE4LUJyaXN0bGVjb25lLVBoYW50b20tUGluZS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ3LS0tQUE4LUJyaXN0bGVjb25lLVBoYW50b20tUGluZS03MmRwaS5wbmcEXODUS/t',
    name: 'Bristlecone Phantom Pine',
    set_name: 'The Dimension That Disappeared',
    set_number: 'AA8',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Brandon McDonald',
    effect:
      'When this creature attacks, target 1 card in your graveyard and put it back in your Main Deck wherever you like. Then, draw 1 energy for each rarity among your creatures in play.',
    ruling:
      "<p>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>\"put it back in your Main Deck wherever you like\" means that you take the target card from the graveyard (looking), flip it face-down, and put it in your Main Deck (without searching through your Main Deck or flipping the cards face-up)<em>—</em>slotting the target card into the Main Deck&nbsp;wherever you like;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>When this creature attacks and its Ability resolves, you may choose 1 card from any player's graveyard on your team and put it back in the owner's Main Deck wherever you like (it does not have to be your own card from your own graveyard, but the target card cannot go from one player's graveyard into&nbsp;a different player's Main Deck);<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<strong><sup>[NEW]&nbsp;</sup></strong>&nbsp;- The player on your team who draws energy from the second part of this creature's Ability can be a different player than the one who put a card from their graveyard into their Main Deck;</p>",
    foil_only: 'Yes',
    card_database_link:
      'https://exodus-players.com/cards/search/Bristlecone-Phantom-Pine-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_658',
    s3_large_image_name: 'NjU4LS0tQUE5LURyYW9oLVVudG9sZC1MaWJlcmF0b3IucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjU4LS0tQUE5LURyYW9oLVVudG9sZC1MaWJlcmF0b3IucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjU4LS0tQUE5LURyYW9oLVVudG9sZC1MaWJlcmF0b3IucG5n/t',
    name: 'Draoh, Untold Liberator',
    set_name: 'Threshold of Time',
    set_number: 'AA9',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Drifter', 'Archive'],
    creature_type_count: 2,
    artist: 'A.Gvin',
    effect:
      'This creature can only enter play on top of a Drifter. You may add any amount of energy from your hand to this creature during your Energy Phase.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Draoh--Untold-Liberator-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_528',
    s3_large_image_name:
      'NTI4LS0tYnQxLWVuZC1vZi10aGUtcmlmdC03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTI4LS0tYnQxLWVuZC1vZi10aGUtcmlmdC03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTI4LS0tYnQxLWVuZC1vZi10aGUtcmlmdC03MmRwaS5wbmcEXODUS/t',
    name: 'End of the Rift',
    set_name: 'The Dimension That Disappeared',
    set_number: 'BT1',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Yosi Saputra',
    effect:
      'Draw 1 energy. If you have equal or less Life Points than your opponent, target 1 "Vortex" symmetry card in play; negate its effect and destroy it.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/End-of-the-Rift-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_644',
    s3_large_image_name: 'NjQ0LS0tQm94LVRvcHBlci10b3JuLWFzdW5kZXIucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjQ0LS0tQm94LVRvcHBlci10b3JuLWFzdW5kZXIucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjQ0LS0tQm94LVRvcHBlci10b3JuLWFzdW5kZXIucG5n/t',
    name: 'Torn Asunder',
    set_name: 'Threshold of Time',
    set_number: 'BT1',
    rarity: 'Box',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Alejandro Arévalo',
    effect:
      "Pay 1 energy. Look at your opponent's hand. Target 1 card from it and have them discard it.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Torn-Asunder-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_366',
    s3_large_image_name:
      'MzY2LS0tQ1QtMWEtRWV2ZW50aWRlLXRoZS1QYXJhZG94aWNhbC1QbGFuZXQucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzY2LS0tQ1QtMWEtRWV2ZW50aWRlLXRoZS1QYXJhZG94aWNhbC1QbGFuZXQucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzY2LS0tQ1QtMWEtRWV2ZW50aWRlLXRoZS1QYXJhZG94aWNhbC1QbGFuZXQucG5n/t',
    name: 'Eeventide, the Paradoxical Planet / Chaos Chasm, Eeventide Awoken',
    set_name: 'Converging Chasms',
    set_number: 'CT1',
    rarity: 'Harmony Rare',
    edition: 'First',
    card_type: ['Eeventide Field', 'Creature'],
    creature_type: ['Grand Wonder', 'Portal'],
    creature_type_count: 2,
    artist: 'André Martinez',
    effect:
      "*Only 1 Eeventide Field can be in play. *This card starts in play and is considered part of the field. It can't leave play. *AWAKEN: Once per game, per player, when a player's Life Points would reach 0, that player may activate this effect to flip this card to the creature side and they go to 1 Life Point instead. CONTINUOUS EFFECT: While this side is face-up, at the start of each turn, each player draws 1 energy card from their energy deck. / *This creature's Ability can't be stopped. *When this creature leaves play, it flips back to the Eeventide Field side. ABILITY: When this card is flipped to the creature side, destroy all other creatures in play and all energy attached to them. This creature goes to the side of the field of the player who flipped it with 10 energy on it.",
    ruling: '',
    foil_only: 'Yes',
    card_database_link:
      'https://exodus-players.com/cards/search/Eeventide--the-Paradoxical-Planet---Chaos-Chasm--Eeventide-Awoken-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_367',
    s3_large_image_name:
      'MzY3LS0tQ1QtMmEtU2xlZXBpbmctU2FuY3R1bS10aGUtVW50b3VjaGFibGUtRm9yZXN0LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzY3LS0tQ1QtMmEtU2xlZXBpbmctU2FuY3R1bS10aGUtVW50b3VjaGFibGUtRm9yZXN0LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzY3LS0tQ1QtMmEtU2xlZXBpbmctU2FuY3R1bS10aGUtVW50b3VjaGFibGUtRm9yZXN0LnBuZwEXODUSEXODUS/t',
    name: "Sleeping Sanctum, the Untouchable Forest / Vital Sanctuary Eeventide's Ascent",
    set_name: 'Converging Chasms',
    set_number: 'CT2',
    rarity: 'Harmony Rare',
    edition: 'First',
    card_type: ['Eeventide Field', 'Creature'],
    creature_type: ['Grand Wonder', 'Forest'],
    creature_type_count: 2,
    artist: 'J.L.Lockwood',
    effect:
      "*Only 1 Eeventide Field can be in play. *This card starts in play and is considered part of the field. It can't leave play. *This card can't AWAKEN during any player's first turn. *AWAKEN: Once per game, per player, at the start of a player's own turn before their Draw Phase, they may activate this effect to flip this card to the creature side and they skip their Draw Phase that turn. CONTINUOUS EFFECT: At the start of a player's turn, that player may reveal the top card of their Main Deck or their opponent's Main Deck. / *This creature's Ability can't be stopped. *When this creature leaves play, it flips back to the Eeventide Field side. ABILITY: When this card is flipped to the creature side, each player loses Life Points equal to the number of their own creatures in play. It goes to the side of the field of the player who flipped it with energy equal to their own Life Points.",
    ruling:
      "<p>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>The part of <em>Vital Sanctuary's</em> Ability that deals Life Point damage as it Awakens is not part of a cost or requirement for Awakening;&nbsp;<br><br>&nbsp; &nbsp; &nbsp;- The only requirement for Awakening is to \"skip your Draw Phase\" at the start of your turn (assuming it isn't your first turn);<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>Cards like <em>Crystallize</em>, <em>Devourer of Dimensions</em>, <em>Shardscale Pterohedron</em>, etc. attempt to \"cancel\" or \"negate\" or prevent Abilities from activating, and thereby stop this creature's Ability--none of those can affect <em>Sanctuary's</em> Ability as it is Awakening;<br><strong><sup><br></sup></strong>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - <em>Anathema's</em> creature side Ability is a blanket effect that says, \"Life Points cannot change\" while visible, affecting this HR in the following way(s):&nbsp;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<em>Vital Sanctuary's</em>&nbsp;Awakening isn't being tampered with by <em>Anathema</em>, nor is it being targeted, nor is its entire Ability trying to be stopped--<em>Anathema's</em> Ability simply causes the Life Point damage portion of <em>Sanctuary's</em> Ability to be ignored since Life Points cannot change (i.e. do as much as possible);<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<em>Vital Sanctuary's</em>&nbsp;starting energy count will be higher when it enters play while <em>Anathema's</em> Ability is active since none of the players are dealt damage when it Awakens;&nbsp;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<em>Flashfire's</em>&nbsp;Afterthought Ability will protect that player or that player's team from being dealt damage by <em>Vital Sanctuary's</em> Ability;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Sleeping-Sanctum--the-Untouchable-Forest---Vital-Sanctuary-Eeventide-s-Ascent-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_368',
    s3_large_image_name:
      'MzY4LS0tQ1QtM2EtR2xhY2lhbC1EcmlmdC10aGUtTG9zdC1EZXB0aHMucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzY4LS0tQ1QtM2EtR2xhY2lhbC1EcmlmdC10aGUtTG9zdC1EZXB0aHMucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzY4LS0tQ1QtM2EtR2xhY2lhbC1EcmlmdC10aGUtTG9zdC1EZXB0aHMucG5n/t',
    name: "Glacial Drift, the Lost Depths / Abyssal Ridge Eeventide's Gallows",
    set_name: 'Converging Chasms',
    set_number: 'CT3',
    rarity: 'Harmony Rare',
    edition: 'First',
    card_type: ['Eeventide Field', 'Creature'],
    creature_type: ['Grand Wonder', 'Ocean'],
    creature_type_count: 2,
    artist: 'J.L.Lockwood',
    effect:
      "*Only 1 Eeventide Field can be in play. *This card starts in play and is considered part of the field. It can't leave play. *AWAKEN: Once per game, per player, when a player ends their own turn, they may activate this effect to flip this card to the creature side and they discard all cards in their hand. CONTINUOUS EFFECT: At the end of a player's turn, that player may freeze one of their own creatures in play. If they do, they may draw 1 energy. / *This creature's Ability can't be stopped. *When this creature leaves play, it flips back to the Eeventide Field side. ABILITY: When this card is flipped to the creature side, permanently freeze all other cards in play. It goes to the side of the field of the player who flipped it with energy equal to the number of frozen cards in play.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Glacial-Drift--the-Lost-Depths---Abyssal-Ridge-Eeventide-s-Gallows-First',
    is_default_edition: true,
  },
  {
    card_id: 'card_546',
    s3_large_image_name:
      'NTQ2LS0tcDEwLWR1YWxpdHktc2FwbGluZy1wcm9tby03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ2LS0tcDEwLWR1YWxpdHktc2FwbGluZy1wcm9tby03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ2LS0tcDEwLWR1YWxpdHktc2FwbGluZy1wcm9tby03MmRwaS5wbmcEXODUS/t',
    name: 'Duality Sapling',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P10',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Thai Vo',
    effect:
      'This creature may conduct a second attack against creature(s) each turn. If you revealed any cards that turn, it may conduct a third attack against creature(s).',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Duality-Sapling-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_655',
    s3_large_image_name:
      'NjU1LS0tcDExLWxlZ2FjeS12ZXN0aWdlLWNvcnJvZGVzdHJpYS1wcm9tby5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjU1LS0tcDExLWxlZ2FjeS12ZXN0aWdlLWNvcnJvZGVzdHJpYS1wcm9tby5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjU1LS0tcDExLWxlZ2FjeS12ZXN0aWdlLWNvcnJvZGVzdHJpYS1wcm9tby5wbmcEXODUS/t',
    name: 'Legacy Vestige, Corrodestria',
    set_name: 'Threshold of Time',
    set_number: 'P11',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Leviathan', 'Machine'],
    creature_type_count: 2,
    artist: 'Wes',
    effect:
      'When this creature enters play and whenever it attacks, you may move up to 1 energy from each of your other Machines and Leviathans to this creature.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Legacy-Vestige--Corrodestria-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_540',
    s3_large_image_name:
      'NTQwLS0tcDExLXN1bmtlbi1yZXZlbmFudC1wcm9tby03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQwLS0tcDExLXN1bmtlbi1yZXZlbmFudC1wcm9tby03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQwLS0tcDExLXN1bmtlbi1yZXZlbmFudC1wcm9tby03MmRwaS5wbmcEXODUS/t',
    name: 'Sunken Revenant',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P11',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Mat Gimeno',
    effect:
      'When this creature enters play, your graveyard becomes hidden to opponents until the end of your next turn. When this creature attacks, reveal your graveyard.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Sunken-Revenant-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_552',
    s3_large_image_name:
      'NTUyLS0tcDEyLWRpbWVuc2lvbmFsLXNlYXNsaXRoZS1wcm9tby03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTUyLS0tcDEyLWRpbWVuc2lvbmFsLXNlYXNsaXRoZS1wcm9tby03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTUyLS0tcDEyLWRpbWVuc2lvbmFsLXNlYXNsaXRoZS1wcm9tby03MmRwaS5wbmcEXODUS/t',
    name: 'Dimensional Seaslithe',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P12',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Alejandro Arévalo',
    effect:
      'Once per turn, per copy, you may discard this card from your hand or field to draw 1 card.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Seaslithe-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_545',
    s3_large_image_name:
      'NTQ1LS0tcDEzLWRlZmVuZGVyLW9mLXRoZS1hZXJpYWwtcHJvdmluY2VzLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ1LS0tcDEzLWRlZmVuZGVyLW9mLXRoZS1hZXJpYWwtcHJvdmluY2VzLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQ1LS0tcDEzLWRlZmVuZGVyLW9mLXRoZS1hZXJpYWwtcHJvdmluY2VzLXByb21vLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Defender of the Aerial Provinces',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P13',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Angel', 'Behemoth'],
    creature_type_count: 2,
    artist: 'A.Gvin',
    effect:
      "This creature can't be damaged by Angels. While you have any symmetries in play, this creature can't be targeted by opposing symmetries.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Defender-of-the-Aerial-Provinces-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_659',
    s3_large_image_name: 'NjU5LS0tQUExMC1UYWNoeW9uLVRvdXJiaWxsb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjU5LS0tQUExMC1UYWNoeW9uLVRvdXJiaWxsb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjU5LS0tQUExMC1UYWNoeW9uLVRvdXJiaWxsb24ucG5n/t',
    name: 'Tachyon Tourbillon',
    set_name: 'Threshold of Time',
    set_number: 'AA10',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect:
      "When this creature is rebuilt, send 1 energy in play to the owner's hand and draw 1 energy. If any Phase was skipped or done out of order this turn, activate this Ability from a viewable zone to target 1 of your Machines in play and rebuild it (even if it and the rebuild target have already been rebuilt this turn).",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Tachyon-Tourbillon-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_660',
    s3_large_image_name:
      'NjYwLS0tQUExMS1QYWxpc2FkZXMtdGhlLUV0ZXJuYWwtRW1iZXIucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjYwLS0tQUExMS1QYWxpc2FkZXMtdGhlLUV0ZXJuYWwtRW1iZXIucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjYwLS0tQUExMS1QYWxpc2FkZXMtdGhlLUV0ZXJuYWwtRW1iZXIucG5n/t',
    name: 'Palisades the Eternal Ember',
    set_name: 'Threshold of Time',
    set_number: 'AA11',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Hailfire'],
    creature_type_count: 1,
    artist: 'Ben Cgant',
    effect:
      'While this creature is in play, once per turn, you are not required to destroy ignited card(s) when bursting. *Ignite *Burst',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Palisades-the-Eternal-Ember-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_661',
    s3_large_image_name: 'NjYxLS0tQUExMi1HaG9zdC1TaGlwLUdhbGxlb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjYxLS0tQUExMi1HaG9zdC1TaGlwLUdhbGxlb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjYxLS0tQUExMi1HaG9zdC1TaGlwLUdhbGxlb24ucG5n/t',
    name: 'Ghost Ship Galleon',
    set_name: 'Threshold of Time',
    set_number: 'AA12',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Leviathan', 'Mistform'],
    creature_type_count: 2,
    artist: 'Brandon McDonald',
    effect:
      'While this creature is in play, once per turn, your opponent loses 1 Life Point whenever energy is moved on the field or sent from their field to their hand.',
    ruling:
      "<p>■ Each&nbsp;<em>Ghost Ship Galleon's </em>Ability operates independently of one another;&nbsp;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - If you have 2 copies of this creature in play, you can cause your opponent to lose 2 Life Points per turn (once per copy) whenever energy is moved or sent back to a player's hand due to an effect or Ability;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Ghost-Ship-Galleon-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_264',
    s3_large_image_name: 'MjY0LS0tQ0YtU3RhcnNoaXAtR2FsYWNpYS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjY0LS0tQ0YtU3RhcnNoaXAtR2FsYWNpYS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjY0LS0tQ0YtU3RhcnNoaXAtR2FsYWNpYS5wbmcEXODUS/t',
    name: 'Starship Galacia',
    set_name: 'Crystal Forge',
    set_number: 'PRE-RELEASE',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Leviathan'],
    creature_type_count: 2,
    artist: 'Hoang Tran',
    effect:
      "When this creature is summoned, freeze 1 creature on the field (it flips face-down and cannot attack while frozen; it unfreezes and flips face-up at the end of the owner's next turn).",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Starship-Galacia-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_370',
    s3_large_image_name:
      'MzcwLS0tUmFyZS1Ta2V0Y2gtQWlyc2hpcC1Db3Jyb2Rlc3RyaWEtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzcwLS0tUmFyZS1Ta2V0Y2gtQWlyc2hpcC1Db3Jyb2Rlc3RyaWEtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzcwLS0tUmFyZS1Ta2V0Y2gtQWlyc2hpcC1Db3Jyb2Rlc3RyaWEtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Airship Corrodestria',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Leviathan', 'Machine'],
    creature_type_count: 2,
    artist: 'Wes',
    effect:
      'When this creature is summoned, move 1 energy from another creature on your side of the field to this creature.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Airship-Corrodestria-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_422',
    s3_large_image_name:
      'NDIyLS0tUHJvbW8tUmFyZS1BaXJzaGlwLUNvcnJvZGVzdHJpYV9Sb3VuZGVkQ29ybmVycy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDIyLS0tUHJvbW8tUmFyZS1BaXJzaGlwLUNvcnJvZGVzdHJpYV9Sb3VuZGVkQ29ybmVycy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDIyLS0tUHJvbW8tUmFyZS1BaXJzaGlwLUNvcnJvZGVzdHJpYV9Sb3VuZGVkQ29ybmVycy5wbmcEXODUS/t',
    name: 'Airship Corrodestria',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Leviathan', 'Machine'],
    creature_type_count: 2,
    artist: 'Wes',
    effect:
      'When this creature is summoned, move 1 energy from another creature on your side of the field to this creature.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Airship-Corrodestria-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_406',
    s3_large_image_name:
      'NDA2LS0tR1QtYWxhbmEtdGhlLXN0YXItZm9ybWF0aW9uLXNrZXRjaC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDA2LS0tR1QtYWxhbmEtdGhlLXN0YXItZm9ybWF0aW9uLXNrZXRjaC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDA2LS0tR1QtYWxhbmEtdGhlLXN0YXItZm9ybWF0aW9uLXNrZXRjaC5qcGcEXODUS/t',
    name: 'Alana the Star Formation',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'COCOs',
    effect:
      "When this creature is summoned, it gains 1 energy and you may look at your opponent's hand.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Alana-the-Star-Formation-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_662',
    s3_large_image_name:
      'NjYyLS0tbGUtYWxjYXphci1tYW5vci1haWN1bG9mdC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjYyLS0tbGUtYWxjYXphci1tYW5vci1haWN1bG9mdC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjYyLS0tbGUtYWxjYXphci1tYW5vci1haWN1bG9mdC5wbmcEXODUS/t',
    name: 'Alcázar Manor, Aiculoft',
    set_name: 'Threshold of Time',
    rarity: 'Secret Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'Pradipta Candra',
    effect:
      'While this creature is in play, once per turn, you may pay 1 frozen energy. If you do, creatures on your field become Shardfolk in addition to their other type(s) for the rest of the turn.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Alc--zar-Manor--Aiculoft-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_423',
    s3_large_image_name:
      'NDIzLS0tUHJvbW8tUmFyZS1BbWJlcmJsYWRlX0RyYWdvbl9Sb3VuZGVkQ29ybmVycy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDIzLS0tUHJvbW8tUmFyZS1BbWJlcmJsYWRlX0RyYWdvbl9Sb3VuZGVkQ29ybmVycy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDIzLS0tUHJvbW8tUmFyZS1BbWJlcmJsYWRlX0RyYWdvbl9Sb3VuZGVkQ29ybmVycy5wbmcEXODUS/t',
    name: 'Amberblade Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Wes',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Amberblade-Dragon-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_530',
    s3_large_image_name: 'anathema-sketch-front',
    s3_backside_large_image_name: 'anathema-sketch-back',
    large_image_url:
      'http://cloud-3.steamusercontent.com/ugc/768365276449669464/397411ADDA184771E1952334619CB1BB2C5E9EF9/',
    small_image_url:
      'http://cloud-3.steamusercontent.com/ugc/768365276449669464/397411ADDA184771E1952334619CB1BB2C5E9EF9/',
    backside_large_image_url:
      'http://cloud-3.steamusercontent.com/ugc/768365276449670057/BD669E889ADE614C0D611165487C4324CEEE39E4/',
    name: 'Anathema',
    set_name: 'The Dimension That Disappeared',
    rarity: 'Secret Rare',
    edition: 'Limited',
    card_type: ['Symmetry', 'Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Thiago Almeida',
    effect:
      'Send the top card of your Main Deck to the graveyard and add 2 energy beneath the Main Deck or to a creature in play. All non-Chronos in play lose 1 energy. You may destroy 1 of your Afterthoughts in play. If you do, flip this card and summon it on an existing blank pile on your field. / • This creature can only enter play through the symmetry effect on the flip side. ABILITY: When this creature is summoned, look at all cards in your Main Deck, then put them back in any order. Life Points cannot change except by creatures attacking directly as long as this card is visible to all players. ',
    ruling:
      '<p>■&nbsp;Since this card is double-sided and both the symmetry and creature side have the same card name, having 1 of this card in your Main Deck automatically counts as 2 copies and fills the 2-card maximum;<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - The card physically counts as 1 card in the deck and on the deck list, but the name printed twice on the card fulfills the 2-count maximum copies by name in deck-building;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>The first part of the effect on the symmetry side is not a cost⁠—do as much as possible;<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;</sup></strong>&nbsp;- You don\'t have to have any cards in the Main Deck to resolve the effect;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>If this card becomes frozen while on the symmetry side, it will still be on the symmetry side when it unfreezes;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong><em>Anathema</em> can be targeted and frozen by <em>Crystal Cove</em> even while it is in play on the creature side, since it is treated as both a symmetry and a creature;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>If this card becomes frozen while on the creature side, it will still be on the creature side when it unfreezes;<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;</sup></strong>&nbsp;- The creature side Ability preventing Life Points from changing except by creature attacks is still active while this card is frozen, regardless of which side it is frozen on, since frozen cards are still visible to all players;<br><br>■&nbsp;<em>Anathema</em>&nbsp;flips back to the symmetry side as soon as the creature leaves play. As long as the card (regardless of which side it\'s on) is in a zone viewable by all players, the continuous Life Point effect from the creature side is active;<br>(i.e. when you look at the cards in a player\'s graveyard, you\'re free to look at the front and back of all cards; since that is considered "visible", it doesn\'t matter which side&nbsp;<em>Anathema&nbsp;</em>is currently on for the continuous effect to be active);</p>\n<p>■&nbsp;Since&nbsp;<em>Anathema\'s</em>&nbsp;creature Ability states "Life Points cannot change except by creatures attacking directly", then players simply cannot trigger cards with a Life Point cost while&nbsp;<em>Anathema</em>&nbsp;is visible to all players. (I.e. this is different from&nbsp;<em>Madness Settles</em>, which says "don\'t lose energy", rather than "cannot".);</p>\n<p>■ If&nbsp;<em>Anathema&nbsp;</em>is triggered&nbsp;<u>in response</u>&nbsp;to a Life Point cost, once&nbsp;<em>Anathema</em>&nbsp;resolves and becomes visible to all players, the original card with the Life Point cost can no longer activate and would fizzle, since&nbsp;<em>Anathema</em>&nbsp;successfully prevented Life Points from changing outside of direct creature attacks;<br><br>■&nbsp;<em>Anathema&nbsp;</em>is considered both a creature and a symmetry, so it can be searched out by cards like&nbsp;<em>Sign of the Crow&nbsp;</em><em>or targeted by&nbsp;</em><em>Chronological Relapse;<br><br>■</em>&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong>&nbsp;When attacking with&nbsp;<em>Ethereal Aurorialis</em>&nbsp;and&nbsp;<em>Anathema</em>&nbsp;is revealed by its Ability,&nbsp;<em>Ethereal Aurorialis</em>&nbsp;attacks both yours and your opponent\'s Life Points at once due to&nbsp;<em>Anathema</em>&nbsp;being both a creature and a symmetry;<em><br></em></p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Anathema-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_382',
    s3_large_image_name:
      'MzgyLS0tUmFyZS1Ta2VjdGgtQW5nZWxpYy1BcHBhcml0aW9uLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzgyLS0tUmFyZS1Ta2VjdGgtQW5nZWxpYy1BcHBhcml0aW9uLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzgyLS0tUmFyZS1Ta2VjdGgtQW5nZWxpYy1BcHBhcml0aW9uLTRDUC5wbmcEXODUS/t',
    name: 'Angelic Apparition',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Angelic-Apparition-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_417',
    s3_large_image_name:
      'NDE3LS0tUmFyZS1BbmdlbGljLUFwcGFyaXRpb24tRXh0ZW5kZWQtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDE3LS0tUmFyZS1BbmdlbGljLUFwcGFyaXRpb24tRXh0ZW5kZWQtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDE3LS0tUmFyZS1BbmdlbGljLUFwcGFyaXRpb24tRXh0ZW5kZWQtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Angelic Apparition',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Angelic-Apparition-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_418',
    s3_large_image_name:
      'NDE4LS0tUHJvbW8tUmFyZS1BbmdlbGljLUFwcGFyaXRpb24tRXh0ZW5kZWQtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDE4LS0tUHJvbW8tUmFyZS1BbmdlbGljLUFwcGFyaXRpb24tRXh0ZW5kZWQtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDE4LS0tUHJvbW8tUmFyZS1BbmdlbGljLUFwcGFyaXRpb24tRXh0ZW5kZWQtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Angelic Apparition',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Angelic-Apparition-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_21',
    s3_large_image_name:
      'MjEtLS0xc3QtZWQtYW5nZWxpYy1hcHBhcml0aW9uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjEtLS0xc3QtZWQtYW5nZWxpYy1hcHBhcml0aW9uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjEtLS0xc3QtZWQtYW5nZWxpYy1hcHBhcml0aW9uLnBuZwEXODUSEXODUS/t',
    name: 'Angelic Apparition',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Angelic-Apparition-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_97',
    s3_large_image_name:
      'OTctLS1VbmNvbW1vbi1BbmdlbGljLUFwcGFyaXRpb24tNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OTctLS1VbmNvbW1vbi1BbmdlbGljLUFwcGFyaXRpb24tNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OTctLS1VbmNvbW1vbi1BbmdlbGljLUFwcGFyaXRpb24tNENQLnBuZwEXODUSEXODUS/t',
    name: 'Angelic Apparition',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Angelic-Apparition-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_59',
    s3_large_image_name:
      'NTktLS0ybmQtZWQtYW5nZWxpYy1hcHBhcml0aW9uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTktLS0ybmQtZWQtYW5nZWxpYy1hcHBhcml0aW9uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTktLS0ybmQtZWQtYW5nZWxpYy1hcHBhcml0aW9uLnBuZwEXODUSEXODUS/t',
    name: 'Angelic Apparition',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Angelic-Apparition-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_138',
    s3_large_image_name: 'MTM4LS0tMS1BbmdlbGljLUFwcGFyaXRpb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTM4LS0tMS1BbmdlbGljLUFwcGFyaXRpb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTM4LS0tMS1BbmdlbGljLUFwcGFyaXRpb24ucG5n/t',
    name: 'Angelic Apparition',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Angelic-Apparition-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_663',
    s3_large_image_name: 'NjYzLS0tbGUtYXJjaGl2aXN0LW1hdmVuLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjYzLS0tbGUtYXJjaGl2aXN0LW1hdmVuLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjYzLS0tbGUtYXJjaGl2aXN0LW1hdmVuLnBuZwEXODUSEXODUS/t',
    name: 'Archivist Maven',
    set_name: 'Threshold of Time',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Drifter'],
    artist: 'J.L.Lockwood',
    effect:
      'Once per turn, you may move 1 energy in play somewhere else on the same side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Archivist-Maven-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_371',
    s3_large_image_name:
      'MzcxLS0tQXN0ZXJvaWQtRHJhZ29uLVNrZXRjaC1DYXJkLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzcxLS0tQXN0ZXJvaWQtRHJhZ29uLVNrZXRjaC1DYXJkLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzcxLS0tQXN0ZXJvaWQtRHJhZ29uLVNrZXRjaC1DYXJkLnBuZwEXODUSEXODUS/t',
    name: 'Asteroid Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Hailfire'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Asteroid-Dragon-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_1',
    s3_large_image_name: 'MS0tLTFzdC1lZC1hc3Rlcm9pZC1kcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MS0tLTFzdC1lZC1hc3Rlcm9pZC1kcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MS0tLTFzdC1lZC1hc3Rlcm9pZC1kcmFnb24ucG5n/t',
    name: 'Asteroid Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Hailfire'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Asteroid-Dragon-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_77',
    s3_large_image_name:
      'NzctLS1VbmNvbW1vbi1Bc3Rlcm9pZC1EcmFnb24tNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NzctLS1VbmNvbW1vbi1Bc3Rlcm9pZC1EcmFnb24tNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NzctLS1VbmNvbW1vbi1Bc3Rlcm9pZC1EcmFnb24tNENQLnBuZwEXODUSEXODUS/t',
    name: 'Asteroid Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Hailfire'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Asteroid-Dragon-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_39',
    s3_large_image_name:
      'MzktLS0ybmQtZWQtYXN0ZXJvaWQtZHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzktLS0ybmQtZWQtYXN0ZXJvaWQtZHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzktLS0ybmQtZWQtYXN0ZXJvaWQtZHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Asteroid Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Hailfire'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Asteroid-Dragon-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_118',
    s3_large_image_name: 'MTE4LS0tMTQtQXN0ZXJvaWQtRHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTE4LS0tMTQtQXN0ZXJvaWQtRHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTE4LS0tMTQtQXN0ZXJvaWQtRHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Asteroid Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Hailfire'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Asteroid-Dragon-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_22',
    s3_large_image_name:
      'MjItLS0xc3QtZWQtYXRtb3NwaGVyaWMtc3RyaWtlci5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjItLS0xc3QtZWQtYXRtb3NwaGVyaWMtc3RyaWtlci5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjItLS0xc3QtZWQtYXRtb3NwaGVyaWMtc3RyaWtlci5wbmcEXODUS/t',
    name: 'Atmospheric Striker',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Atmospheric-Striker-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_98',
    s3_large_image_name: 'OTgtLS1Db21tb24tQXRtb3NwaGVyaWMtU3RyaWtlci00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OTgtLS1Db21tb24tQXRtb3NwaGVyaWMtU3RyaWtlci00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OTgtLS1Db21tb24tQXRtb3NwaGVyaWMtU3RyaWtlci00Q1AucG5n/t',
    name: 'Atmospheric Striker',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Atmospheric-Striker-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_60',
    s3_large_image_name:
      'NjAtLS0ybmQtZWQtYXRtb3NwaGVyaWMtc3RyaWtlci5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjAtLS0ybmQtZWQtYXRtb3NwaGVyaWMtc3RyaWtlci5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjAtLS0ybmQtZWQtYXRtb3NwaGVyaWMtc3RyaWtlci5wbmcEXODUS/t',
    name: 'Atmospheric Striker',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Atmospheric-Striker-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_139',
    s3_large_image_name:
      'MTM5LS0tMi1BdG1vc3BoZXJpYy1TdHJpa2VyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTM5LS0tMi1BdG1vc3BoZXJpYy1TdHJpa2VyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTM5LS0tMi1BdG1vc3BoZXJpYy1TdHJpa2VyLnBuZwEXODUSEXODUS/t',
    name: 'Atmospheric Striker',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Atmospheric-Striker-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_386',
    s3_large_image_name:
      'Mzg2LS0tUmFyZS1Ta2V0Y2gtQXRtb3NwaGVyaWMtU3RyaWtlci00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg2LS0tUmFyZS1Ta2V0Y2gtQXRtb3NwaGVyaWMtU3RyaWtlci00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg2LS0tUmFyZS1Ta2V0Y2gtQXRtb3NwaGVyaWMtU3RyaWtlci00Q1AucG5n/t',
    name: 'Atmospheric Striker',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Atmospheric-Striker-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_407',
    s3_large_image_name:
      'NDA3LS0tR1QtYmF0dGxlc2hpcC1waGlsaXN0aWEtc2tldGNoLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDA3LS0tR1QtYmF0dGxlc2hpcC1waGlsaXN0aWEtc2tldGNoLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDA3LS0tR1QtYmF0dGxlc2hpcC1waGlsaXN0aWEtc2tldGNoLmpwZwEXODUSEXODUS/t',
    name: 'Battleship Philistia',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Leviathan', 'Machine'],
    creature_type_count: 2,
    artist: 'COCOs',
    effect:
      'As long as this creature is on the field, whenever one of your Common Dragons or Angels destroys an opponent\'s creature, send 1 energy on their field back to their hand. This Ability can only be used once per turn, regardless if you control another "Battleship Philistia".',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Battleship-Philistia-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_2',
    s3_large_image_name: 'Mi0tLTFzdC1lZC1iZWRyYWdvdGgucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mi0tLTFzdC1lZC1iZWRyYWdvdGgucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mi0tLTFzdC1lZC1iZWRyYWdvdGgucG5n/t',
    name: 'Bedragoth',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Behemoth'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Bedragoth-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_78',
    s3_large_image_name:
      'NzgtLS1VbmNvbW1vbi1CZWRyYWdvdGgtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NzgtLS1VbmNvbW1vbi1CZWRyYWdvdGgtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NzgtLS1VbmNvbW1vbi1CZWRyYWdvdGgtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Bedragoth',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Behemoth'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Bedragoth-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_40',
    s3_large_image_name: 'NDAtLS0ybmQtZWQtYmVkcmFnb3RoLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDAtLS0ybmQtZWQtYmVkcmFnb3RoLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDAtLS0ybmQtZWQtYmVkcmFnb3RoLnBuZwEXODUSEXODUS/t',
    name: 'Bedragoth',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Behemoth'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Bedragoth-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_119',
    s3_large_image_name: 'MTE5LS0tMTUtQmVkcmFnb3RoLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTE5LS0tMTUtQmVkcmFnb3RoLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTE5LS0tMTUtQmVkcmFnb3RoLnBuZwEXODUSEXODUS/t',
    name: 'Bedragoth',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Behemoth'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Bedragoth-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_375',
    s3_large_image_name:
      'Mzc1LS0tUmFyZS1Ta2V0Y2gtQmVkcmFnb3RoLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc1LS0tUmFyZS1Ta2V0Y2gtQmVkcmFnb3RoLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc1LS0tUmFyZS1Ta2V0Y2gtQmVkcmFnb3RoLTRDUC5wbmcEXODUS/t',
    name: 'Bedragoth',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Behemoth'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Bedragoth-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_23',
    s3_large_image_name:
      'MjMtLS0xc3QtZWQtYmVuZXZvbGVudC1zZXJhcGhpbS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjMtLS0xc3QtZWQtYmVuZXZvbGVudC1zZXJhcGhpbS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjMtLS0xc3QtZWQtYmVuZXZvbGVudC1zZXJhcGhpbS5wbmcEXODUS/t',
    name: 'Benevolent Seraphim',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Benevolent-Seraphim-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_99',
    s3_large_image_name:
      'OTktLS1Db21tb24tQmVuZXZvbGVudC1TZXJhcGhpbWwtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OTktLS1Db21tb24tQmVuZXZvbGVudC1TZXJhcGhpbWwtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OTktLS1Db21tb24tQmVuZXZvbGVudC1TZXJhcGhpbWwtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Benevolent Seraphim',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Benevolent-Seraphim-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_61',
    s3_large_image_name:
      'NjEtLS0ybmQtZWQtYmVuZXZvbGVudC1zZXJhcGhpbS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjEtLS0ybmQtZWQtYmVuZXZvbGVudC1zZXJhcGhpbS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjEtLS0ybmQtZWQtYmVuZXZvbGVudC1zZXJhcGhpbS5wbmcEXODUS/t',
    name: 'Benevolent Seraphim',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Benevolent-Seraphim-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_140',
    s3_large_image_name:
      'MTQwLS0tMy1CZW5ldm9sZW50LVNlcmFwaGltLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQwLS0tMy1CZW5ldm9sZW50LVNlcmFwaGltLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQwLS0tMy1CZW5ldm9sZW50LVNlcmFwaGltLnBuZwEXODUSEXODUS/t',
    name: 'Benevolent Seraphim',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Benevolent-Seraphim-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_387',
    s3_large_image_name: 'Mzg3LS0tQmVuZXZvbGVudC1TZXJhcGhpbS1Ta2V0Y2guanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg3LS0tQmVuZXZvbGVudC1TZXJhcGhpbS1Ta2V0Y2guanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg3LS0tQmVuZXZvbGVudC1TZXJhcGhpbS1Ta2V0Y2guanBn/t',
    name: 'Benevolent Seraphim',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Benevolent-Seraphim-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_34',
    s3_large_image_name: 'MzQtLS0xc3QtZWQtYmxlc3NpbmcucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzQtLS0xc3QtZWQtYmxlc3NpbmcucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzQtLS0xc3QtZWQtYmxlc3NpbmcucG5n/t',
    name: 'Blessing',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and add it to any creature in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Blessing-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_110',
    s3_large_image_name: 'MTEwLS0tQ29tbW9uLUJsZXNzaW5nLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTEwLS0tQ29tbW9uLUJsZXNzaW5nLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTEwLS0tQ29tbW9uLUJsZXNzaW5nLTRDUC5wbmcEXODUS/t',
    name: 'Blessing',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and add it to any creature in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Blessing-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_72',
    s3_large_image_name: 'NzItLS0ybmQtZWQtYmxlc3NpbmcucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NzItLS0ybmQtZWQtYmxlc3NpbmcucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NzItLS0ybmQtZWQtYmxlc3NpbmcucG5n/t',
    name: 'Blessing',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and add it to any creature in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Blessing-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_151',
    s3_large_image_name: 'MTUxLS0tMjctQmxlc3NpbmcuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTUxLS0tMjctQmxlc3NpbmcuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTUxLS0tMjctQmxlc3NpbmcuanBn/t',
    name: 'Blessing',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and add it to any creature in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Blessing-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_410',
    s3_large_image_name:
      'NDEwLS0tQmxvc3NvbWJhcmstR2FwZXItU2tldGNoLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDEwLS0tQmxvc3NvbWJhcmstR2FwZXItU2tldGNoLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDEwLS0tQmxvc3NvbWJhcmstR2FwZXItU2tldGNoLnBuZwEXODUSEXODUS/t',
    name: 'Blossombark Gaper',
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Nivea Toliver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Blossombark-Gaper-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_270',
    s3_large_image_name: 'MjcwLS0tQ0YtYnJpbGxpYW50LWJyaWdodHZlaWwucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjcwLS0tQ0YtYnJpbGxpYW50LWJyaWdodHZlaWwucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjcwLS0tQ0YtYnJpbGxpYW50LWJyaWdodHZlaWwucG5n/t',
    name: 'Brilliant Brightveil',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Hoang Tran',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Brilliant-Brightveil-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_372',
    s3_large_image_name:
      'MzcyLS0tUmFyZS1Ta2V0Y2gtQ2FsYW1pdHktRHJhZ29uLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzcyLS0tUmFyZS1Ta2V0Y2gtQ2FsYW1pdHktRHJhZ29uLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzcyLS0tUmFyZS1Ta2V0Y2gtQ2FsYW1pdHktRHJhZ29uLTRDUC5wbmcEXODUS/t',
    name: 'Calamity Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Calamity-Dragon-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_3',
    s3_large_image_name: 'My0tLTFzdC1lZC1jYWxhbWl0eS1kcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/My0tLTFzdC1lZC1jYWxhbWl0eS1kcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/My0tLTFzdC1lZC1jYWxhbWl0eS1kcmFnb24ucG5n/t',
    name: 'Calamity Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Calamity-Dragon-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_79',
    s3_large_image_name:
      'NzktLS1VbmNvbW1vbi1DYWxhbWl0eS1EcmFnb24tNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NzktLS1VbmNvbW1vbi1DYWxhbWl0eS1EcmFnb24tNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NzktLS1VbmNvbW1vbi1DYWxhbWl0eS1EcmFnb24tNENQLnBuZwEXODUSEXODUS/t',
    name: 'Calamity Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Calamity-Dragon-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_41',
    s3_large_image_name:
      'NDEtLS0ybmQtZWQtY2FsYW1pdHktZHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDEtLS0ybmQtZWQtY2FsYW1pdHktZHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDEtLS0ybmQtZWQtY2FsYW1pdHktZHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Calamity Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Calamity-Dragon-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_120',
    s3_large_image_name: 'MTIwLS0tMTYtQ2FsYW1pdHktRHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTIwLS0tMTYtQ2FsYW1pdHktRHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTIwLS0tMTYtQ2FsYW1pdHktRHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Calamity Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Calamity-Dragon-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_664',
    s3_large_image_name:
      'NjY0LS0tbGUtY2FyY2VyeS10aGUtdHdpc3RlZC10cmVlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjY0LS0tbGUtY2FyY2VyeS10aGUtdHdpc3RlZC10cmVlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjY0LS0tbGUtY2FyY2VyeS10aGUtdHdpc3RlZC10cmVlLnBuZwEXODUSEXODUS/t',
    name: 'Carcery the Twisted Tree',
    set_name: 'Threshold of Time',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect:
      'While this creature is in play, all of your energy in play is twisted. (When twisted energy would leave play, you may pay 1 Life Point to keep it in play instead.)',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Carcery-the-Twisted-Tree-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_265',
    s3_large_image_name:
      'MjY1LS0tQ0YtQ2FydGVyLWNoYW1waW9uLW9mLWNhcmRzbWl0aGluZy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjY1LS0tQ0YtQ2FydGVyLWNoYW1waW9uLW9mLWNhcmRzbWl0aGluZy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjY1LS0tQ0YtQ2FydGVyLWNoYW1waW9uLW9mLWNhcmRzbWl0aGluZy5wbmcEXODUS/t',
    name: 'Carter, Champion of Cardsmithing',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'B.A. Miller',
    effect:
      'Pay 1 Life Point. Each player may select 1 card from their graveyard and add it to their hand.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Carter--Champion-of-Cardsmithing-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_14',
    s3_large_image_name: 'MTQtLS0xc3QtZWQtY2F0YWNseXNtLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQtLS0xc3QtZWQtY2F0YWNseXNtLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQtLS0xc3QtZWQtY2F0YWNseXNtLnBuZwEXODUSEXODUS/t',
    name: 'Cataclysm',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Select one energy from a creature or pile on your opponent's side of the field and have them discard that energy card.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cataclysm-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_90',
    s3_large_image_name: 'OTAtLS1Db21tb24tQ2F0YWNseXNtLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OTAtLS1Db21tb24tQ2F0YWNseXNtLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OTAtLS1Db21tb24tQ2F0YWNseXNtLTRDUC5wbmcEXODUS/t',
    name: 'Cataclysm',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Select one energy from a creature or pile on your opponent's side of the field and have them discard that energy card.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cataclysm-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_52',
    s3_large_image_name: 'NTItLS0ybmQtZWQtY2F0YWNseXNtLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTItLS0ybmQtZWQtY2F0YWNseXNtLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTItLS0ybmQtZWQtY2F0YWNseXNtLnBuZwEXODUSEXODUS/t',
    name: 'Cataclysm',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Select one energy from a creature or pile on your opponent's side of the field and have them discard that energy card.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cataclysm-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_131',
    s3_large_image_name: 'MTMxLS0tMzQtQ2F0YWNseXNtLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTMxLS0tMzQtQ2F0YWNseXNtLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTMxLS0tMzQtQ2F0YWNseXNtLmpwZwEXODUSEXODUS/t',
    name: 'Cataclysm',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Select one energy from a creature or pile on your opponent's side of the field and have them discard that energy card.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cataclysm-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_426',
    s3_large_image_name:
      'NDI2LS0tUHJvbW8tUmFyZS1DYXRhY2x5c20tRXh0ZW5kZWQtQXJ0LUV4b2R1cy1DYXJkLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDI2LS0tUHJvbW8tUmFyZS1DYXRhY2x5c20tRXh0ZW5kZWQtQXJ0LUV4b2R1cy1DYXJkLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDI2LS0tUHJvbW8tUmFyZS1DYXRhY2x5c20tRXh0ZW5kZWQtQXJ0LUV4b2R1cy1DYXJkLnBuZwEXODUSEXODUS/t',
    name: 'Cataclysm',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Select one energy from a creature or pile on your opponent's side of the field and have them discard that energy card.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cataclysm-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_24',
    s3_large_image_name: 'MjQtLS0xc3QtZWQtY2VsZXN0aWFsLXN0YXJjYXN0ZXIucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjQtLS0xc3QtZWQtY2VsZXN0aWFsLXN0YXJjYXN0ZXIucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjQtLS0xc3QtZWQtY2VsZXN0aWFsLXN0YXJjYXN0ZXIucG5n/t',
    name: 'Celestial Starcaster',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Celestial-Starcaster-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_100',
    s3_large_image_name:
      'MTAwLS0tQ29tbW9uLUNlbGVzdGlhbC1TdGFyY2FzdGVyLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTAwLS0tQ29tbW9uLUNlbGVzdGlhbC1TdGFyY2FzdGVyLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTAwLS0tQ29tbW9uLUNlbGVzdGlhbC1TdGFyY2FzdGVyLTRDUC5wbmcEXODUS/t',
    name: 'Celestial Starcaster',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Celestial-Starcaster-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_62',
    s3_large_image_name: 'NjItLS0ybmQtZWQtY2VsZXN0aWFsLXN0YXJjYXN0ZXIucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjItLS0ybmQtZWQtY2VsZXN0aWFsLXN0YXJjYXN0ZXIucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjItLS0ybmQtZWQtY2VsZXN0aWFsLXN0YXJjYXN0ZXIucG5n/t',
    name: 'Celestial Starcaster',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Celestial-Starcaster-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_141',
    s3_large_image_name: 'MTQxLS0tNC1DZWxlc3RpYWwtU3RhcmNhc3Rlci5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQxLS0tNC1DZWxlc3RpYWwtU3RhcmNhc3Rlci5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQxLS0tNC1DZWxlc3RpYWwtU3RhcmNhc3Rlci5wbmcEXODUS/t',
    name: 'Celestial Starcaster',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Celestial-Starcaster-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_388',
    s3_large_image_name:
      'Mzg4LS0tUmFyZS1Ta2V0Y2gtQ2VsZXN0aWFsLVN0YXJjYXN0ZXItNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg4LS0tUmFyZS1Ta2V0Y2gtQ2VsZXN0aWFsLVN0YXJjYXN0ZXItNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg4LS0tUmFyZS1Ta2V0Y2gtQ2VsZXN0aWFsLVN0YXJjYXN0ZXItNENQLnBuZwEXODUSEXODUS/t',
    name: 'Celestial Starcaster',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Celestial-Starcaster-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_424',
    s3_large_image_name:
      'NDI0LS0tUHJvbW8tUmFyZS1DZXJ1bGVhbi1TdG9ybXN0cmVhbS1EcmFnb25fUHJvbW9fQ2FyZC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDI0LS0tUHJvbW8tUmFyZS1DZXJ1bGVhbi1TdG9ybXN0cmVhbS1EcmFnb25fUHJvbW9fQ2FyZC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDI0LS0tUHJvbW8tUmFyZS1DZXJ1bGVhbi1TdG9ybXN0cmVhbS1EcmFnb25fUHJvbW9fQ2FyZC5wbmcEXODUS/t',
    name: 'Cerulean Stormstream Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Wes',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cerulean-Stormstream-Dragon-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_15',
    s3_large_image_name: 'MTUtLS0xc3QtZWQtY2hhaW5zLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTUtLS0xc3QtZWQtY2hhaW5zLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTUtLS0xc3QtZWQtY2hhaW5zLnBuZwEXODUSEXODUS/t',
    name: 'Chains',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "When this card is played, it remains on the field until its effect has occurred. If this card is played on your turn, your opponent cannot attack during their next turn. If this card is played on your opponent's turn, they cannot attack during that turn. ",
    ruling:
      "<p>■&nbsp;<em>Chains</em><strong>&nbsp;affects the player</strong>&nbsp;and&nbsp;<strong>does not target the creatures themselves</strong>;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: Even if a player is 'chained', he or she still cannot attack with a&nbsp;<em>Lantern Leaflore</em>&nbsp;(even though&nbsp;<em>Leaflore</em>&nbsp;is unaffected by symmetry cards) because the player is unable to command the creature to execute the attack;</p>\n<p>■&nbsp;<em>Chains&nbsp;</em>only stops a player from attacking for&nbsp;<u>that</u>&nbsp;turn;</p>\n<p>&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;-&nbsp;Due to the wording \"...it remains on the field until its effect has occurred\",<strong>&nbsp;this card is considered to be resolved and goes to the graveyard</strong>&nbsp;<strong>after the chained player is done with their Attack Phase</strong>&nbsp;(upon entering End Phase);</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: If&nbsp;<em>Chains&nbsp;</em>is played in response to your opponent's&nbsp;<em>Vortex</em>&nbsp;that's currently unfreezing at the end of their turn,&nbsp;<em>Chains&nbsp;</em>will be considered already resolved (since your opponent has already finished their Attack Phase for that turn), and will go the graveyard;</p>\n<p>&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;■&nbsp;Due to the wording \"If this card is played on your opponent's turn, they cannot attack during that turn\", the effect is considered resolved upon the End Phase regardless of whether or not the player attacked that turn;&nbsp;</p>",
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Chains-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_91',
    s3_large_image_name: 'OTEtLS1Db21tb24tQ2hhaW5zLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OTEtLS1Db21tb24tQ2hhaW5zLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OTEtLS1Db21tb24tQ2hhaW5zLTRDUC5wbmcEXODUS/t',
    name: 'Chains',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "When this card is played, it remains on the field until its effect has occurred. If this card is played on your turn, your opponent cannot attack during their next turn. If this card is played on your opponent's turn, they cannot attack during that turn. ",
    ruling:
      "<p>■&nbsp;<em>Chains</em><strong>&nbsp;affects the player</strong>&nbsp;and&nbsp;<strong>does not target the creatures themselves</strong>;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: Even if a player is 'chained', he or she still cannot attack with a&nbsp;<em>Lantern Leaflore</em>&nbsp;(even though&nbsp;<em>Leaflore</em>&nbsp;is unaffected by symmetry cards) because the player is unable to command the creature to execute the attack;</p>\n<p>■&nbsp;<em>Chains&nbsp;</em>only stops a player from attacking for&nbsp;<u>that</u>&nbsp;turn;</p>\n<p>&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;-&nbsp;Due to the wording \"...it remains on the field until its effect has occurred\",<strong>&nbsp;this card is considered to be resolved and goes to the graveyard</strong>&nbsp;<strong>after the chained player is done with their Attack Phase</strong>&nbsp;(upon entering End Phase);</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: If&nbsp;<em>Chains&nbsp;</em>is played in response to your opponent's&nbsp;<em>Vortex</em>&nbsp;that's currently unfreezing at the end of their turn,&nbsp;<em>Chains&nbsp;</em>will be considered already resolved (since your opponent has already finished their Attack Phase for that turn), and will go the graveyard;</p>\n<p>&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;■&nbsp;Due to the wording \"If this card is played on your opponent's turn, they cannot attack during that turn\", the effect is considered resolved upon the End Phase regardless of whether or not the player attacked that turn;&nbsp;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chains-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_111',
    s3_large_image_name: 'MTExLS0tQ29tbW9uLUNoYWluczItNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTExLS0tQ29tbW9uLUNoYWluczItNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTExLS0tQ29tbW9uLUNoYWluczItNENQLnBuZwEXODUSEXODUS/t',
    name: 'Chains',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "When this card is played, it remains on the field until its effect has occurred. If this card is played on your turn, your opponent cannot attack during their next turn. If this card is played on your opponent's turn, they cannot attack during that turn. ",
    ruling:
      "<p>■&nbsp;<em>Chains</em><strong>&nbsp;affects the player</strong>&nbsp;and&nbsp;<strong>does not target the creatures themselves</strong>;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: Even if a player is 'chained', he or she still cannot attack with a&nbsp;<em>Lantern Leaflore</em>&nbsp;(even though&nbsp;<em>Leaflore</em>&nbsp;is unaffected by symmetry cards) because the player is unable to command the creature to execute the attack;</p>\n<p>■&nbsp;<em>Chains&nbsp;</em>only stops a player from attacking for&nbsp;<u>that</u>&nbsp;turn;</p>\n<p>&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;-&nbsp;Due to the wording \"...it remains on the field until its effect has occurred\",<strong>&nbsp;this card is considered to be resolved and goes to the graveyard</strong>&nbsp;<strong>after the chained player is done with their Attack Phase</strong>&nbsp;(upon entering End Phase);</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: If&nbsp;<em>Chains&nbsp;</em>is played in response to your opponent's&nbsp;<em>Vortex</em>&nbsp;that's currently unfreezing at the end of their turn,&nbsp;<em>Chains&nbsp;</em>will be considered already resolved (since your opponent has already finished their Attack Phase for that turn), and will go the graveyard;</p>\n<p>&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;■&nbsp;Due to the wording \"If this card is played on your opponent's turn, they cannot attack during that turn\", the effect is considered resolved upon the End Phase regardless of whether or not the player attacked that turn;&nbsp;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chains-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_53',
    s3_large_image_name: 'NTMtLS0ybmQtZWQtY2hhaW5zLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTMtLS0ybmQtZWQtY2hhaW5zLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTMtLS0ybmQtZWQtY2hhaW5zLnBuZwEXODUSEXODUS/t',
    name: 'Chains',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "When this card is played, it remains on the field until its effect has occurred. If this card is played on your turn, your opponent cannot attack during their next turn. If this card is played on your opponent's turn, they cannot attack during that turn. ",
    ruling:
      "<p>■&nbsp;<em>Chains</em><strong>&nbsp;affects the player</strong>&nbsp;and&nbsp;<strong>does not target the creatures themselves</strong>;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: Even if a player is 'chained', he or she still cannot attack with a&nbsp;<em>Lantern Leaflore</em>&nbsp;(even though&nbsp;<em>Leaflore</em>&nbsp;is unaffected by symmetry cards) because the player is unable to command the creature to execute the attack;</p>\n<p>■&nbsp;<em>Chains&nbsp;</em>only stops a player from attacking for&nbsp;<u>that</u>&nbsp;turn;</p>\n<p>&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;-&nbsp;Due to the wording \"...it remains on the field until its effect has occurred\",<strong>&nbsp;this card is considered to be resolved and goes to the graveyard</strong>&nbsp;<strong>after the chained player is done with their Attack Phase</strong>&nbsp;(upon entering End Phase);</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: If&nbsp;<em>Chains&nbsp;</em>is played in response to your opponent's&nbsp;<em>Vortex</em>&nbsp;that's currently unfreezing at the end of their turn,&nbsp;<em>Chains&nbsp;</em>will be considered already resolved (since your opponent has already finished their Attack Phase for that turn), and will go the graveyard;</p>\n<p>&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;■&nbsp;Due to the wording \"If this card is played on your opponent's turn, they cannot attack during that turn\", the effect is considered resolved upon the End Phase regardless of whether or not the player attacked that turn;&nbsp;</p>",
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Chains-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_132',
    s3_large_image_name: 'MTMyLS0tMzUtQ2hhaW5zX2RyYWdvbmlzLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTMyLS0tMzUtQ2hhaW5zX2RyYWdvbmlzLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTMyLS0tMzUtQ2hhaW5zX2RyYWdvbmlzLmpwZwEXODUSEXODUS/t',
    name: 'Chains',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "When this card is played, it remains on the field until its effect has occurred. If this card is played on your turn, your opponent cannot attack during their next turn. If this card is played on your opponent's turn, they cannot attack during that turn. ",
    ruling:
      "<p>■&nbsp;<em>Chains</em><strong>&nbsp;affects the player</strong>&nbsp;and&nbsp;<strong>does not target the creatures themselves</strong>;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: Even if a player is 'chained', he or she still cannot attack with a&nbsp;<em>Lantern Leaflore</em>&nbsp;(even though&nbsp;<em>Leaflore</em>&nbsp;is unaffected by symmetry cards) because the player is unable to command the creature to execute the attack;</p>\n<p>■&nbsp;<em>Chains&nbsp;</em>only stops a player from attacking for&nbsp;<u>that</u>&nbsp;turn;</p>\n<p>&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;-&nbsp;Due to the wording \"...it remains on the field until its effect has occurred\",<strong>&nbsp;this card is considered to be resolved and goes to the graveyard</strong>&nbsp;<strong>after the chained player is done with their Attack Phase</strong>&nbsp;(upon entering End Phase);</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: If&nbsp;<em>Chains&nbsp;</em>is played in response to your opponent's&nbsp;<em>Vortex</em>&nbsp;that's currently unfreezing at the end of their turn,&nbsp;<em>Chains&nbsp;</em>will be considered already resolved (since your opponent has already finished their Attack Phase for that turn), and will go the graveyard;</p>\n<p>&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;■&nbsp;Due to the wording \"If this card is played on your opponent's turn, they cannot attack during that turn\", the effect is considered resolved upon the End Phase regardless of whether or not the player attacked that turn;&nbsp;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chains-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_152',
    s3_large_image_name: 'MTUyLS0tMjgtQ2hhaW5zX3NreWJvcm4uanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTUyLS0tMjgtQ2hhaW5zX3NreWJvcm4uanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTUyLS0tMjgtQ2hhaW5zX3NreWJvcm4uanBn/t',
    name: 'Chains',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "When this card is played, it remains on the field until its effect has occurred. If this card is played on your turn, your opponent cannot attack during their next turn. If this card is played on your opponent's turn, they cannot attack during that turn. ",
    ruling:
      "<p>■&nbsp;<em>Chains</em><strong>&nbsp;affects the player</strong>&nbsp;and&nbsp;<strong>does not target the creatures themselves</strong>;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: Even if a player is 'chained', he or she still cannot attack with a&nbsp;<em>Lantern Leaflore</em>&nbsp;(even though&nbsp;<em>Leaflore</em>&nbsp;is unaffected by symmetry cards) because the player is unable to command the creature to execute the attack;</p>\n<p>■&nbsp;<em>Chains&nbsp;</em>only stops a player from attacking for&nbsp;<u>that</u>&nbsp;turn;</p>\n<p>&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;-&nbsp;Due to the wording \"...it remains on the field until its effect has occurred\",<strong>&nbsp;this card is considered to be resolved and goes to the graveyard</strong>&nbsp;<strong>after the chained player is done with their Attack Phase</strong>&nbsp;(upon entering End Phase);</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: If&nbsp;<em>Chains&nbsp;</em>is played in response to your opponent's&nbsp;<em>Vortex</em>&nbsp;that's currently unfreezing at the end of their turn,&nbsp;<em>Chains&nbsp;</em>will be considered already resolved (since your opponent has already finished their Attack Phase for that turn), and will go the graveyard;</p>\n<p>&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;■&nbsp;Due to the wording \"If this card is played on your opponent's turn, they cannot attack during that turn\", the effect is considered resolved upon the End Phase regardless of whether or not the player attacked that turn;&nbsp;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chains-Unlimited',
    is_default_edition: false,
  },
  {
    card_id: 'card_411',
    s3_large_image_name: 'NDExLS0tQ2hhb3MtQnVsbC1Ta2V0Y2gucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDExLS0tQ2hhb3MtQnVsbC1Ta2V0Y2gucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDExLS0tQ2hhb3MtQnVsbC1Ta2V0Y2gucG5n/t',
    name: 'Chaos Bull',
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Shardfolk', 'Bull'],
    creature_type_count: 2,
    artist: 'Pradipta Candra',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Chaos-Bull-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_4',
    s3_large_image_name: 'NC0tLTFzdC1lZC1jbG9jay1kcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NC0tLTFzdC1lZC1jbG9jay1kcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NC0tLTFzdC1lZC1jbG9jay1kcmFnb24ucG5n/t',
    name: 'Clock Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Machine'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Clock-Dragon-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_80',
    s3_large_image_name: 'ODAtLS1Db21tb24tQ2xvY2stRHJhZ29uLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/ODAtLS1Db21tb24tQ2xvY2stRHJhZ29uLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/ODAtLS1Db21tb24tQ2xvY2stRHJhZ29uLTRDUC5wbmcEXODUS/t',
    name: 'Clock Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Machine'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Clock-Dragon-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_42',
    s3_large_image_name: 'NDItLS0ybmQtZWQtY2xvY2stZHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDItLS0ybmQtZWQtY2xvY2stZHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDItLS0ybmQtZWQtY2xvY2stZHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Clock Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Machine'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Clock-Dragon-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_121',
    s3_large_image_name: 'MTIxLS0tMTctQ2xvY2stRHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTIxLS0tMTctQ2xvY2stRHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTIxLS0tMTctQ2xvY2stRHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Clock Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Machine'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Clock-Dragon-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_376',
    s3_large_image_name:
      'Mzc2LS0tUmFyZS1Ta2V0Y2gtQ2xvY2stRHJhZ29uLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc2LS0tUmFyZS1Ta2V0Y2gtQ2xvY2stRHJhZ29uLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc2LS0tUmFyZS1Ta2V0Y2gtQ2xvY2stRHJhZ29uLTRDUC5wbmcEXODUS/t',
    name: 'Clock Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Machine'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Clock-Dragon-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_427',
    s3_large_image_name:
      'NDI3LS0tUHJvbW8tUmFyZS1DbG91ZGJ1cnN0LVNwaXJhbC1FeG9kdXMtQ2FyZC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDI3LS0tUHJvbW8tUmFyZS1DbG91ZGJ1cnN0LVNwaXJhbC1FeG9kdXMtQ2FyZC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDI3LS0tUHJvbW8tUmFyZS1DbG91ZGJ1cnN0LVNwaXJhbC1FeG9kdXMtQ2FyZC5wbmcEXODUS/t',
    name: 'Cloudburst Spiral',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Charlo Nocete',
    effect: 'You and your opponent each discard 1 card from hand.',
    ruling:
      '<p>■&nbsp;You do not need to have another card in your hand to discard in order to play<em>&nbsp;Cloudburst Spiral;</em></p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Cloudburst-Spiral-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_395',
    s3_large_image_name:
      'Mzk1LS0tUmFyZS1Ta2V0Y2gtQ29uY2VydG8tVmlydHVvc28tNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk1LS0tUmFyZS1Ta2V0Y2gtQ29uY2VydG8tVmlydHVvc28tNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk1LS0tUmFyZS1Ta2V0Y2gtQ29uY2VydG8tVmlydHVvc28tNENQLnBuZwEXODUSEXODUS/t',
    name: 'Concerto Virtuoso',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'COCOs',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Concerto-Virtuoso-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_445',
    s3_large_image_name:
      'NDQ1LS0tQ29ucXVlcmVkLUxhbmRzY2FwZS1Qcm9tby5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ1LS0tQ29ucXVlcmVkLUxhbmRzY2FwZS1Qcm9tby5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ1LS0tQ29ucXVlcmVkLUxhbmRzY2FwZS1Qcm9tby5wbmcEXODUS/t',
    name: 'Conquered Landscape',
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'J.L.Lockwood',
    effect:
      "When this card is played, it remains on the field until its effect has occurred. At the end of your Attack Phase, if you have Order-type creatures in play while your opponent doesn't have any creatures in play, you may look at your opponent's hand and discard 1 card from it.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Conquered-Landscape-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_271',
    s3_large_image_name: 'MjcxLS0tQ0YtY3J5c3RhbGxpemUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjcxLS0tQ0YtY3J5c3RhbGxpemUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjcxLS0tQ0YtY3J5c3RhbGxpemUucG5n/t',
    name: 'Crystallize',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Nivea Toliver',
    effect:
      'Pay 1 energy. Select one creature in play with an Ability and cancel its effect for the rest of the turn.',
    ruling:
      '<p>■&nbsp;<em>Crystallize&nbsp;</em>cannot target or affect<em>&nbsp;Lantern Leaflore</em>;</p>\n<p>■&nbsp;On-summon creature Abilities (i.e. "When this creature is summoned...") can be negated by this card (<strong>if played in response</strong>&nbsp;to the creature being summoned). After the end of the turn, the creature will already have been summoned and its on-summon Ability will&nbsp;<strong>not</strong>&nbsp;trigger;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystallize-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_272',
    s3_large_image_name:
      'MjcyLS0tQ0YtY3J5c3RhbGx1cy1jb21tYW5kLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjcyLS0tQ0YtY3J5c3RhbGx1cy1jb21tYW5kLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjcyLS0tQ0YtY3J5c3RhbGx1cy1jb21tYW5kLnBuZwEXODUSEXODUS/t',
    name: "Crystallus' Command",
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Hafid Moenir',
    effect:
      'Freeze one of your Common creatures in play. Then, add 1 energy to it from your Energy Deck. (It unfreezes at the end of your next turn.)',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Crystallus--Command-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_5',
    s3_large_image_name: 'NS0tLTFzdC1lZC1kYXJjcmVzdC1kcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NS0tLTFzdC1lZC1kYXJjcmVzdC1kcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NS0tLTFzdC1lZC1kYXJjcmVzdC1kcmFnb24ucG5n/t',
    name: 'Darcrest Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Darcrest-Dragon-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_81',
    s3_large_image_name:
      'ODEtLS1Db21tb24tRGFyY3Jlc3QtRHJhZ29uLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/ODEtLS1Db21tb24tRGFyY3Jlc3QtRHJhZ29uLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/ODEtLS1Db21tb24tRGFyY3Jlc3QtRHJhZ29uLTRDUC5wbmcEXODUS/t',
    name: 'Darcrest Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Darcrest-Dragon-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_43',
    s3_large_image_name:
      'NDMtLS0ybmQtZWQtZGFyY3Jlc3QtZHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDMtLS0ybmQtZWQtZGFyY3Jlc3QtZHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDMtLS0ybmQtZWQtZGFyY3Jlc3QtZHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Darcrest Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Darcrest-Dragon-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_122',
    s3_large_image_name: 'MTIyLS0tMTgtRGFyY3Jlc3QtRHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTIyLS0tMTgtRGFyY3Jlc3QtRHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTIyLS0tMTgtRGFyY3Jlc3QtRHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Darcrest Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Darcrest-Dragon-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_377',
    s3_large_image_name:
      'Mzc3LS0tUmFyZS1Ta2V0Y2gtRGFyY3Jlc3QtRHJhZ29uLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc3LS0tUmFyZS1Ta2V0Y2gtRGFyY3Jlc3QtRHJhZ29uLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc3LS0tUmFyZS1Ta2V0Y2gtRGFyY3Jlc3QtRHJhZ29uLTRDUC5wbmcEXODUS/t',
    name: 'Darcrest Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Darcrest-Dragon-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_6',
    s3_large_image_name: 'Ni0tLTFzdC1lZC1kZW5zaXR5LWRyYWdvbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Ni0tLTFzdC1lZC1kZW5zaXR5LWRyYWdvbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Ni0tLTFzdC1lZC1kZW5zaXR5LWRyYWdvbi5wbmcEXODUS/t',
    name: 'Density Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Density-Dragon-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_82',
    s3_large_image_name:
      'ODItLS1Db21tb24tRGVuc2l0eS1EcmFnb24tNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/ODItLS1Db21tb24tRGVuc2l0eS1EcmFnb24tNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/ODItLS1Db21tb24tRGVuc2l0eS1EcmFnb24tNENQLnBuZwEXODUSEXODUS/t',
    name: 'Density Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Density-Dragon-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_44',
    s3_large_image_name: 'NDQtLS0ybmQtZWQtZGVuc2l0eS1kcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQtLS0ybmQtZWQtZGVuc2l0eS1kcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQtLS0ybmQtZWQtZGVuc2l0eS1kcmFnb24ucG5n/t',
    name: 'Density Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Density-Dragon-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_123',
    s3_large_image_name: 'MTIzLS0tMTktRGVuc2l0eS1EcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTIzLS0tMTktRGVuc2l0eS1EcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTIzLS0tMTktRGVuc2l0eS1EcmFnb24ucG5n/t',
    name: 'Density Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Density-Dragon-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_378',
    s3_large_image_name:
      'Mzc4LS0tUmFyZS1Ta2V0Y2gtRGVuc2l0eS1EcmFnb24tNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc4LS0tUmFyZS1Ta2V0Y2gtRGVuc2l0eS1EcmFnb24tNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc4LS0tUmFyZS1Ta2V0Y2gtRGVuc2l0eS1EcmFnb24tNENQLnBuZwEXODUSEXODUS/t',
    name: 'Density Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Density-Dragon-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_25',
    s3_large_image_name:
      'MjUtLS0xc3QtZWQtZGltZW5zaW9uYWwtZGVzcGVyYWRvLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjUtLS0xc3QtZWQtZGltZW5zaW9uYWwtZGVzcGVyYWRvLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjUtLS0xc3QtZWQtZGltZW5zaW9uYWwtZGVzcGVyYWRvLnBuZwEXODUSEXODUS/t',
    name: 'Dimensional Desperado',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Desperado-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_394',
    s3_large_image_name:
      'Mzk0LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRGVzcGVyYWRvLUJvQy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk0LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRGVzcGVyYWRvLUJvQy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk0LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRGVzcGVyYWRvLUJvQy5wbmcEXODUS/t',
    name: 'Dimensional Desperado',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Desperado-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_396',
    s3_large_image_name:
      'Mzk2LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRGVzcGVyYWRvLUdULTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk2LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRGVzcGVyYWRvLUdULTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk2LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRGVzcGVyYWRvLUdULTRDUC5wbmcEXODUS/t',
    name: 'Dimensional Desperado',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'COCOs',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Desperado-Limited-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_101',
    s3_large_image_name:
      'MTAxLS0tUmFyZS1EaW1lbnNpb25hbC1EZXNwZXJhZG8tRm9pbC00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTAxLS0tUmFyZS1EaW1lbnNpb25hbC1EZXNwZXJhZG8tRm9pbC00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTAxLS0tUmFyZS1EaW1lbnNpb25hbC1EZXNwZXJhZG8tRm9pbC00Q1AucG5n/t',
    name: 'Dimensional Desperado',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Desperado-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_416',
    s3_large_image_name:
      'NDE2LS0tUHJvbW8tUmFyZS1EaW1lbnNpb25hbC1EZXNwZXJhZG8tRXh0ZW5kZWQtQXJ0LTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDE2LS0tUHJvbW8tUmFyZS1EaW1lbnNpb25hbC1EZXNwZXJhZG8tRXh0ZW5kZWQtQXJ0LTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDE2LS0tUHJvbW8tUmFyZS1EaW1lbnNpb25hbC1EZXNwZXJhZG8tRXh0ZW5kZWQtQXJ0LTRDUC5wbmcEXODUS/t',
    name: 'Dimensional Desperado',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Desperado-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_63',
    s3_large_image_name:
      'NjMtLS0ybmQtZWQtZGltZW5zaW9uYWwtZGVzcGVyYWRvLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjMtLS0ybmQtZWQtZGltZW5zaW9uYWwtZGVzcGVyYWRvLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjMtLS0ybmQtZWQtZGltZW5zaW9uYWwtZGVzcGVyYWRvLnBuZwEXODUSEXODUS/t',
    name: 'Dimensional Desperado',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Desperado-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_142',
    s3_large_image_name:
      'MTQyLS0tVW5saW1pdGVkLUVkaXRpb24tRGltZW5zaW9uYWwtRGVzcGVyYWRvLUZvaWwtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQyLS0tVW5saW1pdGVkLUVkaXRpb24tRGltZW5zaW9uYWwtRGVzcGVyYWRvLUZvaWwtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQyLS0tVW5saW1pdGVkLUVkaXRpb24tRGltZW5zaW9uYWwtRGVzcGVyYWRvLUZvaWwtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Dimensional Desperado',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Desperado-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_7',
    s3_large_image_name: 'Ny0tLTFzdC1lZC1kaW1lbnNpb25hbC1kcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Ny0tLTFzdC1lZC1kaW1lbnNpb25hbC1kcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Ny0tLTFzdC1lZC1kaW1lbnNpb25hbC1kcmFnb24ucG5n/t',
    name: 'Dimensional Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Dragon-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_393',
    s3_large_image_name:
      'MzkzLS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRHJhZ29uLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzkzLS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRHJhZ29uLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzkzLS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRHJhZ29uLTRDUC5wbmcEXODUS/t',
    name: 'Dimensional Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Dragon-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_397',
    s3_large_image_name:
      'Mzk3LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRHJhZ29uLUdULTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk3LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRHJhZ29uLUdULTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk3LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRHJhZ29uLUdULTRDUC5wbmcEXODUS/t',
    name: 'Dimensional Dragon',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'COCOs',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Dragon-Limited-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_83',
    s3_large_image_name:
      'ODMtLS1SYXJlLURpbWVuc2lvbmFsLURyYWdvbi1Gb2lsLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/ODMtLS1SYXJlLURpbWVuc2lvbmFsLURyYWdvbi1Gb2lsLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/ODMtLS1SYXJlLURpbWVuc2lvbmFsLURyYWdvbi1Gb2lsLTRDUC5wbmcEXODUS/t',
    name: 'Dimensional Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Dragon-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_415',
    s3_large_image_name:
      'NDE1LS0tUHJvbW8tUmFyZS1EaW1lbnNpb25hbC1EcmFnb24tRXh0ZW5kZWQtQXJ0LTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDE1LS0tUHJvbW8tUmFyZS1EaW1lbnNpb25hbC1EcmFnb24tRXh0ZW5kZWQtQXJ0LTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDE1LS0tUHJvbW8tUmFyZS1EaW1lbnNpb25hbC1EcmFnb24tRXh0ZW5kZWQtQXJ0LTRDUC5wbmcEXODUS/t',
    name: 'Dimensional Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Dragon-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_45',
    s3_large_image_name:
      'NDUtLS0ybmQtZWQtZGltZW5zaW9uYWwtZHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDUtLS0ybmQtZWQtZGltZW5zaW9uYWwtZHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDUtLS0ybmQtZWQtZGltZW5zaW9uYWwtZHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Dimensional Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Dragon-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_124',
    s3_large_image_name:
      'MTI0LS0tVW5saW1pdGVkLUVkaXRpb24tRGltZW5zaW9uYWwtRHJhZ29uLUZvaWwtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTI0LS0tVW5saW1pdGVkLUVkaXRpb24tRGltZW5zaW9uYWwtRHJhZ29uLUZvaWwtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTI0LS0tVW5saW1pdGVkLUVkaXRpb24tRGltZW5zaW9uYWwtRHJhZ29uLUZvaWwtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Dimensional Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Dragon-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_398',
    s3_large_image_name:
      'Mzk4LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRHVzdC00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk4LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRHVzdC00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk4LS0tUmFyZS1Ta2V0Y2gtRGltZW5zaW9uYWwtRHVzdC00Q1AucG5n/t',
    name: 'Dimensional Dust',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'COCOs',
    effect:
      'Search your graveyard for 1 card with "Dimensional" or "Dust" in its name and add it to your hand.\n',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dimensional-Dust-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_383',
    s3_large_image_name:
      'MzgzLS0tUmFyZS1Ta2V0Y2gtRGl2aW5lLU1pbmlzdGVyLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzgzLS0tUmFyZS1Ta2V0Y2gtRGl2aW5lLU1pbmlzdGVyLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzgzLS0tUmFyZS1Ta2V0Y2gtRGl2aW5lLU1pbmlzdGVyLTRDUC5wbmcEXODUS/t',
    name: 'Divine Minister',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Divine-Minister-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_26',
    s3_large_image_name:
      'MjYtLS0xc3QtZWQtZGl2aW5lLW1pbmlzdGVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjYtLS0xc3QtZWQtZGl2aW5lLW1pbmlzdGVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjYtLS0xc3QtZWQtZGl2aW5lLW1pbmlzdGVyLnBuZwEXODUSEXODUS/t',
    name: 'Divine Minister',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Divine-Minister-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_102',
    s3_large_image_name:
      'MTAyLS0tVW5jb21tb24tRGl2aW5lLU1pbmlzdGVyLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTAyLS0tVW5jb21tb24tRGl2aW5lLU1pbmlzdGVyLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTAyLS0tVW5jb21tb24tRGl2aW5lLU1pbmlzdGVyLTRDUC5wbmcEXODUS/t',
    name: 'Divine Minister',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Divine-Minister-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_64',
    s3_large_image_name:
      'NjQtLS0ybmQtZWQtZGl2aW5lLW1pbmlzdGVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjQtLS0ybmQtZWQtZGl2aW5lLW1pbmlzdGVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjQtLS0ybmQtZWQtZGl2aW5lLW1pbmlzdGVyLnBuZwEXODUSEXODUS/t',
    name: 'Divine Minister',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Divine-Minister-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_143',
    s3_large_image_name: 'MTQzLS0tNi1EaXZpbmUtTWluaXN0ZXIucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQzLS0tNi1EaXZpbmUtTWluaXN0ZXIucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQzLS0tNi1EaXZpbmUtTWluaXN0ZXIucG5n/t',
    name: 'Divine Minister',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Divine-Minister-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_384',
    s3_large_image_name:
      'Mzg0LS0tUmFyZS1Ta2V0Y2gtRG9vbWZlc3RFbGRlcmJlYXN0QW5nZWwtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg0LS0tUmFyZS1Ta2V0Y2gtRG9vbWZlc3RFbGRlcmJlYXN0QW5nZWwtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg0LS0tUmFyZS1Ta2V0Y2gtRG9vbWZlc3RFbGRlcmJlYXN0QW5nZWwtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Doomfest Elderbeast Angel',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Doomfest-Elderbeast-Angel-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_27',
    s3_large_image_name:
      'MjctLS0xc3QtZWQtZG9vbWZlc3QtZWxkZXJiZWFzdC1hbmdlbC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjctLS0xc3QtZWQtZG9vbWZlc3QtZWxkZXJiZWFzdC1hbmdlbC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjctLS0xc3QtZWQtZG9vbWZlc3QtZWxkZXJiZWFzdC1hbmdlbC5wbmcEXODUS/t',
    name: 'Doomfest Elderbeast Angel',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Doomfest-Elderbeast-Angel-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_103',
    s3_large_image_name:
      'MTAzLS0tVW5jb21tb24tRG9vbWZlc3RFbGRlcmJlYXN0QW5nZWwtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTAzLS0tVW5jb21tb24tRG9vbWZlc3RFbGRlcmJlYXN0QW5nZWwtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTAzLS0tVW5jb21tb24tRG9vbWZlc3RFbGRlcmJlYXN0QW5nZWwtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Doomfest Elderbeast Angel',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Doomfest-Elderbeast-Angel-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_65',
    s3_large_image_name:
      'NjUtLS0ybmQtZWQtZG9vbWZlc3QtZWxkZXJiZWFzdC1hbmdlbC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjUtLS0ybmQtZWQtZG9vbWZlc3QtZWxkZXJiZWFzdC1hbmdlbC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjUtLS0ybmQtZWQtZG9vbWZlc3QtZWxkZXJiZWFzdC1hbmdlbC5wbmcEXODUS/t',
    name: 'Doomfest Elderbeast Angel',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Doomfest-Elderbeast-Angel-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_144',
    s3_large_image_name:
      'MTQ0LS0tNy1Eb29tZmVzdC1FbGRlcmJlYXN0LUFuZ2VsLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ0LS0tNy1Eb29tZmVzdC1FbGRlcmJlYXN0LUFuZ2VsLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ0LS0tNy1Eb29tZmVzdC1FbGRlcmJlYXN0LUFuZ2VsLnBuZwEXODUSEXODUS/t',
    name: 'Doomfest Elderbeast Angel',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Doomfest-Elderbeast-Angel-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_446',
    s3_large_image_name:
      'NDQ2LS0tRHJhZ29uaXMtV2FyZGVuLVByb21vLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ2LS0tRHJhZ29uaXMtV2FyZGVuLVByb21vLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ2LS0tRHJhZ29uaXMtV2FyZGVuLVByb21vLnBuZwEXODUSEXODUS/t',
    name: 'Dragonis Warden',
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Hafid Moenir',
    effect:
      "You and your opponent must each select one creature from your own sides of the field and send them to the bottom of the Main Deck (all energy attached goes to the owner's hand).",
    ruling:
      '<p>■ You MUST have a creature in play to send to the bottom of the Main Deck in order to use this card effect;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dragonis-Warden-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_408',
    s3_large_image_name: 'NDA4LS0tR1QtZHJhbmdlbC1za2V0Y2guanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDA4LS0tR1QtZHJhbmdlbC1za2V0Y2guanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDA4LS0tR1QtZHJhbmdlbC1za2V0Y2guanBn/t',
    name: 'Drangel',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Angel'],
    creature_type_count: 2,
    artist: 'COCOs',
    effect:
      'While this creature is on the field, each Common Dragon or Angel that attacks a Rare creature gains 1 energy just before the attack hits. Only 1 "Drangel" Ability can be active on the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Drangel-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_412',
    s3_large_image_name:
      'NDEyLS0tRHJhbmdlbGljLU91dGNyb3NzLVNrZXRjaC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDEyLS0tRHJhbmdlbGljLU91dGNyb3NzLVNrZXRjaC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDEyLS0tRHJhbmdlbGljLU91dGNyb3NzLVNrZXRjaC5wbmcEXODUS/t',
    name: 'Drangelic Outcross',
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Angel'],
    creature_type_count: 2,
    artist: 'Nivea Toliver',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Drangelic-Outcross-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_409',
    s3_large_image_name:
      'NDA5LS0tR1QtZHJlYW0tYmxvc3NvbS1kcmFnb24tc2tldGNoLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDA5LS0tR1QtZHJlYW0tYmxvc3NvbS1kcmFnb24tc2tldGNoLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDA5LS0tR1QtZHJlYW0tYmxvc3NvbS1kcmFnb24tc2tldGNoLmpwZwEXODUSEXODUS/t',
    name: 'Dream Blossom Dragon',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'COCOs',
    effect:
      "When this creature is summoned, discard 1 card from your hand if possible. If you do, discard 1 energy from your opponent's side of the field.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Dream-Blossom-Dragon-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_435',
    s3_large_image_name:
      'NDM1LS0tUHJvbW8tUmFyZS1EcmlmdGVycy1CZWdpbm5pbmctNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDM1LS0tUHJvbW8tUmFyZS1EcmlmdGVycy1CZWdpbm5pbmctNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDM1LS0tUHJvbW8tUmFyZS1EcmlmdGVycy1CZWdpbm5pbmctNENQLnBuZwEXODUSEXODUS/t',
    name: "Drifter's Beginning",
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Select a Rare creature on your field with no Ability. This turn, you may have it attack 2 opposing Rare creatures at once (divide the damage your creature deals however you like between the 2 opposing creatures; it receives damage from both opposing creatures).',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Drifter-s-Beginning-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_436',
    s3_large_image_name: 'NDM2LS0tMjAxOC1EcmlmdGVycy1CZWdpbm5pbmcucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDM2LS0tMjAxOC1EcmlmdGVycy1CZWdpbm5pbmcucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDM2LS0tMjAxOC1EcmlmdGVycy1CZWdpbm5pbmcucG5n/t',
    name: "Drifter's Beginning",
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Select a Rare creature on your field with no Ability. This turn, you may have it attack 2 opposing Rare creatures at once (divide the damage your creature deals however you like between the 2 opposing creatures; it receives damage from both opposing creatures).',
    ruling: '',
    foil_only: 'Yes',
    card_database_link:
      'https://exodus-players.com/cards/search/Drifter-s-Beginning-Promo-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_35',
    s3_large_image_name: 'MzUtLS0xc3QtZWQtZW5kb3dtZW50LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzUtLS0xc3QtZWQtZW5kb3dtZW50LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzUtLS0xc3QtZWQtZW5kb3dtZW50LnBuZwEXODUSEXODUS/t',
    name: 'Endowment',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and add it to any creature or pile in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Endowment-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_112',
    s3_large_image_name: 'MTEyLS0tQ29tbW9uLUVuZG93bWVudC00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTEyLS0tQ29tbW9uLUVuZG93bWVudC00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTEyLS0tQ29tbW9uLUVuZG93bWVudC00Q1AucG5n/t',
    name: 'Endowment',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and add it to any creature or pile in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Endowment-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_73',
    s3_large_image_name: 'NzMtLS0ybmQtZWQtZW5kb3dtZW50LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NzMtLS0ybmQtZWQtZW5kb3dtZW50LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NzMtLS0ybmQtZWQtZW5kb3dtZW50LnBuZwEXODUSEXODUS/t',
    name: 'Endowment',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and add it to any creature or pile in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Endowment-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_153',
    s3_large_image_name: 'MTUzLS0tMjktRW5kb3dtZW50LmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTUzLS0tMjktRW5kb3dtZW50LmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTUzLS0tMjktRW5kb3dtZW50LmpwZwEXODUSEXODUS/t',
    name: 'Endowment',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and add it to any creature or pile in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Endowment-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_16',
    s3_large_image_name: 'MTYtLS0xc3QtZWQtZW5lcmdpemUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTYtLS0xc3QtZWQtZW5lcmdpemUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTYtLS0xc3QtZWQtZW5lcmdpemUucG5n/t',
    name: 'Energize',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy card from your Energy Deck and add it to any creature or pile in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energize-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_92',
    s3_large_image_name: 'OTItLS1Db21tb24tRW5lcmdpemUtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OTItLS1Db21tb24tRW5lcmdpemUtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OTItLS1Db21tb24tRW5lcmdpemUtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Energize',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy card from your Energy Deck and add it to any creature or pile in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energize-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_54',
    s3_large_image_name: 'NTQtLS0ybmQtZWQtZW5lcmdpemUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTQtLS0ybmQtZWQtZW5lcmdpemUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTQtLS0ybmQtZWQtZW5lcmdpemUucG5n/t',
    name: 'Energize',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy card from your Energy Deck and add it to any creature or pile in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energize-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_133',
    s3_large_image_name: 'MTMzLS0tMzYtRW5lcmdpemUuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTMzLS0tMzYtRW5lcmdpemUuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTMzLS0tMzYtRW5lcmdpemUuanBn/t',
    name: 'Energize',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy card from your Energy Deck and add it to any creature or pile in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energize-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_38',
    s3_large_image_name: 'MzgtLS0xc3QtZWQtZW5lcmd5LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzgtLS0xc3QtZWQtZW5lcmd5LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzgtLS0xc3QtZWQtZW5lcmd5LnBuZwEXODUSEXODUS/t',
    name: 'Energy',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Energy'],
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Energy-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_117',
    s3_large_image_name: 'MTE3LS0tMDItRW5lcmd5LTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTE3LS0tMDItRW5lcmd5LTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTE3LS0tMDItRW5lcmd5LTRDUC5wbmcEXODUS/t',
    name: 'Energy',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Energy'],
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energy-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_76',
    s3_large_image_name: 'NzYtLS0ybmQtZWQtZW5lcmd5LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NzYtLS0ybmQtZWQtZW5lcmd5LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NzYtLS0ybmQtZWQtZW5lcmd5LnBuZwEXODUSEXODUS/t',
    name: 'Energy',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Energy'],
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Energy-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_158',
    s3_large_image_name: 'MTU4LS0tNDEtRW5lcmd5LmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTU4LS0tNDEtRW5lcmd5LmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTU4LS0tNDEtRW5lcmd5LmpwZwEXODUSEXODUS/t',
    name: 'Energy',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Energy'],
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Energy-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_532',
    s3_large_image_name:
      'NTMyLS0tbGUtZXJvZGEtdGhlLWZsaWNrZXJpbmctZmFjYWRlLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTMyLS0tbGUtZXJvZGEtdGhlLWZsaWNrZXJpbmctZmFjYWRlLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTMyLS0tbGUtZXJvZGEtdGhlLWZsaWNrZXJpbmctZmFjYWRlLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Eroda the Flickering Facade',
    set_name: 'The Dimension That Disappeared',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Brandon McDonald',
    effect:
      '• Only 1 copy of this card is allowed in your Main Deck. ABILITY: When this card would leave your Main Deck, put it face-up beneath your Main Deck instead & attach 1 energy from your field to it at the end of each turn; when zero cards remain in your Main Deck, summon it along with all energy attached. ',
    ruling:
      '<p>■&nbsp;Similar to energy that\'s "beneath the Main Deck", Eroda is&nbsp;<strong><u>not</u></strong>&nbsp;part of the Main Deck, nor is it considered to be "the bottom of" / "at the bottom of"&nbsp;the Main Deck. Eroda is entirely separate and is considered to be underneath / beneath the deck as if in a separate zone;</p>\n<p>■ Due to Eroda\'s wording "when this card&nbsp;<strong><u>would</u></strong>&nbsp;leave your Main Deck" … "put it face-up beneath your Main Deck&nbsp;<strong><u>instead</u></strong>", it does not fulfill a draw requirement, thus allowing the player to draw the next card after Eroda fully resolves from leaving the Main Deck;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Similarly, cards that search or send cards out of the Main Deck (such as&nbsp;<em>Sign of the Crow</em>,&nbsp;<em>Chains of the Ancient One</em>,&nbsp;<em>Bridge Bastion Dragon</em>, etc.), will trigger Eroda\'s Ability and won\'t count Eroda as a card being searched or sent out of the deck. The player would then search / send out the&nbsp;<strong><u>next</u></strong>&nbsp;card in order to fulfill the original card\'s effect / Ability;</p>\n<p>■&nbsp;When Eroda enters play from beneath the Main Deck, the player chooses to either summon it on an existing blank pile along with any energy attached from beneath the Main Deck, OR using only the energy beneath the Main Deck as a new pile. In the case of having no energy beneath the Main Deck when Eroda is summoned (from beneath the Main Deck), it can simply be summoned on an existing blank pile;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;If there are no valid open blank piles on your field and no energy beneath the Main Deck when Eroda needs to be summoned (from beneath the Main Deck), Eroda then goes straight to the graveyard;</p>\n<p>■&nbsp;During the course of normal gameplay, when zero cards remain in the Main Deck and Eroda\'s Ability triggers in an attempt to summon itself from beneath the Main Deck, players can respond to its Ability as usual. However, if Eroda\'s Ability causes it to be summoned from beneath the Main Deck in the middle of the owner\'s Draw Phase while they still need to Deck Recycle &amp; draw more cards, the Ability&nbsp;<strong><u>cannot</u></strong>&nbsp;be responded to and must resolve before the Deck Recycle<em>—</em>because the act of drawing card(s) during the Draw Phase is uninterruptable by default. For this reason, Eroda\'s Ability is considered "semi-automated";<br><br>■&nbsp;<em>If&nbsp;Eroda the Flickering Facade</em>&nbsp;appears in the Starting Hand (whether in the opening hand or by mulligan), its Ability triggers&nbsp;and will cause<br><em>Eroda&nbsp;</em><em>to immediately go beneath the Main Deck and allow the player to draw a replacement card.<br>The replacement draw is due to the fact that&nbsp;</em><em>Eroda\'s&nbsp;</em><em>Ability triggers whenever it "would" leave the Main Deck. Since it never actually goes from the deck to the hand, it doesn\'t count toward the number of cards drawn;<br></em><br><em>■&nbsp;Eroda&nbsp;</em><em>moves 1 energy to itself while beneath the Main Deck at the end of every single turn, and can move your teammate\'s energy in 2v2;</em></p>\n<p><em>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - If both players on a team each have their own&nbsp;</em><em>Eroda&nbsp;triggering to pull energy beneath the deck at the end of the turn, while there is only 1 energy among their shared field, they may come to a mutual agreement regarding which&nbsp;</em><em>Eroda&nbsp;</em><em>the energy should move to;</em></p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Eroda-the-Flickering-Facade-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_531',
    s3_large_image_name: 'NTMxLS0tbGUtZXJvZGFzLWFzY2VuZGFuY2UtNzJkcGkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTMxLS0tbGUtZXJvZGFzLWFzY2VuZGFuY2UtNzJkcGkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTMxLS0tbGUtZXJvZGFzLWFzY2VuZGFuY2UtNzJkcGkucG5n/t',
    name: "Eroda's Ascendance",
    set_name: 'The Dimension That Disappeared',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Odysseas Stamoglou',
    effect:
      'Pay half of your Life Points, rounded down. Send all cards in your Main Deck to the graveyard. Then, you may summon "Eroda the Flickering Facade" and/or "Devourer of Dimensions" from your hand or graveyard, if possible. If you do, you may move your Afterthoughts underneath it (Afterthoughts turn into Chronos). Opposing creatures and piles cannot increase in energy for the rest of the turn.',
    ruling:
      '<p>■&nbsp;&nbsp;<strong><sup>[NEW]</sup></strong><em>&nbsp;</em>"Pay half of your Life Points, rounded down," means that you pay&nbsp;<strong>exactly half</strong>&nbsp;of your current Life total—and if the result is a&nbsp;fractional number, round the result down to the nearest whole number;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - The&nbsp;amount of Life Points you pay is not rounded down, only the result (if needed);<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - "rounded down"&nbsp;is a suffix&nbsp;phrase of the overall cost, affecting the result only and not the cost itself;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Eroda-s-Ascendance-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_399',
    s3_large_image_name:
      'Mzk5LS0tUmFyZS1Ta2V0Y2gtRXVwaG9yaWFzLVJlYWNoLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk5LS0tUmFyZS1Ta2V0Y2gtRXVwaG9yaWFzLVJlYWNoLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzk5LS0tUmFyZS1Ta2V0Y2gtRXVwaG9yaWFzLVJlYWNoLTRDUC5wbmcEXODUS/t',
    name: "Euphoria's Reach",
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Treefolk', 'Mountain'],
    creature_type_count: 2,
    artist: 'Kenny Estrella',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Euphoria-s-Reach-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_400',
    s3_large_image_name:
      'NDAwLS0tUmFyZS1Ta2V0Y2gtRXZlcmRyaWZ0LUlzbGFuZHMtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDAwLS0tUmFyZS1Ta2V0Y2gtRXZlcmRyaWZ0LUlzbGFuZHMtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDAwLS0tUmFyZS1Ta2V0Y2gtRXZlcmRyaWZ0LUlzbGFuZHMtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Everdrift Islands',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'André Martinez',
    effect: 'Each Common creature in play gains 1 energy.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Everdrift-Islands-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_28',
    s3_large_image_name:
      'MjgtLS0xc3QtZWQtZXhhbHRlZC1za3lzaGlmdGVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjgtLS0xc3QtZWQtZXhhbHRlZC1za3lzaGlmdGVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjgtLS0xc3QtZWQtZXhhbHRlZC1za3lzaGlmdGVyLnBuZwEXODUSEXODUS/t',
    name: 'Exalted Skyshifter',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Exalted-Skyshifter-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_104',
    s3_large_image_name: 'MTA0LS0tQ29tbW9uLUV4YWx0ZWQtU2t5c2hpZnRlci00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTA0LS0tQ29tbW9uLUV4YWx0ZWQtU2t5c2hpZnRlci00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTA0LS0tQ29tbW9uLUV4YWx0ZWQtU2t5c2hpZnRlci00Q1AucG5n/t',
    name: 'Exalted Skyshifter',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Exalted-Skyshifter-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_66',
    s3_large_image_name:
      'NjYtLS0ybmQtZWQtZXhhbHRlZC1za3lzaGlmdGVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjYtLS0ybmQtZWQtZXhhbHRlZC1za3lzaGlmdGVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjYtLS0ybmQtZWQtZXhhbHRlZC1za3lzaGlmdGVyLnBuZwEXODUSEXODUS/t',
    name: 'Exalted Skyshifter',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Exalted-Skyshifter-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_145',
    s3_large_image_name: 'MTQ1LS0tOC1FeGFsdGVkLVNreXNoaWZ0ZXIucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ1LS0tOC1FeGFsdGVkLVNreXNoaWZ0ZXIucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ1LS0tOC1FeGFsdGVkLVNreXNoaWZ0ZXIucG5n/t',
    name: 'Exalted Skyshifter',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Exalted-Skyshifter-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_389',
    s3_large_image_name:
      'Mzg5LS0tUmFyZS1Ta2V0Y2gtRXhhbHRlZC1Ta3lzaGlmdGVyLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg5LS0tUmFyZS1Ta2V0Y2gtRXhhbHRlZC1Ta3lzaGlmdGVyLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg5LS0tUmFyZS1Ta2V0Y2gtRXhhbHRlZC1Ta3lzaGlmdGVyLTRDUC5wbmcEXODUS/t',
    name: 'Exalted Skyshifter',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Exalted-Skyshifter-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_447',
    s3_large_image_name:
      'NDQ3LS0tRXhpc3RlbmNlLW9mLVVua25vd24tT3JpZ2lucy1Qcm9tby5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ3LS0tRXhpc3RlbmNlLW9mLVVua25vd24tT3JpZ2lucy1Qcm9tby5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ3LS0tRXhpc3RlbmNlLW9mLVVua25vd24tT3JpZ2lucy1Qcm9tby5wbmcEXODUS/t',
    name: 'Existence of Unknown Origins',
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Lexi Medina',
    effect: 'Switch Life Points with your opponent.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Existence-of-Unknown-Origins-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_273',
    s3_large_image_name:
      'MjczLS0tQ0YtZnJvc3Rmcm9udC1jcnlzYWRlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjczLS0tQ0YtZnJvc3Rmcm9udC1jcnlzYWRlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjczLS0tQ0YtZnJvc3Rmcm9udC1jcnlzYWRlLnBuZwEXODUSEXODUS/t',
    name: 'Frostfront Crysade',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'S. Calvin',
    effect:
      'Choose one of your Common or Uncommon creatures in play that is frozen and unfreeze it. Then, draw 1 card.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Frostfront-Crysade-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_448',
    s3_large_image_name: 'NDQ4LS0tRnJvemVuLURlY3JlZS1Qcm9tby5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ4LS0tRnJvemVuLURlY3JlZS1Qcm9tby5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ4LS0tRnJvemVuLURlY3JlZS1Qcm9tby5wbmcEXODUS/t',
    name: 'Frozen Decree',
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Didi Esmeralda',
    effect:
      'Select 1 creature that was put into play this turn except by a summon and freeze it.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Frozen-Decree-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_274',
    s3_large_image_name: 'Mjc0LS0tQ0YtZ2FybmV0LW1hcmF1ZGVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc0LS0tQ0YtZ2FybmV0LW1hcmF1ZGVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc0LS0tQ0YtZ2FybmV0LW1hcmF1ZGVyLnBuZwEXODUSEXODUS/t',
    name: 'Garnet Marauder',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Shardfolk'],
    creature_type_count: 1,
    artist: 'S. Calvin',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Garnet-Marauder-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_439',
    s3_large_image_name:
      'NDM5LS0tUHJvbW8tUmFyZS1HbGltcHNlLW9mLXRoZS1TYW5jdHVhcnktNENQLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDM5LS0tUHJvbW8tUmFyZS1HbGltcHNlLW9mLXRoZS1TYW5jdHVhcnktNENQLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDM5LS0tUHJvbW8tUmFyZS1HbGltcHNlLW9mLXRoZS1TYW5jdHVhcnktNENQLmpwZwEXODUSEXODUS/t',
    name: 'Glimpse of the Sanctuary',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Marzena Piwowar',
    effect:
      'Each player may have a blank pile on their field gain 1 energy. Then, you may draw 1 card from your Main Deck.',
    ruling:
      '<p>■&nbsp;Because both parts of this card\'s effect involve the word, "<em>may</em>", you do not have to add an energy to a blank pile in order to draw a card from your Main Deck;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Your opponent can add an energy to one of their blank piles either way, as long as they have blank pile(s) of energy on their field;<br><br>■&nbsp;EACH player on a team may add 1 energy to a blank pile on their shared field due to a single activation of&nbsp;<em>Glimpse of the Sanctuary</em>;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Energy added this way can be added to the same pile or different piles;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Glimpse-of-the-Sanctuary-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_440',
    s3_large_image_name: 'NDQwLS0tMjAxOC1HbGltcHNlLW9mLXRoZS1TYW5jdHVhcnkucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQwLS0tMjAxOC1HbGltcHNlLW9mLXRoZS1TYW5jdHVhcnkucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQwLS0tMjAxOC1HbGltcHNlLW9mLXRoZS1TYW5jdHVhcnkucG5n/t',
    name: 'Glimpse of the Sanctuary',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Marzena Piwowar',
    effect:
      'Each player may have a blank pile on their field gain 1 energy. Then, you may draw 1 card from your Main Deck.',
    ruling:
      '<p>■&nbsp;Because both parts of this card\'s effect involve the word, "may", you do not have to add an energy to a blank pile in order to draw a card from your Main Deck;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Your opponent can add an energy to one of their blank piles either way, as long as they have blank pile(s) of energy on their field;<br><br>■ EACH player on a team may add 1 energy to a blank pile on their shared field due to a single activation of <em>Glimpse of the Sanctuary</em>;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Energy added this way can be added to the same pile or different piles;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Glimpse-of-the-Sanctuary-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_401',
    s3_large_image_name:
      'NDAxLS0tUmFyZS1Ta2V0Y2gtR3JhbmNpZWwtRW1pc3Nhcnktb2YtU3RhcnMtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDAxLS0tUmFyZS1Ta2V0Y2gtR3JhbmNpZWwtRW1pc3Nhcnktb2YtU3RhcnMtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDAxLS0tUmFyZS1Ta2V0Y2gtR3JhbmNpZWwtRW1pc3Nhcnktb2YtU3RhcnMtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Granciel, Emissary of Stars',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Rennyl Montuya',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Granciel--Emissary-of-Stars-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_267',
    s3_large_image_name: 'MjY3LS0tQ0YtZ3VpbGQtd2FyZmFyZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjY3LS0tQ0YtZ3VpbGQtd2FyZmFyZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjY3LS0tQ0YtZ3VpbGQtd2FyZmFyZS5wbmcEXODUS/t',
    name: 'Guild Warfare',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Nivea Toliver',
    effect:
      'If all creatures on your field share the same type, destroy 1 energy in play and draw 1 energy.',
    ruling:
      '<p>■&nbsp;<em>Guild Warfare</em>&nbsp;can be used if you have 1 or more creatures in play;</p>\n<p>■&nbsp;<strong>ALL of your creatures in play&nbsp;</strong><strong><u>must</u></strong><strong>&nbsp;share a type</strong>&nbsp;(even if they are multiple types) to use its effect;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Example</strong>: If you have a&nbsp;<em>Drangel</em>&nbsp;(Dragon/Angel) and a&nbsp;<em>Portalback Dragon</em>&nbsp;(Dragon) in play, you MAY use&nbsp;<em>Guild Warfare</em>. However, if you have a&nbsp;<em>Drangel</em>&nbsp;(Dragon/Angel), a&nbsp;<em>Portalback Dragon</em>&nbsp;(Dragon) and a&nbsp;<em>Concerto Virtuoso</em>&nbsp;(Order) in play, you CANNOT use&nbsp;<em>Guild Warfare</em>;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Guild-Warfare-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_269',
    s3_large_image_name:
      'MjY5LS0tQ0YtaGFuZGJlbGwtZGFuY2VyLWdyYXZpdGFzLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjY5LS0tQ0YtaGFuZGJlbGwtZGFuY2VyLWdyYXZpdGFzLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjY5LS0tQ0YtaGFuZGJlbGwtZGFuY2VyLWdyYXZpdGFzLnBuZwEXODUSEXODUS/t',
    name: 'Handbell Dancer Gravitas',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Order'],
    creature_type_count: 1,
    artist: 'Nivea Toliver',
    effect:
      "During the turn this creature is put into play except by a summon, your opponent's creature Abilities cannot activate.",
    ruling:
      "<p>■&nbsp;If this creature is put into play by a card effect (i.e.&nbsp;<em>Nebulawood Barrier, Apparition Grove,&nbsp;</em>etc.) which was played as a response to the activation of a creature Ability,&nbsp;<em>Handbell Dancer Gravitas</em>' Ability \"Silencing Toll\"&nbsp;will be on top of the stack / response chain, and if it resolves first,&nbsp;<strong>it will effectively cancel out or negate the original Ability that was trying to activate</strong>;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;-&nbsp;<strong>Example</strong>: If the opponent's&nbsp;<em>Emberia, Bringer of Infernos</em>&nbsp;hits the field and you put&nbsp;<em>Handbell Dancer Gravitas</em>&nbsp;into play with&nbsp;<em>Nebulawood Barrier</em>—in response to&nbsp;<em>Emberia</em>&nbsp;being summoned—<em>Gravitas</em>' Ability resolves first and would stop&nbsp;<em>Emberia</em>'s Ability from activating for that turn;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;<strong>Any subsequent opposing Abilities that try to activate will not trigger on the same turn after Handbell Dancer Gravitas was put into play via an effect</strong>&nbsp;(including&nbsp;<em>Lantern Leaflore</em>'s Ability after \"Silencing Toll\"&nbsp;has successfully resolved);</p>\n<p>■ If the opponent is summoning or putting&nbsp;<em>Lantern Leaflore</em>&nbsp;into play and you respond with an effect that puts&nbsp;<em>Handbell Dancer Gravitas</em>&nbsp;into play,&nbsp;<em>Leaflore</em>'s Ability will still be active since it already triggered and resolved when it hit the field;</p>\n<p>■&nbsp;<strong>Any creature Abilities that were already active before<em>&nbsp;Handbell Dancer Gravitas&nbsp;</em></strong><strong>came into play are still active</strong>,&nbsp;as his Ability only stops future opposing creature Abilities from activating for the rest of the turn;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Handbell-Dancer-Gravitas-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_421',
    s3_large_image_name:
      'NDIxLS0tUHJvbW8tUmFyZS1IYXJtb25pb3VzLUFuZ2VsLUFsdGVyZWQtQXJ0LTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDIxLS0tUHJvbW8tUmFyZS1IYXJtb25pb3VzLUFuZ2VsLUFsdGVyZWQtQXJ0LTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDIxLS0tUHJvbW8tUmFyZS1IYXJtb25pb3VzLUFuZ2VsLUFsdGVyZWQtQXJ0LTRDUC5wbmcEXODUS/t',
    name: 'Harmonious Angel, the Forthcoming',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Matt Tirre',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Harmonious-Angel--the-Forthcoming-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_29',
    s3_large_image_name:
      'MjktLS0xc3QtZWQtaGFybW9uaW91cy1hbmdlbC10aGUtZm9ydGhjb21pbmcucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjktLS0xc3QtZWQtaGFybW9uaW91cy1hbmdlbC10aGUtZm9ydGhjb21pbmcucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjktLS0xc3QtZWQtaGFybW9uaW91cy1hbmdlbC10aGUtZm9ydGhjb21pbmcucG5n/t',
    name: 'Harmonious Angel, the Forthcoming',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Harmonious-Angel--the-Forthcoming-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_105',
    s3_large_image_name: 'MTA1LS0tVW5jb21tb24tSGFybW9uaW91cy1BbmdlbC00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTA1LS0tVW5jb21tb24tSGFybW9uaW91cy1BbmdlbC00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTA1LS0tVW5jb21tb24tSGFybW9uaW91cy1BbmdlbC00Q1AucG5n/t',
    name: 'Harmonious Angel, the Forthcoming',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Harmonious-Angel--the-Forthcoming-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_67',
    s3_large_image_name:
      'NjctLS0ybmQtZWQtaGFybW9uaW91cy1hbmdlbC10aGUtZm9ydGhjb21pbmcucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjctLS0ybmQtZWQtaGFybW9uaW91cy1hbmdlbC10aGUtZm9ydGhjb21pbmcucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjctLS0ybmQtZWQtaGFybW9uaW91cy1hbmdlbC10aGUtZm9ydGhjb21pbmcucG5n/t',
    name: 'Harmonious Angel, the Forthcoming',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Harmonious-Angel--the-Forthcoming-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_146',
    s3_large_image_name:
      'MTQ2LS0tOS1IYXJtb25pb3VzLUFuZ2VsLXRoZS1Gb3J0aGNvbWluZy5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ2LS0tOS1IYXJtb25pb3VzLUFuZ2VsLXRoZS1Gb3J0aGNvbWluZy5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ2LS0tOS1IYXJtb25pb3VzLUFuZ2VsLXRoZS1Gb3J0aGNvbWluZy5wbmcEXODUS/t',
    name: 'Harmonious Angel, the Forthcoming',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Harmonious-Angel--the-Forthcoming-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_30',
    s3_large_image_name:
      'MzAtLS0xc3QtZWQtaGVhdmVuaGVhcnQtd2FyLWFuZ2VsLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzAtLS0xc3QtZWQtaGVhdmVuaGVhcnQtd2FyLWFuZ2VsLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzAtLS0xc3QtZWQtaGVhdmVuaGVhcnQtd2FyLWFuZ2VsLnBuZwEXODUSEXODUS/t',
    name: 'Heavenheart War-Angel',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenheart-War-Angel-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_106',
    s3_large_image_name:
      'MTA2LS0tQ29tbW9uLUhlYXZlbmhlYXJ0LVdhckFuZ2VsLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTA2LS0tQ29tbW9uLUhlYXZlbmhlYXJ0LVdhckFuZ2VsLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTA2LS0tQ29tbW9uLUhlYXZlbmhlYXJ0LVdhckFuZ2VsLTRDUC5wbmcEXODUS/t',
    name: 'Heavenheart War-Angel',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenheart-War-Angel-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_68',
    s3_large_image_name:
      'NjgtLS0ybmQtZWQtaGVhdmVuaGVhcnQtd2FyLWFuZ2VsLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjgtLS0ybmQtZWQtaGVhdmVuaGVhcnQtd2FyLWFuZ2VsLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjgtLS0ybmQtZWQtaGVhdmVuaGVhcnQtd2FyLWFuZ2VsLnBuZwEXODUSEXODUS/t',
    name: 'Heavenheart War-Angel',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenheart-War-Angel-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_147',
    s3_large_image_name:
      'MTQ3LS0tMTAtSGVhdmVuaGVhcnQtV2FyLUFuZ2VsLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ3LS0tMTAtSGVhdmVuaGVhcnQtV2FyLUFuZ2VsLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ3LS0tMTAtSGVhdmVuaGVhcnQtV2FyLUFuZ2VsLnBuZwEXODUSEXODUS/t',
    name: 'Heavenheart War-Angel',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenheart-War-Angel-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_390',
    s3_large_image_name:
      'MzkwLS0tSGVhdmVuaGVhcnQtV2FyLUFuZ2VsLVNrZXRjaC1DYXJkLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzkwLS0tSGVhdmVuaGVhcnQtV2FyLUFuZ2VsLVNrZXRjaC1DYXJkLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzkwLS0tSGVhdmVuaGVhcnQtV2FyLUFuZ2VsLVNrZXRjaC1DYXJkLnBuZwEXODUSEXODUS/t',
    name: 'Heavenheart War-Angel',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenheart-War-Angel-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_31',
    s3_large_image_name: 'MzEtLS0xc3QtZWQtaGVhdmVubHktZ3VhcmRpYW4ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzEtLS0xc3QtZWQtaGVhdmVubHktZ3VhcmRpYW4ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzEtLS0xc3QtZWQtaGVhdmVubHktZ3VhcmRpYW4ucG5n/t',
    name: 'Heavenly Guardian',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenly-Guardian-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_107',
    s3_large_image_name:
      'MTA3LS0tQ29tbW9uLUhlYXZlbmx5LUd1YXJkaWFuLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTA3LS0tQ29tbW9uLUhlYXZlbmx5LUd1YXJkaWFuLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTA3LS0tQ29tbW9uLUhlYXZlbmx5LUd1YXJkaWFuLTRDUC5wbmcEXODUS/t',
    name: 'Heavenly Guardian',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenly-Guardian-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_69',
    s3_large_image_name: 'NjktLS0ybmQtZWQtaGVhdmVubHktZ3VhcmRpYW4ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjktLS0ybmQtZWQtaGVhdmVubHktZ3VhcmRpYW4ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjktLS0ybmQtZWQtaGVhdmVubHktZ3VhcmRpYW4ucG5n/t',
    name: 'Heavenly Guardian',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenly-Guardian-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_148',
    s3_large_image_name: 'MTQ4LS0tMTEtSGVhdmVubHktR3VhcmRpYW4ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ4LS0tMTEtSGVhdmVubHktR3VhcmRpYW4ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ4LS0tMTEtSGVhdmVubHktR3VhcmRpYW4ucG5n/t',
    name: 'Heavenly Guardian',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenly-Guardian-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_391',
    s3_large_image_name:
      'MzkxLS0tUmFyZS1Ta2V0Y2gtSGVhdmVubHktR3VhcmRpYW4tNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzkxLS0tUmFyZS1Ta2V0Y2gtSGVhdmVubHktR3VhcmRpYW4tNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzkxLS0tUmFyZS1Ta2V0Y2gtSGVhdmVubHktR3VhcmRpYW4tNENQLnBuZwEXODUSEXODUS/t',
    name: 'Heavenly Guardian',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Heavenly-Guardian-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_275',
    s3_large_image_name: 'Mjc1LS0tQ0YtaGVsdmVyLWZvcm1hdGlvbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc1LS0tQ0YtaGVsdmVyLWZvcm1hdGlvbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc1LS0tQ0YtaGVsdmVyLWZvcm1hdGlvbi5wbmcEXODUS/t',
    name: 'Helver Formation',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect:
      "Pay 1 Life Point. Select one of your Common or Uncommon creatures in play that is multiple types and one of your opponent's creatures that is a single type and switch their energy levels.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Helver-Formation-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_17',
    s3_large_image_name: 'MTctLS0xc3QtZWQtaW52b2tlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTctLS0xc3QtZWQtaW52b2tlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTctLS0xc3QtZWQtaW52b2tlLnBuZwEXODUSEXODUS/t',
    name: 'Invoke',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and use it to start a new pile.',
    ruling: '',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Invoke-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_93',
    s3_large_image_name: 'OTMtLS1Db21tb24tSW52b2tlLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OTMtLS1Db21tb24tSW52b2tlLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OTMtLS1Db21tb24tSW52b2tlLTRDUC5wbmcEXODUS/t',
    name: 'Invoke',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and use it to start a new pile.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Invoke-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_113',
    s3_large_image_name: 'MTEzLS0tQ29tbW9uLUludm9rZTItNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTEzLS0tQ29tbW9uLUludm9rZTItNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTEzLS0tQ29tbW9uLUludm9rZTItNENQLnBuZwEXODUSEXODUS/t',
    name: 'Invoke',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and use it to start a new pile.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Invoke-Premiere-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_55',
    s3_large_image_name: 'NTUtLS0ybmQtZWQtaW52b2tlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTUtLS0ybmQtZWQtaW52b2tlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTUtLS0ybmQtZWQtaW52b2tlLnBuZwEXODUSEXODUS/t',
    name: 'Invoke',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and use it to start a new pile.',
    ruling: '',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Invoke-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_134',
    s3_large_image_name: 'MTM0LS0tMzctSW52b2tlX2RyYWdvbmlzLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTM0LS0tMzctSW52b2tlX2RyYWdvbmlzLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTM0LS0tMzctSW52b2tlX2RyYWdvbmlzLmpwZwEXODUSEXODUS/t',
    name: 'Invoke',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and use it to start a new pile.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Invoke-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_154',
    s3_large_image_name: 'MTU0LS0tMzAtSW52b2tlX3NreWJvcm4uanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTU0LS0tMzAtSW52b2tlX3NreWJvcm4uanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTU0LS0tMzAtSW52b2tlX3NreWJvcm4uanBn/t',
    name: 'Invoke',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Take one energy from your Energy Deck and use it to start a new pile.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Invoke-Unlimited-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_402',
    s3_large_image_name:
      'NDAyLS0tUmFyZS1Ta2V0Y2gtSXNsZXMtb2YtdGhlLU1vcm5pbmctU3Rhci00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDAyLS0tUmFyZS1Ta2V0Y2gtSXNsZXMtb2YtdGhlLU1vcm5pbmctU3Rhci00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDAyLS0tUmFyZS1Ta2V0Y2gtSXNsZXMtb2YtdGhlLU1vcm5pbmctU3Rhci00Q1AucG5n/t',
    name: 'Isles of the Morning Star',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Kenny Estrella',
    effect:
      'Draw 1 card from your Main Deck. Your opponent draws 1 card from their Energy Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Isles-of-the-Morning-Star-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_18',
    s3_large_image_name: 'MTgtLS0xc3QtZWQtbGVlY2gucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTgtLS0xc3QtZWQtbGVlY2gucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTgtLS0xc3QtZWQtbGVlY2gucG5n/t',
    name: 'Leech',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Choose one energy from a creature or pile on your opponent's side of the field and have them discard that energy card. Then, take one energy card from your Energy Deck and add it to a creature or pile on your side of the field. ",
    ruling:
      '<p>■&nbsp;<strong><em>Leech&nbsp;</em></strong><strong>is an all-or-nothing type of card</strong>;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Because its effect is broken up into 2 sentences,&nbsp;<strong>the first effect can\'t happen unless the second is possible</strong>&nbsp;and vice-versa;</p>\n<p><em>■ Leech&nbsp;</em>cannot be used to start a new pile of energy<em>;</em>&nbsp;it must be added to an existing one;</p>\n<p>■&nbsp;<em>Leech&nbsp;</em>can be played in response to a "When this creature is summoned..." Ability and will stop the Ability if it destroys the creature\'s last energy;</p>',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Leech-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_94',
    s3_large_image_name: 'OTQtLS1Db21tb24tTGVlY2gtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OTQtLS1Db21tb24tTGVlY2gtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OTQtLS1Db21tb24tTGVlY2gtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Leech',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Choose one energy from a creature or pile on your opponent's side of the field and have them discard that energy card. Then, take one energy card from your Energy Deck and add it to a creature or pile on your side of the field. ",
    ruling:
      '<p>■&nbsp;<strong><em>Leech&nbsp;</em></strong><strong>is an all-or-nothing type of card</strong>;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Because its effect is broken up into 2 sentences,&nbsp;<strong>the first effect can\'t happen unless the second is possible</strong>&nbsp;and vice-versa;</p>\n<p><em>■ Leech&nbsp;</em>cannot be used to start a new pile of energy<em>;</em>&nbsp;it must be added to an existing one;</p>\n<p>■&nbsp;<em>Leech&nbsp;</em>can be played in response to a "When this creature is summoned..." Ability and will stop the Ability if it destroys the creature\'s last energy;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Leech-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_114',
    s3_large_image_name: 'MTE0LS0tQ29tbW9uLUxlZWNoMi00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTE0LS0tQ29tbW9uLUxlZWNoMi00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTE0LS0tQ29tbW9uLUxlZWNoMi00Q1AucG5n/t',
    name: 'Leech',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Choose one energy from a creature or pile on your opponent's side of the field and have them discard that energy card. Then, take one energy card from your Energy Deck and add it to a creature or pile on your side of the field. ",
    ruling:
      '<p>■&nbsp;<strong><em>Leech&nbsp;</em></strong><strong>is an all-or-nothing type of card</strong>;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Because its effect is broken up into 2 sentences,&nbsp;<strong>the first effect can\'t happen unless the second is possible</strong>&nbsp;and vice-versa;</p>\n<p><em>■ Leech&nbsp;</em>cannot be used to start a new pile of energy<em>;</em>&nbsp;it must be added to an existing one;</p>\n<p>■&nbsp;<em>Leech&nbsp;</em>can be played in response to a "When this creature is summoned..." Ability and will stop the Ability if it destroys the creature\'s last energy;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Leech-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_56',
    s3_large_image_name: 'NTYtLS0ybmQtZWQtbGVlY2gucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTYtLS0ybmQtZWQtbGVlY2gucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTYtLS0ybmQtZWQtbGVlY2gucG5n/t',
    name: 'Leech',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Choose one energy from a creature or pile on your opponent's side of the field and have them discard that energy card. Then, take one energy card from your Energy Deck and add it to a creature or pile on your side of the field. ",
    ruling:
      '<p>■&nbsp;<strong><em>Leech&nbsp;</em></strong><strong>is an all-or-nothing type of card</strong>;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Because its effect is broken up into 2 sentences,&nbsp;<strong>the first effect can\'t happen unless the second is possible</strong>&nbsp;and vice-versa;</p>\n<p><em>■ Leech&nbsp;</em>cannot be used to start a new pile of energy<em>;</em>&nbsp;it must be added to an existing one;</p>\n<p>■&nbsp;<em>Leech&nbsp;</em>can be played in response to a "When this creature is summoned..." Ability and will stop the Ability if it destroys the creature\'s last energy;</p>',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Leech-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_135',
    s3_large_image_name: 'MTM1LS0tMzgtTGVlY2hfZHJhZ29uaXMuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTM1LS0tMzgtTGVlY2hfZHJhZ29uaXMuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTM1LS0tMzgtTGVlY2hfZHJhZ29uaXMuanBn/t',
    name: 'Leech',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Choose one energy from a creature or pile on your opponent's side of the field and have them discard that energy card. Then, take one energy card from your Energy Deck and add it to a creature or pile on your side of the field. ",
    ruling:
      '<p>■&nbsp;<strong><em>Leech&nbsp;</em></strong><strong>is an all-or-nothing type of card</strong>;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Because its effect is broken up into 2 sentences,&nbsp;<strong>the first effect can\'t happen unless the second is possible</strong>&nbsp;and vice-versa;</p>\n<p><em>■ Leech&nbsp;</em>cannot be used to start a new pile of energy<em>;</em>&nbsp;it must be added to an existing one;</p>\n<p>■&nbsp;<em>Leech&nbsp;</em>can be played in response to a "When this creature is summoned..." Ability and will stop the Ability if it destroys the creature\'s last energy;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Leech-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_155',
    s3_large_image_name: 'MTU1LS0tMzEtTGVlY2hfc2t5Ym9ybi5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTU1LS0tMzEtTGVlY2hfc2t5Ym9ybi5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTU1LS0tMzEtTGVlY2hfc2t5Ym9ybi5qcGcEXODUS/t',
    name: 'Leech',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Choose one energy from a creature or pile on your opponent's side of the field and have them discard that energy card. Then, take one energy card from your Energy Deck and add it to a creature or pile on your side of the field. ",
    ruling:
      '<p>■&nbsp;<strong><em>Leech&nbsp;</em></strong><strong>is an all-or-nothing type of card</strong>;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Because its effect is broken up into 2 sentences,&nbsp;<strong>the first effect can\'t happen unless the second is possible</strong>&nbsp;and vice-versa;</p>\n<p><em>■ Leech&nbsp;</em>cannot be used to start a new pile of energy<em>;</em>&nbsp;it must be added to an existing one;</p>\n<p>■&nbsp;<em>Leech&nbsp;</em>can be played in response to a "When this creature is summoned..." Ability and will stop the Ability if it destroys the creature\'s last energy;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Leech-Unlimited',
    is_default_edition: false,
  },
  {
    card_id: 'card_369',
    s3_large_image_name:
      'MzY5LS0tQm9DLUxpZ2h0cGF0aC1QYWxhZGluLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzY5LS0tQm9DLUxpZ2h0cGF0aC1QYWxhZGluLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzY5LS0tQm9DLUxpZ2h0cGF0aC1QYWxhZGluLmpwZwEXODUSEXODUS/t',
    name: 'Lightpath Paladin',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lightpath-Paladin-Limited',
    is_default_edition: true,
  },
  {
    card_id: 'card_533',
    s3_large_image_name:
      'NTMzLS0tbGUtbHVjaWEtbGlldmRyYWhzLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTMzLS0tbGUtbHVjaWEtbGlldmRyYWhzLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTMzLS0tbGUtbHVjaWEtbGlldmRyYWhzLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Lucia Lievdrahs',
    set_name: 'The Dimension That Disappeared',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Tommy Suhartono',
    effect:
      'Destroy 1 of your frozen cards in play. Then, target up to 2 energy in play and permanently freeze them.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lucia-Lievdrahs-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_385',
    s3_large_image_name:
      'Mzg1LS0tUmFyZS1Ta2V0Y2gtTHVzdHJvdXMtTGlnaHRicmluZ2VyLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg1LS0tUmFyZS1Ta2V0Y2gtTHVzdHJvdXMtTGlnaHRicmluZ2VyLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzg1LS0tUmFyZS1Ta2V0Y2gtTHVzdHJvdXMtTGlnaHRicmluZ2VyLTRDUC5wbmcEXODUS/t',
    name: 'Lustrous Lightbringer',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lustrous-Lightbringer-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_32',
    s3_large_image_name:
      'MzItLS0xc3QtZWQtbHVzdHJvdXMtbGlnaHRicmluZ2VyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzItLS0xc3QtZWQtbHVzdHJvdXMtbGlnaHRicmluZ2VyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzItLS0xc3QtZWQtbHVzdHJvdXMtbGlnaHRicmluZ2VyLnBuZwEXODUSEXODUS/t',
    name: 'Lustrous Lightbringer',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lustrous-Lightbringer-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_108',
    s3_large_image_name:
      'MTA4LS0tVW5jb21tb24tTHVzdHJvdXMtTGlnaHRicmluZ2VyLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTA4LS0tVW5jb21tb24tTHVzdHJvdXMtTGlnaHRicmluZ2VyLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTA4LS0tVW5jb21tb24tTHVzdHJvdXMtTGlnaHRicmluZ2VyLTRDUC5wbmcEXODUS/t',
    name: 'Lustrous Lightbringer',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lustrous-Lightbringer-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_70',
    s3_large_image_name:
      'NzAtLS0ybmQtZWQtbHVzdHJvdXMtbGlnaHRicmluZ2VyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NzAtLS0ybmQtZWQtbHVzdHJvdXMtbGlnaHRicmluZ2VyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NzAtLS0ybmQtZWQtbHVzdHJvdXMtbGlnaHRicmluZ2VyLnBuZwEXODUSEXODUS/t',
    name: 'Lustrous Lightbringer',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lustrous-Lightbringer-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_149',
    s3_large_image_name:
      'MTQ5LS0tMTItTHVzdHJvdXMtTGlnaHRicmluZ2VyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ5LS0tMTItTHVzdHJvdXMtTGlnaHRicmluZ2VyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTQ5LS0tMTItTHVzdHJvdXMtTGlnaHRicmluZ2VyLnBuZwEXODUSEXODUS/t',
    name: 'Lustrous Lightbringer',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Lustrous-Lightbringer-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_534',
    s3_large_image_name:
      'NTM0LS0tbGUtbWFkbmVzcy1zZXR0bGVzLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTM0LS0tbGUtbWFkbmVzcy1zZXR0bGVzLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTM0LS0tbGUtbWFkbmVzcy1zZXR0bGVzLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: 'Madness Settles',
    set_name: 'The Dimension That Disappeared',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Tommy Suhartono',
    effect:
      "Your Life Points become 3. Your Chronos don't lose energy this turn unless by your own card effects or Abilities. You can't resolve effects or Abilities that switch Life Points with your opponent for the rest of the game.",
    ruling:
      "<p>■ If&nbsp;<em>Tethered to Eeventide</em>&nbsp;is played while&nbsp;<em>Madness Settles</em>&nbsp;is active, the targeted creature will effectively be destroyed, but its energy will remain in play as a blank pile. This is due to the fact that Tethered's effect simultaneously destroys the creature and its energy<em>—</em>but&nbsp;<em>Madness Settles</em>&nbsp;prevents the Chrono's energy from being destroyed, thus, only the creature gets destroyed;</p>\n<p>■&nbsp;Cards such as&nbsp;<em>Unsummon</em>&nbsp;remove the targeted creature&nbsp;<strong><u>before</u></strong>&nbsp;the energy is destroyed, so&nbsp;<em>Madness Settles</em>&nbsp;will no longer effect the energy that was attached to the targeted creature once the creature leaves play;<br><br>■&nbsp;&nbsp;<strong><sup>[NEW]&nbsp;&nbsp;</sup></strong>If Anathema's creature side Ability is active when this card is played, your Life Points won't become 3, but the rest of its effect still applies as your Life Points becoming 3 isn't a cost;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Madness-Settles-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_665',
    s3_large_image_name: 'NjY1LS0tbGUtbWFnbWEtbW91bnRhaW4tbGF2YXNzdXMucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjY1LS0tbGUtbWFnbWEtbW91bnRhaW4tbGF2YXNzdXMucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjY1LS0tbGUtbWFnbWEtbW91bnRhaW4tbGF2YXNzdXMucG5n/t',
    name: 'Magma Mountain Lavassus',
    set_name: 'Threshold of Time',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Hailfire', 'Mountain'],
    creature_type_count: 2,
    artist: 'Tanatola',
    effect:
      'When this creature enters play, you may add 1 Hailfire from your graveyard to your hand for each rarity you have in play. *Ignite *Burst',
    ruling:
      "<p>■&nbsp;Because this creature's Ability does not specify card type, rarity is checked among all types of cards you have in play;</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Magma-Mountain-Lavassus-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_413',
    s3_large_image_name: 'NDEzLS0tTWFpbi1EZWNrLVN0cmlrZS1Ta2V0Y2gucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDEzLS0tTWFpbi1EZWNrLVN0cmlrZS1Ta2V0Y2gucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDEzLS0tTWFpbi1EZWNrLVN0cmlrZS1Ta2V0Y2gucG5n/t',
    name: 'Main Deck Strike',
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Nivea Toliver',
    effect:
      "Send the top card of your opponent's Main Deck to their graveyard.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Main-Deck-Strike-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_33',
    s3_large_image_name: 'MzMtLS0xc3QtZWQtbWFqZXN0aWMtbm96aXJvaC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzMtLS0xc3QtZWQtbWFqZXN0aWMtbm96aXJvaC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzMtLS0xc3QtZWQtbWFqZXN0aWMtbm96aXJvaC5wbmcEXODUS/t',
    name: 'Majestic Noziroh',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Angel', 'Wolf'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Majestic-Noziroh-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_109',
    s3_large_image_name:
      'MTA5LS0tQ29tbW9uLU1hamVzdGljLU5vemlyb2gtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTA5LS0tQ29tbW9uLU1hamVzdGljLU5vemlyb2gtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTA5LS0tQ29tbW9uLU1hamVzdGljLU5vemlyb2gtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Majestic Noziroh',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Angel', 'Wolf'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Majestic-Noziroh-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_71',
    s3_large_image_name: 'NzEtLS0ybmQtZWQtbWFqZXN0aWMtbm96aXJvaC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NzEtLS0ybmQtZWQtbWFqZXN0aWMtbm96aXJvaC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NzEtLS0ybmQtZWQtbWFqZXN0aWMtbm96aXJvaC5wbmcEXODUS/t',
    name: 'Majestic Noziroh',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Angel', 'Wolf'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Majestic-Noziroh-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_150',
    s3_large_image_name: 'MTUwLS0tMTMtTWFqZXN0aWMtTm96aXJvaC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTUwLS0tMTMtTWFqZXN0aWMtTm96aXJvaC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTUwLS0tMTMtTWFqZXN0aWMtTm96aXJvaC5wbmcEXODUS/t',
    name: 'Majestic Noziroh',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Angel', 'Wolf'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Majestic-Noziroh-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_392',
    s3_large_image_name:
      'MzkyLS0tUmFyZS1Ta2V0Y2gtTWFqZXN0aWMtTm96aXJvaC00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzkyLS0tUmFyZS1Ta2V0Y2gtTWFqZXN0aWMtTm96aXJvaC00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzkyLS0tUmFyZS1Ta2V0Y2gtTWFqZXN0aWMtTm96aXJvaC00Q1AucG5n/t',
    name: 'Majestic Noziroh',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel', 'Wolf'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Majestic-Noziroh-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_666',
    s3_large_image_name: 'NjY2LS0tbGUtbWFyZ2FuYS1jaGltZXJpYy1saWJyYXJpYW4ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjY2LS0tbGUtbWFyZ2FuYS1jaGltZXJpYy1saWJyYXJpYW4ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjY2LS0tbGUtbWFyZ2FuYS1jaGltZXJpYy1saWJyYXJpYW4ucG5n/t',
    name: 'Margana, Chimeric Librarian',
    set_name: 'Threshold of Time',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Drifter', 'Archive'],
    creature_type_count: 2,
    artist: 'Nivea Toliver',
    effect:
      'This creature can only enter play on top of a Drifter. Once per turn, when this creature transforms into another creature, you may search your Main Deck or graveyard for an Archive creature and add it to your hand. (Shuffle your Main Deck if it was searched.)',
    ruling:
      '<ul>\n<li style="font-weight: 400;"><span style="font-weight: 400;"><em>Margana’s</em>&nbsp;Ability specifically states, “</span><strong>Once per turn</strong><span style="font-weight: 400;">, when&nbsp;</span><strong>this</strong><span style="font-weight: 400;">&nbsp;creature transforms into another creature…”;&nbsp;</span></li>\n<ul>\n<li style="font-weight: 400;"><span style="font-weight: 400;">Drifter/Archive creatures are considered one in the same creature, meaning this Ability can only be used once per turn, regardless if you have multiple copies of&nbsp;<em>Margana</em>&nbsp;being transformed within the Archive stack;</span></li>\n</ul>\n</ul>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Margana--Chimeric-Librarian-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_373',
    s3_large_image_name:
      'MzczLS0tUmFyZS1Ta2V0Y2gtTWlzdHJhaS1EcmFnb24tRXh0ZW5kZWQtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzczLS0tUmFyZS1Ta2V0Y2gtTWlzdHJhaS1EcmFnb24tRXh0ZW5kZWQtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzczLS0tUmFyZS1Ta2V0Y2gtTWlzdHJhaS1EcmFnb24tRXh0ZW5kZWQtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Mistrai Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Mistform'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mistrai-Dragon-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_419',
    s3_large_image_name:
      'NDE5LS0tUmFyZS1NaXN0cmFpLURyYWdvbi1FeHRlbmRlZC00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDE5LS0tUmFyZS1NaXN0cmFpLURyYWdvbi1FeHRlbmRlZC00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDE5LS0tUmFyZS1NaXN0cmFpLURyYWdvbi1FeHRlbmRlZC00Q1AucG5n/t',
    name: 'Mistrai Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Mistform'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mistrai-Dragon-Premiere-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_420',
    s3_large_image_name:
      'NDIwLS0tUHJvbW8tUmFyZS1NaXN0cmFpLURyYWdvbi1FeHRlbmRlZC00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDIwLS0tUHJvbW8tUmFyZS1NaXN0cmFpLURyYWdvbi1FeHRlbmRlZC00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDIwLS0tUHJvbW8tUmFyZS1NaXN0cmFpLURyYWdvbi1FeHRlbmRlZC00Q1AucG5n/t',
    name: 'Mistrai Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Mistform'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mistrai-Dragon-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_8',
    s3_large_image_name: 'OC0tLTFzdC1lZC1taXN0cmFpLWRyYWdvbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OC0tLTFzdC1lZC1taXN0cmFpLWRyYWdvbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OC0tLTFzdC1lZC1taXN0cmFpLWRyYWdvbi5wbmcEXODUS/t',
    name: 'Mistrai Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Mistform'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mistrai-Dragon-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_84',
    s3_large_image_name: 'ODQtLS1VbmNvbW1vbi1NaXN0cmFpLURyYWdvbi00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/ODQtLS1VbmNvbW1vbi1NaXN0cmFpLURyYWdvbi00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/ODQtLS1VbmNvbW1vbi1NaXN0cmFpLURyYWdvbi00Q1AucG5n/t',
    name: 'Mistrai Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Mistform'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mistrai-Dragon-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_46',
    s3_large_image_name: 'NDYtLS0ybmQtZWQtbWlzdHJhaS1kcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDYtLS0ybmQtZWQtbWlzdHJhaS1kcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDYtLS0ybmQtZWQtbWlzdHJhaS1kcmFnb24ucG5n/t',
    name: 'Mistrai Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Mistform'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mistrai-Dragon-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_125',
    s3_large_image_name: 'MTI1LS0tMjEtTWlzdHJhaS1EcmFnb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTI1LS0tMjEtTWlzdHJhaS1EcmFnb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTI1LS0tMjEtTWlzdHJhaS1EcmFnb24ucG5n/t',
    name: 'Mistrai Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Mistform'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mistrai-Dragon-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_268',
    s3_large_image_name: 'MjY4LS0tQ0YtbW9ydGFyYmxvb20tbGllZ2UucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjY4LS0tQ0YtbW9ydGFyYmxvb20tbGllZ2UucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjY4LS0tQ0YtbW9ydGFyYmxvb20tbGllZ2UucG5n/t',
    name: 'Mortarbloom Liege',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    effect:
      'When this creature is put into play except by a summon, each player reveals the top 2 cards of their Main Deck.',
    ruling:
      '<p>■&nbsp;The cards revealed by this creature\'s Ability are put back in the same order they are revealed;</p>\n<p>■&nbsp;If you reveal a&nbsp;<em>Vanquish, Reverser of Time</em>&nbsp;due to this creature\'s "Clarity Cannon" Ability,&nbsp;<em>Vanquish</em>\'s "Luminescent Chance" Ability allows you to send a card from your opponent\'s Main Deck to their graveyard; you MAY select one of the two cards being revealed from the "Clarity Cannon" Ability as those cards are still considered part of their Main Deck and are only being revealed;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Mortarbloom-Liege-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_276',
    s3_large_image_name: 'Mjc2LS0tQ0YtbmVidWxhLWdleXNlci1tZWFkb3cucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc2LS0tQ0YtbmVidWxhLWdleXNlci1tZWFkb3cucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc2LS0tQ0YtbmVidWxhLWdleXNlci1tZWFkb3cucG5n/t',
    name: 'Nebula Geyser Meadow',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'S. Calvin',
    effect:
      'Select one Common or Uncommon creature in your graveyard and put it into play on an existing blank pile of energy on your side of the field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Nebula-Geyser-Meadow-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_266',
    s3_large_image_name:
      'MjY2LS0tQ0YtTmVidWxhd29vZC1CYXJyaWVyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjY2LS0tQ0YtTmVidWxhd29vZC1CYXJyaWVyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjY2LS0tQ0YtTmVidWxhd29vZC1CYXJyaWVyLnBuZwEXODUSEXODUS/t',
    name: 'Nebulawood Barrier',
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Odysseas Stamoglou',
    effect:
      'Put a creature from your hand into play on a blank pile of energy on your field.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Nebulawood-Barrier-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_667',
    s3_large_image_name:
      'NjY3LS0tbGUtbm9lbGxhZy10aGUtY3J1Y2libGUtb2YtdGltZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjY3LS0tbGUtbm9lbGxhZy10aGUtY3J1Y2libGUtb2YtdGltZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjY3LS0tbGUtbm9lbGxhZy10aGUtY3J1Y2libGUtb2YtdGltZS5wbmcEXODUS/t',
    name: 'Noellag the Crucible of Time',
    set_name: 'Threshold of Time',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Leviathan'],
    creature_type_count: 1,
    artist: 'Monztre Ink Studio',
    effect:
      'While this creature is in play, if you have at least 3 different rarities among your creatures in play, you may attack regardless of any effects or Abilities that prevent you or your creature(s) from attacking. When this creature leaves play, move 2 energy in play somewhere else on the same side of the field.',
    ruling:
      '<p>■ Secret Rare and Harmony Rare are counted as a different rarity from Rare in regards to this creature\'s "Time Fracture" Ability;&nbsp;<br><br>■ You are not required to make the 2 energy move to the same target for this creature\'s Ability—they may even be moved off a target to start a new pile;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Noellag-the-Crucible-of-Time-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_9',
    s3_large_image_name: 'OS0tLTFzdC1lZC1vY2Vhbm8tZHJhZ29uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OS0tLTFzdC1lZC1vY2Vhbm8tZHJhZ29uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OS0tLTFzdC1lZC1vY2Vhbm8tZHJhZ29uLnBuZwEXODUSEXODUS/t',
    name: 'Oceano Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Shardfolk'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Oceano-Dragon-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_85',
    s3_large_image_name:
      'ODUtLS1VbmNvbW1vbi1PY2Vhbm8tRHJhZ29uLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/ODUtLS1VbmNvbW1vbi1PY2Vhbm8tRHJhZ29uLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/ODUtLS1VbmNvbW1vbi1PY2Vhbm8tRHJhZ29uLTRDUC5wbmcEXODUS/t',
    name: 'Oceano Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Shardfolk'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Oceano-Dragon-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_47',
    s3_large_image_name: 'NDctLS0ybmQtZWQtb2NlYW5vLWRyYWdvbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDctLS0ybmQtZWQtb2NlYW5vLWRyYWdvbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDctLS0ybmQtZWQtb2NlYW5vLWRyYWdvbi5wbmcEXODUS/t',
    name: 'Oceano Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Shardfolk'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Oceano-Dragon-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_126',
    s3_large_image_name: 'MTI2LS0tMjItT2NlYW5vLURyYWdvbi5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTI2LS0tMjItT2NlYW5vLURyYWdvbi5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTI2LS0tMjItT2NlYW5vLURyYWdvbi5wbmcEXODUS/t',
    name: 'Oceano Dragon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Shardfolk'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Oceano-Dragon-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_668',
    s3_large_image_name:
      'NjY4LS0tbGUtb2xpdmVyJ3MtcHN5bGVycmFuLXBvd2VyLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjY4LS0tbGUtb2xpdmVyJ3MtcHN5bGVycmFuLXBvd2VyLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjY4LS0tbGUtb2xpdmVyJ3MtcHN5bGVycmFuLXBvd2VyLnBuZwEXODUSEXODUS/t',
    name: "Oliver's Psylerran Power",
    set_name: 'Threshold of Time',
    rarity: 'Secret Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Albert Zhou',
    effect:
      'If your opponent has energy in play greater than your Life Points, draw energy equal to the difference.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Oliver-s-Psylerran-Power-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_449',
    s3_large_image_name: 'NDQ5LS0tUGxhZ3Vlc3BpcmUtQ2FsYW1pdHktUHJvbW8ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ5LS0tUGxhZ3Vlc3BpcmUtQ2FsYW1pdHktUHJvbW8ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ5LS0tUGxhZ3Vlc3BpcmUtQ2FsYW1pdHktUHJvbW8ucG5n/t',
    name: 'Plaguespire Calamity',
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Wolf'],
    creature_type_count: 2,
    artist: 'Nivea Toliver',
    effect:
      "This creature may attack your opponent's Life Points directly. If its energy exceeds 1, it is immediately destroyed (and all energy attached to it).",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Plaguespire-Calamity-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_403',
    s3_large_image_name:
      'NDAzLS0tUmFyZS1Ta2V0Y2gtUHJpbmNlc3Mtb2YtQmxhZGVzLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDAzLS0tUmFyZS1Ta2V0Y2gtUHJpbmNlc3Mtb2YtQmxhZGVzLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDAzLS0tUmFyZS1Ta2V0Y2gtUHJpbmNlc3Mtb2YtQmxhZGVzLTRDUC5wbmcEXODUS/t',
    name: 'Princess of Blades',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Didi Esmeralda',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Princess-of-Blades-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_36',
    s3_large_image_name: 'MzYtLS0xc3QtZWQtcmVldmFsdWF0ZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzYtLS0xc3QtZWQtcmVldmFsdWF0ZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzYtLS0xc3QtZWQtcmVldmFsdWF0ZS5wbmcEXODUS/t',
    name: 'Reevaluate',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Discard your entire hand and draw the same amount of cards from your Main Deck. When this card is played, it is no longer counted as a card in your hand.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Reevaluate-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_115',
    s3_large_image_name:
      'MTE1LS0tQ29tbW9uLVJlZXZhbHVhdGUtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTE1LS0tQ29tbW9uLVJlZXZhbHVhdGUtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTE1LS0tQ29tbW9uLVJlZXZhbHVhdGUtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Reevaluate',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Discard your entire hand and draw the same amount of cards from your Main Deck. When this card is played, it is no longer counted as a card in your hand.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Reevaluate-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_74',
    s3_large_image_name: 'NzQtLS0ybmQtZWQtcmVldmFsdWF0ZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NzQtLS0ybmQtZWQtcmVldmFsdWF0ZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NzQtLS0ybmQtZWQtcmVldmFsdWF0ZS5wbmcEXODUS/t',
    name: 'Reevaluate',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Discard your entire hand and draw the same amount of cards from your Main Deck. When this card is played, it is no longer counted as a card in your hand.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Reevaluate-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_156',
    s3_large_image_name: 'MTU2LS0tMzItUmVldmFsdWF0ZS5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTU2LS0tMzItUmVldmFsdWF0ZS5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTU2LS0tMzItUmVldmFsdWF0ZS5qcGcEXODUS/t',
    name: 'Reevaluate',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Discard your entire hand and draw the same amount of cards from your Main Deck. When this card is played, it is no longer counted as a card in your hand.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Reevaluate-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_19',
    s3_large_image_name: 'MTktLS0xc3QtZWQtcmV2ZXJzaW9uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTktLS0xc3QtZWQtcmV2ZXJzaW9uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTktLS0xc3QtZWQtcmV2ZXJzaW9uLnBuZwEXODUSEXODUS/t',
    name: 'Reversion',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Select one creature on the field and return it to the owner's hand. All energy attached to that creature remains in play. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Reversion-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_95',
    s3_large_image_name: 'OTUtLS1Db21tb24tUmV2ZXJzaW9uLTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OTUtLS1Db21tb24tUmV2ZXJzaW9uLTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OTUtLS1Db21tb24tUmV2ZXJzaW9uLTRDUC5wbmcEXODUS/t',
    name: 'Reversion',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Select one creature on the field and return it to the owner's hand. All energy attached to that creature remains in play. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Reversion-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_57',
    s3_large_image_name: 'NTctLS0ybmQtZWQtcmV2ZXJzaW9uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTctLS0ybmQtZWQtcmV2ZXJzaW9uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTctLS0ybmQtZWQtcmV2ZXJzaW9uLnBuZwEXODUSEXODUS/t',
    name: 'Reversion',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Select one creature on the field and return it to the owner's hand. All energy attached to that creature remains in play. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Reversion-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_136',
    s3_large_image_name: 'MTM2LS0tMzktUmV2ZXJzaW9uLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTM2LS0tMzktUmV2ZXJzaW9uLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTM2LS0tMzktUmV2ZXJzaW9uLmpwZwEXODUSEXODUS/t',
    name: 'Reversion',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Select one creature on the field and return it to the owner's hand. All energy attached to that creature remains in play. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Reversion-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_374',
    s3_large_image_name:
      'Mzc0LS0tUmFyZS1Ta2V0Y2gtUm9zZS1TbGl0aGUtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc0LS0tUmFyZS1Ta2V0Y2gtUm9zZS1TbGl0aGUtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc0LS0tUmFyZS1Ta2V0Y2gtUm9zZS1TbGl0aGUtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Rose Slithe',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rose-Slithe-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_10',
    s3_large_image_name: 'MTAtLS0xc3QtZWQtcm9zZS1zbGl0aGUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTAtLS0xc3QtZWQtcm9zZS1zbGl0aGUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTAtLS0xc3QtZWQtcm9zZS1zbGl0aGUucG5n/t',
    name: 'Rose Slithe',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rose-Slithe-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_86',
    s3_large_image_name: 'ODYtLS1VbmNvbW1vbi1Sb3NlLVNsaXRoZS00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/ODYtLS1VbmNvbW1vbi1Sb3NlLVNsaXRoZS00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/ODYtLS1VbmNvbW1vbi1Sb3NlLVNsaXRoZS00Q1AucG5n/t',
    name: 'Rose Slithe',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rose-Slithe-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_48',
    s3_large_image_name: 'NDgtLS0ybmQtZWQtcm9zZS1zbGl0aGUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDgtLS0ybmQtZWQtcm9zZS1zbGl0aGUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDgtLS0ybmQtZWQtcm9zZS1zbGl0aGUucG5n/t',
    name: 'Rose Slithe',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rose-Slithe-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_127',
    s3_large_image_name: 'MTI3LS0tMjMtUm9zZS1TbGl0aGUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTI3LS0tMjMtUm9zZS1TbGl0aGUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTI3LS0tMjMtUm9zZS1TbGl0aGUucG5n/t',
    name: 'Rose Slithe',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rose-Slithe-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_277',
    s3_large_image_name: 'Mjc3LS0tQ0Ytcm9zZXMtcmVhY2gucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc3LS0tQ0Ytcm9zZXMtcmVhY2gucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mjc3LS0tQ0Ytcm9zZXMtcmVhY2gucG5n/t',
    name: "Rose's Reach",
    set_name: 'Crystal Forge',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Hafid Moenir',
    effect:
      'If you have at least 1 Common, Uncommon, and Rare creature on your field, unfreeze all non-Shardfolk creatures in play.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Rose-s-Reach-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_414',
    s3_large_image_name:
      'NDE0LS0tU2VjbHVkZWQtU2hvcnRjdXQtU2tldGNoLmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDE0LS0tU2VjbHVkZWQtU2hvcnRjdXQtU2tldGNoLmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDE0LS0tU2VjbHVkZWQtU2hvcnRjdXQtU2tldGNoLmpwZwEXODUSEXODUS/t',
    name: 'Secluded Shortcut',
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Pradipta Candra',
    effect: 'Draw 1 card from your Energy Deck. You lose 1 Life Point.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Secluded-Shortcut-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_450',
    s3_large_image_name:
      'NDUwLS0tU2hhY2tsZWQtU2lsZW5jZXItU2t5Ym9ybnMtUmVncmV0LVByb21vLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDUwLS0tU2hhY2tsZWQtU2lsZW5jZXItU2t5Ym9ybnMtUmVncmV0LVByb21vLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDUwLS0tU2hhY2tsZWQtU2lsZW5jZXItU2t5Ym9ybnMtUmVncmV0LVByb21vLnBuZwEXODUSEXODUS/t',
    name: "Shackled Silencer, Skyborn's Regret",
    set_name: 'Converging Chasms',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Nivea Toliver',
    effect:
      'When one of your Angels is attacked, you may put this creature from your hand into play on a blank pile on your field and have it gain 1 energy. Then, it battles alongside your Angel against the attacking creature. Each creature deals and receives damage simultaneously.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Shackled-Silencer--Skyborn-s-Regret-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_11',
    s3_large_image_name: 'MTEtLS0xc3QtZWQtc2t5d2FyZC1zbGl0aGUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTEtLS0xc3QtZWQtc2t5d2FyZC1zbGl0aGUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTEtLS0xc3QtZWQtc2t5d2FyZC1zbGl0aGUucG5n/t',
    name: 'Skyward Slithe',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Skyward-Slithe-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_87',
    s3_large_image_name:
      'ODctLS1Db21tb24tU2t5d2FyZC1TbGl0aGUtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/ODctLS1Db21tb24tU2t5d2FyZC1TbGl0aGUtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/ODctLS1Db21tb24tU2t5d2FyZC1TbGl0aGUtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Skyward Slithe',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Skyward-Slithe-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_49',
    s3_large_image_name: 'NDktLS0ybmQtZWQtc2t5d2FyZC1zbGl0aGUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDktLS0ybmQtZWQtc2t5d2FyZC1zbGl0aGUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDktLS0ybmQtZWQtc2t5d2FyZC1zbGl0aGUucG5n/t',
    name: 'Skyward Slithe',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Skyward-Slithe-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_128',
    s3_large_image_name: 'MTI4LS0tMjQtU2t5d2FyZC1TbGl0aGUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTI4LS0tMjQtU2t5d2FyZC1TbGl0aGUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTI4LS0tMjQtU2t5d2FyZC1TbGl0aGUucG5n/t',
    name: 'Skyward Slithe',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Skyward-Slithe-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_379',
    s3_large_image_name:
      'Mzc5LS0tUmFyZS1Ta2V0Y2gtU2t5d2FyZC1TbGl0aGUtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc5LS0tUmFyZS1Ta2V0Y2gtU2t5d2FyZC1TbGl0aGUtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/Mzc5LS0tUmFyZS1Ta2V0Y2gtU2t5d2FyZC1TbGl0aGUtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Skyward Slithe',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Slithe'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Skyward-Slithe-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_12',
    s3_large_image_name: 'MTItLS0xc3QtZWQtc2xpdGhlci1kcmFrZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTItLS0xc3QtZWQtc2xpdGhlci1kcmFrZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTItLS0xc3QtZWQtc2xpdGhlci1kcmFrZS5wbmcEXODUS/t',
    name: 'Slither Drake',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Slithe'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Slither-Drake-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_88',
    s3_large_image_name: 'ODgtLS1Db21tb24tU2xpdGhlci1EcmFrZS00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/ODgtLS1Db21tb24tU2xpdGhlci1EcmFrZS00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/ODgtLS1Db21tb24tU2xpdGhlci1EcmFrZS00Q1AucG5n/t',
    name: 'Slither Drake',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Slithe'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Slither-Drake-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_50',
    s3_large_image_name: 'NTAtLS0ybmQtZWQtc2xpdGhlci1kcmFrZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTAtLS0ybmQtZWQtc2xpdGhlci1kcmFrZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTAtLS0ybmQtZWQtc2xpdGhlci1kcmFrZS5wbmcEXODUS/t',
    name: 'Slither Drake',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Slithe'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Slither-Drake-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_129',
    s3_large_image_name: 'MTI5LS0tMjUtU2xpdGhlci1EcmFrZS5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTI5LS0tMjUtU2xpdGhlci1EcmFrZS5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTI5LS0tMjUtU2xpdGhlci1EcmFrZS5qcGcEXODUS/t',
    name: 'Slither Drake',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Slithe'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Slither-Drake-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_380',
    s3_large_image_name: 'MzgwLS0tUmFyZS1Ta2V0Y2gtU2xpdGhlci1EcmFrZS00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzgwLS0tUmFyZS1Ta2V0Y2gtU2xpdGhlci1EcmFrZS00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzgwLS0tUmFyZS1Ta2V0Y2gtU2xpdGhlci1EcmFrZS00Q1AucG5n/t',
    name: 'Slither Drake',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon', 'Slithe'],
    creature_type_count: 2,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Slither-Drake-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_669',
    s3_large_image_name:
      'NjY5LS0tbGUtdGFjaHlvbi10b3VyYmlsbG9uLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NjY5LS0tbGUtdGFjaHlvbi10b3VyYmlsbG9uLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NjY5LS0tbGUtdGFjaHlvbi10b3VyYmlsbG9uLnBuZwEXODUSEXODUS/t',
    name: 'Tachyon Tourbillon',
    set_name: 'Threshold of Time',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Machine'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect:
      "When this creature is rebuilt, send 1 energy in play to the owner's hand and draw 1 energy. If any Phase was skipped or done out of order this turn, activate this Ability from a viewable zone to target 1 of your Machines in play and rebuild it (even if it and the rebuild target have already been rebuilt this turn).",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Tachyon-Tourbillon-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_437',
    s3_large_image_name:
      'NDM3LS0tUHJvbW8tUmFyZS1UZXRoZXJlZC10by1FZXZlbnRpZGUtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDM3LS0tUHJvbW8tUmFyZS1UZXRoZXJlZC10by1FZXZlbnRpZGUtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDM3LS0tUHJvbW8tUmFyZS1UZXRoZXJlZC10by1FZXZlbnRpZGUtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Tethered to Eeventide',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'If you have only 1 Life Point left, destroy an opposing creature and all energy attached to it.',
    ruling:
      "<p>■&nbsp;This card's effect targets an opposing creature AND that creature's energy simultaneously;</p>\n<p>■ This card's requirement is not considered a cost;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - You may resolve the rest of this card's effect if you fulfill the condition of having 1 Life Point, or if you can ignore the requirement entirely due to an effect or Ability, such as&nbsp;<em>Silent Irregularity's&nbsp;</em>Afterthought Ability.</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Tethered-to-Eeventide-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_438',
    s3_large_image_name: 'NDM4LS0tMjAxOC1UZXRoZXJlZC10by1FZXZlbnRpZGUucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDM4LS0tMjAxOC1UZXRoZXJlZC10by1FZXZlbnRpZGUucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDM4LS0tMjAxOC1UZXRoZXJlZC10by1FZXZlbnRpZGUucG5n/t',
    name: 'Tethered to Eeventide',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'If you have only 1 Life Point left, destroy an opposing creature and all energy attached to it.',
    ruling:
      "<p>■&nbsp;This card's effect targets an opposing creature AND that creature's energy simultaneously;</p>\n<p>■ This card's requirement is not considered a cost;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - You may resolve the rest of this card's effect if you fulfill the condition of having 1 Life Point, or if you can ignore the requirement entirely due to an effect or Ability, such as&nbsp;<em>Silent Irregularity's&nbsp;</em>Afterthought Ability.</p>",
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Tethered-to-Eeventide-Promo',
    is_default_edition: false,
  },
  {
    card_id: 'card_428',
    s3_large_image_name:
      'NDI4LS0tUHJvbW8tUmFyZS1UaG91Z2h0c29mUHJvZ3Jlc3MtUHJvbW8tQ2FyZC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDI4LS0tUHJvbW8tUmFyZS1UaG91Z2h0c29mUHJvZ3Jlc3MtUHJvbW8tQ2FyZC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDI4LS0tUHJvbW8tUmFyZS1UaG91Z2h0c29mUHJvZ3Jlc3MtUHJvbW8tQ2FyZC5wbmcEXODUS/t',
    name: 'Thoughts of Progress',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Draw 1 card from your Main Deck. Then, discard 1 card from your hand.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Thoughts-of-Progress-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_429',
    s3_large_image_name: 'NDI5LS0tVGhvdWdodHMtb2YtUHJvZ3Jlc3MtUHJvbW8ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDI5LS0tVGhvdWdodHMtb2YtUHJvZ3Jlc3MtUHJvbW8ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDI5LS0tVGhvdWdodHMtb2YtUHJvZ3Jlc3MtUHJvbW8ucG5n/t',
    name: 'Thoughts of Progress',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Draw 1 card from your Main Deck. Then, discard 1 card from your hand.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Thoughts-of-Progress-Promo-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_430',
    s3_large_image_name:
      'NDMwLS0tUHJvbW8tUmFyZS1UaG91Z2h0c3RyZWFtcy1FZGdlLUV4b2R1cy1DYXJkLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDMwLS0tUHJvbW8tUmFyZS1UaG91Z2h0c3RyZWFtcy1FZGdlLUV4b2R1cy1DYXJkLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDMwLS0tUHJvbW8tUmFyZS1UaG91Z2h0c3RyZWFtcy1FZGdlLUV4b2R1cy1DYXJkLnBuZwEXODUSEXODUS/t',
    name: "Thoughtstream's Edge",
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'If you have less Life Points than your opponent, draw 1 card from your Main Deck or Energy Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Thoughtstream-s-Edge-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_432',
    s3_large_image_name:
      'NDMyLS0tUHJvbW8tUmVwcmludC1UaG91Z2h0c3RyZWFtcy1FZGdlLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDMyLS0tUHJvbW8tUmVwcmludC1UaG91Z2h0c3RyZWFtcy1FZGdlLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDMyLS0tUHJvbW8tUmVwcmludC1UaG91Z2h0c3RyZWFtcy1FZGdlLnBuZwEXODUSEXODUS/t',
    name: "Thoughtstream's Edge",
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'If you have less Life Points than your opponent, draw 1 card from your Main Deck or Energy Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Thoughtstream-s-Edge-Promo-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_535',
    s3_large_image_name:
      'NTM1LS0tbGUtdGhvdWdodHN0cmVhbS1lZXZlbnRpZGVzLXN3b3JkLTcyZHBpLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTM1LS0tbGUtdGhvdWdodHN0cmVhbS1lZXZlbnRpZGVzLXN3b3JkLTcyZHBpLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTM1LS0tbGUtdGhvdWdodHN0cmVhbS1lZXZlbnRpZGVzLXN3b3JkLTcyZHBpLnBuZwEXODUSEXODUS/t',
    name: "Thoughtstream, Eeventide's Sword",
    set_name: 'The Dimension That Disappeared',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Symmetry'],
    artist: 'Yosi Saputra',
    effect:
      "Destroy 1 of your creatures and all energy attached. Then, destroy all cards on the field (except energy) that don't have any energy attached. If any cards left a player's field due to this effect, that player loses 1 Life Point. ",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Thoughtstream--Eeventide-s-Sword-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_425',
    s3_large_image_name:
      'NDI1LS0tUHJvbW8tUmFyZS1UaW1lbGVzcy1BbmdlbC1PZi1FdGVybml0eS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDI1LS0tUHJvbW8tUmFyZS1UaW1lbGVzcy1BbmdlbC1PZi1FdGVybml0eS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDI1LS0tUHJvbW8tUmFyZS1UaW1lbGVzcy1BbmdlbC1PZi1FdGVybml0eS5wbmcEXODUS/t',
    name: 'Timeless Angel of Eternity',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Dallin Bifano',
    effect:
      'When this card is destroyed by battle, send it to your hand instead of the graveyard.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Timeless-Angel-of-Eternity-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_431',
    s3_large_image_name:
      'NDMxLS0tUHJvbW8tUmFyZS1Ud2lzdGVkVm9ydGV4X1Byb21vX0NhcmQucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDMxLS0tUHJvbW8tUmFyZS1Ud2lzdGVkVm9ydGV4X1Byb21vX0NhcmQucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDMxLS0tUHJvbW8tUmFyZS1Ud2lzdGVkVm9ydGV4X1Byb21vX0NhcmQucG5n/t',
    name: 'Twisted Vortex',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Pay 1 Energy. Send the top 3 cards of your opponent's Main Deck to their graveyard and draw 3 cards from your Main Deck.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Twisted-Vortex-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_433',
    s3_large_image_name:
      'NDMzLS0tUHJvbW8tUmFyZS1VbmNoYXJ0ZWQtVGVycml0b3J5LTRDUC5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDMzLS0tUHJvbW8tUmFyZS1VbmNoYXJ0ZWQtVGVycml0b3J5LTRDUC5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDMzLS0tUHJvbW8tUmFyZS1VbmNoYXJ0ZWQtVGVycml0b3J5LTRDUC5wbmcEXODUS/t',
    name: 'Uncharted Territory',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Select 2 of your Common creatures in play and move an energy from one to the other. If both were multiple Types, move an additional energy between them.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Uncharted-Territory-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_434',
    s3_large_image_name:
      'NDM0LS0tMjAxOC1VbmNoYXJ0ZWQtVGVycml0b3J5LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDM0LS0tMjAxOC1VbmNoYXJ0ZWQtVGVycml0b3J5LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDM0LS0tMjAxOC1VbmNoYXJ0ZWQtVGVycml0b3J5LnBuZwEXODUSEXODUS/t',
    name: 'Uncharted Territory',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Select 2 of your Common creatures in play and move an energy from one to the other. If both were multiple Types, move an additional energy between them.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Uncharted-Territory-Promo-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_443',
    s3_large_image_name:
      'NDQzLS0tUHJvbW8tUmFyZS1VbmNvbW1vbi1BbGxpYW5jZS00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQzLS0tUHJvbW8tUmFyZS1VbmNvbW1vbi1BbGxpYW5jZS00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQzLS0tUHJvbW8tUmFyZS1VbmNvbW1vbi1BbGxpYW5jZS00Q1AucG5n/t',
    name: 'Uncommon Alliance',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Cristian Giraldes',
    effect:
      'If you control at least 1 Uncommon Dragon and 1 Uncommon Angel on the field, put a card from your graveyard on top of your Main Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Uncommon-Alliance-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_444',
    s3_large_image_name: 'NDQ0LS0tMjAxOC1VbmNvbW1vbi1BbGxpYW5jZS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ0LS0tMjAxOC1VbmNvbW1vbi1BbGxpYW5jZS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQ0LS0tMjAxOC1VbmNvbW1vbi1BbGxpYW5jZS5wbmcEXODUS/t',
    name: 'Uncommon Alliance',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'Cristian Giraldes',
    effect:
      'If you control at least 1 Uncommon Dragon and 1 Uncommon Angel on the field, put a card from your graveyard on top of your Main Deck.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Uncommon-Alliance-Promo-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_37',
    s3_large_image_name: 'MzctLS0xc3QtZWQtdW5zdW1tb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzctLS0xc3QtZWQtdW5zdW1tb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzctLS0xc3QtZWQtdW5zdW1tb24ucG5n/t',
    name: 'Unsummon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Pay 1 energy. Select one creature on the field and return it to the owner's hand. All energy attached to that creature is discarded.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Unsummon-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_116',
    s3_large_image_name:
      'MTE2LS0tVW5jb21tb24tVW5zdW1tb24tNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTE2LS0tVW5jb21tb24tVW5zdW1tb24tNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTE2LS0tVW5jb21tb24tVW5zdW1tb24tNENQLnBuZwEXODUSEXODUS/t',
    name: 'Unsummon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Pay 1 energy. Select one creature on the field and return it to the owner's hand. All energy attached to that creature is discarded.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Unsummon-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_75',
    s3_large_image_name: 'NzUtLS0ybmQtZWQtdW5zdW1tb24ucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NzUtLS0ybmQtZWQtdW5zdW1tb24ucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NzUtLS0ybmQtZWQtdW5zdW1tb24ucG5n/t',
    name: 'Unsummon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Pay 1 energy. Select one creature on the field and return it to the owner's hand. All energy attached to that creature is discarded.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Unsummon-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_157',
    s3_large_image_name: 'MTU3LS0tMzMtVW5zdW1tb24uanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTU3LS0tMzMtVW5zdW1tb24uanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTU3LS0tMzMtVW5zdW1tb24uanBn/t',
    name: 'Unsummon',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      "Pay 1 energy. Select one creature on the field and return it to the owner's hand. All energy attached to that creature is discarded.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Unsummon-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_13',
    s3_large_image_name: 'MTMtLS0xc3QtZWQtdmFsZm9yY2UucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTMtLS0xc3QtZWQtdmFsZm9yY2UucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTMtLS0xc3QtZWQtdmFsZm9yY2UucG5n/t',
    name: 'Valforce',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'First',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Valforce-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_89',
    s3_large_image_name: 'ODktLS1Db21tb24tVmFsZm9yY2UtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/ODktLS1Db21tb24tVmFsZm9yY2UtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/ODktLS1Db21tb24tVmFsZm9yY2UtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Valforce',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Premiere',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Valforce-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_51',
    s3_large_image_name: 'NTEtLS0ybmQtZWQtdmFsZm9yY2UucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTEtLS0ybmQtZWQtdmFsZm9yY2UucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTEtLS0ybmQtZWQtdmFsZm9yY2UucG5n/t',
    name: 'Valforce',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Second',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Valforce-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_130',
    s3_large_image_name: 'MTMwLS0tMjYtVmFsZm9yY2UuanBn',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTMwLS0tMjYtVmFsZm9yY2UuanBn',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTMwLS0tMjYtVmFsZm9yY2UuanBn/t',
    name: 'Valforce',
    set_name: 'Birth of Creation',
    rarity: 'Common',
    edition: 'Unlimited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Valforce-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_381',
    s3_large_image_name:
      'MzgxLS0tUmFyZS1Ta2V0Y2gtVmFsZm9yY2UtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MzgxLS0tUmFyZS1Ta2V0Y2gtVmFsZm9yY2UtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MzgxLS0tUmFyZS1Ta2V0Y2gtVmFsZm9yY2UtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Valforce',
    set_name: 'Birth of Creation',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Dragon'],
    creature_type_count: 1,
    artist: 'Roy Ugang',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Valforce-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_536',
    s3_large_image_name:
      'NTM2LS0tbGUtdmVybmVlanVzLXRoZS1tb2xlY3VsYXItbW9ja2VyeS03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTM2LS0tbGUtdmVybmVlanVzLXRoZS1tb2xlY3VsYXItbW9ja2VyeS03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTM2LS0tbGUtdmVybmVlanVzLXRoZS1tb2xlY3VsYXItbW9ja2VyeS03MmRwaS5wbmcEXODUS/t',
    name: 'Verneejus the Molecular Mockery',
    set_name: 'The Dimension That Disappeared',
    rarity: 'Secret Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'A.Gvin',
    effect:
      'This creature is every creature type. While this creature is in play, once per turn, you may discard 1 card from hand to target 1 creature on the field; that creature loses its Ability and this creature gains it for the rest of the turn. AFTERTHOUGHT ABILITY: Creatures on your side of the field are Chrono in addition to their other type(s).',
    ruling:
      '<p>■&nbsp;Verneejus cannot target Afterthoughts since Afterthoughts are not creatures;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - However, Verneejus&nbsp;<em>can&nbsp;</em>target a Chrono with an (inactive) Afterthought Ability to gain the Afterthought Ability instead of the regular Ability;<br><br>■ If target creature has multiple Abilities, Verneejus chooses 1 Ability;</p>\n<p>■&nbsp;Verneejus&nbsp;<em>is</em>&nbsp;able to trigger its own Ability to gain a "when this creature is summoned" Ability in response to its own summon;<br><br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Due to the wording "while this creature is in play", like&nbsp;<em>Lantern Leaflore</em>, the Ability can be used the moment it hits the field, before its summon fully resolves;</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Verneejus-the-Molecular-Mockery-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_441',
    s3_large_image_name:
      'NDQxLS0tUHJvbW8tUmFyZS1WaWN0b3JpYXMtVWx0aW1hdHVtLTRDUC5qcGcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQxLS0tUHJvbW8tUmFyZS1WaWN0b3JpYXMtVWx0aW1hdHVtLTRDUC5qcGcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQxLS0tUHJvbW8tUmFyZS1WaWN0b3JpYXMtVWx0aW1hdHVtLTRDUC5qcGcEXODUS/t',
    name: "Victoria's Ultimatum",
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'COCOs',
    effect:
      'Once, this turn, when one of your Uncommon Order creatures attacks an Angel, both creatures destroy each other and all energy attached during battle.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Victoria-s-Ultimatum-Promo',
    is_default_edition: true,
  },
  {
    card_id: 'card_442',
    s3_large_image_name:
      'NDQyLS0tMjAxOC1WaWN0b3JpYXMtVWx0aW1hdHVtLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDQyLS0tMjAxOC1WaWN0b3JpYXMtVWx0aW1hdHVtLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDQyLS0tMjAxOC1WaWN0b3JpYXMtVWx0aW1hdHVtLnBuZwEXODUSEXODUS/t',
    name: "Victoria's Ultimatum",
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Symmetry'],
    artist: 'COCOs',
    effect:
      'Once, this turn, when one of your Uncommon Order creatures attacks an Angel, both creatures destroy each other and all energy attached during battle.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Victoria-s-Ultimatum-Promo-1',
    is_default_edition: false,
  },
  {
    card_id: 'card_404',
    s3_large_image_name:
      'NDA0LS0tUmFyZS1Ta2V0Y2gtVmluZWJyYW5jaC1TZXJhcGgtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDA0LS0tUmFyZS1Ta2V0Y2gtVmluZWJyYW5jaC1TZXJhcGgtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDA0LS0tUmFyZS1Ta2V0Y2gtVmluZWJyYW5jaC1TZXJhcGgtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Vinebranch Seraph',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Angel'],
    creature_type_count: 1,
    artist: 'Didi Esmeralda',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Vinebranch-Seraph-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_20',
    s3_large_image_name: 'MjAtLS0xc3QtZWQtdm9ydGV4LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MjAtLS0xc3QtZWQtdm9ydGV4LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MjAtLS0xc3QtZWQtdm9ydGV4LnBuZwEXODUSEXODUS/t',
    name: 'Vortex',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'First',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Pay 1 energy. Both you and your opponent discard your entire hand (including any unplayed energy cards) and draw 3 new cards each from your Main Deck.',
    ruling:
      '<p>■ When this card is played, both players can still stack symmetry cards in response before discarding their hand;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Cards played in response to&nbsp;<em>Vortex</em>&nbsp;happen first;</p>\n<p><em>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;</em>If a&nbsp;<em>Vortex&nbsp;</em>is played in response to a&nbsp;<em>Vortex</em>, players can continue playing symmetries or activating Abilities by "adding to the stack" after the first&nbsp;<em>Vortex&nbsp;</em>has resolved, due to symmetries and Abilities being instant-speed<em>;</em>&nbsp;</p>\n<p><em>■</em>&nbsp;<em>Vortex&nbsp;</em>can be played&nbsp;at the start or end of a player\'s Draw Phase, but&nbsp;<strong>NOT&nbsp;</strong>in the middle while they are still drawing;</p>\n<p><em>■</em>&nbsp;Card effects or Abilities cannot be played or trigger in the middle of&nbsp;<em>Vortex&nbsp;</em>resolving. (<strong>Example</strong>:&nbsp;You cannot play&nbsp;<em>Forest of Crags</em>&nbsp;between the cards drawn from&nbsp;<em>Vortex)</em>; (<strong>Example</strong>: Your opponent cannot play&nbsp;<em>Drifter\'s Dueling</em>&nbsp;between the cards drawn from&nbsp;<em>Vortex</em>);</p>',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Vortex-First',
    is_default_edition: false,
  },
  {
    card_id: 'card_96',
    s3_large_image_name: 'OTYtLS1VbmNvbW1vbi1Wb3J0ZXgtNENQLnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/OTYtLS1VbmNvbW1vbi1Wb3J0ZXgtNENQLnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/OTYtLS1VbmNvbW1vbi1Wb3J0ZXgtNENQLnBuZwEXODUSEXODUS/t',
    name: 'Vortex',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Premiere',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Pay 1 energy. Both you and your opponent discard your entire hand (including any unplayed energy cards) and draw 3 new cards each from your Main Deck.',
    ruling:
      '<p>■ When this card is played, both players can still stack symmetry cards in response before discarding their hand;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Cards played in response to&nbsp;<em>Vortex</em>&nbsp;happen first;</p>\n<p><em>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;</em>If a&nbsp;<em>Vortex&nbsp;</em>is played in response to a&nbsp;<em>Vortex</em>, players can continue playing symmetries or activating Abilities by "adding to the stack" after the first&nbsp;<em>Vortex&nbsp;</em>has resolved, due to symmetries and Abilities being instant-speed<em>;</em>&nbsp;</p>\n<p><em>■</em>&nbsp;<em>Vortex&nbsp;</em>can be played&nbsp;at the start or end of a player\'s Draw Phase, but&nbsp;<strong>NOT&nbsp;</strong>in the middle while they are still drawing;</p>\n<p><em>■</em>&nbsp;Card effects or Abilities cannot be played or trigger in the middle of&nbsp;<em>Vortex&nbsp;</em>resolving. (<strong>Example</strong>:&nbsp;You cannot play&nbsp;<em>Forest of Crags</em>&nbsp;between the cards drawn from&nbsp;<em>Vortex)</em>; (<strong>Example</strong>: Your opponent cannot play&nbsp;<em>Drifter\'s Dueling</em>&nbsp;between the cards drawn from&nbsp;<em>Vortex</em>);</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Vortex-Premiere',
    is_default_edition: false,
  },
  {
    card_id: 'card_58',
    s3_large_image_name: 'NTgtLS0ybmQtZWQtdm9ydGV4LnBuZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTgtLS0ybmQtZWQtdm9ydGV4LnBuZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTgtLS0ybmQtZWQtdm9ydGV4LnBuZwEXODUSEXODUS/t',
    name: 'Vortex',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Second',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Pay 1 energy. Both you and your opponent discard your entire hand (including any unplayed energy cards) and draw 3 new cards each from your Main Deck.',
    ruling:
      '<p>■ When this card is played, both players can still stack symmetry cards in response before discarding their hand;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Cards played in response to&nbsp;<em>Vortex</em>&nbsp;happen first;</p>\n<p><em>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;</em>If a&nbsp;<em>Vortex&nbsp;</em>is played in response to a&nbsp;<em>Vortex</em>, players can continue playing symmetries or activating Abilities by "adding to the stack" after the first&nbsp;<em>Vortex&nbsp;</em>has resolved, due to symmetries and Abilities being instant-speed<em>;</em>&nbsp;</p>\n<p><em>■</em>&nbsp;<em>Vortex&nbsp;</em>can be played&nbsp;at the start or end of a player\'s Draw Phase, but&nbsp;<strong>NOT&nbsp;</strong>in the middle while they are still drawing;</p>\n<p><em>■</em>&nbsp;Card effects or Abilities cannot be played or trigger in the middle of&nbsp;<em>Vortex&nbsp;</em>resolving. (<strong>Example</strong>:&nbsp;You cannot play&nbsp;<em>Forest of Crags</em>&nbsp;between the cards drawn from&nbsp;<em>Vortex)</em>; (<strong>Example</strong>: Your opponent cannot play&nbsp;<em>Drifter\'s Dueling</em>&nbsp;between the cards drawn from&nbsp;<em>Vortex</em>);</p>',
    foil_only: 'No',
    card_database_link: 'https://exodus-players.com/cards/search/Vortex-Second',
    is_default_edition: false,
  },
  {
    card_id: 'card_137',
    s3_large_image_name: 'MTM3LS0tNDAtVm9ydGV4LmpwZwEXODUSEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/MTM3LS0tNDAtVm9ydGV4LmpwZwEXODUSEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/MTM3LS0tNDAtVm9ydGV4LmpwZwEXODUSEXODUS/t',
    name: 'Vortex',
    set_name: 'Birth of Creation',
    rarity: 'Uncommon',
    edition: 'Unlimited',
    card_type: ['Symmetry'],
    artist: 'Roy Ugang',
    effect:
      'Pay 1 energy. Both you and your opponent discard your entire hand (including any unplayed energy cards) and draw 3 new cards each from your Main Deck.',
    ruling:
      '<p>■ When this card is played, both players can still stack symmetry cards in response before discarding their hand;&nbsp;</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Cards played in response to&nbsp;<em>Vortex</em>&nbsp;happen first;</p>\n<p><em>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -&nbsp;</em>If a&nbsp;<em>Vortex&nbsp;</em>is played in response to a&nbsp;<em>Vortex</em>, players can continue playing symmetries or activating Abilities by "adding to the stack" after the first&nbsp;<em>Vortex&nbsp;</em>has resolved, due to symmetries and Abilities being instant-speed<em>;</em>&nbsp;</p>\n<p><em>■</em>&nbsp;<em>Vortex&nbsp;</em>can be played&nbsp;at the start or end of a player\'s Draw Phase, but&nbsp;<strong>NOT&nbsp;</strong>in the middle while they are still drawing;</p>\n<p><em>■</em>&nbsp;Card effects or Abilities cannot be played or trigger in the middle of&nbsp;<em>Vortex&nbsp;</em>resolving. (<strong>Example</strong>:&nbsp;You cannot play&nbsp;<em>Forest of Crags</em>&nbsp;between the cards drawn from&nbsp;<em>Vortex)</em>; (<strong>Example</strong>: Your opponent cannot play&nbsp;<em>Drifter\'s Dueling</em>&nbsp;between the cards drawn from&nbsp;<em>Vortex</em>);</p>',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Vortex-Unlimited',
    is_default_edition: true,
  },
  {
    card_id: 'card_537',
    s3_large_image_name:
      'NTM3LS0tbGUtd2FuZGVyd29sZi10aGUtaW5uZXItZmVhci03MmRwaS5wbmcEXODUS',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NTM3LS0tbGUtd2FuZGVyd29sZi10aGUtaW5uZXItZmVhci03MmRwaS5wbmcEXODUS',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NTM3LS0tbGUtd2FuZGVyd29sZi10aGUtaW5uZXItZmVhci03MmRwaS5wbmcEXODUS/t',
    name: 'Wanderwolf the Inner Fear',
    set_name: 'The Dimension That Disappeared',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Chrono', 'Wolf'],
    creature_type_count: 2,
    artist: 'A.Gvin',
    effect:
      "This creature may attack blank piles of energy. (Blank piles don't deal damage to it.) AFTERTHOUGHT ABILITY: The first time your opponent damages your Life Points each turn, you take 1 less damage.",
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Wanderwolf-the-Inner-Fear-Limited',
    is_default_edition: false,
  },
  {
    card_id: 'card_405',
    s3_large_image_name:
      'NDA1LS0tUmFyZS1Ta2V0Y2gtV2lzaHdha2VyLVdpbGxvdy00Q1AucG5n',
    large_image_url:
      'https://exodus-players.com/cards/loadImg/NDA1LS0tUmFyZS1Ta2V0Y2gtV2lzaHdha2VyLVdpbGxvdy00Q1AucG5n',
    small_image_url:
      'https://exodus-players.com/cards/loadImg/NDA1LS0tUmFyZS1Ta2V0Y2gtV2lzaHdha2VyLVdpbGxvdy00Q1AucG5n/t',
    name: 'Wishwaker Willow',
    set_name: 'Galaxy Tides',
    rarity: 'Rare',
    edition: 'Limited',
    card_type: ['Creature'],
    creature_type: ['Treefolk'],
    creature_type_count: 1,
    artist: 'Kenny Estrella',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://exodus-players.com/cards/search/Wishwaker-Willow-Limited',
    is_default_edition: false,
  },
  {
    name: 'Distorted Lingerer',
    card_id: 'card_tdtd_p6',
    s3_large_image_name: 'card_tdtd_p6',
    large_image_url:
      'http://cloud-3.steamusercontent.com/ugc/768365276448975899/81E7A7B10CA8F8AAB39FFE472B5E6A7FC1EFEABE/',
    small_image_url:
      'http://cloud-3.steamusercontent.com/ugc/768365276448975899/81E7A7B10CA8F8AAB39FFE472B5E6A7FC1EFEABE/',
    set_name: 'The Dimension That Disappeared',
    set_number: 'P6',
    rarity: 'Rare',
    edition: 'Promo',
    card_type: ['Creature'],
    creature_type: ['Chrono'],
    creature_type_count: 1,
    artist: 'Thai Vo',
    effect:
      'When this creature enters play, you may target and activate 1 Ability on the field that triggers when it enters play. AFTERTHOUGHT ABILITY: Whenever a player draws from a Deck, they draw from the opposite Deck instead.',
    ruling: '',
    foil_only: 'No',
    card_database_link:
      'https://www.exodus-cards.com/Exodus_Newsletter-issue-048.html',
    is_default_edition: true,
  },
]);
